window.theme = window.theme || {};

/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  document.addEventListener(
    'shopify:section:load',
    this._onSectionLoad.bind(this)
  );
  document.addEventListener(
    'shopify:section:unload',
    this._onSectionUnload.bind(this)
  );
  document.addEventListener(
    'shopify:section:select',
    this._onSelect.bind(this)
  );
  document.addEventListener(
    'shopify:section:deselect',
    this._onDeselect.bind(this)
  );
  document.addEventListener(
    'shopify:block:select',
    this._onBlockSelect.bind(this)
  );
  document.addEventListener(
    'shopify:block:deselect',
    this._onBlockDeselect.bind(this)
  );
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var id = container.getAttribute('data-section-id');
    var type = container.getAttribute('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = Object.assign(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = document.querySelector(
      '[data-section-id="' + evt.detail.sectionId + '"]'
    );

    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = this.instances.filter(function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (typeof instance.onUnload === 'function') {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== 'undefined' &&
      typeof instance.onSelect === 'function'
    ) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== 'undefined' &&
      typeof instance.onDeselect === 'function'
    ) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== 'undefined' &&
      typeof instance.onBlockSelect === 'function'
    ) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== 'undefined' &&
      typeof instance.onBlockDeselect === 'function'
    ) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    document.querySelectorAll('[data-section-type="' + type + '"]').forEach(
      function(container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

window.slate = window.slate || {};

/**
 * Slate utilities
 * -----------------------------------------------------------------------------
 * A collection of useful utilities to help build your theme
 *
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Get the query params in a Url
   * Ex
   * https://mysite.com/search?q=noodles&b
   * getParameterByName('q') = "noodles"
   * getParameterByName('b') = "" (empty value)
   * getParameterByName('test') = null (absent)
   */
  getParameterByName: function(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },

  resizeSelects: function(selects) {
    selects.forEach(function(select) {
      var arrowWidth = 55;

      var test = document.createElement('span');
      test.innerHTML = select.selectedOptions[0].label;

      document.querySelector('.site-').appendChild(test);

      var width = test.offsetWidth + arrowWidth;
      test.remove();

      select.style.width = width + 'px';
    });
  },

  keyboardKeys: {
    TAB: 9,
    ENTER: 13,
    ESCAPE: 27,
    LEFTARROW: 37,
    RIGHTARROW: 39
  }
};

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {NodeList} options.tables - Elements of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    options.tables.forEach(function(table) {
      var wrapper = document.createElement('div');
      wrapper.classList.add(options.tableWrapperClass);

      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {NodeList} options.iframes - Elements of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    options.iframes.forEach(function(iframe) {
      var wrapper = document.createElement('div');
      wrapper.classList.add(options.iframeWrapperClass);

      iframe.parentNode.insertBefore(wrapper, iframe);
      wrapper.appendChild(iframe);

      iframe.src = iframe.src;
    });
  }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  state: {
    firstFocusable: null,
    lastFocusable: null
  },
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects
   *
   * @param {HTMLElement} element - The element to be acted upon
   */
  pageLinkFocus: function(element) {
    if (!element) return;
    var focusClass = 'js-focus-hidden';

    element.setAttribute('tabIndex', '-1');
    element.focus();
    element.classList.add(focusClass);
    element.addEventListener('blur', callback, { once: true });

    function callback() {
      element.classList.remove(focusClass);
      element.removeAttribute('tabindex');
    }
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {HTMLElement} options.container - Container to trap focus within
   * @param {HTMLElement} options.elementToFocus - Element to be focused when focus leaves container
   */
  trapFocus: function(options) {
    var focusableElements = Array.from(
      options.container.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
      )
    ).filter(function(element) {
      var width = element.offsetWidth;
      var height = element.offsetHeight;

      return (
        width !== 0 &&
        height !== 0 &&
        getComputedStyle(element).getPropertyValue('display') !== 'none'
      );
    });

    this.state.firstFocusable = focusableElements[0];
    this.state.lastFocusable = focusableElements[focusableElements.length - 1];

    if (!options.elementToFocus) {
      options.elementToFocus = options.container;
    }

    options.container.setAttribute('tabindex', '-1');
    options.elementToFocus.focus();

    this._setupHandlers();

    document.addEventListener('focusin', this._onFocusInHandler);
    document.addEventListener('focusout', this._onFocusOutHandler);
  },

  _setupHandlers: function() {
    if (!this._onFocusInHandler) {
      this._onFocusInHandler = this._onFocusIn.bind(this);
    }

    if (!this._onFocusOutHandler) {
      this._onFocusOutHandler = this._onFocusIn.bind(this);
    }

    if (!this._manageFocusHandler) {
      this._manageFocusHandler = this._manageFocus.bind(this);
    }
  },

  _onFocusOut: function() {
    document.removeEventListener('keydown', this._manageFocusHandler);
  },

  _onFocusIn: function(evt) {
    if (
      evt.target !== this.state.lastFocusable &&
      evt.target !== this.state.firstFocusable
    )
      return;

    document.addEventListener('keydown', this._manageFocusHandler);
  },

  _manageFocus: function(evt) {
    if (evt.keyCode !== slate.utils.keyboardKeys.TAB) return;

    /**
     * On the last focusable element and tab forward,
     * focus the first element.
     */
    if (evt.target === this.state.lastFocusable && !evt.shiftKey) {
      evt.preventDefault();
      this.state.firstFocusable.focus();
    }
    /**
     * On the first focusable element and tab backward,
     * focus the last element.
     */
    if (evt.target === this.state.firstFocusable && evt.shiftKey) {
      evt.preventDefault();
      this.state.lastFocusable.focus();
    }
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {HTMLElement} options.container - Container to trap focus within
   */
  removeTrapFocus: function(options) {
    if (options.container) {
      options.container.removeAttribute('tabindex');
    }
    document.removeEventListener('focusin', this._onFocusInHandler);
  },

  /**
   * Add aria-describedby attribute to external and new window links
   *
   * @param {object} options - Options to be used
   * @param {object} options.messages - Custom messages to be used
   * @param {HTMLElement} options.links - Specific links to be targeted
   */
  accessibleLinks: function(options) {
    var body = document.querySelector('body');

    var idSelectors = {
      newWindow: 'a11y-new-window-message',
      external: 'a11y-external-message',
      newWindowExternal: 'a11y-new-window-external-message'
    };

    if (options.links === undefined || !options.links.length) {
      options.links = document.querySelectorAll(
        'a[href]:not([aria-describedby])'
      );
    }

    function generateHTML(customMessages) {
      if (typeof customMessages !== 'object') {
        customMessages = {};
      }

      var messages = Object.assign(
        {
          newWindow: 'Opens in a new window.',
          external: 'Opens external website.',
          newWindowExternal: 'Opens external website in a new window.'
        },
        customMessages
      );

      var container = document.createElement('ul');
      var htmlMessages = '';

      for (var message in messages) {
        htmlMessages +=
          '<li id=' + idSelectors[message] + '>' + messages[message] + '</li>';
      }

      container.setAttribute('hidden', true);
      container.innerHTML = htmlMessages;

      body.appendChild(container);
    }

    function _externalSite(link) {
      var hostname = window.location.hostname;

      return link.hostname !== hostname;
    }

    options.links.forEach(function(link) {
      var target = link.getAttribute('target');
      var rel = link.getAttribute('rel');
      var isExternal = _externalSite(link);
      var isTargetBlank = target === '_blank';

      if (isExternal) {
        link.setAttribute('aria-describedby', idSelectors.external);
      }

      if (isTargetBlank) {
        if (!rel || rel.indexOf('noopener') === -1) {
          var relValue = rel === undefined ? '' : rel + ' ';
          relValue = relValue + 'noopener';
          link.setAttribute('rel', relValue);
        }

        link.setAttribute('aria-describedby', idSelectors.newWindow);
      }

      if (isExternal && isTargetBlank) {
        link.setAttribute('aria-describedby', idSelectors.newWindowExternal);
      }
    });

    generateHTML(options.messages);
  }
};

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function() {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
    );

    if (match !== null) {
      if (match[2] !== undefined) {
        return match[1] + match[2];
      } else {
        return match[1];
      }
    } else {
      return null;
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.container = options.container;
    this.product = options.product;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.singleOptions = this.container.querySelectorAll(
      options.singleOptionSelector
    );
    this.currentVariant = this._getVariantFromOptions();

    this.singleOptions.forEach(
      function(option) {
        option.addEventListener('change', this._onSelectChange.bind(this));
      }.bind(this)
    );
  }

  Variants.prototype = Object.assign({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var result = [];

      this.singleOptions.forEach(function(option) {
        var type = option.getAttribute('type');
        var isRadioOrCheckbox = type === 'radio' || type === 'checkbox';

        if (!isRadioOrCheckbox || option.checked) {
          result.push({
            value: option.value,
            index: option.getAttribute('data-index')
          });
        }
      });

      return result;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = variants.find(function(variant) {
        return selectedValues.every(function(values) {
          return variant[values.index] === values.value;
        });
      });

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.container.dispatchEvent(
        new CustomEvent('variantChange', {
          detail: {
            variant: variant
          },
          bubbles: true,
          cancelable: true
        })
      );

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.container.dispatchEvent(
        new CustomEvent('variantImageChange', {
          detail: {
            variant: variant
          },
          bubbles: true,
          cancelable: true
        })
      );
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price &&
        variant.unit_price === this.currentVariant.unit_price
      ) {
        return;
      }

      this.container.dispatchEvent(
        new CustomEvent('variantPriceChange', {
          detail: {
            variant: variant
          },
          bubbles: true,
          cancelable: true
        })
      );
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.container.dispatchEvent(
        new CustomEvent('variantSKUChange', {
          detail: {
            variant: variant
          },
          bubbles: true,
          cancelable: true
        })
      );
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' +
        variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      var masterSelect = this.container.querySelector(this.originalSelectorId);

      if (!masterSelect) return;
      masterSelect.value = variant.id;
    }
  });

  return Variants;
})();

this.Shopify = this.Shopify || {};
this.Shopify.theme = this.Shopify.theme || {};
this.Shopify.theme.PredictiveSearch = (function() {
  'use strict';

  function validateQuery(query) {
    var error;

    if (query === null || query === undefined) {
      error = new TypeError("'query' is missing");
      error.type = 'argument';
      throw error;
    }

    if (typeof query !== 'string') {
      error = new TypeError("'query' is not a string");
      error.type = 'argument';
      throw error;
    }
  }

  function GenericError() {
    var error = Error.call(this);

    error.name = 'Server error';
    error.message = 'Something went wrong on the server';
    error.status = 500;

    return error;
  }

  function NotFoundError(status) {
    var error = Error.call(this);

    error.name = 'Not found';
    error.message = 'Not found';
    error.status = status;

    return error;
  }

  function ServerError() {
    var error = Error.call(this);

    error.name = 'Server error';
    error.message = 'Something went wrong on the server';
    error.status = 500;

    return error;
  }

  function ContentTypeError(status) {
    var error = Error.call(this);

    error.name = 'Content-Type error';
    error.message = 'Content-Type was not provided or is of wrong type';
    error.status = status;

    return error;
  }

  function JsonParseError(status) {
    var error = Error.call(this);

    error.name = 'JSON parse error';
    error.message = 'JSON syntax error';
    error.status = status;

    return error;
  }

  function ThrottledError(status, name, message, retryAfter) {
    var error = Error.call(this);

    error.name = name;
    error.message = message;
    error.status = status;
    error.retryAfter = retryAfter;

    return error;
  }

  function InvalidParameterError(status, name, message) {
    var error = Error.call(this);

    error.name = name;
    error.message = message;
    error.status = status;

    return error;
  }

  function ExpectationFailedError(status, name, message) {
    var error = Error.call(this);

    error.name = name;
    error.message = message;
    error.status = status;

    return error;
  }

  function request(searchUrl, queryParams, query, onSuccess, onError) {
    var xhr = new XMLHttpRequest();
    var route = searchUrl + '/suggest.json';

    xhr.onreadystatechange = function() {
      if (xhr.readyState !== XMLHttpRequest.DONE) {
        return;
      }

      var contentType = xhr.getResponseHeader('Content-Type');

      if (xhr.status >= 500) {
        onError(new ServerError());

        return;
      }

      if (xhr.status === 404) {
        onError(new NotFoundError(xhr.status));

        return;
      }

      if (
        typeof contentType !== 'string' ||
        contentType.toLowerCase().match('application/json') === null
      ) {
        onError(new ContentTypeError(xhr.status));

        return;
      }

      if (xhr.status === 417) {
        try {
          var invalidParameterJson = JSON.parse(xhr.responseText);

          onError(
            new InvalidParameterError(
              xhr.status,
              invalidParameterJson.message,
              invalidParameterJson.description
            )
          );
        } catch (error) {
          onError(new JsonParseError(xhr.status));
        }

        return;
      }

      if (xhr.status === 422) {
        try {
          var expectationFailedJson = JSON.parse(xhr.responseText);

          onError(
            new ExpectationFailedError(
              xhr.status,
              expectationFailedJson.message,
              expectationFailedJson.description
            )
          );
        } catch (error) {
          onError(new JsonParseError(xhr.status));
        }

        return;
      }

      if (xhr.status === 429) {
        try {
          var throttledJson = JSON.parse(xhr.responseText);

          onError(
            new ThrottledError(
              xhr.status,
              throttledJson.message,
              throttledJson.description,
              xhr.getResponseHeader('Retry-After')
            )
          );
        } catch (error) {
          onError(new JsonParseError(xhr.status));
        }

        return;
      }

      if (xhr.status === 200) {
        try {
          var res = JSON.parse(xhr.responseText);
          res.query = query;
          onSuccess(res);
        } catch (error) {
          onError(new JsonParseError(xhr.status));
        }

        return;
      }

      try {
        var genericErrorJson = JSON.parse(xhr.responseText);
        onError(
          new GenericError(
            xhr.status,
            genericErrorJson.message,
            genericErrorJson.description
          )
        );
      } catch (error) {
        onError(new JsonParseError(xhr.status));
      }

      return;
    };

    xhr.open(
      'get',
      route + '?q=' + encodeURIComponent(query) + '&' + queryParams
    );

    xhr.setRequestHeader('Content-Type', 'application/json');

    xhr.send();
  }

  function Cache(config) {
    this._store = {};
    this._keys = [];
    if (config && config.bucketSize) {
      this.bucketSize = config.bucketSize;
    } else {
      this.bucketSize = 20;
    }
  }

  Cache.prototype.set = function(key, value) {
    if (this.count() >= this.bucketSize) {
      var deleteKey = this._keys.splice(0, 1);
      this.delete(deleteKey);
    }

    this._keys.push(key);
    this._store[key] = value;

    return this._store;
  };

  Cache.prototype.get = function(key) {
    return this._store[key];
  };

  Cache.prototype.has = function(key) {
    return Boolean(this._store[key]);
  };

  Cache.prototype.count = function() {
    return Object.keys(this._store).length;
  };

  Cache.prototype.delete = function(key) {
    var exists = Boolean(this._store[key]);
    delete this._store[key];
    return exists && !this._store[key];
  };

  function Dispatcher() {
    this.events = {};
  }

  Dispatcher.prototype.on = function(eventName, callback) {
    var event = this.events[eventName];
    if (!event) {
      event = new DispatcherEvent(eventName);
      this.events[eventName] = event;
    }
    event.registerCallback(callback);
  };

  Dispatcher.prototype.off = function(eventName, callback) {
    var event = this.events[eventName];
    if (event && event.callbacks.indexOf(callback) > -1) {
      event.unregisterCallback(callback);
      if (event.callbacks.length === 0) {
        delete this.events[eventName];
      }
    }
  };

  Dispatcher.prototype.dispatch = function(eventName, payload) {
    var event = this.events[eventName];
    if (event) {
      event.fire(payload);
    }
  };

  function DispatcherEvent(eventName) {
    this.eventName = eventName;
    this.callbacks = [];
  }

  DispatcherEvent.prototype.registerCallback = function(callback) {
    this.callbacks.push(callback);
  };

  DispatcherEvent.prototype.unregisterCallback = function(callback) {
    var index = this.callbacks.indexOf(callback);
    if (index > -1) {
      this.callbacks.splice(index, 1);
    }
  };

  DispatcherEvent.prototype.fire = function(payload) {
    var callbacks = this.callbacks.slice(0);
    callbacks.forEach(function(callback) {
      callback(payload);
    });
  };

  function debounce(func, wait) {
    var timeout = null;
    return function() {
      var context = this;
      var args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        timeout = null;
        func.apply(context, args);
      }, wait || 0);
    };
  }

  function objectToQueryParams(obj, parentKey) {
    var output = '';
    parentKey = parentKey || null;

    Object.keys(obj).forEach(function(key) {
      var outputKey = key + '=';
      if (parentKey) {
        outputKey = parentKey + '[' + key + ']';
      }

      switch (trueTypeOf(obj[key])) {
        case 'object':
          output += objectToQueryParams(obj[key], parentKey ? outputKey : key);
          break;
        case 'array':
          output += outputKey + '=' + obj[key].join(',') + '&';
          break;
        default:
          if (parentKey) {
            outputKey += '=';
          }
          output += outputKey + encodeURIComponent(obj[key]) + '&';
          break;
      }
    });

    return output;
  }

  function trueTypeOf(obj) {
    return Object.prototype.toString
      .call(obj)
      .slice(8, -1)
      .toLowerCase();
  }

  var DEBOUNCE_RATE = 10;
  var requestDebounced = debounce(request, DEBOUNCE_RATE);

  function PredictiveSearch(params, searchUrl) {
    if (!params) {
      throw new TypeError('No params object was specified');
    }

    this.searchUrl = searchUrl;

    this._retryAfter = null;
    this._currentQuery = null;

    this.dispatcher = new Dispatcher();
    this.cache = new Cache({ bucketSize: 40 });

    this.queryParams = objectToQueryParams(params);
  }

  PredictiveSearch.TYPES = {
    PRODUCT: 'product',
    PAGE: 'page',
    ARTICLE: 'article'
  };

  PredictiveSearch.FIELDS = {
    AUTHOR: 'author',
    BODY: 'body',
    PRODUCT_TYPE: 'product_type',
    TAG: 'tag',
    TITLE: 'title',
    VARIANTS_BARCODE: 'variants.barcode',
    VARIANTS_SKU: 'variants.sku',
    VARIANTS_TITLE: 'variants.title',
    VENDOR: 'vendor'
  };

  PredictiveSearch.UNAVAILABLE_PRODUCTS = {
    SHOW: 'show',
    HIDE: 'hide',
    LAST: 'last'
  };

  PredictiveSearch.prototype.query = function query(query) {
    try {
      validateQuery(query);
    } catch (error) {
      this.dispatcher.dispatch('error', error);
      return;
    }

    if (query === '') {
      return this;
    }

    this._currentQuery = normalizeQuery(query);
    var cacheResult = this.cache.get(this._currentQuery);
    if (cacheResult) {
      this.dispatcher.dispatch('success', cacheResult);
      return this;
    }

    requestDebounced(
      this.searchUrl,
      this.queryParams,
      query,
      function(result) {
        this.cache.set(normalizeQuery(result.query), result);
        if (normalizeQuery(result.query) === this._currentQuery) {
          this._retryAfter = null;
          this.dispatcher.dispatch('success', result);
        }
      }.bind(this),
      function(error) {
        if (error.retryAfter) {
          this._retryAfter = error.retryAfter;
        }
        this.dispatcher.dispatch('error', error);
      }.bind(this)
    );

    return this;
  };

  PredictiveSearch.prototype.on = function on(eventName, callback) {
    this.dispatcher.on(eventName, callback);

    return this;
  };

  PredictiveSearch.prototype.off = function on(eventName, callback) {
    this.dispatcher.off(eventName, callback);

    return this;
  };

  function normalizeQuery(query) {
    if (typeof query !== 'string') {
      return null;
    }

    return query
      .trim()
      .replace(' ', '-')
      .toLowerCase();
  }

  return PredictiveSearch;
})();

this.Shopify = this.Shopify || {};
this.Shopify.theme = this.Shopify.theme || {};
this.Shopify.theme.PredictiveSearchComponent = (function(PredictiveSearch) {
  'use strict';

  PredictiveSearch =
    PredictiveSearch && PredictiveSearch.hasOwnProperty('default')
      ? PredictiveSearch['default']
      : PredictiveSearch;

  var DEFAULT_PREDICTIVE_SEARCH_API_CONFIG = {
    resources: {
      type: [PredictiveSearch.TYPES.PRODUCT],
      options: {
        unavailable_products: PredictiveSearch.UNAVAILABLE_PRODUCTS.LAST,
        fields: [
          PredictiveSearch.FIELDS.TITLE,
          PredictiveSearch.FIELDS.VENDOR,
          PredictiveSearch.FIELDS.PRODUCT_TYPE,
          PredictiveSearch.FIELDS.VARIANTS_TITLE
        ]
      }
    }
  };

  function PredictiveSearchComponent(config) {
    // validate config
    if (
      !config ||
      !config.selectors ||
      !config.selectors.input ||
      !isString(config.selectors.input) ||
      !config.selectors.result ||
      !isString(config.selectors.result) ||
      !config.resultTemplateFct ||
      !isFunction(config.resultTemplateFct) ||
      !config.numberOfResultsTemplateFct ||
      !isFunction(config.numberOfResultsTemplateFct) ||
      !config.loadingResultsMessageTemplateFct ||
      !isFunction(config.loadingResultsMessageTemplateFct)
    ) {
      var error = new TypeError(
        'PredictiveSearchComponent config is not valid'
      );
      error.type = 'argument';
      throw error;
    }

    // Find nodes
    this.nodes = findNodes(config.selectors);

    // Validate nodes
    if (!isValidNodes(this.nodes)) {
      // eslint-disable-next-line no-console
      console.warn('Could not find valid nodes');
      return;
    }

    this.searchUrl = config.searchUrl || '/search';

    // Store the keyword that was used for the search
    this._searchKeyword = '';

    // Assign result template
    this.resultTemplateFct = config.resultTemplateFct;

    // Assign number of results template
    this.numberOfResultsTemplateFct = config.numberOfResultsTemplateFct;

    // Assign loading state template function
    this.loadingResultsMessageTemplateFct =
      config.loadingResultsMessageTemplateFct;

    // Assign number of search results
    this.numberOfResults = config.numberOfResults || 4;

    // Set classes
    this.classes = {
      visibleVariant: config.visibleVariant
        ? config.visibleVariant
        : 'predictive-search-wrapper--visible',
      itemSelected: config.itemSelectedClass
        ? config.itemSelectedClass
        : 'predictive-search-item--selected',
      clearButtonVisible: config.clearButtonVisibleClass
        ? config.clearButtonVisibleClass
        : 'predictive-search__clear-button--visible'
    };

    this.selectors = {
      searchResult: config.searchResult
        ? config.searchResult
        : '[data-search-result]'
    };

    // Assign callbacks
    this.callbacks = assignCallbacks(config);

    // Add input attributes
    addInputAttributes(this.nodes.input);

    // Add input event listeners
    this._addInputEventListeners();

    // Add body listener
    this._addBodyEventListener();

    // Add accessibility announcer
    this._addAccessibilityAnnouncer();

    // Display the reset button if the input is not empty
    this._toggleClearButtonVisibility();

    // Instantiate Predictive Search API
    this.predictiveSearch = new PredictiveSearch(
      config.PredictiveSearchAPIConfig
        ? config.PredictiveSearchAPIConfig
        : DEFAULT_PREDICTIVE_SEARCH_API_CONFIG,
      this.searchUrl
    );

    // Add predictive search success event listener
    this.predictiveSearch.on(
      'success',
      this._handlePredictiveSearchSuccess.bind(this)
    );

    // Add predictive search error event listener
    this.predictiveSearch.on(
      'error',
      this._handlePredictiveSearchError.bind(this)
    );
  }

  /**
   * Private methods
   */
  function findNodes(selectors) {
    return {
      input: document.querySelector(selectors.input),
      reset: document.querySelector(selectors.reset),
      result: document.querySelector(selectors.result)
    };
  }

  function isValidNodes(nodes) {
    if (
      !nodes ||
      !nodes.input ||
      !nodes.result ||
      nodes.input.tagName !== 'INPUT'
    ) {
      return false;
    }

    return true;
  }

  function assignCallbacks(config) {
    return {
      onBodyMousedown: config.onBodyMousedown,
      onBeforeOpen: config.onBeforeOpen,
      onOpen: config.onOpen,
      onBeforeClose: config.onBeforeClose,
      onClose: config.onClose,
      onInputFocus: config.onInputFocus,
      onInputKeyup: config.onInputKeyup,
      onInputBlur: config.onInputBlur,
      onInputReset: config.onInputReset,
      onBeforeDestroy: config.onBeforeDestroy,
      onDestroy: config.onDestroy
    };
  }

  function addInputAttributes(input) {
    input.setAttribute('autocorrect', 'off');
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('autocapitalize', 'off');
    input.setAttribute('spellcheck', 'false');
  }

  function removeInputAttributes(input) {
    input.removeAttribute('autocorrect', 'off');
    input.removeAttribute('autocomplete', 'off');
    input.removeAttribute('autocapitalize', 'off');
    input.removeAttribute('spellcheck', 'false');
  }

  /**
   * Public variables
   */
  PredictiveSearchComponent.prototype.isResultVisible = false;
  PredictiveSearchComponent.prototype.results = {};

  /**
   * "Private" variables
   */
  PredictiveSearchComponent.prototype._latencyTimer = null;
  PredictiveSearchComponent.prototype._resultNodeClicked = false;

  /**
   * "Private" instance methods
   */
  PredictiveSearchComponent.prototype._addInputEventListeners = function() {
    var input = this.nodes.input;
    var reset = this.nodes.reset;

    if (!input) {
      return;
    }

    this._handleInputFocus = this._handleInputFocus.bind(this);
    this._handleInputBlur = this._handleInputBlur.bind(this);
    this._handleInputKeyup = this._handleInputKeyup.bind(this);
    this._handleInputKeydown = this._handleInputKeydown.bind(this);

    input.addEventListener('focus', this._handleInputFocus);
    input.addEventListener('blur', this._handleInputBlur);
    input.addEventListener('keyup', this._handleInputKeyup);
    input.addEventListener('keydown', this._handleInputKeydown);

    if (reset) {
      this._handleInputReset = this._handleInputReset.bind(this);
      reset.addEventListener('click', this._handleInputReset);
    }
  };

  PredictiveSearchComponent.prototype._removeInputEventListeners = function() {
    var input = this.nodes.input;

    input.removeEventListener('focus', this._handleInputFocus);
    input.removeEventListener('blur', this._handleInputBlur);
    input.removeEventListener('keyup', this._handleInputKeyup);
    input.removeEventListener('keydown', this._handleInputKeydown);
  };

  PredictiveSearchComponent.prototype._addBodyEventListener = function() {
    this._handleBodyMousedown = this._handleBodyMousedown.bind(this);

    document
      .querySelector('body')
      .addEventListener('mousedown', this._handleBodyMousedown);
  };

  PredictiveSearchComponent.prototype._removeBodyEventListener = function() {
    document
      .querySelector('body')
      .removeEventListener('mousedown', this._handleBodyMousedown);
  };

  PredictiveSearchComponent.prototype._removeClearButtonEventListener = function() {
    var reset = this.nodes.reset;

    if (!reset) {
      return;
    }

    reset.removeEventListener('click', this._handleInputReset);
  };

  /**
   * Event handlers
   */
  PredictiveSearchComponent.prototype._handleBodyMousedown = function(evt) {
    if (this.isResultVisible && this.nodes !== null) {
      if (
        evt.target.isEqualNode(this.nodes.input) ||
        this.nodes.input.contains(evt.target) ||
        evt.target.isEqualNode(this.nodes.result) ||
        this.nodes.result.contains(evt.target)
      ) {
        this._resultNodeClicked = true;
      } else {
        if (isFunction(this.callbacks.onBodyMousedown)) {
          var returnedValue = this.callbacks.onBodyMousedown(this.nodes);
          if (isBoolean(returnedValue) && returnedValue) {
            this.close();
          }
        } else {
          this.close();
        }
      }
    }
  };

  PredictiveSearchComponent.prototype._handleInputFocus = function(evt) {
    if (isFunction(this.callbacks.onInputFocus)) {
      var returnedValue = this.callbacks.onInputFocus(this.nodes);
      if (isBoolean(returnedValue) && !returnedValue) {
        return false;
      }
    }

    if (evt.target.value.length > 0) {
      this._search();
    }

    return true;
  };

  PredictiveSearchComponent.prototype._handleInputBlur = function() {
    // This has to be done async, to wait for the focus to be on the next
    // element and avoid closing the results.
    // Example: Going from the input to the reset button.
    setTimeout(
      function() {
        if (isFunction(this.callbacks.onInputBlur)) {
          var returnedValue = this.callbacks.onInputBlur(this.nodes);
          if (isBoolean(returnedValue) && !returnedValue) {
            return false;
          }
        }

        if (document.activeElement.isEqualNode(this.nodes.reset)) {
          return false;
        }

        if (this._resultNodeClicked) {
          this._resultNodeClicked = false;
          return false;
        }

        this.close();
      }.bind(this)
    );

    return true;
  };

  PredictiveSearchComponent.prototype._addAccessibilityAnnouncer = function() {
    this._accessibilityAnnouncerDiv = window.document.createElement('div');

    this._accessibilityAnnouncerDiv.setAttribute(
      'style',
      'position: absolute !important; overflow: hidden; clip: rect(0 0 0 0); height: 1px; width: 1px; margin: -1px; padding: 0; border: 0;'
    );

    this._accessibilityAnnouncerDiv.setAttribute('data-search-announcer', '');
    this._accessibilityAnnouncerDiv.setAttribute('aria-live', 'polite');
    this._accessibilityAnnouncerDiv.setAttribute('aria-atomic', 'true');

    this.nodes.result.parentElement.appendChild(
      this._accessibilityAnnouncerDiv
    );
  };

  PredictiveSearchComponent.prototype._removeAccessibilityAnnouncer = function() {
    this.nodes.result.parentElement.removeChild(
      this._accessibilityAnnouncerDiv
    );
  };

  PredictiveSearchComponent.prototype._updateAccessibilityAttributesAfterSelectingElement = function(
    previousSelectedElement,
    currentSelectedElement
  ) {
    // Update the active descendant on the search input
    this.nodes.input.setAttribute(
      'aria-activedescendant',
      currentSelectedElement.id
    );

    // Unmark the previousSelected elemented as selected
    if (previousSelectedElement) {
      previousSelectedElement.removeAttribute('aria-selected');
    }

    // Mark the element as selected
    currentSelectedElement.setAttribute('aria-selected', true);
  };

  PredictiveSearchComponent.prototype._clearAriaActiveDescendant = function() {
    this.nodes.input.setAttribute('aria-activedescendant', '');
  };

  PredictiveSearchComponent.prototype._announceNumberOfResultsFound = function(
    results
  ) {
    var currentAnnouncedMessage = this._accessibilityAnnouncerDiv.innerHTML;
    var newMessage = this.numberOfResultsTemplateFct(results);

    // If the messages are the same, they won't get announced
    // add white space so it gets announced
    if (currentAnnouncedMessage === newMessage) {
      newMessage = newMessage + '&nbsp;';
    }

    this._accessibilityAnnouncerDiv.innerHTML = newMessage;
  };

  PredictiveSearchComponent.prototype._announceLoadingState = function() {
    this._accessibilityAnnouncerDiv.innerHTML = this.loadingResultsMessageTemplateFct();
  };

  PredictiveSearchComponent.prototype._handleInputKeyup = function(evt) {
    var UP_ARROW_KEY_CODE = 38;
    var DOWN_ARROW_KEY_CODE = 40;
    var RETURN_KEY_CODE = 13;
    var ESCAPE_KEY_CODE = 27;

    if (isFunction(this.callbacks.onInputKeyup)) {
      var returnedValue = this.callbacks.onInputKeyup(this.nodes);
      if (isBoolean(returnedValue) && !returnedValue) {
        return false;
      }
    }

    this._toggleClearButtonVisibility();

    if (this.isResultVisible && this.nodes !== null) {
      if (evt.keyCode === UP_ARROW_KEY_CODE) {
        this._navigateOption(evt, 'UP');
        return true;
      }

      if (evt.keyCode === DOWN_ARROW_KEY_CODE) {
        this._navigateOption(evt, 'DOWN');
        return true;
      }

      if (evt.keyCode === RETURN_KEY_CODE) {
        this._selectOption();
        return true;
      }

      if (evt.keyCode === ESCAPE_KEY_CODE) {
        this.close();
      }
    }

    if (evt.target.value.length <= 0) {
      this.close();
      this._setKeyword('');
    } else if (evt.target.value.length > 0) {
      this._search();
    }

    return true;
  };

  PredictiveSearchComponent.prototype._handleInputKeydown = function(evt) {
    var RETURN_KEY_CODE = 13;
    var UP_ARROW_KEY_CODE = 38;
    var DOWN_ARROW_KEY_CODE = 40;

    // Prevent the form default submission if there is a selected option
    if (evt.keyCode === RETURN_KEY_CODE && this._getSelectedOption() !== null) {
      evt.preventDefault();
    }

    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (
      evt.keyCode === UP_ARROW_KEY_CODE ||
      evt.keyCode === DOWN_ARROW_KEY_CODE
    ) {
      evt.preventDefault();
    }
  };

  PredictiveSearchComponent.prototype._handleInputReset = function(evt) {
    evt.preventDefault();

    if (isFunction(this.callbacks.onInputReset)) {
      var returnedValue = this.callbacks.onInputReset(this.nodes);
      if (isBoolean(returnedValue) && !returnedValue) {
        return false;
      }
    }

    this.nodes.input.value = '';
    this.nodes.input.focus();
    this._toggleClearButtonVisibility();
    this.close();

    return true;
  };

  PredictiveSearchComponent.prototype._navigateOption = function(
    evt,
    direction
  ) {
    var currentOption = this._getSelectedOption();

    if (!currentOption) {
      var firstOption = this.nodes.result.querySelector(
        this.selectors.searchResult
      );
      firstOption.classList.add(this.classes.itemSelected);
      this._updateAccessibilityAttributesAfterSelectingElement(
        null,
        firstOption
      );
    } else {
      if (direction === 'DOWN') {
        var nextOption = currentOption.nextElementSibling;
        if (nextOption) {
          currentOption.classList.remove(this.classes.itemSelected);
          nextOption.classList.add(this.classes.itemSelected);
          this._updateAccessibilityAttributesAfterSelectingElement(
            currentOption,
            nextOption
          );
        }
      } else {
        var previousOption = currentOption.previousElementSibling;
        if (previousOption) {
          currentOption.classList.remove(this.classes.itemSelected);
          previousOption.classList.add(this.classes.itemSelected);
          this._updateAccessibilityAttributesAfterSelectingElement(
            currentOption,
            previousOption
          );
        }
      }
    }
  };

  PredictiveSearchComponent.prototype._getSelectedOption = function() {
    return this.nodes.result.querySelector('.' + this.classes.itemSelected);
  };

  PredictiveSearchComponent.prototype._selectOption = function() {
    var selectedOption = this._getSelectedOption();

    if (selectedOption) {
      selectedOption.querySelector('a, button').click();
    }
  };

  PredictiveSearchComponent.prototype._search = function() {
    var newSearchKeyword = this.nodes.input.value;

    if (this._searchKeyword === newSearchKeyword) {
      return;
    }

    clearTimeout(this._latencyTimer);
    this._latencyTimer = setTimeout(
      function() {
        this.results.isLoading = true;

        // Annonuce that we're loading the results
        this._announceLoadingState();

        this.nodes.result.classList.add(this.classes.visibleVariant);
        // NOTE: We could benifit in using DOMPurify.
        // https://github.com/cure53/DOMPurify
        this.nodes.result.innerHTML = this.resultTemplateFct(this.results);
      }.bind(this),
      500
    );

    this.predictiveSearch.query(newSearchKeyword);
    this._setKeyword(newSearchKeyword);
  };

  PredictiveSearchComponent.prototype._handlePredictiveSearchSuccess = function(
    json
  ) {
    clearTimeout(this._latencyTimer);
    this.results = json.resources.results;

    this.results.isLoading = false;
    this.results.products = this.results.products.slice(
      0,
      this.numberOfResults
    );
    this.results.canLoadMore =
      this.numberOfResults <= this.results.products.length;
    this.results.searchQuery = this.nodes.input.value;

    if (this.results.products.length > 0 || this.results.searchQuery) {
      this.nodes.result.innerHTML = this.resultTemplateFct(this.results);
      this._announceNumberOfResultsFound(this.results);
      this.open();
    } else {
      this.nodes.result.innerHTML = '';

      this._closeOnNoResults();
    }
  };

  PredictiveSearchComponent.prototype._handlePredictiveSearchError = function() {
    clearTimeout(this._latencyTimer);
    this.nodes.result.innerHTML = '';

    this._closeOnNoResults();
  };

  PredictiveSearchComponent.prototype._closeOnNoResults = function() {
    if (this.nodes) {
      this.nodes.result.classList.remove(this.classes.visibleVariant);
    }

    this.isResultVisible = false;
  };

  PredictiveSearchComponent.prototype._setKeyword = function(keyword) {
    this._searchKeyword = keyword;
  };

  PredictiveSearchComponent.prototype._toggleClearButtonVisibility = function() {
    if (!this.nodes.reset) {
      return;
    }

    if (this.nodes.input.value.length > 0) {
      this.nodes.reset.classList.add(this.classes.clearButtonVisible);
    } else {
      this.nodes.reset.classList.remove(this.classes.clearButtonVisible);
    }
  };

  /**
   * Public methods
   */
  PredictiveSearchComponent.prototype.open = function() {
    if (this.isResultVisible) {
      return;
    }

    if (isFunction(this.callbacks.onBeforeOpen)) {
      var returnedValue = this.callbacks.onBeforeOpen(this.nodes);
      if (isBoolean(returnedValue) && !returnedValue) {
        return false;
      }
    }

    this.nodes.result.classList.add(this.classes.visibleVariant);
    this.nodes.input.setAttribute('aria-expanded', true);
    this.isResultVisible = true;

    if (isFunction(this.callbacks.onOpen)) {
      return this.callbacks.onOpen(this.nodes) || true;
    }

    return true;
  };

  PredictiveSearchComponent.prototype.close = function() {
    if (!this.isResultVisible) {
      return true;
    }

    if (isFunction(this.callbacks.onBeforeClose)) {
      var returnedValue = this.callbacks.onBeforeClose(this.nodes);
      if (isBoolean(returnedValue) && !returnedValue) {
        return false;
      }
    }

    if (this.nodes) {
      this.nodes.result.classList.remove(this.classes.visibleVariant);
    }

    this.nodes.input.setAttribute('aria-expanded', false);
    this._clearAriaActiveDescendant();
    this._setKeyword('');

    if (isFunction(this.callbacks.onClose)) {
      this.callbacks.onClose(this.nodes);
    }

    this.isResultVisible = false;
    this.results = {};

    return true;
  };

  PredictiveSearchComponent.prototype.destroy = function() {
    this.close();

    if (isFunction(this.callbacks.onBeforeDestroy)) {
      var returnedValue = this.callbacks.onBeforeDestroy(this.nodes);
      if (isBoolean(returnedValue) && !returnedValue) {
        return false;
      }
    }

    this.nodes.result.classList.remove(this.classes.visibleVariant);
    removeInputAttributes(this.nodes.input);
    this._removeInputEventListeners();
    this._removeBodyEventListener();
    this._removeAccessibilityAnnouncer();
    this._removeClearButtonEventListener();

    if (isFunction(this.callbacks.onDestroy)) {
      this.callbacks.onDestroy(this.nodes);
    }

    return true;
  };

  PredictiveSearchComponent.prototype.clearAndClose = function() {
    this.nodes.input.value = '';
    this.close();
  };

  /**
   * Utilities
   */
  function getTypeOf(value) {
    return Object.prototype.toString.call(value);
  }

  function isString(value) {
    return getTypeOf(value) === '[object String]';
  }

  function isBoolean(value) {
    return getTypeOf(value) === '[object Boolean]';
  }

  function isFunction(value) {
    return getTypeOf(value) === '[object Function]';
  }

  return PredictiveSearchComponent;
})(Shopify.theme.PredictiveSearch);

window.theme = window.theme || {};

theme.TouchEvents = function TouchEvents(element, options) {
  this.axis;
  this.checkEvents = [];
  this.eventHandlers = {};
  this.eventModel = {};
  this.events = [
    ['touchstart', 'touchmove', 'touchend', 'touchcancel'],
    ['pointerdown', 'pointermove', 'pointerup', 'pointercancel'],
    ['mousedown', 'mousemove', 'mouseup']
  ];
  this.eventType;
  this.difference = {};
  this.direction;
  this.start = {};

  this.element = element;
  this.options = Object.assign(
    {},
    {
      dragThreshold: 10,
      start: function() {}, // eslint-disable-line
      move: function() {}, // eslint-disable-line
      end: function() {} // eslint-disable-line
    },
    options
  );

  this.checkEvents = this._getCheckEvents();
  this.eventModel = this._getEventModel();

  this._setupEventHandlers();
};

theme.TouchEvents.prototype = Object.assign({}, theme.TouchEvents.prototype, {
  destroy: function() {
    this.element.removeEventListener(
      'dragstart',
      this.eventHandlers.preventDefault
    );

    this.element.removeEventListener(
      this.events[this.eventModel][0],
      this.eventHandlers.touchStart
    );

    if (!this.eventModel) {
      this.element.removeEventListener(
        this.events[2][0],
        this.eventHandlers.touchStart
      );
    }

    this.element.removeEventListener('click', this.eventHandlers.preventClick);
  },

  _setupEventHandlers: function() {
    this.eventHandlers.preventDefault = this._preventDefault.bind(this);
    this.eventHandlers.preventClick = this._preventClick.bind(this);
    this.eventHandlers.touchStart = this._touchStart.bind(this);
    this.eventHandlers.touchMove = this._touchMove.bind(this);
    this.eventHandlers.touchEnd = this._touchEnd.bind(this);

    // Prevent element from dragging when using mouse
    this.element.addEventListener(
      'dragstart',
      this.eventHandlers.preventDefault
    );

    // Bind the touchstart/pointerdown event
    this.element.addEventListener(
      this.events[this.eventModel][0],
      this.eventHandlers.touchStart
    );

    // Bind mousedown if necessary
    if (!this.eventModel) {
      this.element.addEventListener(
        this.events[2][0],
        this.eventHandlers.touchStart
      );
    }

    // No clicking during touch
    this.element.addEventListener('click', this.eventHandlers.preventClick);
  },

  _touchStart: function(event) {
    this.eventType = this.eventModel;

    if (event.type === 'mousedown' && !this.eventModel) {
      this.eventType = 2;
    }

    if (this.checkEvents[this.eventType](event)) return;
    if (this.eventType) this._preventDefault(event);

    document.addEventListener(
      this.events[this.eventType][1],
      this.eventHandlers.touchMove
    );

    document.addEventListener(
      this.events[this.eventType][2],
      this.eventHandlers.touchEnd
    );

    if (this.eventType < 2) {
      document.addEventListener(
        this.events[this.eventType][3],
        this.eventHandlers.touchEnd
      );
    }

    this.start = {
      xPosition: this.eventType ? event.clientX : event.touches[0].clientX,
      yPosition: this.eventType ? event.clientY : event.touches[0].clientY,
      time: new Date().getTime()
    };

    // Ensure we empty out the this.difference object
    Object.keys(this.difference).forEach(
      function(key) {
        delete this.difference[key];
      }.bind(this)
    );

    this.options.start(event);
  },

  _touchMove: function(event) {
    this.difference = this._getDifference(event);

    // Prevent document from scrolling during swipe gesture
    document['on' + this.events[this.eventType][1]] = function(event) {
      this._preventDefault(event);
    }.bind(this);

    // Get the direction user is dragging
    if (!this.axis) {
      if (this.options.dragThreshold < Math.abs(this.difference.xPosition)) {
        this.axis = 'xPosition';
      } else if (
        this.options.dragThreshold < Math.abs(this.difference.yPosition)
      ) {
        this.axis = 'yPosition';
      } else {
        this.axis = false;
      }
    } else if (this.axis === 'xPosition') {
      this.direction = this.difference.xPosition < 0 ? 'left' : 'right';
    } else if (this.axis === 'yPosition') {
      this.direction = this.difference.yPosition < 0 ? 'up' : 'down';
    }

    this.options.move(event, this.direction, this.difference);
  },

  _touchEnd: function(event) {
    document.removeEventListener(
      this.events[this.eventType][1],
      this.eventHandlers.touchMove
    );

    document.removeEventListener(
      this.events[this.eventType][2],
      this.eventHandlers.touchEnd
    );

    if (this.eventType < 2) {
      document.removeEventListener(
        this.events[this.eventType][3],
        this.eventHandlers.touchEnd
      );
    }

    // Re-enable document scrolling
    document['on' + this.events[this.eventType][1]] = function() {
      return true;
    };

    this.options.end(event, this.direction, this.difference);
    this.axis = false;
  },

  _getDifference: function(event) {
    return {
      xPosition:
        (this.eventType ? event.clientX : event.touches[0].clientX) -
        this.start.xPosition,
      yPosition:
        (this.eventType ? event.clientY : event.touches[0].clientY) -
        this.start.yPosition,
      time: new Date().getTime() - this.start.time
    };
  },

  _getCheckEvents: function() {
    return [
      // Touch events
      function(event) {
        // Skip the event if it's a multi-touch or pinch move
        return (
          (event.touches && event.touches.length > 1) ||
          (event.scale && event.scale !== 1)
        );
      },
      // Pointer events
      function(event) {
        // Skip it, if:
        // 1. The event is not primary (other pointers during multi-touch),
        // 2. Left mouse button is not pressed,
        // 3. Event is not a touch event
        return (
          !event.isPrimary ||
          (event.buttons && event.buttons !== 1) ||
          (event.pointerType !== 'touch' && event.pointerType !== 'pen')
        );
      },
      // Mouse events
      function(event) {
        // Skip the event if left mouse button is not pressed
        return event.buttons && event.buttons !== 1;
      }
    ];
  },

  _getEventModel: function() {
    return window.navigator.pointerEnabled ? 1 : 0;
  },

  _preventDefault: function(event) {
    event.preventDefault ? event.preventDefault() : (event.returnValue = false);
  },

  _preventClick: function(event) {
    if (Math.abs(this.difference.xPosition) > this.options.dragThreshold) {
      this._preventDefault(event);
    }
  }
});


/* ================ GLOBAL ================ */
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function() {
  function Drawer(id, position, options) {
    var DEFAULT_OPEN_CLASS = 'js-drawer-open';
    var DEFAULT_CLOSE_CLASS = 'js-drawer-close';

    var defaults = {
      selectors: {
        openVariant: '.' + DEFAULT_OPEN_CLASS + '-' + position,
        close: '.' + DEFAULT_CLOSE_CLASS
      },
      classes: {
        open: DEFAULT_OPEN_CLASS,
        openVariant: DEFAULT_OPEN_CLASS + '-' + position
      },
      withPredictiveSearch: false
    };

    this.nodes = {
      parents: [document.documentElement, document.body],
      page: document.getElementById('PageContainer')
    };

    this.eventHandlers = {};

    this.config = Object.assign({}, defaults, options);
    this.position = position;
    this.drawer = document.getElementById(id);

    if (!this.drawer) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function() {
    document
      .querySelector(this.config.selectors.openVariant)
      .addEventListener('click', this.open.bind(this));
    this.drawer
      .querySelector(this.config.selectors.close)
      .addEventListener('click', this.close.bind(this));
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.activeSource = evt.currentTarget;
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    if (!this.config.withPredictiveSearch) {
      theme.Helpers.prepareTransition(this.drawer);
    }

    this.nodes.parents.forEach(
      function(parent) {
        parent.classList.add(
          this.config.classes.open,
          this.config.classes.openVariant
        );
      }.bind(this)
    );

    this.drawerIsOpen = true;

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.activeSource && this.activeSource.hasAttribute('aria-expanded')) {
      this.activeSource.setAttribute('aria-expanded', 'true');
    }

    // Set focus on drawer
    var trapFocusConfig = {
      container: this.drawer
    };

    if (this.config.elementToFocusOnOpen) {
      trapFocusConfig.elementToFocus = this.config.elementToFocusOnOpen;
    }

    slate.a11y.trapFocus(trapFocusConfig);

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) {
      // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    document.activeElement.dispatchEvent(
      new CustomEvent('blur', { bubbles: true, cancelable: true })
    );

    // Ensure closing transition is applied to moved elements, like the nav
    if (!this.config.withPredictiveSearch) {
      theme.Helpers.prepareTransition(this.drawer);
    }

    this.nodes.parents.forEach(
      function(parent) {
        parent.classList.remove(
          this.config.classes.open,
          this.config.classes.openVariant
        );
      }.bind(this)
    );

    if (this.activeSource && this.activeSource.hasAttribute('aria-expanded')) {
      this.activeSource.setAttribute('aria-expanded', 'false');
    }

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      container: this.drawer
    });

    this.unbindEvents();

    // Run function when draw closes if set
    if (
      this.config.onDrawerClose &&
      typeof this.config.onDrawerClose === 'function'
    ) {
      this.config.onDrawerClose();
    }
  };

  Drawer.prototype.bindEvents = function() {
    this.eventHandlers.drawerKeyupHandler = function(evt) {
      // close on 'esc' keypress
      if (evt.keyCode === 27) {
        this.close();
        return false;
      } else {
        return true;
      }
    }.bind(this);

    this.eventHandlers.drawerTouchmoveHandler = function() {
      return false;
    };

    this.eventHandlers.drawerClickHandler = function() {
      this.close();
      return false;
    }.bind(this);

    // Add event listener to document body
    document.body.addEventListener(
      'keyup',
      this.eventHandlers.drawerKeyupHandler
    );

    // Lock scrolling on mobile
    this.nodes.page.addEventListener(
      'touchmove',
      this.eventHandlers.drawerTouchmoveHandler
    );

    this.nodes.page.addEventListener(
      'click',
      this.eventHandlers.drawerClickHandler
    );
  };

  Drawer.prototype.unbindEvents = function() {
    this.nodes.page.removeEventListener(
      'touchmove',
      this.eventHandlers.drawerTouchmoveHandler
    );
    this.nodes.page.removeEventListener(
      'click',
      this.eventHandlers.drawerClickHandler
    );
    document.body.removeEventListener(
      'keyup',
      this.eventHandlers.drawerKeyupHandler
    );
  };

  return Drawer;
})();

theme.Helpers = (function() {
  var touchDevice = false;

  var classes = {
    preventScrolling: 'prevent-scrolling'
  };

  var scrollPosition = window.pageYOffset;

  function setTouch() {
    touchDevice = true;
  }

  function isTouch() {
    return touchDevice;
  }

  function enableScrollLock() {
    scrollPosition = window.pageYOffset;
    document.body.style.top = '-' + scrollPosition + 'px';
    document.body.classList.add(classes.preventScrolling);
  }

  function disableScrollLock() {
    document.body.classList.remove(classes.preventScrolling);
    document.body.style.removeProperty('top');
    window.scrollTo(0, scrollPosition);
  }

  function debounce(func, wait, immediate) {
    var timeout;

    return function() {
      var context = this,
        args = arguments;

      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };

      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  function getScript(source, beforeEl) {
    return new Promise(function(resolve, reject) {
      var script = document.createElement('script');
      var prior = beforeEl || document.getElementsByTagName('script')[0];

      script.async = true;
      script.defer = true;

      // eslint-disable-next-line shopify/prefer-early-return
      function onloadHander(_, isAbort) {
        if (
          isAbort ||
          !script.readyState ||
          /loaded|complete/.test(script.readyState)
        ) {
          script.onload = null;
          script.onreadystatechange = null;
          script = undefined;

          if (isAbort) {
            reject();
          } else {
            resolve();
          }
        }
      }

      script.onload = onloadHander;
      script.onreadystatechange = onloadHander;

      script.src = source;
      prior.parentNode.insertBefore(script, prior);
    });
  }

  /* Based on the prepareTransition by Jonathan Snook */
  /* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
  function prepareTransition(element) {
    element.addEventListener(
      'transitionend',
      function(event) {
        event.currentTarget.classList.remove('is-transitioning');
      },
      { once: true }
    );

    var properties = [
      'transition-duration',
      '-moz-transition-duration',
      '-webkit-transition-duration',
      '-o-transition-duration'
    ];

    var duration = 0;

    properties.forEach(function(property) {
      var computedValue = getComputedStyle(element)[property];

      if (computedValue) {
        computedValue.replace(/\D/g, '');
        duration || (duration = parseFloat(computedValue));
      }
    });

    if (duration !== 0) {
      element.classList.add('is-transitioning');
      element.offsetWidth;
    }
  }

  /*!
   * Serialize all form data into a SearchParams string
   * (c) 2020 Chris Ferdinandi, MIT License, https://gomakethings.com
   * @param  {Node}   form The form to serialize
   * @return {String}      The serialized form data
   */
  function serialize(form) {
    var arr = [];
    Array.prototype.slice.call(form.elements).forEach(function(field) {
      if (
        !field.name ||
        field.disabled ||
        ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
      )
        return;
      if (field.type === 'select-multiple') {
        Array.prototype.slice.call(field.options).forEach(function(option) {
          if (!option.selected) return;
          arr.push(
            encodeURIComponent(field.name) +
              '=' +
              encodeURIComponent(option.value)
          );
        });
        return;
      }
      if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
        return;
      arr.push(
        encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
      );
    });
    return arr.join('&');
  }
  function cookiesEnabled() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = 'testcookie';
      cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
    }

    return cookieEnabled;
  }

  function promiseStylesheet(stylesheet) {
    var stylesheetUrl = stylesheet || theme.stylesheet;

    if (typeof this.stylesheetPromise === 'undefined') {
      this.stylesheetPromise = new Promise(function(resolve) {
        var link = document.querySelector('link[href="' + stylesheetUrl + '"]');

        if (link.loaded) resolve();

        link.addEventListener('load', function() {
          setTimeout(resolve, 0);
        });
      });
    }

    return this.stylesheetPromise;
  }

  return {
    setTouch: setTouch,
    isTouch: isTouch,
    enableScrollLock: enableScrollLock,
    disableScrollLock: disableScrollLock,
    debounce: debounce,
    getScript: getScript,
    prepareTransition: prepareTransition,
    serialize: serialize,
    cookiesEnabled: cookiesEnabled,
    promiseStylesheet: promiseStylesheet
  };
})();

theme.LibraryLoader = (function() {
  var types = {
    link: 'link',
    script: 'script'
  };

  var status = {
    requested: 'requested',
    loaded: 'loaded'
  };

  var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';

  var libraries = {
    plyrShopifyStyles: {
      tagId: 'plyr-shopify-styles',
      src: cloudCdn + 'plyr/v2.0/shopify-plyr.css',
      type: types.link
    },
    modelViewerUiStyles: {
      tagId: 'shopify-model-viewer-ui-styles',
      src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
      type: types.link
    }
  };

  function load(libraryName, callback) {
    var library = libraries[libraryName];

    if (!library) return;
    if (library.status === status.requested) return;

    callback = callback || function() {};
    if (library.status === status.loaded) {
      callback();
      return;
    }

    library.status = status.requested;

    var tag;

    switch (library.type) {
      case types.script:
        tag = createScriptTag(library, callback);
        break;
      case types.link:
        tag = createLinkTag(library, callback);
        break;
    }

    tag.id = library.tagId;
    library.element = tag;

    var firstScriptTag = document.getElementsByTagName(library.type)[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  function createScriptTag(library, callback) {
    var tag = document.createElement('script');
    tag.src = library.src;
    tag.addEventListener('load', function() {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  function createLinkTag(library, callback) {
    var tag = document.createElement('link');
    tag.href = library.src;
    tag.rel = 'stylesheet';
    tag.type = 'text/css';
    tag.addEventListener('load', function() {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  return {
    load: load
  };
})();


/* ================ MODULES ================ */
window.theme = window.theme || {};

theme.Header = (function() {
  var selectors = {
    body: 'body',
    navigation: '#AccessibleNav',
    siteNavHasDropdown: '[data-has-dropdowns]',
    siteNavChildLinks: '.site-nav__child-link',
    siteNavActiveDropdown: '.site-nav--active-dropdown',
    siteNavHasCenteredDropdown: '.site-nav--has-centered-dropdown',
    siteNavCenteredDropdown: '.site-nav__dropdown--centered',
    siteNavLinkMain: '.site-nav__link--main',
    siteNavChildLink: '.site-nav__link--last',
    siteNavDropdown: '.site-nav__dropdown',
    siteHeader: '.site-header'
  };

  var config = {
    activeClass: 'site-nav--active-dropdown',
    childLinkClass: 'site-nav__child-link',
    rightDropdownClass: 'site-nav__dropdown--right',
    leftDropdownClass: 'site-nav__dropdown--left'
  };

  var cache = {};

  function init() {
    cacheSelectors();
    styleDropdowns(document.querySelectorAll(selectors.siteNavHasDropdown));
    positionFullWidthDropdowns();

    cache.parents.forEach(function(element) {
      element.addEventListener('click', submenuParentClickHandler);
    });

    // check when we're leaving a dropdown and close the active dropdown
    cache.siteNavChildLink.forEach(function(element) {
      element.addEventListener('focusout', submenuFocusoutHandler);
    });

    cache.topLevel.forEach(function(element) {
      element.addEventListener('focus', hideDropdown);
    });

    cache.subMenuLinks.forEach(function(element) {
      element.addEventListener('click', stopImmediatePropagation);
    });

    window.addEventListener('resize', resizeHandler);
  }

  function stopImmediatePropagation(event) {
    event.stopImmediatePropagation();
  }

  function cacheSelectors() {
    var navigation = document.querySelector(selectors.navigation);

    cache = {
      nav: navigation,
      topLevel: document.querySelectorAll(selectors.siteNavLinkMain),
      parents: navigation.querySelectorAll(selectors.siteNavHasDropdown),
      subMenuLinks: document.querySelectorAll(selectors.siteNavChildLinks),
      activeDropdown: document.querySelector(selectors.siteNavActiveDropdown),
      siteHeader: document.querySelector(selectors.siteHeader),
      siteNavChildLink: document.querySelectorAll(selectors.siteNavChildLink)
    };
  }

  function showDropdown(element) {
    element.classList.add(config.activeClass);

    if (cache.activeDropdown) hideDropdown();

    cache.activeDropdown = element;

    element
      .querySelector(selectors.siteNavLinkMain)
      .setAttribute('aria-expanded', 'true');

    setTimeout(function() {
      window.addEventListener('keyup', keyUpHandler);
      document.body.addEventListener('click', hideDropdown);
    }, 250);
  }

  function hideDropdown() {
    if (!cache.activeDropdown) return;

    cache.activeDropdown
      .querySelector(selectors.siteNavLinkMain)
      .setAttribute('aria-expanded', 'false');
    cache.activeDropdown.classList.remove(config.activeClass);

    cache.activeDropdown = document.querySelector(
      selectors.siteNavActiveDropdown
    );

    window.removeEventListener('keyup', keyUpHandler);
    document.body.removeEventListener('click', hideDropdown);
  }

  function styleDropdowns(dropdownListItems) {
    dropdownListItems.forEach(function(item) {
      var dropdownLi = item.querySelector(selectors.siteNavDropdown);

      if (!dropdownLi) return;

      if (isRightOfLogo(item)) {
        dropdownLi.classList.remove(config.leftDropdownClass);
        dropdownLi.classList.add(config.rightDropdownClass);
      } else {
        dropdownLi.classList.remove(config.rightDropdownClass);
        dropdownLi.classList.add(config.leftDropdownClass);
      }
    });
  }

  function isRightOfLogo(item) {
    var rect = item.getBoundingClientRect();
    var win = item.ownerDocument.defaultView;
    var leftOffset = rect.left + win.pageXOffset;

    var headerWidth = Math.floor(cache.siteHeader.offsetWidth) / 2;
    return leftOffset > headerWidth;
  }

  function positionFullWidthDropdowns() {
    document
      .querySelectorAll(selectors.siteNavHasCenteredDropdown)
      .forEach(function(el) {
        var fullWidthDropdown = el.querySelector(
          selectors.siteNavCenteredDropdown
        );

        var fullWidthDropdownOffset = el.offsetTop + 41;
        fullWidthDropdown.style.top = fullWidthDropdownOffset + 'px';
      });
  }

  function keyUpHandler(event) {
    if (event.keyCode === 27) hideDropdown();
  }

  function resizeHandler() {
    adjustStyleAndPosition();
  }

  function submenuParentClickHandler(event) {
    var element = event.currentTarget;

    element.classList.contains(config.activeClass)
      ? hideDropdown()
      : showDropdown(element);
  }

  function submenuFocusoutHandler() {
    setTimeout(function() {
      if (
        document.activeElement.classList.contains(config.childLinkClass) ||
        !cache.activeDropdown
      ) {
        return;
      }

      hideDropdown();
    });
  }

  var adjustStyleAndPosition = theme.Helpers.debounce(function() {
    styleDropdowns(document.querySelectorAll(selectors.siteNavHasDropdown));
    positionFullWidthDropdowns();
  }, 50);

  function unload() {
    cache.topLevel.forEach(function(element) {
      element.removeEventListener('focus', hideDropdown);
    });

    cache.subMenuLinks.forEach(function(element) {
      element.removeEventListener('click', stopImmediatePropagation);
    });

    cache.parents.forEach(function(element) {
      element.removeEventListener('click', submenuParentClickHandler);
    });

    cache.siteNavChildLink.forEach(function(element) {
      element.removeEventListener('focusout', submenuFocusoutHandler);
    });

    window.removeEventListener('resize', resizeHandler);
    window.removeEventListener('keyup', keyUpHandler);
    document.body.removeEventListener('click', hideDropdown);
  }

  return {
    init: init,
    unload: unload
  };
})();

window.theme = window.theme || {};

theme.MobileNav = (function() {
  var classes = {
    mobileNavOpenIcon: 'mobile-nav--open',
    mobileNavCloseIcon: 'mobile-nav--close',
    navLinkWrapper: 'mobile-nav__item',
    navLink: 'mobile-nav__link',
    subNavLink: 'mobile-nav__sublist-link',
    return: 'mobile-nav__return-btn',
    subNavActive: 'is-active',
    subNavClosing: 'is-closing',
    navOpen: 'js-menu--is-open',
    subNavShowing: 'sub-nav--is-open',
    thirdNavShowing: 'third-nav--is-open',
    subNavToggleBtn: 'js-toggle-submenu'
  };

  var cache = {};
  var isTransitioning;
  var activeSubNav;
  var activeTrigger;
  var menuLevel = 1;
  var mediumUpQuery = '(min-width: ' + theme.breakpoints.medium + 'px)';
  var mql = window.matchMedia(mediumUpQuery);

  function init() {
    cacheSelectors();

    if (cache.mobileNavToggle) {
      cache.mobileNavToggle.addEventListener('click', toggleMobileNav);
    }

    cache.subNavToggleBtns.forEach(function(element) {
      element.addEventListener('click', toggleSubNav);
    });

    mql.addListener(initBreakpoints);
  }

  function initBreakpoints() {
    if (
      mql.matches &&
      cache.mobileNavContainer.classList.contains(classes.navOpen)
    ) {
      closeMobileNav();
    }
  }

  function toggleMobileNav() {
    var mobileNavIsOpen = cache.mobileNavToggle.classList.contains(
      classes.mobileNavCloseIcon
    );

    if (mobileNavIsOpen) {
      closeMobileNav();
    } else {
      openMobileNav();
    }
  }

  function cacheSelectors() {
    cache = {
      pageContainer: document.querySelector('#PageContainer'),
      siteHeader: document.querySelector('.site-header'),
      mobileNavToggle: document.querySelector('.js-mobile-nav-toggle'),
      mobileNavContainer: document.querySelector('.mobile-nav-wrapper'),
      mobileNav: document.querySelector('#MobileNav'),
      sectionHeader: document.querySelector('#shopify-section-header'),
      subNavToggleBtns: document.querySelectorAll('.' + classes.subNavToggleBtn)
    };
  }

  function openMobileNav() {
    var translateHeaderHeight = cache.siteHeader.offsetHeight;

    theme.Helpers.prepareTransition(cache.mobileNavContainer);
    cache.mobileNavContainer.classList.add(classes.navOpen);

    cache.mobileNavContainer.style.transform =
      'translateY(' + translateHeaderHeight + 'px)';

    cache.pageContainer.style.transform =
      'translate3d(0, ' + cache.mobileNavContainer.scrollHeight + 'px, 0)';

    slate.a11y.trapFocus({
      container: cache.sectionHeader,
      elementToFocus: cache.mobileNavToggle
    });

    cache.mobileNavToggle.classList.add(classes.mobileNavCloseIcon);
    cache.mobileNavToggle.classList.remove(classes.mobileNavOpenIcon);
    cache.mobileNavToggle.setAttribute('aria-expanded', true);

    window.addEventListener('keyup', keyUpHandler);
  }

  function keyUpHandler(event) {
    if (event.which === 27) {
      closeMobileNav();
    }
  }

  function closeMobileNav() {
    theme.Helpers.prepareTransition(cache.mobileNavContainer);
    cache.mobileNavContainer.classList.remove(classes.navOpen);
    cache.mobileNavContainer.style.transform = 'translateY(-100%)';
    cache.pageContainer.setAttribute('style', '');

    slate.a11y.trapFocus({
      container: document.querySelector('html'),
      elementToFocus: document.body
    });

    cache.mobileNavContainer.addEventListener(
      'transitionend',
      mobileNavRemoveTrapFocus,
      { once: true }
    );

    cache.mobileNavToggle.classList.add(classes.mobileNavOpenIcon);
    cache.mobileNavToggle.classList.remove(classes.mobileNavCloseIcon);
    cache.mobileNavToggle.setAttribute('aria-expanded', false);
    cache.mobileNavToggle.focus();

    window.removeEventListener('keyup', keyUpHandler);
    window.scrollTo(0, 0);
  }

  function mobileNavRemoveTrapFocus() {
    slate.a11y.removeTrapFocus({
      container: cache.mobileNav
    });
  }

  function toggleSubNav(event) {
    if (isTransitioning) return;

    var toggleBtn = event.currentTarget;
    var isReturn = toggleBtn.classList.contains(classes.return);

    isTransitioning = true;

    if (isReturn) {
      var subNavToggleBtn = document.querySelectorAll(
        '.' + classes.subNavToggleBtn + "[data-level='" + (menuLevel - 1) + "']"
      );

      subNavToggleBtn.forEach(function(element) {
        element.classList.remove(classes.subNavActive);
      });

      if (activeTrigger) {
        activeTrigger.classList.remove(classes.subNavActive);
      }
    } else {
      toggleBtn.classList.add(classes.subNavActive);
    }

    activeTrigger = toggleBtn;

    goToSubnav(toggleBtn.getAttribute('data-target'));
  }

  function goToSubnav(target) {
    var targetMenu = target
      ? document.querySelector(
          '.mobile-nav__dropdown[data-parent="' + target + '"]'
        )
      : cache.mobileNav;

    menuLevel = targetMenu.dataset.level ? Number(targetMenu.dataset.level) : 1;

    if (activeSubNav) {
      theme.Helpers.prepareTransition(activeSubNav);
      activeSubNav.classList.add(classes.subNavClosing);
    }

    activeSubNav = targetMenu;

    var translateMenuHeight = targetMenu.offsetHeight;

    var openNavClass =
      menuLevel > 2 ? classes.thirdNavShowing : classes.subNavShowing;

    cache.mobileNavContainer.style.height = translateMenuHeight + 'px';
    cache.mobileNavContainer.classList.remove(classes.thirdNavShowing);
    cache.mobileNavContainer.classList.add(openNavClass);

    if (!target) {
      cache.mobileNavContainer.classList.remove(
        classes.thirdNavShowing,
        classes.subNavShowing
      );
    }

    /* if going back to first subnav, focus is on whole header */
    var container = menuLevel === 1 ? cache.sectionHeader : targetMenu;

    cache.mobileNavContainer.addEventListener(
      'transitionend',
      trapMobileNavFocus,
      { once: true }
    );

    function trapMobileNavFocus() {
      slate.a11y.trapFocus({
        container: container
      });

      cache.mobileNavContainer.removeEventListener(
        'transitionend',
        trapMobileNavFocus
      );

      isTransitioning = false;
    }

    // Match height of subnav
    cache.pageContainer.style.transform =
      'translateY(' + translateMenuHeight + 'px)';

    activeSubNav.classList.remove(classes.subNavClosing);
  }

  function unload() {
    mql.removeListener(initBreakpoints);
  }

  return {
    init: init,
    unload: unload,
    closeMobileNav: closeMobileNav
  };
})();

window.Modals = (function() {
  function Modal(id, name, options) {
    var defaults = {
      close: '.js-modal-close',
      open: '.js-modal-open-' + name,
      openClass: 'modal--is-active',
      closeModalOnClick: false
    };

    this.modal = document.getElementById(id);

    if (!this.modal) return false;

    this.nodes = {
      parents: [document.querySelector('html'), document.body]
    };

    this.config = Object.assign(defaults, options);

    this.modalIsOpen = false;

    this.focusOnOpen = this.config.focusOnOpen
      ? document.getElementById(this.config.focusOnOpen)
      : this.modal;

    this.openElement = document.querySelector(this.config.open);
    this.init();
  }

  Modal.prototype.init = function() {
    this.openElement.addEventListener('click', this.open.bind(this));

    this.modal
      .querySelector(this.config.close)
      .addEventListener('click', this.closeModal.bind(this));
  };

  Modal.prototype.open = function(evt) {
    var self = this;
    // Keep track if modal was opened from a click, or called by another function
    var externalCall = false;

    if (this.modalIsOpen) return;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the modal opens, the click event bubbles up
    // which closes the modal.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
    }

    if (this.modalIsOpen && !externalCall) {
      this.closeModal();
    }

    this.modal.classList.add(this.config.openClass);

    this.nodes.parents.forEach(function(node) {
      node.classList.add(self.config.openClass);
    });

    this.modalIsOpen = true;

    slate.a11y.trapFocus({
      container: this.modal,
      elementToFocus: this.focusOnOpen
    });

    this.bindEvents();
  };

  Modal.prototype.closeModal = function() {
    if (!this.modalIsOpen) return;

    document.activeElement.blur();

    this.modal.classList.remove(this.config.openClass);

    var self = this;

    this.nodes.parents.forEach(function(node) {
      node.classList.remove(self.config.openClass);
    });

    this.modalIsOpen = false;

    slate.a11y.removeTrapFocus({
      container: this.modal
    });

    this.openElement.focus();

    this.unbindEvents();
  };

  Modal.prototype.bindEvents = function() {
    this.keyupHandler = this.keyupHandler.bind(this);
    this.clickHandler = this.clickHandler.bind(this);
    document.body.addEventListener('keyup', this.keyupHandler);
    document.body.addEventListener('click', this.clickHandler);
  };

  Modal.prototype.unbindEvents = function() {
    document.body.removeEventListener('keyup', this.keyupHandler);
    document.body.removeEventListener('click', this.clickHandler);
  };

  Modal.prototype.keyupHandler = function(event) {
    if (event.keyCode === 27) {
      this.closeModal();
    }
  };

  Modal.prototype.clickHandler = function(event) {
    if (this.config.closeModalOnClick && !this.modal.contains(event.target)) {
      this.closeModal();
    }
  };

  return Modal;
})();

(function() {
  var selectors = {
    backButton: '.return-link'
  };

  var backButton = document.querySelector(selectors.backButton);

  if (!document.referrer || !backButton || !window.history.length) {
    return;
  }

  backButton.addEventListener(
    'click',
    function(evt) {
      evt.preventDefault();

      var referrerDomain = urlDomain(document.referrer);
      var shopDomain = urlDomain(window.location.href);

      if (shopDomain === referrerDomain) {
        history.back();
      }

      return false;
    },
    { once: true }
  );

  function urlDomain(url) {
    var anchor = document.createElement('a');
    anchor.ref = url;

    return anchor.hostname;
  }
})();

theme.Slideshow = (function() {
  var selectors = {
    button: '[data-slider-button]',
    indicator: '[data-slider-indicator]',
    indicators: '[data-slider-indicators]',
    pause: '[data-slider-pause]',
    slider: '[data-slider]',
    sliderItem: '[data-slider-item]',
    sliderItemLink: '[data-slider-item-link]',
    sliderTrack: '[data-slider-track]',
    sliderContainer: '[data-slider-container]'
  };

  var classes = {
    isPaused: 'slideshow__pause--is-paused',
    indicator: 'slider-indicators__item',
    indicatorActive: 'slick-active',
    sliderInitialized: 'slick-initialized',
    slideActive: 'slideshow__slide--active',
    slideClone: 'slick-cloned'
  };

  var attributes = {
    buttonNext: 'data-slider-button-next'
  };

  function Slideshow(container, options) {
    this.container = container;
    this.slider = this.container.querySelector(selectors.slider);

    if (!this.slider) return;

    this.eventHandlers = {};
    this.lastSlide = 0;
    this.slideIndex = 0;
    this.sliderContainer = null;
    this.slides = [];
    this.options = Object.assign(
      {},
      {
        autoplay: false,
        canUseKeyboardArrows: true,
        canUseTouchEvents: false,
        slideActiveClass: classes.slideActive,
        slideInterval: 0,
        slidesToShow: 0,
        slidesToScroll: 1,
        type: 'fade'
      },
      options
    );

    this.sliderContainer = this.slider.querySelector(selectors.sliderContainer);
    this.adaptHeight =
      this.sliderContainer.getAttribute('data-adapt-height') === 'true';
    this.slides = Array.from(
      this.sliderContainer.querySelectorAll(selectors.sliderItem)
    );
    // adding -1 to accomodate Array order
    this.lastSlide = this.slides.length - 1;
    this.buttons = this.container.querySelectorAll(selectors.button);
    this.pause = this.container.querySelector(selectors.pause);
    this.indicators = this.container.querySelectorAll(selectors.indicators);

    if (this.slides.length <= 1) return;

    this.timeout = 250;

    if (this.options.autoplay) {
      this.startAutoplay();
    }

    if (this.adaptHeight) {
      this.setSlideshowHeight();
    }

    if (this.options.type === 'slide') {
      this.isFirstSlide = false;
      this.isLastSlide = false;
      this.sliderItemWidthTotal = 0;
      this.sliderTrack = this.slider.querySelector(selectors.sliderTrack);
      // added setTimeout due to matchMedia calling too early
      // which result wrong value when getting dimension from an element
      this.sliderItemWidthTotal = 0;
      theme.Helpers.promiseStylesheet().then(
        function() {
          this._setupSlideType();
        }.bind(this)
      );
    } else {
      this.setupSlider(0);
    }

    this._setupEventHandlers();
  }

  Slideshow.prototype = Object.assign({}, Slideshow.prototype, {
    /**
     * Moves to the previous slide
     */
    previousSlide: function() {
      this._move();
    },

    /**
     * Moves to the next slide
     */
    nextSlide: function() {
      this._move('next');
    },

    /**
     * Moves to the specified slide
     * @param {Number} index - The index of the slide to move to
     */
    setSlide: function(index) {
      this._setPosition(Number(index));
    },

    /**
     * Starts autoplaying the slider if autoplay is enabled
     */
    startAutoplay: function() {
      this.isAutoPlaying = true;

      window.clearTimeout(this.autoTimeOut);

      this.autoTimeOut = window.setTimeout(
        function() {
          var nextSlideIndex = this._getNextSlideIndex('next');
          this._setPosition(nextSlideIndex);
        }.bind(this),
        this.options.slideInterval
      );
    },

    /**
     * Stops autoplaying the slider if autoplay is enabled
     */
    stopAutoplay: function() {
      this.isAutoPlaying = false;

      window.clearTimeout(this.autoTimeOut);
    },

    /**
     * Set active states for sliders and indicators
     * @param {index} integer - Slide index to set up slider from
     */
    setupSlider: function(index) {
      this.slideIndex = index;

      if (this.indicators.length) {
        this._setActiveIndicator(index);
      }

      this._setupActiveSlide(index);
    },

    /**
     * Removes event listeners, among other things when wanting to destroy the
     * slider instance. This method needs to be called manually and will most
     * likely be included in a section's onUnload() method.
     */
    destroy: function() {
      if (this.adaptHeight) {
        window.removeEventListener('resize', this.eventHandlers.debounceResize);
      }

      this.container.removeEventListener(
        'focus',
        this.eventHandlers.focus,
        true
      );
      this.slider.removeEventListener(
        'focusin',
        this.eventHandlers.focusIn,
        true
      );
      this.slider.removeEventListener(
        'focusout',
        this.eventHandlers.focusOut,
        true
      );
      this.container.removeEventListener('blur', this.eventHandlers.blur, true);

      if (this.buttons) {
        this.buttons.forEach(
          function(button) {
            button.removeEventListener('click', this.eventHandlers.clickButton);
          }.bind(this)
        );
      }

      this.indicators.forEach(function(indicatorWrapper) {
        indicatorWrapper.childNodes.forEach(function(indicator) {
          indicator.firstElementChild.removeEventListener(
            'click',
            this.eventHandlers.onClickIndicator
          );

          indicator.firstElementChild.removeEventListener(
            'keydown',
            this.eventHandlers.onKeydownIndicator
          );
        }, this);
      }, this);

      if (this.options.type === 'slide') {
        window.removeEventListener(
          'resize',
          this.eventHandlers.debounceResizeSlideIn
        );

        if (this.touchEvents && this.options.canUseTouchEvents) {
          this.touchEvents.destroy();
          this.touchEvents = null;
        }
      }
    },

    _setupEventHandlers: function() {
      this.eventHandlers.focus = this._onFocus.bind(this);
      this.eventHandlers.focusIn = this._onFocusIn.bind(this);
      this.eventHandlers.focusOut = this._onFocusOut.bind(this);
      this.eventHandlers.blur = this._onBlur.bind(this);
      this.eventHandlers.keyUp = this._onKeyUp.bind(this);
      this.eventHandlers.clickButton = this._onClickButton.bind(this);
      this.eventHandlers.onClickIndicator = this._onClickIndicator.bind(this);
      this.eventHandlers.onKeydownIndicator = this._onKeydownIndicator.bind(
        this
      );
      this.eventHandlers.onClickPause = this._onClickPause.bind(this);

      if (this.adaptHeight) {
        this.eventHandlers.debounceResize = theme.Helpers.debounce(
          function() {
            this.setSlideshowHeight();
          }.bind(this),
          50
        );

        window.addEventListener('resize', this.eventHandlers.debounceResize);
      }

      this.container.addEventListener('focus', this.eventHandlers.focus, true);
      this.slider.addEventListener('focusin', this.eventHandlers.focusIn, true);
      this.slider.addEventListener(
        'focusout',
        this.eventHandlers.focusOut,
        true
      );
      this.container.addEventListener('blur', this.eventHandlers.blur, true);

      if (this.buttons) {
        this.buttons.forEach(
          function(button) {
            button.addEventListener('click', this.eventHandlers.clickButton);
          }.bind(this)
        );
      }

      if (this.pause) {
        this.pause.addEventListener('click', this.eventHandlers.onClickPause);
      }

      this.indicators.forEach(function(indicatorWrapper) {
        indicatorWrapper.childNodes.forEach(function(indicator) {
          indicator.firstElementChild.addEventListener(
            'click',
            this.eventHandlers.onClickIndicator
          );

          indicator.firstElementChild.addEventListener(
            'keydown',
            this.eventHandlers.onKeydownIndicator
          );
        }, this);
      }, this);

      if (this.options.type === 'slide') {
        this.eventHandlers.debounceResizeSlideIn = theme.Helpers.debounce(
          function() {
            this.sliderItemWidthTotal = 0;
            this._setupSlideType(true);
          }.bind(this),
          50
        );

        window.addEventListener(
          'resize',
          this.eventHandlers.debounceResizeSlideIn
        );

        if (
          this.options.canUseTouchEvents &&
          this.options.slidesToScroll < this.slides.length
        ) {
          this._setupTouchEvents();
        }
      }
    },

    _setupTouchEvents: function() {
      this.touchEvents = new theme.TouchEvents(this.sliderTrack, {
        start: function() {
          this._onTouchStart();
        }.bind(this),
        move: function(event, direction, difference) {
          this._onTouchMove(event, direction, difference);
        }.bind(this),
        end: function(event, direction, difference) {
          this._onTouchEnd(event, direction, difference);
        }.bind(this)
      });
    },

    /**
     * Set slideshop for "slide-in" effect
     * @param {Boolean} onResize if function call came from resize event
     */
    _setupSlideType: function(onResize) {
      this.sliderItemWidth = Math.floor(
        this.sliderContainer.offsetWidth / this.options.slidesToShow
      );
      this.sliderTranslateXMove =
        this.sliderItemWidth * this.options.slidesToScroll;

      if (!onResize) {
        this.sliderContainer.classList.add(classes.sliderInitialized);
      }

      // Loop through all slider items
      // Set width according to the number of items to show in 1 slide
      // Set container width to accomodate all items
      this.slides.forEach(function(sliderItem, index) {
        var sliderItemLink = sliderItem.querySelector(selectors.sliderItemLink);
        sliderItem.style.width = this.sliderItemWidth + 'px';
        sliderItem.setAttribute('aria-hidden', true);
        sliderItem.setAttribute('tabindex', -1);
        this.sliderItemWidthTotal =
          this.sliderItemWidthTotal + sliderItem.offsetWidth;

        if (sliderItemLink) {
          sliderItemLink.setAttribute('tabindex', -1);
        }

        if (index < this.options.slidesToShow) {
          sliderItem.setAttribute('aria-hidden', false);
          sliderItem.classList.add(this.options.slideActiveClass);

          if (sliderItemLink) {
            sliderItemLink.setAttribute('tabindex', 0);
          }
        }
      }, this);

      this.sliderTrack.style.width =
        Math.floor(this.sliderItemWidthTotal) + 'px';
      this.sliderTrack.style.transform = 'translateX(-0px)';

      // set disabled attribute on Previous button
      if (this.buttons.length) {
        this.buttons[0].setAttribute('aria-disabled', true);
        this.buttons[1].removeAttribute('aria-disabled');
      }

      if (this.indicators.length) {
        this._setActiveIndicator(0);
      }
    },

    _onTouchStart: function() {
      this.touchStartPosition = this._getTranslateXPosition();
    },

    _onTouchMove: function(event, direction, difference) {
      // Fix touch events cause unexpected behaviour
      // when the dragging motion goes beyond the theme editor preview.
      var threshold = 80;
      if (
        Shopify.designMode &&
        (event.clientX <= threshold ||
          event.clientX >= window.innerWidth - threshold)
      ) {
        event.target.dispatchEvent(
          new MouseEvent('mouseup', {
            bubbles: true,
            cancelable: true
          })
        );
        return;
      }

      if (direction !== 'left' && direction !== 'right') return;

      this.touchMovePosition = this.touchStartPosition + difference.xPosition;

      this.sliderTrack.style.transform =
        'translateX(' + this.touchMovePosition + 'px';
    },

    _onTouchEnd: function(event, direction, difference) {
      var nextTranslateXPosition = 0;

      if (Object.keys(difference).length === 0) return;

      var slideDirection = direction === 'left' ? 'next' : '';

      if (direction === 'left') {
        if (this._isNextTranslateXLast(this.touchStartPosition)) {
          nextTranslateXPosition = this.touchStartPosition;
        } else {
          nextTranslateXPosition =
            this.touchStartPosition - this.sliderTranslateXMove;
        }
      } else {
        nextTranslateXPosition =
          this.touchStartPosition + this.sliderTranslateXMove;
        if (this._isNextTranslateXFirst(this.touchStartPosition)) {
          nextTranslateXPosition = 0;
        }
      }

      this.slideIndex = this._getNextSlideIndex(slideDirection);

      this.sliderTrack.style.transition = 'transform 500ms ease 0s';
      this.sliderTrack.style.transform =
        'translateX(' + nextTranslateXPosition + 'px';

      window.setTimeout(
        function() {
          this.sliderTrack.style.transition = '';
        }.bind(this),
        500
      );

      this._verifyFirstLastSlideTranslateX(nextTranslateXPosition);

      this._postTransitionEnd();
    },

    /**
     * Events handlers for next and previous button
     * @param {Object} event event handler
     */
    _onClickButton: function(event) {
      // prevent multiple clicks
      if (event.detail > 1) return;

      var button = event.currentTarget;
      var nextButton = button.hasAttribute(attributes.buttonNext);

      if (
        this.options.type === 'slide' &&
        button.getAttribute('aria-disabled') === 'true'
      ) {
        return;
      }

      if (this.options.autoplay && this.isAutoPlaying) {
        this.stopAutoplay();
      }

      if (nextButton) {
        this.nextSlide();
      } else {
        this.previousSlide();
      }
    },

    _onClickIndicator: function(event) {
      event.preventDefault();

      if (event.target.classList.contains(classes.indicatorActive)) return;

      if (this.options.autoplay && this.isAutoPlaying) {
        this.stopAutoplay();
      }

      this.slideIndex = Number(event.target.dataset.slideNumber);
      this.goToSlideByIndex(this.slideIndex);
    },

    goToSlideByIndex: function(index) {
      this._setPosition(index);

      if (this.options.type === 'slide' && this.sliderTrack) {
        this.sliderTrack.style.transition = 'transform 500ms ease 0s';
        var newPosition = index * this.slides[0].offsetWidth;

        this.sliderTrack.style.transform = 'translateX(-' + newPosition + 'px)';

        if (this.options.slidesToShow > 1) {
          this._verifyFirstLastSlideTranslateX(newPosition);

          if (this.buttons.length) {
            this._disableArrows();
          }

          this._setupMultipleActiveSlide(
            index,
            index + (this.options.slidesToShow - 1)
          );
        }
      }
    },

    _onKeydownIndicator: function(event) {
      if (event.keyCode !== slate.utils.keyboardKeys.ENTER) return;

      this._onClickIndicator(event);

      this.slider.focus();
    },

    _onClickPause: function(event) {
      if (!event.currentTarget.classList.contains(classes.isPaused)) {
        event.currentTarget.classList.add(classes.isPaused);
        this.stopAutoplay();
      } else {
        event.currentTarget.classList.remove(classes.isPaused);
        this.startAutoplay();
      }
    },

    _onFocus: function() {
      this.container.addEventListener('keyup', this.eventHandlers.keyUp);
    },

    _onFocusIn: function() {
      if (this.slider.hasAttribute('aria-live')) return;

      if (this.options.autoplay && this.isAutoPlaying) {
        this.stopAutoplay();
      }

      this.slider.setAttribute('aria-live', 'polite');
    },

    _onBlur: function() {
      this.container.removeEventListener('keyup', this.eventHandlers.keyUp);
    },

    _onFocusOut: function() {
      this.slider.removeAttribute('aria-live');

      // Adding a setTimeout because everytime we focus out
      // It automatically goes to <body>
      // We want to resume autoplay when focus is outside of the slideshow container
      setTimeout(
        function() {
          if (
            !document.activeElement.closest(
              '#' + this.slider.getAttribute('id')
            )
          ) {
            if (
              this.options.autoplay &&
              !this.isAutoPlaying &&
              !this.pause.classList.contains(classes.isPaused)
            ) {
              this.startAutoplay();
            }
          }
        }.bind(this),
        this.timeout
      );
    },

    _onKeyUp: function(event) {
      switch (event.keyCode) {
        case slate.utils.keyboardKeys.LEFTARROW:
          if (!this.options.canUseKeyboardArrows) return;

          if (this.options.type === 'slide' && this.isFirstSlide) {
            return;
          }

          this.previousSlide();

          break;
        case slate.utils.keyboardKeys.RIGHTARROW:
          if (!this.options.canUseKeyboardArrows) return;

          if (this.options.type === 'slide' && this.isLastSlide) {
            return;
          }

          this.nextSlide();

          break;
        case slate.utils.keyboardKeys.ESCAPE:
          this.slider.blur();
          break;
      }
    },

    _move: function(direction) {
      if (this.options.type === 'slide') {
        this.slideIndex = this._getNextSlideIndex(direction);
        this._moveSlideshow(direction);
      } else {
        var nextSlideIndex = this._getNextSlideIndex(direction);
        this._setPosition(nextSlideIndex);
      }
    },

    _moveSlideshow: function(direction) {
      this.direction = direction;
      var valueXToMove = 0;

      // Get current position of translateX
      var currentTranslateXPosition = this._getTranslateXPosition();
      var currentActiveSlidesIndex = this._getActiveSlidesIndex();

      // In the future, we'll use ES6 deconstructure
      // Math.min(...currentActiveSlidesIndex);
      var currentActiveSlidesMinIndex = Math.min.apply(
        Math,
        currentActiveSlidesIndex
      );
      var currentActiveSlidesMaxIndex = Math.max.apply(
        Math,
        currentActiveSlidesIndex
      );

      // Set the next active state depending on the direction
      // We bump up the index depending on the "slidesToShow" option
      this.nextMinIndex =
        direction === 'next'
          ? currentActiveSlidesMinIndex + this.options.slidesToShow
          : currentActiveSlidesMinIndex - this.options.slidesToShow;
      this.nextMaxIndex =
        direction === 'next'
          ? currentActiveSlidesMaxIndex + this.options.slidesToShow
          : currentActiveSlidesMinIndex - 1;

      this.sliderTrack.style.transition = 'transform 500ms ease 0s';

      if (direction === 'next') {
        valueXToMove = currentTranslateXPosition - this.sliderTranslateXMove;
        this.sliderTrack.style.transform = 'translateX(' + valueXToMove + 'px)';
      } else {
        valueXToMove = currentTranslateXPosition + this.sliderTranslateXMove;
        this.sliderTrack.style.transform = 'translateX(' + valueXToMove + 'px)';
      }

      this._verifyFirstLastSlideTranslateX(valueXToMove);

      this._postTransitionEnd();

      this._setupMultipleActiveSlide(this.nextMinIndex, this.nextMaxIndex);
    },

    _setPosition: function(nextSlideIndex) {
      this.slideIndex = nextSlideIndex;

      if (this.indicators.length) {
        this._setActiveIndicator(nextSlideIndex);
      }

      this._setupActiveSlide(nextSlideIndex);

      if (this.options.autoplay && this.isAutoPlaying) {
        this.startAutoplay();
      }

      this.container.dispatchEvent(
        new CustomEvent('slider_slide_changed', {
          detail: nextSlideIndex
        })
      );
    },

    _setupActiveSlide: function(index) {
      this.slides.forEach(function(slide) {
        slide.setAttribute('aria-hidden', true);
        slide.classList.remove(this.options.slideActiveClass);
      }, this);

      this.slides[index].setAttribute('aria-hidden', false);
      this.slides[index].classList.add(this.options.slideActiveClass);
    },

    /**
     * Loops through all slide items
     * Set the active state depending the direction and slide indexes
     * Because slide-in effect can have multiple items in 1 slide, we need to target multiple active elements
     * @param {String} direction "next" for next slides or empty string for previous
     * @param {*} minIndex the current active minimum index
     * @param {*} maxIndex the current active maximum index
     */
    _setupMultipleActiveSlide: function(minIndex, maxIndex) {
      this.slides.forEach(function(slide) {
        var sliderIndex = Number(slide.getAttribute('data-slider-slide-index'));
        var sliderItemLink = slide.querySelector(selectors.sliderItemLink);

        slide.setAttribute('aria-hidden', true);
        slide.classList.remove(this.options.slideActiveClass);
        if (sliderItemLink) {
          sliderItemLink.setAttribute('tabindex', -1);
        }

        if (sliderIndex >= minIndex && sliderIndex <= maxIndex) {
          slide.setAttribute('aria-hidden', false);
          slide.classList.add(this.options.slideActiveClass);

          if (sliderItemLink) {
            sliderItemLink.setAttribute('tabindex', 0);
          }
        }
      }, this);
    },

    _setActiveIndicator: function(index) {
      this.indicators.forEach(function(indicatorWrapper) {
        var activeIndicator = indicatorWrapper.querySelector(
          '.' + classes.indicatorActive
        );

        var nextIndicator = indicatorWrapper.childNodes[index];

        if (activeIndicator) {
          activeIndicator.setAttribute('aria-selected', false);
          activeIndicator.classList.remove(classes.indicatorActive);
          activeIndicator.firstElementChild.removeAttribute('aria-current');
        }

        nextIndicator.classList.add(classes.indicatorActive);
        nextIndicator.setAttribute('aria-selected', true);
        nextIndicator.firstElementChild.setAttribute('aria-current', true);
      }, this);
    },

    setSlideshowHeight: function() {
      var minAspectRatio = this.sliderContainer.getAttribute(
        'data-min-aspect-ratio'
      );
      this.sliderContainer.style.height =
        document.documentElement.offsetWidth / minAspectRatio + 'px';
    },

    /**
     * Increase or decrease index position of the slideshow
     * Automatically auto-rotate
     * - Last slide goes to first slide when clicking "next"
     * - First slide goes to last slide when clicking "previous"
     * @param {String} direction "next" as a String, other empty string is previous slide
     */
    _getNextSlideIndex: function(direction) {
      var counter = direction === 'next' ? 1 : -1;

      if (direction === 'next') {
        if (this.slideIndex === this.lastSlide) {
          return this.options.type === 'slide' ? this.lastSlide : 0;
        }
      } else if (!this.slideIndex) {
        return this.options.type === 'slide' ? 0 : this.lastSlide;
      }

      return this.slideIndex + counter;
    },

    /**
     * In "slide-in" type, multiple items are active in 1 slide
     * This will return an array containing their indexes
     */
    _getActiveSlidesIndex: function() {
      var currentActiveSlides = this.slides.filter(function(sliderItem) {
        if (sliderItem.classList.contains(this.options.slideActiveClass)) {
          return sliderItem;
        }
      }, this);
      var currentActiveSlidesIndex = currentActiveSlides.map(function(
        sliderItem
      ) {
        return Number(sliderItem.getAttribute('data-slider-slide-index'));
      });

      return currentActiveSlidesIndex;
    },

    /**
     * This checks the next "translateX" value and verifies
     * If it's at the last slide or beginning of the slide
     * So we can disable the arrow buttons
     */
    _disableArrows: function() {
      if (this.buttons.length === 0) return;

      var previousButton = this.buttons[0];
      var nextButton = this.buttons[1];

      // first slide
      if (this.isFirstSlide) {
        previousButton.setAttribute('aria-disabled', true);
      } else {
        previousButton.removeAttribute('aria-disabled');
      }

      // last slide
      if (this.isLastSlide) {
        nextButton.setAttribute('aria-disabled', true);
      } else {
        nextButton.removeAttribute('aria-disabled');
      }
    },

    /**
     * Verify if translateX reaches at first or last slide
     * @param {Number} translateXValue
     */
    _verifyFirstLastSlideTranslateX: function(translateXValue) {
      // first slide
      if (this._isNextTranslateXFirst(translateXValue)) {
        this.isFirstSlide = true;
      } else {
        this.isFirstSlide = false;
      }

      // last slide
      if (this._isNextTranslateXLast(translateXValue)) {
        this.isLastSlide = true;
      } else {
        this.isLastSlide = false;
      }
    },

    _getTranslateXPosition: function() {
      return Number(this.sliderTrack.style.transform.match(/(-?[0-9]+)/g)[0]);
    },

    _isNextTranslateXFirst: function(translateXValue) {
      return translateXValue === 0;
    },

    _isNextTranslateXLast: function(translateXValue) {
      // because translateX values are using negative, I'm converting into positive value
      var translateXValueAbsolute = Math.abs(translateXValue);
      var nextTranslateXValue =
        translateXValueAbsolute + this.sliderTranslateXMove;

      return nextTranslateXValue >= this.sliderItemWidthTotal;
    },

    _postTransitionEnd: function() {
      if (this.buttons.length) {
        this._disableArrows();
      }

      if (this.indicators.length) {
        this._setActiveIndicator(this.slideIndex);
      }
    }
  });

  return Slideshow;
})();

theme.Video = (function() {
  var autoplayCheckComplete = false;
  var playOnClickChecked = false;
  var playOnClick = false;
  var youtubeLoaded = false;
  var videos = {};
  var videoPlayers = [];
  var videoOptions = {
    ratio: 16 / 9,
    scrollAnimationDuration: 400,
    playerVars: {
      // eslint-disable-next-line camelcase
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 0,
      controls: 0,
      wmode: 'opaque',
      branding: 0,
      autohide: 0,
      rel: 0
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange
    }
  };
  var classes = {
    playing: 'video-is-playing',
    paused: 'video-is-paused',
    loading: 'video-is-loading',
    loaded: 'video-is-loaded',
    backgroundVideoWrapper: 'video-background-wrapper',
    videoWithImage: 'video--image_with_play',
    backgroundVideo: 'video--background',
    userPaused: 'is-paused',
    supportsAutoplay: 'autoplay',
    supportsNoAutoplay: 'no-autoplay',
    wrapperMinHeight: 'video-section-wrapper--min-height'
  };

  var selectors = {
    section: '.video-section',
    videoWrapper: '.video-section-wrapper',
    playVideoBtn: '.video-control__play',
    closeVideoBtn: '.video-control__close-wrapper',
    pauseVideoBtn: '.video__pause',
    pauseVideoStop: '.video__pause-stop',
    pauseVideoResume: '.video__pause-resume',
    fallbackText: '.icon__fallback-text'
  };

  /**
   * Public functions
   */
  function init(video) {
    if (!video) return;

    videos[video.id] = {
      id: video.id,
      videoId: video.dataset.id,
      type: video.dataset.type,
      status:
        video.dataset.type === 'image_with_play' ? 'closed' : 'background', // closed, open, background
      video: video,
      videoWrapper: video.closest(selectors.videoWrapper),
      section: video.closest(selectors.section),
      controls: video.dataset.type === 'background' ? 0 : 1
    };

    if (!youtubeLoaded) {
      // This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    playOnClickCheck();
  }

  function customPlayVideo(playerId) {
    // Make sure we have carried out the playOnClick check first
    if (!playOnClickChecked && !playOnClick) {
      return;
    }

    if (playerId && typeof videoPlayers[playerId].playVideo === 'function') {
      privatePlayVideo(playerId);
    }
  }

  function pauseVideo(playerId) {
    if (
      videoPlayers[playerId] &&
      typeof videoPlayers[playerId].pauseVideo === 'function'
    ) {
      videoPlayers[playerId].pauseVideo();
    }
  }

  function loadVideos() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        createPlayer(key);
      }
    }

    initEvents();
    youtubeLoaded = true;
  }

  function editorLoadVideo(key) {
    if (!youtubeLoaded) {
      return;
    }
    createPlayer(key);

    initEvents();
  }

  /**
   * Private functions
   */

  function privatePlayVideo(id, clicked) {
    var videoData = videos[id];
    var player = videoPlayers[id];
    var videoWrapper = videoData.videoWrapper;

    if (playOnClick) {
      // playOnClick means we are probably on mobile (no autoplay).
      // setAsPlaying will show the iframe, requiring another click
      // to play the video.
      setAsPlaying(videoData);
    } else if (clicked || autoplayCheckComplete) {
      // Play if autoplay is available or clicked to play
      videoWrapper.classList.remove(classes.loading);
      setAsPlaying(videoData);
      player.playVideo();
      return;
    } else {
      player.playVideo();
    }
  }

  function setAutoplaySupport(supported) {
    var supportClass = supported
      ? classes.supportsAutoplay
      : classes.supportsNoAutoplay;
    document.documentElement.classList.remove(
      classes.supportsAutoplay,
      classes.supportsNoAutoplay
    );
    document.documentElement.classList.add(supportClass);

    if (!supported) {
      playOnClick = true;
    }

    autoplayCheckComplete = true;
  }

  function playOnClickCheck() {
    if (playOnClickChecked) {
      return;
    }

    if (isMobile()) {
      playOnClick = true;
    }

    if (playOnClick) {
      // No need to also do the autoplay check
      setAutoplaySupport(false);
    }

    playOnClickChecked = true;
  }

  // The API will call this function when each video player is ready
  function onPlayerReady(evt) {
    evt.target.setPlaybackQuality('hd1080');
    var videoData = getVideoOptions(evt);
    var videoTitle = evt.target.getVideoData().title;
    playOnClickCheck();

    // Prevent tabbing through YouTube player controls until visible
    document.getElementById(videoData.id).setAttribute('tabindex', '-1');

    sizeBackgroundVideos();
    setButtonLabels(videoData.videoWrapper, videoTitle);

    // Customize based on options from the video ID
    if (videoData.type === 'background') {
      evt.target.mute();
      privatePlayVideo(videoData.id);
    }

    videoData.videoWrapper.classList.add(classes.loaded);
  }

  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt);
    if (
      videoData.status === 'background' &&
      !isMobile() &&
      !autoplayCheckComplete &&
      (evt.data === YT.PlayerState.PLAYING ||
        evt.data === YT.PlayerState.BUFFERING)
    ) {
      setAutoplaySupport(true);
      autoplayCheckComplete = true;
      videoData.videoWrapper.classList.remove(classes.loading);
    }
    switch (evt.data) {
      case YT.PlayerState.ENDED:
        setAsFinished(videoData);
        break;
      case YT.PlayerState.PAUSED:
        // Seeking on a YouTube video also fires a PAUSED state change,
        // checking the state after a delay prevents us pausing the video when
        // the user is seeking instead of pausing
        setTimeout(function() {
          if (evt.target.getPlayerState() === YT.PlayerState.PAUSED) {
            setAsPaused(videoData);
          }
        }, 200);
        break;
    }
  }

  function setAsFinished(videoData) {
    switch (videoData.type) {
      case 'background':
        videoPlayers[videoData.id].seekTo(0);
        break;
      case 'image_with_play':
        closeVideo(videoData.id);
        toggleExpandVideo(videoData.id, false);
        break;
    }
  }

  function setAsPlaying(videoData) {
    var videoWrapper = videoData.videoWrapper;
    var pauseButton = videoWrapper.querySelector(selectors.pauseVideoBtn);

    videoWrapper.classList.remove(classes.loading);

    if (pauseButton.classList.contains(classes.userPaused)) {
      pauseButton.classList.remove(classes.userPaused);
    }

    // Do not change element visibility if it is a background video
    if (videoData.status === 'background') {
      return;
    }

    document.getElementById(videoData.id).setAttribute('tabindex', '0');

    if (videoData.type === 'image_with_play') {
      videoWrapper.classList.remove(classes.paused);
      videoWrapper.classList.add(classes.playing);
    }

    // Update focus to the close button so we stay within the video wrapper,
    // allowing time for the scroll animation
    setTimeout(function() {
      videoWrapper.querySelector(selectors.closeVideoBtn).focus();
    }, videoOptions.scrollAnimationDuration);
  }

  function setAsPaused(videoData) {
    var videoWrapper = videoData.videoWrapper;

    // YT's events fire after our click event. This status flag ensures
    // we don't interact with a closed or background video.
    if (videoData.type === 'image_with_play') {
      if (videoData.status === 'closed') {
        videoWrapper.classList.remove(classes.paused);
      } else {
        videoWrapper.classList.add(classes.paused);
      }
    }

    videoWrapper.classList.remove(classes.playing);
  }

  function closeVideo(playerId) {
    var videoData = videos[playerId];
    var videoWrapper = videoData.videoWrapper;

    document.getElementById(videoData.id).setAttribute('tabindex', '-1');

    videoData.status = 'closed';

    switch (videoData.type) {
      case 'image_with_play':
        videoPlayers[playerId].stopVideo();
        setAsPaused(videoData); // in case the video is already paused
        break;
      case 'background':
        videoPlayers[playerId].mute();
        setBackgroundVideo(playerId);
        break;
    }

    videoWrapper.classList.remove(classes.paused, classes.playing);
  }

  function getVideoOptions(evt) {
    var id = evt.target.getIframe().id;
    return videos[id];
  }

  function toggleExpandVideo(playerId, expand) {
    var video = videos[playerId];
    var elementTop =
      video.videoWrapper.getBoundingClientRect().top + window.pageYOffset;
    var playButton = video.videoWrapper.querySelector(selectors.playVideoBtn);
    var offset = 0;
    var newHeight = 0;

    if (isMobile()) {
      video.videoWrapper.parentElement.classList.toggle('page-width', !expand);
    }

    if (expand) {
      if (isMobile()) {
        newHeight = window.innerWidth / videoOptions.ratio;
      } else {
        newHeight = video.videoWrapper.offsetWidth / videoOptions.ratio;
      }
      offset = (window.innerHeight - newHeight) / 2;

      video.videoWrapper.style.height =
        video.videoWrapper.getBoundingClientRect().height + 'px';
      video.videoWrapper.classList.remove(classes.wrapperMinHeight);
      video.videoWrapper.style.height = newHeight + 'px';

      // Animate doesn't work in mobile editor, so we don't use it
      if (!(isMobile() && Shopify.designMode)) {
        var scrollBehavior = document.documentElement.style.scrollBehavior;
        document.documentElement.style.scrollBehavior = 'smooth';
        window.scrollTo({ top: elementTop - offset });
        document.documentElement.style.scrollBehavior = scrollBehavior;
      }
    } else {
      if (isMobile()) {
        newHeight = video.videoWrapper.dataset.mobileHeight;
      } else {
        newHeight = video.videoWrapper.dataset.desktopHeight;
      }

      video.videoWrapper.style.height = newHeight + 'px';

      setTimeout(function() {
        video.videoWrapper.classList.add(classes.wrapperMinHeight);
      }, 600);
      // Set focus on play button, but don't scroll page
      var x = window.scrollX;
      var y = window.scrollY;
      playButton.focus();
      window.scrollTo(x, y);
    }
  }

  function togglePause(playerId) {
    var pauseButton = videos[playerId].videoWrapper.querySelector(
      selectors.pauseVideoBtn
    );
    var paused = pauseButton.classList.contains(classes.userPaused);
    if (paused) {
      pauseButton.classList.remove(classes.userPaused);
      customPlayVideo(playerId);
    } else {
      pauseButton.classList.add(classes.userPaused);
      pauseVideo(playerId);
    }
    pauseButton.setAttribute('aria-pressed', !paused);
  }

  function startVideoOnClick(playerId) {
    var video = videos[playerId];

    // add loading class to wrapper
    video.videoWrapper.classList.add(classes.loading);

    // Explicity set the video wrapper height (needed for height transition)
    video.videoWrapper.style.height = video.videoWrapper.offsetHeight + 'px';

    video.status = 'open';

    switch (video.type) {
      case 'image_with_play':
        privatePlayVideo(playerId, true);
        break;
      case 'background':
        unsetBackgroundVideo(playerId, video);
        videoPlayers[playerId].unMute();
        privatePlayVideo(playerId, true);
        break;
    }

    toggleExpandVideo(playerId, true);

    // esc to close video player
    document.addEventListener('keydown', handleVideoPlayerKeydown);
  }

  var handleVideoPlayerKeydown = function(evt) {
    var playerId = document.activeElement.dataset.controls;
    if (evt.keyCode !== slate.utils.keyboardKeys.ESCAPE || !playerId) {
      return;
    }

    closeVideo(playerId);
    toggleExpandVideo(playerId, false);
  };

  function sizeBackgroundVideos() {
    var backgroundVideos = document.querySelectorAll(
      '.' + classes.backgroundVideo
    );
    backgroundVideos.forEach(function(el) {
      sizeBackgroundVideo(el);
    });
  }

  function sizeBackgroundVideo(videoPlayer) {
    if (!youtubeLoaded) {
      return;
    }

    if (isMobile()) {
      videoPlayer.style.cssText = null;
    } else {
      var videoWrapper = videoPlayer.closest(selectors.videoWrapper);
      var videoWidth = videoWrapper.clientWidth;
      var playerWidth = videoPlayer.clientWidth;
      var desktopHeight = videoWrapper.dataset.desktopHeight;

      // when screen aspect ratio differs from video, video must center and underlay one dimension
      if (videoWidth / videoOptions.ratio < desktopHeight) {
        playerWidth = Math.ceil(desktopHeight * videoOptions.ratio); // get new player width
        var styles =
          'width: ' +
          playerWidth +
          'px; height: ' +
          desktopHeight +
          'px; left: ' +
          (videoWidth - playerWidth) / 2 +
          'px; top: 0;';
        videoPlayer.style.cssText = styles;
      } else {
        // new video width < window width (gap to right)
        desktopHeight = Math.ceil(videoWidth / videoOptions.ratio); // get new player height
        var styles2 =
          'width: ' +
          videoWidth +
          'px; height: ' +
          desktopHeight +
          'px; top: ' +
          (desktopHeight - desktopHeight) / 2 +
          'px; left: 0;'; // player height is greater, offset top; reset left
        videoPlayer.style.cssText = styles2;
      }

      theme.Helpers.prepareTransition(videoPlayer);
      videoWrapper.classList.add(classes.loaded);
    }
  }

  function unsetBackgroundVideo(playerId) {
    // Switch the background video to a chrome-only player once played
    var player = document.getElementById(playerId);
    player.classList.remove(classes.backgroundVideo);
    player.classList.add(classes.videoWithImage);

    setTimeout(function() {
      document.getElementById(playerId).style.cssText = null;
    }, 600);

    videos[playerId].videoWrapper.classList.remove(
      classes.backgroundVideoWrapper
    );
    videos[playerId].videoWrapper.classList.add(classes.playing);

    videos[playerId].status = 'open';
  }

  function setBackgroundVideo(playerId) {
    var player = document.getElementById(playerId);
    player.classList.remove(classes.videoWithImage);
    player.classList.add(classes.backgroundVideo);

    videos[playerId].videoWrapper.classList.add(classes.backgroundVideoWrapper);

    videos[playerId].status = 'background';
    sizeBackgroundVideo(player);
  }

  function isMobile() {
    return window.innerWidth < theme.breakpoints.medium;
  }

  var handleWindowResize = theme.Helpers.debounce(function() {
    if (!youtubeLoaded) return;
    var key;
    var fullscreen = window.innerHeight === screen.height;
    sizeBackgroundVideos();

    if (isMobile()) {
      for (key in videos) {
        if (videos.hasOwnProperty(key)) {
          if (videos[key].videoWrapper.classList.contains(classes.playing)) {
            if (!fullscreen) {
              pauseVideo(key);
              setAsPaused(videos[key]);
            }
          }
          videos[key].videoWrapper.style.height =
            document.documentElement.clientWidth / videoOptions.ratio + 'px';
        }
      }
      setAutoplaySupport(false);
    } else {
      setAutoplaySupport(true);
      for (key in videos) {
        var videosWithImage = videos[key].videoWrapper.querySelectorAll(
          '.' + classes.videoWithImage
        );
        if (videosWithImage.length) {
          continue;
        }
        videoPlayers[key].playVideo();
        setAsPlaying(videos[key]);
      }
    }
  }, 200);

  var handleWindowScroll = theme.Helpers.debounce(function() {
    if (!youtubeLoaded) return;

    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var videoWrapper = videos[key].videoWrapper;
        var condition =
          videoWrapper.getBoundingClientRect().top +
            window.pageYOffset +
            videoWrapper.offsetHeight * 0.75 <
            window.pageYOffset ||
          videoWrapper.getBoundingClientRect().top +
            window.pageYOffset +
            videoWrapper.offsetHeight * 0.25 >
            window.pageYOffset + window.innerHeight;

        // Close the video if more than 75% of it is scrolled out of view
        if (videoWrapper.classList.contains(classes.playing)) {
          if (!condition) return;
          closeVideo(key);
          toggleExpandVideo(key, false);
        }
      }
    }
  }, 50);

  function initEvents() {
    var playVideoBtns = document.querySelectorAll(selectors.playVideoBtn);
    var closeVideoBtns = document.querySelectorAll(selectors.closeVideoBtn);
    var pauseVideoBtns = document.querySelectorAll(selectors.pauseVideoBtn);

    playVideoBtns.forEach(function(btn) {
      btn.addEventListener('click', function(evt) {
        var playerId = evt.currentTarget.dataset.controls;
        startVideoOnClick(playerId);
      });
    });

    closeVideoBtns.forEach(function(btn) {
      btn.addEventListener('click', function(evt) {
        var playerId = evt.currentTarget.dataset.controls;

        evt.currentTarget.blur();
        closeVideo(playerId);
        toggleExpandVideo(playerId, false);
      });
    });

    pauseVideoBtns.forEach(function(btn) {
      btn.addEventListener('click', function(evt) {
        var playerId = evt.currentTarget.dataset.controls;
        togglePause(playerId);
      });
    });

    // Listen to resize to keep a background-size:cover-like layout
    window.addEventListener('resize', handleWindowResize);

    window.addEventListener('scroll', handleWindowScroll);
  }

  function createPlayer(key) {
    var args = Object.assign(videoOptions, videos[key]);

    args.playerVars.controls = args.controls;
    videoPlayers[key] = new YT.Player(key, args);
  }

  function removeEvents() {
    document.removeEventListener('keydown', handleVideoPlayerKeydown);
    window.removeEventListener('resize', handleWindowResize);
    window.removeEventListener('scroll', handleWindowScroll);
  }

  function setButtonLabels(videoWrapper, title) {
    var playButtons = videoWrapper.querySelectorAll(selectors.playVideoBtn);
    var closeButton = videoWrapper.querySelector(selectors.closeVideoBtn);
    var pauseButton = videoWrapper.querySelector(selectors.pauseVideoBtn);
    var closeButtonText = closeButton.querySelector(selectors.fallbackText);

    var pauseButtonStop = pauseButton.querySelector(selectors.pauseVideoStop);
    var pauseButtonStopText = pauseButtonStop.querySelector(
      selectors.fallbackText
    );

    var pauseButtonResume = pauseButton.querySelector(
      selectors.pauseVideoResume
    );
    var pauseButtonResumeText = pauseButtonResume.querySelector(
      selectors.fallbackText
    );

    // Insert the video title retrieved from YouTube into the instructional text
    // for each button
    playButtons.forEach(function(playButton) {
      var playButtonText = playButton.querySelector(selectors.fallbackText);

      playButtonText.textContent = playButtonText.textContent.replace(
        '[video_title]',
        title
      );
    });
    closeButtonText.textContent = closeButtonText.textContent.replace(
      '[video_title]',
      title
    );
    pauseButtonStopText.textContent = pauseButtonStopText.textContent.replace(
      '[video_title]',
      title
    );
    pauseButtonResumeText.textContent = pauseButtonResumeText.textContent.replace(
      '[video_title]',
      title
    );
  }

  return {
    init: init,
    editorLoadVideo: editorLoadVideo,
    loadVideos: loadVideos,
    playVideo: customPlayVideo,
    pauseVideo: pauseVideo,
    removeEvents: removeEvents
  };
})();

theme.ProductVideo = (function() {
  var videos = {};

  var hosts = {
    shopify: 'shopify',
    external: 'external'
  };

  var selectors = {
    productMediaWrapper: '[data-product-single-media-wrapper]'
  };

  var attributes = {
    enableVideoLooping: 'enable-video-looping',
    videoId: 'video-id'
  };

  function init(videoContainer, sectionId) {
    if (!videoContainer) {
      return;
    }

    var videoElement = videoContainer.querySelector('iframe, video');

    if (!videoElement) {
      return;
    }

    var mediaId = videoContainer.getAttribute('data-media-id');

    videos[mediaId] = {
      mediaId: mediaId,
      sectionId: sectionId,
      host: hostFromVideoElement(videoElement),
      container: videoContainer,
      element: videoElement,
      ready: function() {
        createPlayer(this);
      }
    };

    window.Shopify.loadFeatures([
      {
        name: 'video-ui',
        version: '2.0',
        onLoad: setupVideos
      }
    ]);
    theme.LibraryLoader.load('plyrShopifyStyles');
  }

  function setupVideos(errors) {
    if (errors) {
      fallbackToNativeVideo();
      return;
    }

    loadVideos();
  }

  function createPlayer(video) {
    if (video.player) {
      return;
    }

    var productMediaWrapper = video.container.closest(
      selectors.productMediaWrapper
    );

    var enableLooping = productMediaWrapper.getAttribute(
      'data-' + attributes.enableVideoLooping
    );

    // eslint-disable-next-line no-undef
    video.player = new Shopify.Video(video.element, {
      loop: { active: enableLooping }
    });

    var pauseVideo = function() {
      if (!video.player) return;
      video.player.pause();
    };

    productMediaWrapper.addEventListener('mediaHidden', pauseVideo);
    productMediaWrapper.addEventListener('xrLaunch', pauseVideo);

    productMediaWrapper.addEventListener('mediaVisible', function() {
      if (theme.Helpers.isTouch()) return;
      if (!video.player) return;
      video.player.play();
    });
  }

  function hostFromVideoElement(video) {
    if (video.tagName === 'VIDEO') {
      return hosts.shopify;
    }

    return hosts.external;
  }

  function loadVideos() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var video = videos[key];
        video.ready();
      }
    }
  }

  function fallbackToNativeVideo() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var video = videos[key];

        if (video.nativeVideo) continue;

        if (video.host === hosts.shopify) {
          video.element.setAttribute('controls', 'controls');
          video.nativeVideo = true;
        }
      }
    }
  }

  function removeSectionVideos(sectionId) {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var video = videos[key];

        if (video.sectionId === sectionId) {
          if (video.player) video.player.destroy();
          delete videos[key];
        }
      }
    }
  }

  return {
    init: init,
    hosts: hosts,
    loadVideos: loadVideos,
    removeSectionVideos: removeSectionVideos
  };
})();

theme.ProductModel = (function() {
  var modelJsonSections = {};
  var models = {};
  var xrButtons = {};

  var selectors = {
    mediaGroup: '[data-product-single-media-group]',
    xrButton: '[data-shopify-xr]'
  };

  function init(modelViewerContainers, sectionId) {
    modelJsonSections[sectionId] = {
      loaded: false
    };

    modelViewerContainers.forEach(function(modelViewerContainer, index) {
      var mediaId = modelViewerContainer.getAttribute('data-media-id');
      var modelViewerElement = modelViewerContainer.querySelector(
        'model-viewer'
      );
      var modelId = modelViewerElement.getAttribute('data-model-id');

      if (index === 0) {
        var mediaGroup = modelViewerContainer.closest(selectors.mediaGroup);
        var xrButton = mediaGroup.querySelector(selectors.xrButton);
        xrButtons[sectionId] = {
          element: xrButton,
          defaultId: modelId
        };
      }

      models[mediaId] = {
        modelId: modelId,
        sectionId: sectionId,
        container: modelViewerContainer,
        element: modelViewerElement
      };
    });

    window.Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: setupShopifyXr
      },
      {
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad: setupModelViewerUi
      }
    ]);
    theme.LibraryLoader.load('modelViewerUiStyles');
  }

  function setupShopifyXr(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', function() {
        setupShopifyXr();
      });
      return;
    }

    for (var sectionId in modelJsonSections) {
      if (modelJsonSections.hasOwnProperty(sectionId)) {
        var modelSection = modelJsonSections[sectionId];

        if (modelSection.loaded) continue;
        var modelJson = document.querySelector('#ModelJson-' + sectionId);

        window.ShopifyXR.addModels(JSON.parse(modelJson.innerHTML));
        modelSection.loaded = true;
      }
    }
    window.ShopifyXR.setupXRElements();
  }

  function setupModelViewerUi(errors) {
    if (errors) return;

    for (var key in models) {
      if (models.hasOwnProperty(key)) {
        var model = models[key];
        if (!model.modelViewerUi) {
          model.modelViewerUi = new Shopify.ModelViewerUI(model.element);
        }
        setupModelViewerListeners(model);
      }
    }
  }

  function setupModelViewerListeners(model) {
    var xrButton = xrButtons[model.sectionId];

    model.container.addEventListener('mediaVisible', function() {
      xrButton.element.setAttribute('data-shopify-model3d-id', model.modelId);
      if (theme.Helpers.isTouch()) return;
      model.modelViewerUi.play();
    });

    model.container.addEventListener('mediaHidden', function() {
      xrButton.element.setAttribute(
        'data-shopify-model3d-id',
        xrButton.defaultId
      );
      model.modelViewerUi.pause();
    });

    model.container.addEventListener('xrLaunch', function() {
      model.modelViewerUi.pause();
    });
  }

  function removeSectionModels(sectionId) {
    for (var key in models) {
      if (models.hasOwnProperty(key)) {
        var model = models[key];
        if (model.sectionId === sectionId) {
          models[key].modelViewerUi.destroy();
          delete models[key];
        }
      }
    }
    delete modelJsonSections[sectionId];
  }

  return {
    init: init,
    removeSectionModels: removeSectionModels
  };
})();

window.theme = window.theme || {};

theme.FormStatus = (function() {
  var selectors = {
    statusMessage: '[data-form-status]'
  };

  function init() {
    var statusMessages = document.querySelectorAll(selectors.statusMessage);

    statusMessages.forEach(function(statusMessage) {
      statusMessage.setAttribute('tabindex', -1);
      statusMessage.focus();

      statusMessage.addEventListener(
        'blur',
        function(evt) {
          evt.target.removeAttribute('tabindex');
        },
        { once: true }
      );
    });
  }

  return {
    init: init
  };
})();

theme.Hero = (function() {
  var classes = {
    indexSectionFlush: 'index-section--flush'
  };

  var selectors = {
    heroFixedWidthContent: '.hero-fixed-width__content',
    heroFixedWidthImage: '.hero-fixed-width__image'
  };

  function hero(el, sectionId) {
    var hero = document.querySelector(el);
    var layout = hero.getAttribute('data-layout');
    var parentSection = document.querySelector('#shopify-section-' + sectionId);
    var heroContent = parentSection.querySelector(
      selectors.heroFixedWidthContent
    );
    var heroImage = parentSection.querySelector(selectors.heroFixedWidthImage);

    if (layout !== 'fixed_width') {
      return;
    }

    parentSection.classList.remove(classes.indexSectionFlush);
    heroFixedHeight();

    window.addEventListener('resize', function() {
      theme.Helpers.debounce(function() {
        heroFixedHeight();
      }, 50);
    });

    function heroFixedHeight() {
      var contentHeight;
      var imageHeight;

      if (heroContent) {
        contentHeight = heroContent.offsetHeight + 50;
      }

      if (heroImage) {
        imageHeight = heroImage.offsetHeight;
      }

      if (contentHeight > imageHeight) {
        heroImage.style.minHeight = contentHeight + 'px';
      }
    }
  }

  return hero;
})();

// prettier-ignore
window.theme = window.theme || {};

theme.SearchResultsTemplate = (function() {
  function renderResults(products, isLoading, searchQuery) {
    return [
      '<div class="predictive-search">',
      renderHeader(products, isLoading),
      renderProducts(products, searchQuery),
      '</div>'
    ].join('');
  }

  function renderHeader(products, isLoading) {
    if (products.length === 0) {
      return '';
    }

    return [
      '<div class="predictive-search-title">',
      '<h3 id="predictive-search" class="predictive-search-title__content">' +
        theme.strings.products +
        '</h3>',
      '<span class="predictive-search-title__loading-spinner">' +
        (isLoading
          ? '<span class= "icon-predictive-search-spinner" ></span >'
          : '') +
        '</span>',
      '</div>'
    ].join('');
  }

  function loadingState() {
    return [
      '<div class="predictive-search">',
      '<div class="predictive-search-loading">',
      '<span class="visually-hidden">' + theme.strings.loading + '</span>',
      '<span class="predictive-search-loading__icon">',
      '<span class="icon-predictive-search-spinner"></span>',
      '</span>',
      '</div>',
      '</div>'
    ].join('');
  }

  function renderViewAll(searchQuery) {
    return [
      '<button type="submit" class="predictive-search-view-all__button" tabindex="-1">',
      theme.strings.searchFor +
        '<span class="predictive-search-view-all__query"> &ldquo;' +
        _htmlEscape(searchQuery) +
        '&rdquo;</span>',
      '</button>'
    ].join('');
  }

  function renderProducts(products, searchQuery) {
    var resultsCount = products.length;

    return [
      '<ul id="predictive-search-results" class="predictive-search__list" role="listbox" aria-labelledby="predictive-search">',
      products
        .map(function(product, index) {
          return renderProduct(normalizeProduct(product), index, resultsCount);
        })
        .join(''),
      '<li id="search-all" class="predictive-search-view-all" role="option" data-search-result>' +
        renderViewAll(searchQuery) +
        '</li>',
      '</ul>'
    ].join('');
  }

  function renderProduct(product, index, resultsCount) {
    return [
      '<li id="search-result-' +
        index +
        '" class="predictive-search-item" role="option" data-search-result>',
      '<a class="predictive-search-item__link" href="' +
        product.url +
        '" tabindex="-1">',
      '<div class="predictive-search__column predictive-search__column--image" data-image-loading-animation>',
      renderProductImage(product),
      '</div>',
      '<div class="predictive-search__column predictive-search__column--content ' +
        (getDetailsCount() ? '' : 'predictive-search__column--center') +
        '">',
      '<span class="predictive-search-item__title">',
      '<span class="predictive-search-item__title-text">' +
        product.title +
        '</span>',
      '</span>' + (getDetailsCount() ? renderProductDetails(product) : ''),
      '<span class="visually-hidden">, </span>',
      '<span class="visually-hidden">' +
        getNumberOfResultsString(index + 1, resultsCount) +
        '</span>',
      '</div>',
      '</a>',
      '</li>'
    ].join('');
  }

  function renderProductImage(product) {
    if (product.image === null) {
      return '';
    }

    return (
      '<img class="predictive-search-item__image lazyload" src="' +
      product.image.url +
      '" data-src="' +
      product.image.url +
      '" data-image alt="' +
      product.image.alt +
      '" />'
    );
  }

  function renderProductDetails(product) {
    return [
      '<dl class="predictive-search-item__details price' +
        (product.isOnSale ? ' price--on-sale' : '') +
        (!product.available ? ' price--sold-out' : '') +
        (!product.isPriceVaries && product.isCompareVaries
          ? ' price--compare-price-hidden'
          : '') +
        '">',
      '<div class="predictive-search-item__detail">',
      renderVendor(product),
      '</div>',
      '<div class="predictive-search-item__detail predictive-search-item__detail--inline">' +
        renderProductPrice(product),
      '</div>',
      '</dl>'
    ].join('');
  }
  function renderProductPrice(product) {
    if (!theme.settings.predictiveSearchShowPrice) {
      return '';
    }

    var accessibilityAnnounceComma = '<span class="visually-hidden">, </span>';

    var priceMarkup =
      '<div class="price__regular">' + renderPrice(product) + '</div>';

    var salePriceMarkup =
      '<div class="price__sale">' + renderSalePrice(product) + '</div>';

    return (
      accessibilityAnnounceComma +
      '<div class="price__pricing-group">' +
      (product.isOnSale ? salePriceMarkup : priceMarkup) +
      '</div>'
    );
  }

  function renderSalePrice(product) {
    return [
      '<dt>',
      '<span class="visually-hidden">' + theme.strings.salePrice + '</span>',
      '</dt>',
      '<dd>',
      '<span class="predictive-search-item__price predictive-search-item__price--sale">' +
        (product.isPriceVaries
          ? theme.strings.fromLowestPrice.replace('[price]', product.price)
          : product.price) +
        '</span>',
      '</dd>',
      '<div class="price__compare">' + renderCompareAtPrice(product) + '</div>'
    ].join('');
  }

  function renderCompareAtPrice(product) {
    return [
      '<dt>',
      '<span class="visually-hidden">' +
        theme.strings.regularPrice +
        '</span> ',
      '</dt>',
      '<dd>',
      '<span class="predictive-search-item__price predictive-search-item__price--compare">' +
        product.compareAtPrice +
        '</span>',
      '</dd>'
    ].join('');
  }

  function renderPrice(product) {
    return [
      '<dt>',
      '<span class="visually-hidden">' + theme.strings.regularPrice + '</span>',
      '</dt>',
      '<dd>',
      '<span class="predictive-search-item__price">' +
        (product.isPriceVaries
          ? theme.strings.fromLowestPrice.replace('[price]', product.price)
          : product.price) +
        '</span>',
      '</dd>'
    ].join('');
  }

  function renderVendor(product) {
    if (!theme.settings.predictiveSearchShowVendor || product.vendor === '') {
      return '';
    }

    return [
      '<dt>',
      '<span class="visually-hidden">' + theme.strings.vendor + '</span>',
      '</dt>',
      '<dd class="predictive-search-item__vendor">' + product.vendor + '</dd>'
    ].join('');
  }

  function normalizeProduct(product) {
    var productOrVariant =
      product.variants.length > 0 ? product.variants[0] : product;

    return {
      url: productOrVariant.url,
      image: getProductImage(product),
      title: product.title,
      vendor: product.vendor || '',
      price: theme.Currency.formatMoney(product.price_min, theme.moneyFormat),
      compareAtPrice: theme.Currency.formatMoney(
        product.compare_at_price_min,
        theme.moneyFormat
      ),
      available: product.available,
      isOnSale: isOnSale(product),
      isPriceVaries: isPriceVaries(product),
      isCompareVaries: isCompareVaries(product)
    };
  }

  function getProductImage(product) {
    var image;
    var featuredImage;

    if (product.variants.length > 0 && product.variants[0].image !== null) {
      featuredImage = product.variants[0].featured_image;
    } else if (product.image) {
      featuredImage = product.featured_image;
    } else {
      image = null;
    }

    if (image !== null) {
      image = {
        url: theme.Images.getSizedImageUrl(featuredImage.url, '100x'),
        alt: featuredImage.alt
      };
    }

    return image;
  }

  function isOnSale(product) {
    return (
      product.compare_at_price_min !== null &&
      parseInt(product.compare_at_price_min, 10) >
        parseInt(product.price_min, 10)
    );
  }

  function isPriceVaries(product) {
    return product.price_max !== product.price_min;
  }

  function isCompareVaries(product) {
    return product.compare_at_price_max !== product.compare_at_price_min;
  }

  // Returns the number of optional product details to be shown,
  // values of the detailsList need to be boolean.
  function getDetailsCount() {
    var detailsList = [
      theme.settings.predictiveSearchShowPrice,
      theme.settings.predictiveSearchShowVendor
    ];

    var detailsCount = detailsList.reduce(function(acc, detail) {
      return acc + (detail ? 1 : 0);
    }, 0);

    return detailsCount;
  }

  function getNumberOfResultsString(resultNumber, resultsCount) {
    return theme.strings.number_of_results
      .replace('[result_number]', resultNumber)
      .replace('[results_count]', resultsCount);
  }

  function _htmlEscape(input) {
    return input
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  return function(data) {
    var products = data.products || [];
    var isLoading = data.isLoading;
    var searchQuery = data.searchQuery || '';

    if (isLoading && products.length === 0) {
      return loadingState();
    }

    return renderResults(products, isLoading, searchQuery);
  };
})();

window.theme = window.theme || {};

(function() {
  // (a11y) This function will be used by the Predictive Search Component
  // to announce the number of search results
  function numberOfResultsTemplateFct(data) {
    if (data.products.length === 1) {
      return theme.strings.one_result_found;
    } else {
      return theme.strings.number_of_results_found.replace(
        '[results_count]',
        data.products.length
      );
    }
  }

  // (a11y) This function will be used by the Predictive Search Component
  // to announce that it's loading results
  function loadingResultsMessageTemplateFct() {
    return theme.strings.loading;
  }

  function isPredictiveSearchSupported() {
    var shopifyFeatures = JSON.parse(
      document.getElementById('shopify-features').textContent
    );

    return shopifyFeatures.predictiveSearch;
  }

  function isPredictiveSearchEnabled() {
    return window.theme.settings.predictiveSearchEnabled;
  }

  function canInitializePredictiveSearch() {
    return isPredictiveSearchSupported() && isPredictiveSearchEnabled();
  }

  // listen for search submits and validate query
  function validateSearchHandler(searchEl, submitEl) {
    submitEl.addEventListener(
      'click',
      validateSearchInput.bind(this, searchEl)
    );
  }

  // if there is nothing in the search field, prevent submit
  function validateSearchInput(searchEl, evt) {
    var isInputValueEmpty = searchEl.value.trim().length === 0;
    if (!isInputValueEmpty) {
      return;
    }

    if (typeof evt !== 'undefined') {
      evt.preventDefault();
    }

    searchEl.focus();
  }

  window.theme.SearchPage = (function() {
    var selectors = {
      searchReset: '[data-search-page-predictive-search-clear]',
      searchInput: '[data-search-page-predictive-search-input]',
      searchSubmit: '[data-search-page-predictive-search-submit]',
      searchResults: '[data-predictive-search-mount="default"]'
    };

    var componentInstance;

    function init(config) {
      var searchInput = document.querySelector(selectors.searchInput);
      var searchSubmit = document.querySelector(selectors.searchSubmit);
      var searchUrl = searchInput.dataset.baseUrl;

      componentInstance = new window.Shopify.theme.PredictiveSearchComponent({
        selectors: {
          input: selectors.searchInput,
          reset: selectors.searchReset,
          result: selectors.searchResults
        },
        searchUrl: searchUrl,
        resultTemplateFct: window.theme.SearchResultsTemplate,
        numberOfResultsTemplateFct: numberOfResultsTemplateFct,
        loadingResultsMessageTemplateFct: loadingResultsMessageTemplateFct,
        onOpen: function(nodes) {
          if (config.isTabletAndUp) {
            return;
          }

          var searchInputBoundingRect = searchInput.getBoundingClientRect();
          var bodyHeight = document.body.offsetHeight;
          var offset = 50;
          var resultsMaxHeight =
            bodyHeight - searchInputBoundingRect.bottom - offset;

          nodes.result.style.maxHeight = resultsMaxHeight + 'px';
        },
        onBeforeDestroy: function(nodes) {
          // If the viewport width changes from mobile to tablet
          // reset the top position of the results
          nodes.result.style.maxHeight = '';
        }
      });

      validateSearchHandler(searchInput, searchSubmit);
    }

    function unload() {
      if (!componentInstance) {
        return;
      }
      componentInstance.destroy();
      componentInstance = null;
    }

    return {
      init: init,
      unload: unload
    };
  })();

  window.theme.SearchHeader = (function() {
    var selectors = {
      searchInput: '[data-predictive-search-drawer-input]',
      searchResults: '[data-predictive-search-mount="drawer"]',
      searchFormContainer: '[data-search-form-container]',
      searchSubmit: '[data-search-form-submit]'
    };

    var componentInstance;

    function init(config) {
      var searchInput = document.querySelector(selectors.searchInput);
      var searchSubmit = document.querySelector(selectors.searchSubmit);
      var searchUrl = searchInput.dataset.baseUrl;

      componentInstance = new window.Shopify.theme.PredictiveSearchComponent({
        selectors: {
          input: selectors.searchInput,
          result: selectors.searchResults
        },
        searchUrl: searchUrl,
        resultTemplateFct: window.theme.SearchResultsTemplate,
        numberOfResultsTemplateFct: numberOfResultsTemplateFct,
        numberOfResults: config.numberOfResults,
        loadingResultsMessageTemplateFct: loadingResultsMessageTemplateFct,
        onInputBlur: function() {
          return false;
        },
        onOpen: function(nodes) {
          var searchInputBoundingRect = searchInput.getBoundingClientRect();

          // For tablet screens and up, stop the scroll area from extending past
          // the bottom of the screen because we're locking the body scroll
          var maxHeight =
            window.innerHeight -
            searchInputBoundingRect.bottom -
            (config.isTabletAndUp ? 20 : 0);

          nodes.result.style.top = config.isTabletAndUp
            ? ''
            : searchInputBoundingRect.bottom + 'px';
          nodes.result.style.maxHeight = maxHeight + 'px';
        },
        onClose: function(nodes) {
          nodes.result.style.maxHeight = '';
        },
        onBeforeDestroy: function(nodes) {
          // If the viewport width changes from mobile to tablet
          // reset the top position of the results
          nodes.result.style.top = '';
        }
      });

      validateSearchHandler(searchInput, searchSubmit);
    }

    function unload() {
      if (!componentInstance) {
        return;
      }

      componentInstance.destroy();
      componentInstance = null;
    }

    function clearAndClose() {
      if (!componentInstance) {
        return;
      }

      componentInstance.clearAndClose();
    }

    return {
      init: init,
      unload: unload,
      clearAndClose: clearAndClose
    };
  })();

  window.theme.Search = (function() {
    var classes = {
      searchTemplate: 'template-search'
    };
    var selectors = {
      siteHeader: '.site-header'
    };
    var mediaQueryList = {
      mobile: window.matchMedia('(max-width: 749px)'),
      tabletAndUp: window.matchMedia('(min-width: 750px)')
    };

    function init() {
      if (!document.querySelector(selectors.siteHeader)) {
        return;
      }

      if (!canInitializePredictiveSearch()) {
        return;
      }

      Object.keys(mediaQueryList).forEach(function(device) {
        mediaQueryList[device].addListener(initSearchAccordingToViewport);
      });

      initSearchAccordingToViewport();
    }

    function initSearchAccordingToViewport() {
      theme.SearchDrawer.close();
      theme.SearchHeader.unload();
      theme.SearchPage.unload();

      if (mediaQueryList.mobile.matches) {
        theme.SearchHeader.init({
          numberOfResults: 4,
          isTabletAndUp: false
        });

        if (isSearchPage()) {
          theme.SearchPage.init({ isTabletAndUp: false });
        }
      } else {
        // Tablet and up
        theme.SearchHeader.init({
          numberOfResults: 4,
          isTabletAndUp: true
        });

        if (isSearchPage()) {
          theme.SearchPage.init({ isTabletAndUp: true });
        }
      }
    }

    function isSearchPage() {
      return document.body.classList.contains(classes.searchTemplate);
    }

    function unload() {
      theme.SearchHeader.unload();
      theme.SearchPage.unload();
    }

    return {
      init: init,
      unload: unload
    };
  })();
})();

window.theme = window.theme || {};

theme.SearchDrawer = (function() {
  var selectors = {
    headerSection: '[data-header-section]',
    drawer: '[data-predictive-search-drawer]',
    drawerOpenButton: '[data-predictive-search-open-drawer]',
    headerSearchInput: '[data-predictive-search-drawer-input]',
    predictiveSearchWrapper: '[data-predictive-search-mount="drawer"]'
  };

  var drawerInstance;

  function init() {
    setAccessibilityProps();

    drawerInstance = new theme.Drawers('SearchDrawer', 'top', {
      onDrawerOpen: function() {
        setHeight();
        theme.MobileNav.closeMobileNav();
        lockBodyScroll();
      },
      onDrawerClose: function() {
        theme.SearchHeader.clearAndClose();
        var drawerOpenButton = document.querySelector(
          selectors.drawerOpenButton
        );

        if (drawerOpenButton) drawerOpenButton.focus();

        unlockBodyScroll();
      },
      withPredictiveSearch: true,
      elementToFocusOnOpen: document.querySelector(selectors.headerSearchInput)
    });
  }

  function setAccessibilityProps() {
    var drawerOpenButton = document.querySelector(selectors.drawerOpenButton);

    if (drawerOpenButton) {
      drawerOpenButton.setAttribute('aria-controls', 'SearchDrawer');
      drawerOpenButton.setAttribute('aria-expanded', 'false');
      drawerOpenButton.setAttribute('aria-controls', 'dialog');
    }
  }

  function setHeight() {
    var searchDrawer = document.querySelector(selectors.drawer);
    var headerHeight = document.querySelector(selectors.headerSection)
      .offsetHeight;

    searchDrawer.style.height = headerHeight + 'px';
  }

  function close() {
    drawerInstance.close();
  }

  function lockBodyScroll() {
    theme.Helpers.enableScrollLock();
  }

  function unlockBodyScroll() {
    theme.Helpers.disableScrollLock();
  }

  return {
    init: init,
    close: close
  };
})();

theme.Disclosure = (function() {
  var selectors = {
    disclosureForm: '[data-disclosure-form]',
    disclosureList: '[data-disclosure-list]',
    disclosureToggle: '[data-disclosure-toggle]',
    disclosureInput: '[data-disclosure-input]',
    disclosureOptions: '[data-disclosure-option]'
  };

  var classes = {
    listVisible: 'disclosure-list--visible'
  };

  function Disclosure(disclosure) {
    this.container = disclosure;
    this._cacheSelectors();
    this._setupListeners();
  }

  Disclosure.prototype = Object.assign({}, Disclosure.prototype, {
    _cacheSelectors: function() {
      this.cache = {
        disclosureForm: this.container.closest(selectors.disclosureForm),
        disclosureList: this.container.querySelector(selectors.disclosureList),
        disclosureToggle: this.container.querySelector(
          selectors.disclosureToggle
        ),
        disclosureInput: this.container.querySelector(
          selectors.disclosureInput
        ),
        disclosureOptions: this.container.querySelectorAll(
          selectors.disclosureOptions
        )
      };
    },

    _setupListeners: function() {
      this.eventHandlers = this._setupEventHandlers();

      this.cache.disclosureToggle.addEventListener(
        'click',
        this.eventHandlers.toggleList
      );

      this.cache.disclosureOptions.forEach(function(disclosureOption) {
        disclosureOption.addEventListener(
          'click',
          this.eventHandlers.connectOptions
        );
      }, this);

      this.container.addEventListener(
        'keyup',
        this.eventHandlers.onDisclosureKeyUp
      );

      this.cache.disclosureList.addEventListener(
        'focusout',
        this.eventHandlers.onDisclosureListFocusOut
      );

      this.cache.disclosureToggle.addEventListener(
        'focusout',
        this.eventHandlers.onDisclosureToggleFocusOut
      );

      document.body.addEventListener('click', this.eventHandlers.onBodyClick);
    },

    _setupEventHandlers: function() {
      return {
        connectOptions: this._connectOptions.bind(this),
        toggleList: this._toggleList.bind(this),
        onBodyClick: this._onBodyClick.bind(this),
        onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
        onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
        onDisclosureToggleFocusOut: this._onDisclosureToggleFocusOut.bind(this)
      };
    },

    _connectOptions: function(event) {
      event.preventDefault();

      this._submitForm(event.currentTarget.dataset.value);
    },

    _onDisclosureToggleFocusOut: function(event) {
      var disclosureLostFocus =
        this.container.contains(event.relatedTarget) === false;

      if (disclosureLostFocus) {
        this._hideList();
      }
    },

    _onDisclosureListFocusOut: function(event) {
      var childInFocus = event.currentTarget.contains(event.relatedTarget);

      var isVisible = this.cache.disclosureList.classList.contains(
        classes.listVisible
      );

      if (isVisible && !childInFocus) {
        this._hideList();
      }
    },

    _onDisclosureKeyUp: function(event) {
      if (event.which !== slate.utils.keyboardKeys.ESCAPE) return;
      this._hideList();
      this.cache.disclosureToggle.focus();
    },

    _onBodyClick: function(event) {
      var isOption = this.container.contains(event.target);
      var isVisible = this.cache.disclosureList.classList.contains(
        classes.listVisible
      );

      if (isVisible && !isOption) {
        this._hideList();
      }
    },

    _submitForm: function(value) {
      this.cache.disclosureInput.value = value;
      this.cache.disclosureForm.submit();
    },

    _hideList: function() {
      this.cache.disclosureList.classList.remove(classes.listVisible);
      this.cache.disclosureToggle.setAttribute('aria-expanded', false);
    },

    _toggleList: function() {
      var ariaExpanded =
        this.cache.disclosureToggle.getAttribute('aria-expanded') === 'true';
      this.cache.disclosureList.classList.toggle(classes.listVisible);
      this.cache.disclosureToggle.setAttribute('aria-expanded', !ariaExpanded);
    },

    destroy: function() {
      this.cache.disclosureToggle.removeEventListener(
        'click',
        this.eventHandlers.toggleList
      );

      this.cache.disclosureOptions.forEach(function(disclosureOption) {
        disclosureOption.removeEventListener(
          'click',
          this.eventHandlers.connectOptions
        );
      }, this);

      this.container.removeEventListener(
        'keyup',
        this.eventHandlers.onDisclosureKeyUp
      );

      this.cache.disclosureList.removeEventListener(
        'focusout',
        this.eventHandlers.onDisclosureListFocusOut
      );

      this.cache.disclosureToggle.removeEventListener(
        'focusout',
        this.eventHandlers.onDisclosureToggleFocusOut
      );

      document.body.removeEventListener(
        'click',
        this.eventHandlers.onBodyClick
      );
    }
  });

  return Disclosure;
})();

theme.Zoom = (function() {
  var selectors = {
    imageZoom: '[data-image-zoom]'
  };

  var classes = {
    zoomImg: 'zoomImg'
  };

  var attributes = {
    imageZoomTarget: 'data-image-zoom-target'
  };

  function Zoom(container) {
    this.container = container;
    this.cache = {};
    this.url = container.dataset.zoom;

    this._cacheSelectors();

    if (!this.cache.sourceImage) return;

    this._duplicateImage();
  }

  Zoom.prototype = Object.assign({}, Zoom.prototype, {
    _cacheSelectors: function() {
      this.cache = {
        sourceImage: this.container.querySelector(selectors.imageZoom)
      };
    },

    _init: function() {
      var targetWidth = this.cache.targetImage.width;
      var targetHeight = this.cache.targetImage.height;

      if (this.cache.sourceImage === this.cache.targetImage) {
        this.sourceWidth = targetWidth;
        this.sourceHeight = targetHeight;
      } else {
        this.sourceWidth = this.cache.sourceImage.width;
        this.sourceHeight = this.cache.sourceImage.height;
      }

      this.xRatio =
        (this.cache.sourceImage.width - targetWidth) / this.sourceWidth;
      this.yRatio =
        (this.cache.sourceImage.height - targetHeight) / this.sourceHeight;
    },

    _start: function(e) {
      this._init();
      this._move(e);
    },

    _stop: function() {
      this.cache.targetImage.style.opacity = 0;
    },

    /**
     * Sets the correct coordinates top and left position in px
     * It sets a limit within between 0 and the max height of the image
     * So when the mouse leaves the target image, it could
     * never go above or beyond the target image zone
     */
    _setTopLeftMaxValues: function(top, left) {
      return {
        left: Math.max(Math.min(left, this.sourceWidth), 0),
        top: Math.max(Math.min(top, this.sourceHeight), 0)
      };
    },

    _move: function(e) {
      // get left and top position within the "source image" zone
      var left =
        e.pageX -
        (this.cache.sourceImage.getBoundingClientRect().left + window.scrollX);
      var top =
        e.pageY -
        (this.cache.sourceImage.getBoundingClientRect().top + window.scrollY);
      // make sure the left and top position don't go
      // above or beyond the target image zone
      var position = this._setTopLeftMaxValues(top, left);

      top = position.top;
      left = position.left;

      this.cache.targetImage.style.left = -(left * -this.xRatio) + 'px';
      this.cache.targetImage.style.top = -(top * -this.yRatio) + 'px';
      this.cache.targetImage.style.opacity = 1;
    },

    /**
     * This loads a high resolution image
     * via the data attributes url
     * It adds all necessary CSS styles and adds to the container
     */
    _duplicateImage: function() {
      this._loadImage()
        .then(
          function(image) {
            this.cache.targetImage = image;
            image.style.width = image.width + 'px';
            image.style.height = image.height + 'px';
            image.style.position = 'absolute';
            image.style.maxWidth = 'none';
            image.style.maxHeight = 'none';
            image.style.opacity = 0;
            image.style.border = 'none';
            image.style.left = 0;
            image.style.top = 0;

            this.container.appendChild(image);

            this._init();

            this._start = this._start.bind(this);
            this._stop = this._stop.bind(this);
            this._move = this._move.bind(this);

            this.container.addEventListener('mouseenter', this._start);
            this.container.addEventListener('mouseleave', this._stop);
            this.container.addEventListener('mousemove', this._move);

            this.container.style.position = 'relative';
            this.container.style.overflow = 'hidden';
          }.bind(this)
        )
        .catch(function(error) {
          // eslint-disable-next-line no-console
          console.warn('Error fetching image', error);
        });
    },

    _loadImage: function() {
      // eslint-disable-next-line
      return new Promise(function(resolve, reject) {
          var image = new Image();
          image.setAttribute('role', 'presentation');
          image.setAttribute(attributes.imageZoomTarget, true);
          image.classList.add(classes.zoomImg);
          image.src = this.url;

          image.addEventListener('load', function() {
            resolve(image);
          });

          image.addEventListener('error', function(error) {
            reject(error);
          });
        }.bind(this)
      );
    },

    unload: function() {
      var targetImage = this.container.querySelector(
        '[' + attributes.imageZoomTarget + ']'
      );
      if (targetImage) {
        targetImage.remove();
      }

      this.container.removeEventListener('mouseenter', this._start);
      this.container.removeEventListener('mouseleave', this._stop);
      this.container.removeEventListener('mousemove', this._move);
    }
  });

  return Zoom;
})();


/* ================ TEMPLATES ================ */
(function() {
  var filterBys = document.querySelectorAll('[data-blog-tag-filter]');

  if (!filterBys.length) return;

  slate.utils.resizeSelects(filterBys);

  filterBys.forEach(function(filterBy) {
    filterBy.addEventListener('change', function(evt) {
      location.href = evt.target.value;
    });
  });
})();

window.theme = theme || {};

theme.customerTemplates = (function() {
  var selectors = {
    RecoverHeading: '#RecoverHeading',
    RecoverEmail: '#RecoverEmail',
    LoginHeading: '#LoginHeading'
  };

  function initEventListeners() {
    this.recoverHeading = document.querySelector(selectors.RecoverHeading);
    this.recoverEmail = document.querySelector(selectors.RecoverEmail);
    this.loginHeading = document.querySelector(selectors.LoginHeading);
    var recoverPassword = document.getElementById('RecoverPassword');
    var hideRecoverPasswordLink = document.getElementById(
      'HideRecoverPasswordLink'
    );

    // Show reset password form
    if (recoverPassword) {
      recoverPassword.addEventListener(
        'click',
        function(evt) {
          evt.preventDefault();
          showRecoverPasswordForm();
          this.recoverHeading.setAttribute('tabindex', '-1');
          this.recoverHeading.focus();
        }.bind(this)
      );
    }

    // Hide reset password form
    if (hideRecoverPasswordLink) {
      hideRecoverPasswordLink.addEventListener(
        'click',
        function(evt) {
          evt.preventDefault();
          hideRecoverPasswordForm();
          this.loginHeading.setAttribute('tabindex', '-1');
          this.loginHeading.focus();
        }.bind(this)
      );
    }

    if (this.recoverHeading) {
      this.recoverHeading.addEventListener('blur', function(evt) {
        evt.target.removeAttribute('tabindex');
      });
    }

    if (this.loginHeading) {
      this.loginHeading.addEventListener('blur', function(evt) {
        evt.target.removeAttribute('tabindex');
      });
    }
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */

  function showRecoverPasswordForm() {
    document.getElementById('RecoverPasswordForm').classList.remove('hide');
    document.getElementById('CustomerLoginForm').classList.add('hide');

    if (this.recoverEmail.getAttribute('aria-invalid') === 'true') {
      this.recoverEmail.focus();
    }
  }

  function hideRecoverPasswordForm() {
    document.getElementById('RecoverPasswordForm').classList.add('hide');
    document.getElementById('CustomerLoginForm').classList.remove('hide');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var formState = document.querySelector('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!formState) {
      return;
    }

    // show success message
    var resetSuccess = document.getElementById('ResetSuccess');
    resetSuccess.classList.remove('hide');
    resetSuccess.focus();
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var newAddressForm = document.getElementById('AddressNewForm');
    var newAddressFormButton = document.getElementById('AddressNewButton');

    if (!newAddressForm) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        'AddressCountryNew',
        'AddressProvinceNew',
        {
          hideElement: 'AddressProvinceContainerNew'
        }
      );
    }

    // Initialize each edit form's country/province selector
    document
      .querySelectorAll('.address-country-option')
      .forEach(function(option) {
        var formId = option.dataset.formId;
        var countrySelector = 'AddressCountry_' + formId;
        var provinceSelector = 'AddressProvince_' + formId;
        var containerSelector = 'AddressProvinceContainer_' + formId;

        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
          hideElement: containerSelector
        });
      });

    // Toggle new/edit address forms
    document.querySelectorAll('.address-new-toggle').forEach(function(button) {
      button.addEventListener('click', function() {
        var isExpanded =
          newAddressFormButton.getAttribute('aria-expanded') === 'true';

        newAddressForm.classList.toggle('hide');
        newAddressFormButton.setAttribute('aria-expanded', !isExpanded);
        newAddressFormButton.focus();
      });
    });

    document.querySelectorAll('.address-edit-toggle').forEach(function(button) {
      button.addEventListener('click', function(evt) {
        var formId = evt.target.dataset.formId;
        var editButton = document.getElementById('EditFormButton_' + formId);
        var editAddress = document.getElementById('EditAddress_' + formId);
        var isExpanded = editButton.getAttribute('aria-expanded') === 'true';

        editAddress.classList.toggle('hide');
        editButton.setAttribute('aria-expanded', !isExpanded);
        editButton.focus();
      });
    });

    document.querySelectorAll('.address-delete').forEach(function(button) {
      button.addEventListener('click', function(evt) {
        var target = evt.target.dataset.target;
        var confirmMessage = evt.target.dataset.confirmMessage;

        // eslint-disable-next-line no-alert
        if (
          confirm(
            confirmMessage || 'Are you sure you wish to delete this address?'
          )
        ) {
          Shopify.postLink(target, {
            parameters: { _method: 'delete' }
          });
        }
      });
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      showRecoverPasswordForm.bind(this)();
    }
  }

  return {
    init: function() {
      initEventListeners();
      checkUrlHash();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();


/*================ SECTIONS ================*/
window.theme = window.theme || {};

theme.Cart = (function() {
  var selectors = {
    cartCount: '[data-cart-count]',
    cartCountBubble: '[data-cart-count-bubble]',
    cartDiscount: '[data-cart-discount]',
    cartDiscountTitle: '[data-cart-discount-title]',
    cartDiscountAmount: '[data-cart-discount-amount]',
    cartDiscountWrapper: '[data-cart-discount-wrapper]',
    cartErrorMessage: '[data-cart-error-message]',
    cartErrorMessageWrapper: '[data-cart-error-message-wrapper]',
    cartItem: '[data-cart-item]',
    cartItemDetails: '[data-cart-item-details]',
    cartItemDiscount: '[data-cart-item-discount]',
    cartItemDiscountedPriceGroup: '[data-cart-item-discounted-price-group]',
    cartItemDiscountTitle: '[data-cart-item-discount-title]',
    cartItemDiscountAmount: '[data-cart-item-discount-amount]',
    cartItemDiscountList: '[data-cart-item-discount-list]',
    cartItemFinalPrice: '[data-cart-item-final-price]',
    cartItemImage: '[data-cart-item-image]',
    cartItemLinePrice: '[data-cart-item-line-price]',
    cartItemOriginalPrice: '[data-cart-item-original-price]',
    cartItemPrice: '[data-cart-item-price]',
    cartItemPriceList: '[data-cart-item-price-list]',
    cartItemProperty: '[data-cart-item-property]',
    cartItemPropertyName: '[data-cart-item-property-name]',
    cartItemPropertyValue: '[data-cart-item-property-value]',
    cartItemRegularPriceGroup: '[data-cart-item-regular-price-group]',
    cartItemRegularPrice: '[data-cart-item-regular-price]',
    cartItemTitle: '[data-cart-item-title]',
    cartItemOption: '[data-cart-item-option]',
    cartItemSellingPlanName: '[data-cart-item-selling-plan-name]',
    cartLineItems: '[data-cart-line-items]',
    cartNote: '[data-cart-notes]',
    cartQuantityErrorMessage: '[data-cart-quantity-error-message]',
    cartQuantityErrorMessageWrapper:
      '[data-cart-quantity-error-message-wrapper]',
    cartRemove: '[data-cart-remove]',
    cartStatus: '[data-cart-status]',
    cartSubtotal: '[data-cart-subtotal]',
    cartTableCell: '[data-cart-table-cell]',
    cartWrapper: '[data-cart-wrapper]',
    emptyPageContent: '[data-empty-page-content]',
    quantityInput: '[data-quantity-input]',
    quantityInputMobile: '[data-quantity-input-mobile]',
    quantityInputDesktop: '[data-quantity-input-desktop]',
    quantityLabelMobile: '[data-quantity-label-mobile]',
    quantityLabelDesktop: '[data-quantity-label-desktop]',
    inputQty: '[data-quantity-input]',
    thumbnails: '.cart__image',
    unitPrice: '[data-unit-price]',
    unitPriceBaseUnit: '[data-unit-price-base-unit]',
    unitPriceGroup: '[data-unit-price-group]'
  };

  var classes = {
    cartNoCookies: 'cart--no-cookies',
    cartRemovedProduct: 'cart__removed-product',
    thumbnails: 'cart__image',
    hide: 'hide',
    inputError: 'input--error'
  };

  var attributes = {
    cartItemIndex: 'data-cart-item-index',
    cartItemKey: 'data-cart-item-key',
    cartItemQuantity: 'data-cart-item-quantity',
    cartItemTitle: 'data-cart-item-title',
    cartItemUrl: 'data-cart-item-url',
    quantityItem: 'data-quantity-item'
  };

  var mediumUpQuery = '(min-width: ' + theme.breakpoints.medium + 'px)';

  function Cart(container) {
    this.container = container;
    this.thumbnails = this.container.querySelectorAll(selectors.thumbnails);
    this.quantityInputs = this.container.querySelectorAll(selectors.inputQty);
    this.ajaxEnabled =
      this.container.getAttribute('data-ajax-enabled') === 'true';

    this._handleInputQty = theme.Helpers.debounce(
      this._handleInputQty.bind(this),
      500
    );
    this.setQuantityFormControllers = this.setQuantityFormControllers.bind(
      this
    );
    this._onNoteChange = this._onNoteChange.bind(this);
    this._onRemoveItem = this._onRemoveItem.bind(this);

    if (!theme.Helpers.cookiesEnabled()) {
      this.container.classList.add(classes.cartNoCookies);
    }

    this.thumbnails.forEach(function(element) {
      element.style.cursor = 'pointer';
    });

    this.container.addEventListener('click', this._handleThumbnailClick);
    this.container.addEventListener('change', this._handleInputQty);

    this.mql = window.matchMedia(mediumUpQuery);
    this.mql.addListener(this.setQuantityFormControllers);

    this.setQuantityFormControllers();

    if (this.ajaxEnabled) {
      /**
       * Because the entire cart is recreated when a cart item is updated,
       * we cannot cache the elements in the cart. Instead, we add the event
       * listeners on the cart's container to allow us to retain the event
       * listeners after rebuilding the cart when an item is updated.
       */
      this.container.addEventListener('click', this._onRemoveItem);
      this.container.addEventListener('change', this._onNoteChange);

      this._setupCartTemplates();
    }
  }

  Cart.prototype = Object.assign({}, Cart.prototype, {
    _setupCartTemplates: function() {
      var cartItem = this.container.querySelector(selectors.cartItem);
      if (!cartItem) return;

      this.itemTemplate = this.container
        .querySelector(selectors.cartItem)
        .cloneNode(true);

      this.itemDiscountTemplate = this.itemTemplate
        .querySelector(selectors.cartItemDiscount)
        .cloneNode(true);

      this.cartDiscountTemplate = this.container
        .querySelector(selectors.cartDiscount)
        .cloneNode(true);

      this.itemPriceListTemplate = this.itemTemplate
        .querySelector(selectors.cartItemPriceList)
        .cloneNode(true);

      this.itemOptionTemplate = this.itemTemplate
        .querySelector(selectors.cartItemOption)
        .cloneNode(true);

      this.itemPropertyTemplate = this.itemTemplate
        .querySelector(selectors.cartItemProperty)
        .cloneNode(true);

      this.itemSellingPlanNameTemplate = this.itemTemplate
        .querySelector(selectors.cartItemSellingPlanName)
        .cloneNode(true);
    },

    _handleInputQty: function(evt) {
      if (!evt.target.hasAttribute('data-quantity-input')) return;

      var input = evt.target;
      var itemElement = input.closest(selectors.cartItem);

      var itemIndex = Number(input.getAttribute('data-quantity-item'));

      var itemQtyInputs = this.container.querySelectorAll(
        "[data-quantity-item='" + itemIndex + "']"
      );

      var value = parseInt(input.value);

      var isValidValue = !(value < 0 || isNaN(value));

      itemQtyInputs.forEach(function(element) {
        element.value = value;
      });

      this._hideCartError();
      this._hideQuantityErrorMessage();

      if (!isValidValue) {
        this._showQuantityErrorMessages(itemElement);
        return;
      }

      if (isValidValue && this.ajaxEnabled) {
        this._updateItemQuantity(itemIndex, itemElement, itemQtyInputs, value);
      }
    },

    _updateItemQuantity: function(
      itemIndex,
      itemElement,
      itemQtyInputs,
      value
    ) {
      var key = itemElement.getAttribute(attributes.cartItemKey);
      var index = Number(itemElement.getAttribute(attributes.cartItemIndex));

      var request = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;'
        },
        body: JSON.stringify({
          line: index,
          quantity: value
        })
      };

      fetch('/cart/change.js', request)
        .then(function(response) {
          return response.json();
        })
        .then(
          function(state) {
            this._setCartCountBubble(state.item_count);

            if (!state.item_count) {
              this._emptyCart();
              return;
            }

            // Cache current in-focus element, used later to restore focus
            var inFocus = document.activeElement;

            this._createCart(state);

            if (!value) {
              this._showRemoveMessage(itemElement.cloneNode(true));
              return;
            }

            var item = this.getItem(key, state);

            this._updateLiveRegion(item);

            // Restore focus to the "equivalent" element after the DOM has been updated
            if (!inFocus) return;
            var row = inFocus.closest('[' + attributes.cartItemIndex + ']');
            if (!row) return;
            var target = this.container.querySelector(
              '[' +
                attributes.cartItemIndex +
                '="' +
                row.getAttribute(attributes.cartItemIndex) +
                '"] [data-role="' +
                inFocus.getAttribute('data-role') +
                '"]'
            );
            if (!target) return;
            target.focus();
          }.bind(this)
        )
        .catch(
          function() {
            this._showCartError(null);
          }.bind(this)
        );
    },

    getItem: function(key, state) {
      return state.items.find(function(item) {
        return item.key === key;
      });
    },

    _liveRegionText: function(item) {
      // Dummy content for live region
      var liveRegionText =
        theme.strings.update +
        ': [QuantityLabel]: [Quantity], [Regular] [$$] [DiscountedPrice] [$]. [PriceInformation]';

      // Update Quantity
      liveRegionText = liveRegionText
        .replace('[QuantityLabel]', theme.strings.quantity)
        .replace('[Quantity]', item.quantity);

      // Update pricing information
      var regularLabel = '';
      var regularPrice = theme.Currency.formatMoney(
        item.original_line_price,
        theme.moneyFormat
      );
      var discountLabel = '';
      var discountPrice = '';
      var discountInformation = '';

      if (item.original_line_price > item.final_line_price) {
        regularLabel = theme.strings.regularTotal;

        discountLabel = theme.strings.discountedTotal;
        discountPrice = theme.Currency.formatMoney(
          item.final_line_price,
          theme.moneyFormat
        );

        discountInformation = theme.strings.priceColumn;
      }

      liveRegionText = liveRegionText
        .replace('[Regular]', regularLabel)
        .replace('[$$]', regularPrice)
        .replace('[DiscountedPrice]', discountLabel)
        .replace('[$]', discountPrice)
        .replace('[PriceInformation]', discountInformation)
        .trim();

      return liveRegionText;
    },

    _updateLiveRegion: function(item) {
      if (!item) return;

      var liveRegion = this.container.querySelector(selectors.cartStatus);

      liveRegion.textContent = this._liveRegionText(item);
      liveRegion.setAttribute('aria-hidden', false);

      setTimeout(function() {
        liveRegion.setAttribute('aria-hidden', true);
      }, 1000);
    },

    _createCart: function(state) {
      var cartDiscountList = this._createCartDiscountList(state);

      var cartTable = this.container.querySelector(selectors.cartLineItems);
      cartTable.innerHTML = '';

      this._createLineItemList(state).forEach(function(lineItem) {
        cartTable.appendChild(lineItem);
      });

      this.setQuantityFormControllers();

      this.cartNotes =
        this.cartNotes || this.container.querySelector(selectors.cartNote);

      if (this.cartNotes) {
        this.cartNotes.value = state.note;
      }

      var discountWrapper = this.container.querySelector(
        selectors.cartDiscountWrapper
      );

      if (cartDiscountList.length === 0) {
        discountWrapper.innerHTML = '';
        discountWrapper.classList.add(classes.hide);
      } else {
        discountWrapper.innerHTML = '';

        cartDiscountList.forEach(function(discountItem) {
          discountWrapper.appendChild(discountItem);
        });

        discountWrapper.classList.remove(classes.hide);
      }

      this.container.querySelector(
        selectors.cartSubtotal
      ).innerHTML = theme.Currency.formatMoney(
        state.total_price,
        theme.moneyFormatWithCurrency
      );
    },

    _createCartDiscountList: function(cart) {
      return cart.cart_level_discount_applications.map(
        function(discount) {
          var discountNode = this.cartDiscountTemplate.cloneNode(true);

          discountNode.querySelector(selectors.cartDiscountTitle).textContent =
            discount.title;

          discountNode.querySelector(
            selectors.cartDiscountAmount
          ).innerHTML = theme.Currency.formatMoney(
            discount.total_allocated_amount,
            theme.moneyFormat
          );

          return discountNode;
        }.bind(this)
      );
    },

    _createLineItemList: function(state) {
      return state.items.map(
        function(item, index) {
          var itemNode = this.itemTemplate.cloneNode(true);

          var itemPriceList = this.itemPriceListTemplate.cloneNode(true);

          this._setLineItemAttributes(itemNode, item, index);
          this._setLineItemImage(itemNode, item.featured_image);

          var cartItemTitle = itemNode.querySelector(selectors.cartItemTitle);
          cartItemTitle.textContent = item.product_title;
          cartItemTitle.setAttribute('href', item.url);

          var selling_plan_name = item.selling_plan_allocation
            ? item.selling_plan_allocation.selling_plan.name
            : null;

          var productDetailsList = this._createProductDetailsList(
            item.product_has_only_default_variant,
            item.options_with_values,
            item.properties,
            selling_plan_name
          );

          this._setProductDetailsList(itemNode, productDetailsList);

          this._setItemRemove(itemNode, item.title);

          itemPriceList.innerHTML = this._createItemPrice(
            item.original_price,
            item.final_price
          ).outerHTML;

          if (item.unit_price_measurement) {
            itemPriceList.appendChild(
              this._createUnitPrice(
                item.unit_price,
                item.unit_price_measurement
              )
            );
          }

          this._setItemPrice(itemNode, itemPriceList);

          var itemDiscountList = this._createItemDiscountList(item);
          this._setItemDiscountList(itemNode, itemDiscountList);
          this._setQuantityInputs(itemNode, item, index);

          var itemLinePrice = this._createItemPrice(
            item.original_line_price,
            item.final_line_price
          );

          this._setItemLinePrice(itemNode, itemLinePrice);

          return itemNode;
        }.bind(this)
      );
    },

    _setLineItemAttributes: function(itemNode, item, index) {
      itemNode.setAttribute(attributes.cartItemKey, item.key);
      itemNode.setAttribute(attributes.cartItemUrl, item.url);
      itemNode.setAttribute(attributes.cartItemTitle, item.title);
      itemNode.setAttribute(attributes.cartItemIndex, index + 1);
      itemNode.setAttribute(attributes.cartItemQuantity, item.quantity);
    },

    _setLineItemImage: function(itemNode, featuredImage) {
      var image = itemNode.querySelector(selectors.cartItemImage);

      var sizedImageUrl =
        featuredImage.url !== null
          ? theme.Images.getSizedImageUrl(featuredImage.url, 'x190')
          : null;

      if (sizedImageUrl) {
        image.setAttribute('alt', featuredImage.alt);
        image.setAttribute('src', sizedImageUrl);
        image.classList.remove(classes.hide);
      } else {
        image.parentNode.removeChild(image);
      }
    },

    _setProductDetailsList: function(item, productDetailsList) {
      var itemDetails = item.querySelector(selectors.cartItemDetails);

      if (productDetailsList.length) {
        itemDetails.classList.remove(classes.hide);
        itemDetails.innerHTML = productDetailsList.reduce(function(
          result,
          element
        ) {
          return result + element.outerHTML;
        },
        '');

        return;
      }

      itemDetails.classList.add(classes.hide);
      itemDetails.textContent = '';
    },

    _setItemPrice: function(item, price) {
      item.querySelector(selectors.cartItemPrice).innerHTML = price.outerHTML;
    },

    _setItemDiscountList: function(item, discountList) {
      var itemDiscountList = item.querySelector(selectors.cartItemDiscountList);

      if (discountList.length === 0) {
        itemDiscountList.innerHTML = '';
        itemDiscountList.classList.add(classes.hide);
      } else {
        itemDiscountList.innerHTML = discountList.reduce(function(
          result,
          element
        ) {
          return result + element.outerHTML;
        },
        '');

        itemDiscountList.classList.remove(classes.hide);
      }
    },

    _setItemRemove: function(item, title) {
      item
        .querySelector(selectors.cartRemove)
        .setAttribute(
          'aria-label',
          theme.strings.removeLabel.replace('[product]', title)
        );
    },

    _setQuantityInputs: function(itemNode, item, index) {
      var mobileInput = itemNode.querySelector(selectors.quantityInputMobile);
      var desktopInput = itemNode.querySelector(selectors.quantityInputDesktop);

      mobileInput.setAttribute('id', 'updates_' + item.key);
      desktopInput.setAttribute('id', 'updates_large_' + item.key);

      [mobileInput, desktopInput].forEach(function(element) {
        element.setAttribute(attributes.quantityItem, index + 1);
        element.value = item.quantity;
      });

      itemNode
        .querySelector(selectors.quantityLabelMobile)
        .setAttribute('for', 'updates_' + item.key);

      itemNode
        .querySelector(selectors.quantityLabelDesktop)
        .setAttribute('for', 'updates_large_' + item.key);
    },

    setQuantityFormControllers: function() {
      var desktopQuantityInputs = document.querySelectorAll(
        selectors.quantityInputDesktop
      );

      var mobileQuantityInputs = document.querySelectorAll(
        selectors.quantityInputMobile
      );

      if (this.mql.matches) {
        addNameAttribute(desktopQuantityInputs);
        removeNameAttribute(mobileQuantityInputs);
      } else {
        addNameAttribute(mobileQuantityInputs);
        removeNameAttribute(desktopQuantityInputs);
      }

      function addNameAttribute(inputs) {
        inputs.forEach(function(element) {
          element.setAttribute('name', 'updates[]');
        });
      }

      function removeNameAttribute(inputs) {
        inputs.forEach(function(element) {
          element.removeAttribute('name');
        });
      }
    },

    _setItemLinePrice: function(item, price) {
      item.querySelector(selectors.cartItemLinePrice).innerHTML =
        price.outerHTML;
    },

    _createProductDetailsList: function(
      product_has_only_default_variant,
      options,
      properties,
      selling_plan_name
    ) {
      var optionsPropertiesHTML = [];

      if (!product_has_only_default_variant) {
        optionsPropertiesHTML = optionsPropertiesHTML.concat(
          this._getOptionList(options)
        );
      }

      if (selling_plan_name) {
        optionsPropertiesHTML = optionsPropertiesHTML.concat(
          this._getSellingPlanName(selling_plan_name)
        );
      }

      if (properties !== null && Object.keys(properties).length !== 0) {
        optionsPropertiesHTML = optionsPropertiesHTML.concat(
          this._getPropertyList(properties)
        );
      }

      return optionsPropertiesHTML;
    },

    _getOptionList: function(options) {
      return options.map(
        function(option) {
          var optionElement = this.itemOptionTemplate.cloneNode(true);

          optionElement.textContent = option.name + ': ' + option.value;
          optionElement.classList.remove(classes.hide);

          return optionElement;
        }.bind(this)
      );
    },

    _getPropertyList: function(properties) {
      var propertiesArray =
        properties !== null ? Object.entries(properties) : [];

      var filteredPropertiesArray = propertiesArray.filter(function(property) {
        // Line item properties prefixed with an underscore are not to be displayed
        // if the property value has a length of 0 (empty), don't display it
        if (property[0].charAt(0) === '_' || property[1].length === 0) {
          return false;
        } else {
          return true;
        }
      });

      return filteredPropertiesArray.map(
        function(property) {
          var propertyElement = this.itemPropertyTemplate.cloneNode(true);

          propertyElement.querySelector(
            selectors.cartItemPropertyName
          ).textContent = property[0] + ': ';

          if (property[0].indexOf('/uploads/') === -1) {
            propertyElement.querySelector(
              selectors.cartItemPropertyValue
            ).textContent = property[1];
          } else {
            propertyElement.querySelector(
              selectors.cartItemPropertyValue
            ).innerHTML =
              '<a href="' +
              property[1] +
              '"> ' +
              property[1].split('/').pop() +
              '</a>';
          }

          propertyElement.classList.remove(classes.hide);

          return propertyElement;
        }.bind(this)
      );
    },

    _getSellingPlanName: function(selling_plan_name) {
      var sellingPlanNameElement = this.itemSellingPlanNameTemplate.cloneNode(
        true
      );

      sellingPlanNameElement.textContent = selling_plan_name;
      sellingPlanNameElement.classList.remove(classes.hide);

      return sellingPlanNameElement;
    },

    _createItemPrice: function(original_price, final_price) {
      var originalPriceHTML = theme.Currency.formatMoney(
        original_price,
        theme.moneyFormat
      );

      var resultHTML;

      if (original_price !== final_price) {
        resultHTML = this.itemPriceListTemplate
          .querySelector(selectors.cartItemDiscountedPriceGroup)
          .cloneNode(true);

        resultHTML.querySelector(
          selectors.cartItemOriginalPrice
        ).innerHTML = originalPriceHTML;

        resultHTML.querySelector(
          selectors.cartItemFinalPrice
        ).innerHTML = theme.Currency.formatMoney(
          final_price,
          theme.moneyFormat
        );
      } else {
        resultHTML = this.itemPriceListTemplate
          .querySelector(selectors.cartItemRegularPriceGroup)
          .cloneNode(true);

        resultHTML.querySelector(
          selectors.cartItemRegularPrice
        ).innerHTML = originalPriceHTML;
      }

      resultHTML.classList.remove(classes.hide);
      return resultHTML;
    },

    _createUnitPrice: function(unitPrice, unitPriceMeasurement) {
      var unitPriceGroup = this.itemPriceListTemplate
        .querySelector(selectors.unitPriceGroup)
        .cloneNode(true);

      var unitPriceBaseUnit =
        (unitPriceMeasurement.reference_value !== 1
          ? unitPriceMeasurement.reference_value
          : '') + unitPriceMeasurement.reference_unit;

      unitPriceGroup.querySelector(
        selectors.unitPriceBaseUnit
      ).textContent = unitPriceBaseUnit;

      unitPriceGroup.querySelector(
        selectors.unitPrice
      ).innerHTML = theme.Currency.formatMoney(unitPrice, theme.moneyFormat);

      unitPriceGroup.classList.remove(classes.hide);

      return unitPriceGroup;
    },

    _createItemDiscountList: function(item) {
      return item.line_level_discount_allocations.map(
        function(discount) {
          var discountNode = this.itemDiscountTemplate.cloneNode(true);

          discountNode.querySelector(
            selectors.cartItemDiscountTitle
          ).textContent = discount.discount_application.title;

          discountNode.querySelector(
            selectors.cartItemDiscountAmount
          ).innerHTML = theme.Currency.formatMoney(
            discount.amount,
            theme.moneyFormat
          );

          return discountNode;
        }.bind(this)
      );
    },

    _showQuantityErrorMessages: function(itemElement) {
      itemElement
        .querySelectorAll(selectors.cartQuantityErrorMessage)
        .forEach(function(element) {
          element.textContent = theme.strings.quantityMinimumMessage;
        });

      itemElement
        .querySelectorAll(selectors.cartQuantityErrorMessageWrapper)
        .forEach(function(element) {
          element.classList.remove(classes.hide);
        });

      itemElement
        .querySelectorAll(selectors.inputQty)
        .forEach(function(element) {
          element.classList.add(classes.inputError);
          element.focus();
        });
    },

    _hideQuantityErrorMessage: function() {
      var errorMessages = document.querySelectorAll(
        selectors.cartQuantityErrorMessageWrapper
      );

      errorMessages.forEach(function(element) {
        element.classList.add(classes.hide);

        element.querySelector(selectors.cartQuantityErrorMessage).textContent =
          '';
      });

      this.container
        .querySelectorAll(selectors.inputQty)
        .forEach(function(element) {
          element.classList.remove(classes.inputError);
        });
    },

    _handleThumbnailClick: function(evt) {
      if (!evt.target.classList.contains(classes.thumbnails)) return;

      window.location.href = evt.target
        .closest(selectors.cartItem)
        .getAttribute('data-cart-item-url');
    },

    _onNoteChange: function(evt) {
      if (!evt.target.hasAttribute('data-cart-notes')) return;

      var note = evt.target.value;
      this._hideCartError();
      this._hideQuantityErrorMessage();

      var headers = new Headers({ 'Content-Type': 'application/json' });

      var request = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ note: note })
      };

      fetch('/cart/update.js', request).catch(
        function() {
          this._showCartError(evt.target);
        }.bind(this)
      );
    },

    _showCartError: function(elementToFocus) {
      document.querySelector(selectors.cartErrorMessage).textContent =
        theme.strings.cartError;

      document
        .querySelector(selectors.cartErrorMessageWrapper)
        .classList.remove(classes.hide);

      if (!elementToFocus) return;
      elementToFocus.focus();
    },

    _hideCartError: function() {
      document
        .querySelector(selectors.cartErrorMessageWrapper)
        .classList.add(classes.hide);
      document.querySelector(selectors.cartErrorMessage).textContent = '';
    },

    _onRemoveItem: function(evt) {
      if (!evt.target.hasAttribute('data-cart-remove')) return;

      evt.preventDefault();
      var lineItem = evt.target.closest(selectors.cartItem);
      var index = Number(lineItem.getAttribute(attributes.cartItemIndex));

      this._hideCartError();

      var request = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;'
        },
        body: JSON.stringify({
          line: index,
          quantity: 0
        })
      };

      fetch('/cart/change.js', request)
        .then(function(response) {
          return response.json();
        })
        .then(
          function(state) {
            if (state.item_count === 0) {
              this._emptyCart();
            } else {
              this._createCart(state);
              this._showRemoveMessage(lineItem.cloneNode(true));
            }

            this._setCartCountBubble(state.item_count);
          }.bind(this)
        )
        .catch(
          function() {
            this._showCartError(null);
          }.bind(this)
        );
    },

    _showRemoveMessage: function(lineItem) {
      var index = lineItem.getAttribute('data-cart-item-index');
      var removeMessage = this._getRemoveMessage(lineItem);

      if (index - 1 === 0) {
        this.container
          .querySelector('[data-cart-item-index="1"]')
          .insertAdjacentHTML('beforebegin', removeMessage.outerHTML);
      } else {
        this.container
          .querySelector("[data-cart-item-index='" + (index - 1) + "']")
          .insertAdjacentHTML('afterend', removeMessage.outerHTML);
      }

      this.container.querySelector('[data-removed-item-row]').focus();
    },

    _getRemoveMessage: function(lineItem) {
      var formattedMessage = this._formatRemoveMessage(lineItem);

      var tableCell = lineItem
        .querySelector(selectors.cartTableCell)
        .cloneNode(true);

      tableCell.removeAttribute('class');
      tableCell.classList.add(classes.cartRemovedProduct);
      tableCell.setAttribute('colspan', '4');
      tableCell.innerHTML = formattedMessage;

      lineItem.setAttribute('role', 'alert');
      lineItem.setAttribute('tabindex', '-1');
      lineItem.setAttribute('data-removed-item-row', true);
      lineItem.innerHTML = tableCell.outerHTML;

      return lineItem;
    },

    _formatRemoveMessage: function(lineItem) {
      var quantity = lineItem.getAttribute('data-cart-item-quantity');
      var url = lineItem.getAttribute(attributes.cartItemUrl);
      var title = lineItem.getAttribute(attributes.cartItemTitle);

      return theme.strings.removedItemMessage
        .replace('[quantity]', quantity)
        .replace(
          '[link]',
          '<a ' +
            'href="' +
            url +
            '" class="text-link text-link--accent">' +
            title +
            '</a>'
        );
    },

    _setCartCountBubble: function(quantity) {
      this.cartCountBubble =
        this.cartCountBubble ||
        document.querySelector(selectors.cartCountBubble);

      this.cartCount =
        this.cartCount || document.querySelector(selectors.cartCount);

      if (quantity > 0) {
        this.cartCountBubble.classList.remove(classes.hide);
        this.cartCount.textContent = quantity;
      } else {
        this.cartCountBubble.classList.add(classes.hide);
        this.cartCount.textContent = '';
      }
    },

    _emptyCart: function() {
      this.emptyPageContent =
        this.emptyPageContent ||
        this.container.querySelector(selectors.emptyPageContent);

      this.cartWrapper =
        this.cartWrapper || this.container.querySelector(selectors.cartWrapper);

      this.emptyPageContent.classList.remove(classes.hide);
      this.cartWrapper.classList.add(classes.hide);
    }
  });

  return Cart;
})();

window.theme = window.theme || {};

theme.Filters = (function() {
  var settings = {
    mediaQueryMediumUp: '(min-width: ' + theme.breakpoints.medium + 'px)'
  };

  var selectors = {
    filterSelection: '#FilterTags',
    sortSelection: '#SortBy',
    selectInput: '[data-select-input]'
  };

  function Filters(container) {
    this.filterSelect = container.querySelector(selectors.filterSelection);
    this.sortSelect = container.querySelector(selectors.sortSelection);

    this.selects = document.querySelectorAll(selectors.selectInput);

    if (this.sortSelect) {
      this.defaultSort = this._getDefaultSortValue();
    }

    if (this.selects.length) {
      this.selects.forEach(function(select) {
        select.classList.remove('hidden');
      });
    }

    this.initBreakpoints = this._initBreakpoints.bind(this);

    this.mql = window.matchMedia(settings.mediaQueryMediumUp);
    this.mql.addListener(this.initBreakpoints);

    if (this.filterSelect) {
      this.filterSelect.addEventListener(
        'change',
        this._onFilterChange.bind(this)
      );
    }

    if (this.sortSelect) {
      this.sortSelect.addEventListener('change', this._onSortChange.bind(this));
    }

    theme.Helpers.promiseStylesheet().then(
      function() {
        this._initBreakpoints();
      }.bind(this)
    );
    this._initParams();
  }

  Filters.prototype = Object.assign({}, Filters.prototype, {
    _initBreakpoints: function() {
      if (this.mql.matches) {
        slate.utils.resizeSelects(this.selects);
      }
    },

    _initParams: function() {
      this.queryParams = {};
      if (location.search.length) {
        var aKeyValue;
        var aCouples = location.search.substr(1).split('&');
        for (var i = 0; i < aCouples.length; i++) {
          aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
            this.queryParams[
              decodeURIComponent(aKeyValue[0])
            ] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }
    },

    _onSortChange: function() {
      this.queryParams.sort_by = this._getSortValue();

      if (this.queryParams.page) {
        delete this.queryParams.page;
      }

      window.location.search = decodeURIComponent(
        new URLSearchParams(Object.entries(this.queryParams)).toString()
      );
    },

    _onFilterChange: function() {
      document.location.href = this._getFilterValue();
    },

    _getFilterValue: function() {
      return this.filterSelect.value;
    },

    _getSortValue: function() {
      return this.sortSelect.value || this.defaultSort;
    },

    _getDefaultSortValue: function() {
      return this.sortSelect.dataset.defaultSortby;
    },

    onUnload: function() {
      if (this.filterSelect) {
        this.filterSelect.removeEventListener('change', this._onFilterChange);
      }

      if (this.sortSelect) {
        this.sortSelect.removeEventListener('change', this._onSortChange);
      }

      this.mql.removeListener(this.initBreakpoints);
    }
  });

  return Filters;
})();

window.theme = window.theme || {};

theme.HeaderSection = (function() {
  function Header() {
    theme.Header.init();
    theme.MobileNav.init();
    theme.SearchDrawer.init();
    theme.Search.init();
  }

  Header.prototype = Object.assign({}, Header.prototype, {
    onUnload: function() {
      theme.Header.unload();
      theme.Search.unload();
      theme.MobileNav.unload();
    }
  });

  return Header;
})();

theme.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];

  var errors = {
    addressNoResults: theme.strings.addressNoResults,
    addressQueryLimit: theme.strings.addressQueryLimit,
    addressError: theme.strings.addressError,
    authError: theme.strings.authError
  };

  var selectors = {
    section: '[data-section-type="map"]',
    map: '[data-map]',
    mapOverlay: '[data-map-overlay]'
  };

  var classes = {
    mapError: 'map-section--load-error',
    errorMsg: 'map-section__error errors text-center'
  };

  // Global function called by Google on auth errors.
  // Show an auto error message on all map instances.
  // eslint-disable-next-line camelcase, no-unused-vars
  window.gm_authFailure = function() {
    if (!Shopify.designMode) {
      return;
    }

    document.querySelector(selectors.section).classList.add(classes.mapError);
    document.querySelector(selectors.map).remove();
    document
      .querySelector(selectors.mapOverlay)
      .insertAdjacentHTML(
        'afterend',
        '<div class="' +
          classes.errorMsg +
          '">' +
          theme.strings.authError +
          '</div>'
      );
  };

  function Map(container) {
    this.map = container.querySelector(selectors.map);
    if (!this.map) return;
    this.key = this.map.dataset.apiKey;

    if (typeof this.key === 'undefined') {
      return;
    }

    if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          theme.Helpers.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + this.key
          ).then(function() {
            apiStatus = 'loaded';
            initAllMaps();
          });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    mapsToLoad.forEach(function(map) {
      map.createMap();
    });
  }

  function geolocate(map) {
    return new Promise(function(resolve, reject) {
      var geocoder = new google.maps.Geocoder();
      var address = map.dataset.addressSetting;

      geocoder.geocode({ address: address }, function(results, status) {
        if (status !== google.maps.GeocoderStatus.OK) {
          reject(status);
        }

        resolve(results);
      });
    });
  }

  Map.prototype = Object.assign({}, Map.prototype, {
    createMap: function() {
      return geolocate(this.map)
        .then(
          function(results) {
            var mapOptions = {
              zoom: config.zoom,
              center: results[0].geometry.location,
              draggable: false,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true
            };

            var map = (this.map = new google.maps.Map(this.map, mapOptions));
            var center = (this.center = map.getCenter());

            //eslint-disable-next-line no-unused-vars
            var marker = new google.maps.Marker({
              map: map,
              position: map.getCenter()
            });

            google.maps.event.addDomListener(
              window,
              'resize',
              theme.Helpers.debounce(
                function() {
                  google.maps.event.trigger(map, 'resize');
                  map.setCenter(center);
                  this.map.removeAttribute('style');
                }.bind(this),
                250
              )
            );
          }.bind(this)
        )
        .catch(
          function() {
            var errorMessage;

            switch (status) {
              case 'ZERO_RESULTS':
                errorMessage = errors.addressNoResults;
                break;
              case 'OVER_QUERY_LIMIT':
                errorMessage = errors.addressQueryLimit;
                break;
              case 'REQUEST_DENIED':
                errorMessage = errors.authError;
                break;
              default:
                errorMessage = errors.addressError;
                break;
            }

            // Show errors only to merchant in the editor.
            if (Shopify.designMode) {
              this.map.parentNode.classList.add(classes.mapError);
              this.map.parentNode.innerHTML =
                '<div class="' +
                classes.errorMsg +
                '">' +
                errorMessage +
                '</div>';
            }
          }.bind(this)
        );
    },

    onUnload: function() {
      if (this.map) {
        google.maps.event.clearListeners(this.map, 'resize');
      }
    }
  });

  return Map;
})();

/* eslint-disable no-new */
theme.Product = (function() {
  function Product(container) {
    this.container = container;
    var sectionId = container.getAttribute('data-section-id');
    this.zoomPictures = [];
    this.ajaxEnabled = container.getAttribute('data-ajax-enabled') === 'true';

    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 749px)',
      bpSmall: false,
      enableHistoryState:
        container.getAttribute('data-enable-history-state') || false,
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      zoomEnabled: false
    };

    this.selectors = {
      addToCart: '[data-add-to-cart]',
      addToCartText: '[data-add-to-cart-text]',
      cartCount: '[data-cart-count]',
      cartCountBubble: '[data-cart-count-bubble]',
      cartPopup: '[data-cart-popup]',
      cartPopupCartQuantity: '[data-cart-popup-cart-quantity]',
      cartPopupClose: '[data-cart-popup-close]',
      cartPopupDismiss: '[data-cart-popup-dismiss]',
      cartPopupImage: '[data-cart-popup-image]',
      cartPopupImageWrapper: '[data-cart-popup-image-wrapper]',
      cartPopupImagePlaceholder: '[data-image-loading-animation]',
      cartPopupProductDetails: '[data-cart-popup-product-details]',
      cartPopupQuantity: '[data-cart-popup-quantity]',
      cartPopupQuantityLabel: '[data-cart-popup-quantity-label]',
      cartPopupTitle: '[data-cart-popup-title]',
      cartPopupWrapper: '[data-cart-popup-wrapper]',
      loader: '[data-loader]',
      loaderStatus: '[data-loader-status]',
      quantity: '[data-quantity-input]',
      SKU: '.variant-sku',
      productStatus: '[data-product-status]',
      originalSelectorId: '#ProductSelect-' + sectionId,
      productForm: '[data-product-form]',
      errorMessage: '[data-error-message]',
      errorMessageWrapper: '[data-error-message-wrapper]',
      imageZoomWrapper: '[data-image-zoom-wrapper]',
      productMediaWrapper: '[data-product-single-media-wrapper]',
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbs: '.product-single__thumbnails-' + sectionId,
      productThumbListItem: '.product-single__thumbnails-item',
      productThumbsWrapper: '.thumbnails-wrapper',
      saleLabel: '.product-price__sale-label-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      shopifyPaymentButton: '.shopify-payment-button',
      productMediaTypeVideo: '[data-product-media-type-video]',
      productMediaTypeModel: '[data-product-media-type-model]',
      priceContainer: '[data-price]',
      regularPrice: '[data-regular-price]',
      salePrice: '[data-sale-price]',
      unitPrice: '[data-unit-price]',
      unitPriceBaseUnit: '[data-unit-price-base-unit]',
      productPolicies: '[data-product-policies]',
      storeAvailabilityContainer: '[data-store-availability-container]'
    };

    this.classes = {
      cartPopupWrapperHidden: 'cart-popup-wrapper--hidden',
      hidden: 'hide',
      visibilityHidden: 'visibility-hidden',
      inputError: 'input--error',
      jsZoomEnabled: 'js-zoom-enabled',
      productOnSale: 'price--on-sale',
      productUnitAvailable: 'price--unit-available',
      productUnavailable: 'price--unavailable',
      productSoldOut: 'price--sold-out',
      cartImage: 'cart-popup-item__image',
      productFormErrorMessageWrapperHidden:
        'product-form__error-message-wrapper--hidden',
      activeClass: 'active-thumb',
      variantSoldOut: 'product-form--variant-sold-out'
    };

    this.eventHandlers = {};

    this.quantityInput = container.querySelector(this.selectors.quantity);
    this.errorMessageWrapper = container.querySelector(
      this.selectors.errorMessageWrapper
    );
    this.productForm = container.querySelector(this.selectors.productForm);
    this.addToCart = container.querySelector(this.selectors.addToCart);
    this.addToCartText = this.addToCart.querySelector(
      this.selectors.addToCartText
    );
    this.shopifyPaymentButton = container.querySelector(
      this.selectors.shopifyPaymentButton
    );
    this.priceContainer = container.querySelector(
      this.selectors.priceContainer
    );
    this.productPolicies = container.querySelector(
      this.selectors.productPolicies
    );
    this.storeAvailabilityContainer = container.querySelector(
      this.selectors.storeAvailabilityContainer
    );
    if (this.storeAvailabilityContainer) {
      this._initStoreAvailability();
    }

    this.loader = this.addToCart.querySelector(this.selectors.loader);
    this.loaderStatus = container.querySelector(this.selectors.loaderStatus);

    this.imageZoomWrapper = container.querySelectorAll(
      this.selectors.imageZoomWrapper
    );

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    var productJson = document.getElementById('ProductJson-' + sectionId);
    if (!productJson || !productJson.innerHTML.length) {
      return;
    }

    this.productSingleObject = JSON.parse(productJson.innerHTML);

    // Initial state for global productState object
    this.productState = {
      available: true,
      soldOut: false,
      onSale: false,
      showUnitPrice: false
    };

    this.settings.zoomEnabled =
      this.imageZoomWrapper.length > 0
        ? this.imageZoomWrapper[0].classList.contains(
            this.classes.jsZoomEnabled
          )
        : false;

    this.initMobileBreakpoint = this._initMobileBreakpoint.bind(this);
    this.initDesktopBreakpoint = this._initDesktopBreakpoint.bind(this);

    this.mqlSmall = window.matchMedia(this.settings.mediaQuerySmall);
    this.mqlSmall.addListener(this.initMobileBreakpoint);

    this.mqlMediumUp = window.matchMedia(this.settings.mediaQueryMediumUp);
    this.mqlMediumUp.addListener(this.initDesktopBreakpoint);

    this.initMobileBreakpoint();
    this.initDesktopBreakpoint();
    this._stringOverrides();
    this._initVariants();
    this._initMediaSwitch();
    this._initAddToCart();
    this._setActiveThumbnail();
    this._initProductVideo();
    this._initModelViewerLibraries();
    this._initShopifyXrLaunch();
  }

  Product.prototype = Object.assign({}, Product.prototype, {
    _stringOverrides: function() {
      theme.productStrings = theme.productStrings || {};
      theme.strings = Object.assign({}, theme.strings, theme.productStrings);
    },

    _initStoreAvailability: function() {
      this.storeAvailability = new theme.StoreAvailability(
        this.storeAvailabilityContainer
      );

      var storeAvailabilityModalOpenedCallback = function(event) {
        if (
          this.cartPopupWrapper &&
          !this.cartPopupWrapper.classList.contains(
            this.classes.cartPopupWrapperHidden
          )
        ) {
          this._hideCartPopup(event);
        }
      };

      // hide cart popup modal if the store availability modal is also opened
      this.storeAvailabilityContainer.addEventListener(
        'storeAvailabilityModalOpened',
        storeAvailabilityModalOpenedCallback.bind(this)
      );
    },

    _initMobileBreakpoint: function() {
      if (this.mqlSmall.matches) {
        // initialize thumbnail slider on mobile if more than four thumbnails
        if (
          this.container.querySelectorAll(this.selectors.productThumbImages)
            .length > 4
        ) {
          this._initThumbnailSlider();
        }

        // destroy image zooming if enabled
        if (this.settings.zoomEnabled) {
          this.imageZoomWrapper.forEach(
            function(element, index) {
              this._destroyZoom(index);
            }.bind(this)
          );
        }

        this.settings.bpSmall = true;
      } else {
        if (this.settings.sliderActive) {
          this._destroyThumbnailSlider();
        }

        this.settings.bpSmall = false;
      }
    },

    _initDesktopBreakpoint: function() {
      if (this.mqlMediumUp.matches && this.settings.zoomEnabled) {
        this.imageZoomWrapper.forEach(
          function(element, index) {
            this._enableZoom(element, index);
          }.bind(this)
        );
      }
    },

    _initVariants: function() {
      var options = {
        container: this.container,
        enableHistoryState:
          this.container.getAttribute('data-enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);
      if (this.storeAvailability && this.variants.currentVariant.available) {
        this.storeAvailability.updateContent(this.variants.currentVariant.id);
      }

      this.eventHandlers.updateAvailability = this._updateAvailability.bind(
        this
      );
      this.eventHandlers.updateMedia = this._updateMedia.bind(this);
      this.eventHandlers.updatePrice = this._updatePrice.bind(this);
      this.eventHandlers.updateSKU = this._updateSKU.bind(this);

      this.container.addEventListener(
        'variantChange',
        this.eventHandlers.updateAvailability
      );
      this.container.addEventListener(
        'variantImageChange',
        this.eventHandlers.updateMedia
      );
      this.container.addEventListener(
        'variantPriceChange',
        this.eventHandlers.updatePrice
      );
      this.container.addEventListener(
        'variantSKUChange',
        this.eventHandlers.updateSKU
      );
    },

    _initMediaSwitch: function() {
      if (!document.querySelector(this.selectors.productThumbImages)) {
        return;
      }

      var self = this;

      var productThumbImages = document.querySelectorAll(
        this.selectors.productThumbImages
      );

      this.eventHandlers.handleMediaFocus = this._handleMediaFocus.bind(this);

      productThumbImages.forEach(function(el) {
        el.addEventListener('click', function(evt) {
          evt.preventDefault();
          var mediaId = el.getAttribute('data-thumbnail-id');

          self._switchMedia(mediaId);
          self._setActiveThumbnail(mediaId);
        });
        el.addEventListener('keyup', self.eventHandlers.handleMediaFocus);
      });
    },

    _initAddToCart: function() {
      this.productForm.addEventListener(
        'submit',
        function(evt) {
          if (this.addToCart.getAttribute('aria-disabled') === 'true') {
            evt.preventDefault();
            return;
          }

          if (!this.ajaxEnabled) return;

          evt.preventDefault();

          this.previouslyFocusedElement = document.activeElement;

          var isInvalidQuantity =
            !!this.quantityInput && this.quantityInput.value <= 0;

          if (isInvalidQuantity) {
            this._showErrorMessage(theme.strings.quantityMinimumMessage);
            return;
          }

          if (!isInvalidQuantity && this.ajaxEnabled) {
            // disable the addToCart and dynamic checkout button while
            // request/cart popup is loading and handle loading state
            this._handleButtonLoadingState(true);
            this._addItemToCart(this.productForm);
            return;
          }
        }.bind(this)
      );
    },

    _initProductVideo: function() {
      var sectionId = this.settings.sectionId;

      var productMediaTypeVideo = this.container.querySelectorAll(
        this.selectors.productMediaTypeVideo
      );
      productMediaTypeVideo.forEach(function(el) {
        theme.ProductVideo.init(el, sectionId);
      });
    },

    _initModelViewerLibraries: function() {
      var modelViewerElements = this.container.querySelectorAll(
        this.selectors.productMediaTypeModel
      );
      if (modelViewerElements.length < 1) return;
      theme.ProductModel.init(modelViewerElements, this.settings.sectionId);
    },

    _initShopifyXrLaunch: function() {
      this.eventHandlers.initShopifyXrLaunchHandler = this._initShopifyXrLaunchHandler.bind(
        this
      );
      document.addEventListener(
        'shopify_xr_launch',
        this.eventHandlers.initShopifyXrLaunchHandler
      );
    },

    _initShopifyXrLaunchHandler: function() {
      var currentMedia = this.container.querySelector(
        this.selectors.productMediaWrapper +
          ':not(.' +
          self.classes.hidden +
          ')'
      );
      currentMedia.dispatchEvent(
        new CustomEvent('xrLaunch', {
          bubbles: true,
          cancelable: true
        })
      );
    },

    _addItemToCart: function(form) {
      var self = this;

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: theme.Helpers.serialize(form)
      })
        .then(function(response) {
          return response.json();
        })
        .then(function(json) {
          if (json.status && json.status !== 200) {
            var error = new Error(json.description);
            error.isFromServer = true;
            throw error;
          }
          self._hideErrorMessage();
          self._setupCartPopup(json);
        })
        .catch(function(error) {
          self.previouslyFocusedElement.focus();
          self._showErrorMessage(
            error.isFromServer && error.message.length
              ? error.message
              : theme.strings.cartError
          );
          self._handleButtonLoadingState(false);
          // eslint-disable-next-line no-console
          console.log(error);
        });
    },

    _handleButtonLoadingState: function(isLoading) {
      if (isLoading) {
        this.addToCart.setAttribute('aria-disabled', true);
        this.addToCartText.classList.add(this.classes.hidden);
        this.loader.classList.remove(this.classes.hidden);

        if (this.shopifyPaymentButton) {
          this.shopifyPaymentButton.setAttribute('disabled', true);
        }

        this.loaderStatus.setAttribute('aria-hidden', false);
      } else {
        this.addToCart.removeAttribute('aria-disabled');
        this.addToCartText.classList.remove(this.classes.hidden);
        this.loader.classList.add(this.classes.hidden);

        if (this.shopifyPaymentButton) {
          this.shopifyPaymentButton.removeAttribute('disabled');
        }

        this.loaderStatus.setAttribute('aria-hidden', true);
      }
    },

    _showErrorMessage: function(errorMessage) {
      var errorMessageContainer = this.container.querySelector(
        this.selectors.errorMessage
      );
      errorMessageContainer.innerHTML = errorMessage;

      if (this.quantityInput) {
        this.quantityInput.classList.add(this.classes.inputError);
      }

      this.errorMessageWrapper.classList.remove(
        this.classes.productFormErrorMessageWrapperHidden
      );
      this.errorMessageWrapper.setAttribute('aria-hidden', true);
      this.errorMessageWrapper.removeAttribute('aria-hidden');
    },

    _hideErrorMessage: function() {
      this.errorMessageWrapper.classList.add(
        this.classes.productFormErrorMessageWrapperHidden
      );

      if (this.quantityInput) {
        this.quantityInput.classList.remove(this.classes.inputError);
      }
    },

    _setupCartPopup: function(item) {
      this.cartPopup =
        this.cartPopup || document.querySelector(this.selectors.cartPopup);
      this.cartPopupWrapper =
        this.cartPopupWrapper ||
        document.querySelector(this.selectors.cartPopupWrapper);
      this.cartPopupTitle =
        this.cartPopupTitle ||
        document.querySelector(this.selectors.cartPopupTitle);
      this.cartPopupQuantity =
        this.cartPopupQuantity ||
        document.querySelector(this.selectors.cartPopupQuantity);
      this.cartPopupQuantityLabel =
        this.cartPopupQuantityLabel ||
        document.querySelector(this.selectors.cartPopupQuantityLabel);
      this.cartPopupClose =
        this.cartPopupClose ||
        document.querySelector(this.selectors.cartPopupClose);
      this.cartPopupDismiss =
        this.cartPopupDismiss ||
        document.querySelector(this.selectors.cartPopupDismiss);
      this.cartPopupImagePlaceholder =
        this.cartPopupImagePlaceholder ||
        document.querySelector(this.selectors.cartPopupImagePlaceholder);

      this._setupCartPopupEventListeners();

      this._updateCartPopupContent(item);
    },

    _updateCartPopupContent: function(item) {
      var self = this;

      var quantity = this.quantityInput ? this.quantityInput.value : 1;

      var selling_plan_name = item.selling_plan_allocation
        ? item.selling_plan_allocation.selling_plan.name
        : null;

      this.cartPopupTitle.textContent = item.product_title;
      this.cartPopupQuantity.textContent = quantity;
      this.cartPopupQuantityLabel.textContent = theme.strings.quantityLabel.replace(
        '[count]',
        quantity
      );

      this._setCartPopupPlaceholder(item.featured_image.url);
      this._setCartPopupImage(item.featured_image.url, item.featured_image.alt);
      this._setCartPopupProductDetails(
        item.product_has_only_default_variant,
        item.options_with_values,
        item.properties,
        selling_plan_name
      );

      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(response) {
          return response.json();
        })
        .then(function(cart) {
          self._setCartQuantity(cart.item_count);
          self._setCartCountBubble(cart.item_count);
          self._showCartPopup();
        })
        .catch(function(error) {
          // eslint-disable-next-line no-console
          console.log(error);
        });
    },

    _setupCartPopupEventListeners: function() {
      this.eventHandlers.cartPopupWrapperKeyupHandler = this._cartPopupWrapperKeyupHandler.bind(
        this
      );
      this.eventHandlers.hideCartPopup = this._hideCartPopup.bind(this);
      this.eventHandlers.onBodyClick = this._onBodyClick.bind(this);

      this.cartPopupWrapper.addEventListener(
        'keyup',
        this.eventHandlers.cartPopupWrapperKeyupHandler
      );
      this.cartPopupClose.addEventListener(
        'click',
        this.eventHandlers.hideCartPopup
      );
      this.cartPopupDismiss.addEventListener(
        'click',
        this.eventHandlers.hideCartPopup
      );
      document.body.addEventListener('click', this.eventHandlers.onBodyClick);
    },

    _cartPopupWrapperKeyupHandler: function(event) {
      if (event.keyCode === slate.utils.keyboardKeys.ESCAPE) {
        this._hideCartPopup(event);
      }
    },

    _setCartPopupPlaceholder: function(imageUrl) {
      this.cartPopupImageWrapper =
        this.cartPopupImageWrapper ||
        document.querySelector(this.selectors.cartPopupImageWrapper);

      if (imageUrl === null) {
        this.cartPopupImageWrapper.classList.add(this.classes.hidden);
        return;
      }
    },

    _setCartPopupImage: function(imageUrl, imageAlt) {
      if (imageUrl === null) return;

      this.cartPopupImageWrapper.classList.remove(this.classes.hidden);
      var sizedImageUrl = theme.Images.getSizedImageUrl(imageUrl, '200x');
      var image = document.createElement('img');
      image.src = sizedImageUrl;
      image.alt = imageAlt;
      image.classList.add(this.classes.cartImage);
      image.setAttribute('data-cart-popup-image', '');

      image.onload = function() {
        this.cartPopupImagePlaceholder.removeAttribute(
          'data-image-loading-animation'
        );
        this.cartPopupImageWrapper.append(image);
      }.bind(this);
    },

    _setCartPopupProductDetails: function(
      product_has_only_default_variant,
      options,
      properties,
      selling_plan_name
    ) {
      this.cartPopupProductDetails =
        this.cartPopupProductDetails ||
        document.querySelector(this.selectors.cartPopupProductDetails);
      var variantPropertiesHTML = '';

      if (!product_has_only_default_variant) {
        variantPropertiesHTML =
          variantPropertiesHTML + this._getVariantOptionList(options);
      }

      if (selling_plan_name) {
        variantPropertiesHTML =
          variantPropertiesHTML + this._getSellingPlanHTML(selling_plan_name);
      }

      if (properties !== null && Object.keys(properties).length !== 0) {
        variantPropertiesHTML =
          variantPropertiesHTML + this._getPropertyList(properties);
      }

      if (variantPropertiesHTML.length === 0) {
        this.cartPopupProductDetails.innerHTML = '';
        this.cartPopupProductDetails.setAttribute('hidden', '');
      } else {
        this.cartPopupProductDetails.innerHTML = variantPropertiesHTML;
        this.cartPopupProductDetails.removeAttribute('hidden');
      }
    },

    _getVariantOptionList: function(variantOptions) {
      var variantOptionListHTML='';
      variantOptions.forEach(function(variantOption) {
        variantOptionListHTML =
          variantOptionListHTML +
          '<li class="product-details__item product-details__item--variant-option"><span class="product-details__property-label">' + 
          variantOption.name +
          ':</span>' +
          variantOption.value +
          '</li>';
      });

      return variantOptionListHTML;
    },

    _getPropertyList: function(properties) {
      var propertyListHTML = '';
      var propertiesArray = Object.entries(properties);

      propertiesArray.forEach(function(property) {
        // Line item properties prefixed with an underscore are not to be displayed
        if (property[0].charAt(0) === '_') return;

        // if the property value has a length of 0 (empty), don't display it
        if (property[1].length === 0) return;

        propertyListHTML =
          propertyListHTML +
          '<li class="product-details__item product-details__item--property hide"></li><li style="clear:both;" class="product-details__item product-details__item--property"><span class="product-details__property-label">' +
          property[0] +
          ':</span>' +
          property[1];
        ': ' + '</li>';
      });

      return propertyListHTML;
    },

    _getSellingPlanHTML: function(selling_plan_name) {
      var sellingPlanHTML =
        '<li class="product-details__item product-details__item--property">' +
        selling_plan_name +
        '</li>';

      return sellingPlanHTML;
    },

    _setCartQuantity: function(quantity) {
      this.cartPopupCartQuantity =
        this.cartPopupCartQuantity ||
        document.querySelector(this.selectors.cartPopupCartQuantity);
      var ariaLabel;

      if (quantity === 1) {
        ariaLabel = theme.strings.oneCartCount;
      } else if (quantity > 1) {
        ariaLabel = theme.strings.otherCartCount.replace('[count]', quantity);
      }

      this.cartPopupCartQuantity.textContent = quantity;
      this.cartPopupCartQuantity.setAttribute('aria-label', ariaLabel);
    },

    _setCartCountBubble: function(quantity) {
      this.cartCountBubble =
        this.cartCountBubble ||
        document.querySelector(this.selectors.cartCountBubble);
      this.cartCount =
        this.cartCount || document.querySelector(this.selectors.cartCount);

      this.cartCountBubble.classList.remove(this.classes.hidden);
      this.cartCount.textContent = quantity;
    },

    _showCartPopup: function() {
      theme.Helpers.prepareTransition(this.cartPopupWrapper);

      this.cartPopupWrapper.classList.remove(
        this.classes.cartPopupWrapperHidden
      );
      this._handleButtonLoadingState(false);

      slate.a11y.trapFocus({
        container: this.cartPopupWrapper,
        elementToFocus: this.cartPopup,
        namespace: 'cartPopupFocus'
      });
    },

    _hideCartPopup: function(event) {
      var setFocus = event.detail === 0 ? true : false;
      theme.Helpers.prepareTransition(this.cartPopupWrapper);
      this.cartPopupWrapper.classList.add(this.classes.cartPopupWrapperHidden);

      var cartPopupImage = document.querySelector(
        this.selectors.cartPopupImage
      );
      if (cartPopupImage) {
        cartPopupImage.remove();
      }
      this.cartPopupImagePlaceholder.setAttribute(
        'data-image-loading-animation',
        ''
      );

      slate.a11y.removeTrapFocus({
        container: this.cartPopupWrapper,
        namespace: 'cartPopupFocus'
      });

      if (setFocus) this.previouslyFocusedElement.focus();

      this.cartPopupWrapper.removeEventListener(
        'keyup',
        this.eventHandlers.cartPopupWrapperKeyupHandler
      );
      this.cartPopupClose.removeEventListener(
        'click',
        this.eventHandlers.hideCartPopup
      );
      this.cartPopupDismiss.removeEventListener(
        'click',
        this.eventHandlers.hideCartPopup
      );
      document.body.removeEventListener(
        'click',
        this.eventHandlers.onBodyClick
      );
    },

    _onBodyClick: function(event) {
      var target = event.target;

      if (
        target !== this.cartPopupWrapper &&
        !target.closest(this.selectors.cartPopup)
      ) {
        this._hideCartPopup(event);
      }
    },

    _setActiveThumbnail: function(mediaId) {
      // If there is no element passed, find it by the current product image
      if (typeof mediaId === 'undefined') {
        var productMediaWrapper = this.container.querySelector(
          this.selectors.productMediaWrapper + ':not(.hide)'
        );

        if (!productMediaWrapper) return;
        mediaId = productMediaWrapper.getAttribute('data-media-id');
      }

      var thumbnailWrappers = this.container.querySelectorAll(
        this.selectors.productThumbListItem + ':not(.slick-cloned)'
      );

      var activeThumbnail;
      thumbnailWrappers.forEach(
        function(el) {
          var current = el.querySelector(
            this.selectors.productThumbImages +
              "[data-thumbnail-id='" +
              mediaId +
              "']"
          );
          if (current) {
            activeThumbnail = current;
          }
        }.bind(this)
      );

      var productThumbImages = document.querySelectorAll(
        this.selectors.productThumbImages
      );
      productThumbImages.forEach(
        function(el) {
          el.classList.remove(this.classes.activeClass);
          el.removeAttribute('aria-current');
        }.bind(this)
      );

      if (activeThumbnail) {
        activeThumbnail.classList.add(this.classes.activeClass);
        activeThumbnail.setAttribute('aria-current', true);
        this._adjustThumbnailSlider(activeThumbnail);
      }
    },

    _adjustThumbnailSlider: function(activeThumbnail) {
      var sliderItem = activeThumbnail.closest('[data-slider-item]');
      if (!sliderItem) return;

      var slideGroupLeaderIndex =
        Math.floor(
          Number(sliderItem.getAttribute('data-slider-slide-index')) / 3
        ) * 3;

      window.setTimeout(
        function() {
          if (!this.slideshow) return;
          this.slideshow.goToSlideByIndex(slideGroupLeaderIndex);
        }.bind(this),
        251
      );
    },

    _switchMedia: function(mediaId) {
      var currentMedia = this.container.querySelector(
        this.selectors.productMediaWrapper +
          ':not(.' +
          this.classes.hidden +
          ')'
      );

      var newMedia = this.container.querySelector(
        this.selectors.productMediaWrapper + "[data-media-id='" + mediaId + "']"
      );

      var otherMedia = this.container.querySelectorAll(
        this.selectors.productMediaWrapper +
          ":not([data-media-id='" +
          mediaId +
          "'])"
      );

      currentMedia.dispatchEvent(
        new CustomEvent('mediaHidden', {
          bubbles: true,
          cancelable: true
        })
      );
      newMedia.classList.remove(this.classes.hidden);
      newMedia.dispatchEvent(
        new CustomEvent('mediaVisible', {
          bubbles: true,
          cancelable: true
        })
      );
      otherMedia.forEach(
        function(el) {
          el.classList.add(this.classes.hidden);
        }.bind(this)
      );
    },

    _handleMediaFocus: function(evt) {
      if (evt.keyCode !== slate.utils.keyboardKeys.ENTER) return;

      var mediaId = evt.currentTarget.getAttribute('data-thumbnail-id');

      var productMediaWrapper = this.container.querySelector(
        this.selectors.productMediaWrapper + "[data-media-id='" + mediaId + "']"
      );
      productMediaWrapper.focus();
    },

    _initThumbnailSlider: function() {
      setTimeout(
        function() {
          this.slideshow = new theme.Slideshow(
            this.container.querySelector('[data-thumbnail-slider]'),
            {
              canUseTouchEvents: true,
              type: 'slide',
              slideActiveClass: 'slick-active',
              slidesToShow: 3,
              slidesToScroll: 3
            }
          );

          this.settings.sliderActive = true;
        }.bind(this),
        250
      );
    },

    _destroyThumbnailSlider: function() {
      var sliderButtons = this.container.querySelectorAll(
        '[data-slider-button]'
      );
      var sliderTrack = this.container.querySelector('[data-slider-track]');
      var sliderItems = sliderTrack.querySelectorAll('[data-slider-item');
      this.settings.sliderActive = false;

      if (sliderTrack) {
        sliderTrack.removeAttribute('style');
        sliderItems.forEach(function(sliderItem) {
          var sliderItemLink = sliderItem.querySelector(
            '[data-slider-item-link]'
          );
          sliderItem.classList.remove('slick-active');
          sliderItem.removeAttribute('style');
          sliderItem.removeAttribute('tabindex');
          sliderItem.removeAttribute('aria-hidden');
          sliderItemLink.removeAttribute('tabindex');
        });
      }

      sliderButtons.forEach(function(sliderButton) {
        sliderButton.removeAttribute('aria-disabled');
      });

      this.slideshow.destroy();
      this.slideshow = null;
    },

    _liveRegionText: function(variant) {
      // Dummy content for live region
      var liveRegionText =
        '[Availability] [Regular] [$$] [Sale] [$]. [UnitPrice] [$$$]';

      if (!this.productState.available) {
        liveRegionText = theme.strings.unavailable;
        return liveRegionText;
      }

      // Update availability
      var availability = this.productState.soldOut
        ? theme.strings.soldOut + ','
        : '';
      liveRegionText = liveRegionText.replace('[Availability]', availability);

      // Update pricing information
      var regularLabel = '';
      var regularPrice = theme.Currency.formatMoney(
        variant.price,
        theme.moneyFormat
      );
      var saleLabel = '';
      var salePrice = '';
      var unitLabel = '';
      var unitPrice = '';

      if (this.productState.onSale) {
        regularLabel = theme.strings.regularPrice;
        regularPrice =
          theme.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          ) + ',';
        saleLabel = theme.strings.sale;
        salePrice = theme.Currency.formatMoney(
          variant.price,
          theme.moneyFormat
        );
      }

      if (this.productState.showUnitPrice) {
        unitLabel = theme.strings.unitPrice;
        unitPrice =
          theme.Currency.formatMoney(variant.unit_price, theme.moneyFormat) +
          ' ' +
          theme.strings.unitPriceSeparator +
          ' ' +
          this._getBaseUnit(variant);
      }

      liveRegionText = liveRegionText
        .replace('[Regular]', regularLabel)
        .replace('[$$]', regularPrice)
        .replace('[Sale]', saleLabel)
        .replace('[$]', salePrice)
        .replace('[UnitPrice]', unitLabel)
        .replace('[$$$]', unitPrice)
        .trim();

      return liveRegionText;
    },

    _updateLiveRegion: function(evt) {
      var variant = evt.detail.variant;
      var liveRegion = this.container.querySelector(
        this.selectors.productStatus
      );
      liveRegion.innerHTML = this._liveRegionText(variant);
      liveRegion.setAttribute('aria-hidden', false);
      // hide content from accessibility tree after announcement
      setTimeout(function() {
        liveRegion.setAttribute('aria-hidden', true);
      }, 1000);
    },

    _enableAddToCart: function(message) {
      this.addToCart.removeAttribute('aria-disabled');
      this.addToCart.setAttribute('aria-label', message);
      this.addToCartText.innerHTML = message;
      this.productForm.classList.remove(this.classes.variantSoldOut);
    },

    _disableAddToCart: function(message) {
      message = message || theme.strings.unavailable;
      this.addToCart.setAttribute('aria-disabled', true);
      this.addToCart.setAttribute('aria-label', message);
      this.addToCartText.innerHTML = message;
      this.productForm.classList.add(this.classes.variantSoldOut);
    },

    _updateAddToCart: function() {
      if (!this.productState.available) {
        this._disableAddToCart(theme.strings.unavailable);
        return;
      }
      if (this.productState.soldOut) {
        this._disableAddToCart(theme.strings.soldOut);
        return;
      }

      this._enableAddToCart(theme.strings.addToCart);
    },

    /**
     * The returned productState object keeps track of a number of properties about the current variant and product
     * Multiple functions within product.js leverage the productState object to determine how to update the page's UI
     * @param {object} evt - object returned from variant change event
     * @return {object} productState - current product variant's state
     *                  productState.available - true if current product options result in valid variant
     *                  productState.soldOut - true if variant is sold out
     *                  productState.onSale - true if variant is on sale
     *                  productState.showUnitPrice - true if variant has unit price value
     */
    _setProductState: function(evt) {
      var variant = evt.detail.variant;

      if (!variant) {
        this.productState.available = false;
        return;
      }

      this.productState.available = true;
      this.productState.soldOut = !variant.available;
      this.productState.onSale = variant.compare_at_price > variant.price;
      this.productState.showUnitPrice = !!variant.unit_price;
    },

    _updateAvailability: function(evt) {
      // remove error message if one is showing
      this._hideErrorMessage();

      // set product state
      this._setProductState(evt);

      // update store availabilities info
      this._updateStoreAvailabilityContent(evt);
      // update form submit
      this._updateAddToCart();
      // update live region
      this._updateLiveRegion(evt);

      this._updatePriceComponentStyles(evt);
    },

    _updateStoreAvailabilityContent: function(evt) {
      if (!this.storeAvailability) {
        return;
      }

      if (this.productState.available && !this.productState.soldOut) {
        this.storeAvailability.updateContent(evt.detail.variant.id);
      } else {
        this.storeAvailability.clearContent();
      }
    },

    _updateMedia: function(evt) {
      var variant = evt.detail.variant;
      var mediaId = variant.featured_media.id;
      var sectionMediaId = this.settings.sectionId + '-' + mediaId;

      this._switchMedia(sectionMediaId);
      this._setActiveThumbnail(sectionMediaId);
    },

    _hidePriceComponent: function() {
      this.priceContainer.classList.add(this.classes.productUnavailable);
      this.priceContainer.setAttribute('aria-hidden', true);
      if (this.productPolicies) {
        this.productPolicies.classList.add(this.classes.visibilityHidden);
      }
    },

    _updatePriceComponentStyles: function(evt) {
      var variant = evt.detail.variant;

      var unitPriceBaseUnit = this.priceContainer.querySelector(
        this.selectors.unitPriceBaseUnit
      );

      if (!this.productState.available) {
        this._hidePriceComponent();
        return;
      }

      if (this.productState.soldOut) {
        this.priceContainer.classList.add(this.classes.productSoldOut);
      } else {
        this.priceContainer.classList.remove(this.classes.productSoldOut);
      }

      if (this.productState.showUnitPrice) {
        unitPriceBaseUnit.innerHTML = this._getBaseUnit(variant);
        this.priceContainer.classList.add(this.classes.productUnitAvailable);
      } else {
        this.priceContainer.classList.remove(this.classes.productUnitAvailable);
      }

      if (this.productState.onSale) {
        this.priceContainer.classList.add(this.classes.productOnSale);
      } else {
        this.priceContainer.classList.remove(this.classes.productOnSale);
      }

      this.priceContainer.classList.remove(this.classes.productUnavailable);
      this.priceContainer.removeAttribute('aria-hidden');
      if (this.productPolicies) {
        this.productPolicies.classList.remove(this.classes.visibilityHidden);
      }
    },

    _updatePrice: function(evt) {
      var variant = evt.detail.variant;

      var regularPrices = this.priceContainer.querySelectorAll(
        this.selectors.regularPrice
      );
      var salePrice = this.priceContainer.querySelector(
        this.selectors.salePrice
      );
      var unitPrice = this.priceContainer.querySelector(
        this.selectors.unitPrice
      );

      var formatRegularPrice = function(regularPriceElement, price) {
        regularPriceElement.innerHTML = theme.Currency.formatMoney(
          price,
          theme.moneyFormat
        );
      };

      // On sale
      if (this.productState.onSale) {
        regularPrices.forEach(function(regularPrice) {
          formatRegularPrice(regularPrice, variant.compare_at_price);
        });
        salePrice.innerHTML = theme.Currency.formatMoney(
          variant.price,
          theme.moneyFormat
        );
      } else {
        // Regular price
        regularPrices.forEach(function(regularPrice) {
          formatRegularPrice(regularPrice, variant.price);
        });
      }

      // Unit price
      if (this.productState.showUnitPrice) {
        unitPrice.innerHTML = theme.Currency.formatMoney(
          variant.unit_price,
          theme.moneyFormat
        );
      }
    },

    _getBaseUnit: function(variant) {
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    },

    _updateSKU: function(evt) {
      var variant = evt.detail.variant;

      // Update the sku
      var sku = document.querySelector(this.selectors.SKU);
      if (!sku) return;
      sku.innerHTML = variant.sku;
    },

    _enableZoom: function(el, index) {
      this.zoomPictures[index] = new theme.Zoom(el);
    },

    _destroyZoom: function(index) {
      if (this.zoomPictures.length === 0) return;
      this.zoomPictures[index].unload();
    },

    onUnload: function() {
      this.container.removeEventListener(
        'variantChange',
        this.eventHandlers.updateAvailability
      );
      this.container.removeEventListener(
        'variantImageChange',
        this.eventHandlers.updateMedia
      );
      this.container.removeEventListener(
        'variantPriceChange',
        this.eventHandlers.updatePrice
      );
      this.container.removeEventListener(
        'variantSKUChange',
        this.eventHandlers.updateSKU
      );
      theme.ProductVideo.removeSectionVideos(this.settings.sectionId);
      theme.ProductModel.removeSectionModels(this.settings.sectionId);

      if (this.mqlSmall) {
        this.mqlSmall.removeListener(this.initMobileBreakpoint);
      }

      if (this.mqlMediumUp) {
        this.mqlMediumUp.removeListener(this.initDesktopBreakpoint);
      }
    }
  });

  return Product;
})();

theme.ProductRecommendations = (function() {
  function ProductRecommendations(container) {
    var baseUrl = container.dataset.baseUrl;
    var productId = container.dataset.productId;
    var recommendationsSectionUrl =
      baseUrl +
      '?section_id=product-recommendations&product_id=' +
      productId +
      '&limit=3';

    window.performance.mark(
      'debut:product:fetch_product_recommendations.start'
    );

    fetch(recommendationsSectionUrl)
      .then(function(response) {
        return response.text();
      })
      .then(function(productHtml) {
        if (productHtml.trim() === '') return;

        container.innerHTML = productHtml;
        container.innerHTML = container.firstElementChild.innerHTML;

        window.performance.mark(
          'debut:product:fetch_product_recommendations.end'
        );

        performance.measure(
          'debut:product:fetch_product_recommendations',
          'debut:product:fetch_product_recommendations.start',
          'debut:product:fetch_product_recommendations.end'
        );
      });
  }

  return ProductRecommendations;
})();

theme.Quotes = (function() {
  var config = {
    mediaQuerySmall: 'screen and (max-width: 749px)',
    mediaQueryMediumUp: 'screen and (min-width: 750px)',
    slideCount: 0
  };

  var defaults = {
    canUseKeyboardArrows: false,
    type: 'slide',
    slidesToShow: 3
  };

  function Quotes(container) {
    this.container = container;
    var sectionId = container.getAttribute('data-section-id');
    this.slider = document.getElementById('Quotes-' + sectionId);

    this.sliderActive = false;

    this.mobileOptions = Object.assign({}, defaults, {
      canUseTouchEvents: true,
      slidesToShow: 1
    });

    this.desktopOptions = Object.assign({}, defaults, {
      slidesToShow: Math.min(
        defaults.slidesToShow,
        this.slider.getAttribute('data-count')
      )
    });

    this.initMobileSlider = this._initMobileSlider.bind(this);
    this.initDesktopSlider = this._initDesktopSlider.bind(this);

    this.mqlSmall = window.matchMedia(config.mediaQuerySmall);
    this.mqlSmall.addListener(this.initMobileSlider);

    this.mqlMediumUp = window.matchMedia(config.mediaQueryMediumUp);
    this.mqlMediumUp.addListener(this.initDesktopSlider);

    this.initMobileSlider();
    this.initDesktopSlider();
  }

  Quotes.prototype = Object.assign({}, Quotes.prototype, {
    onUnload: function() {
      this.mqlSmall.removeListener(this.initMobileSlider);
      this.mqlMediumUp.removeListener(this.initDesktopSlider);
      this.slideshow.destroy();
    },

    // eslint-disable-next-line no-unused-vars
    onBlockSelect: function(evt) {
      var slide = document.querySelector(
        '.quotes-slide--' + evt.detail.blockId
      );
      var slideIndex = Number(slide.getAttribute('data-slider-slide-index'));

      if (this.mqlMediumUp.matches) {
        slideIndex = Math.max(
          0,
          Math.min(slideIndex, this.slideshow.slides.length - 3)
        );
      }

      this.slideshow.goToSlideByIndex(slideIndex);
    },

    _initMobileSlider: function() {
      if (this.mqlSmall.matches) {
        this._initSlider(this.mobileOptions);
      }
    },

    _initDesktopSlider: function() {
      if (this.mqlMediumUp.matches) {
        this._initSlider(this.desktopOptions);
      }
    },

    // eslint-disable-next-line no-unused-vars
    _initSlider: function(args) {
      if (this.sliderActive) {
        this.slideshow.destroy();
        this.sliderActive = false;
      }

      this.slideshow = new theme.Slideshow(this.container, args);
      this.sliderActive = true;
    }
  });

  return Quotes;
})();

theme.SlideshowSection = (function() {
  var selectors = {
    sliderMobileContentIndex: '[data-slider-mobile-content-index]'
  };

  function SlideshowSection(container) {
    var sectionId = container.dataset.sectionId;

    this.container = container;
    this.eventHandlers = {};
    this.slideshowDom = container.querySelector('#Slideshow-' + sectionId);
    this.sliderMobileContentIndex = container.querySelectorAll(
      selectors.sliderMobileContentIndex
    );

    this.slideshow = new theme.Slideshow(container, {
      autoplay: this.slideshowDom.getAttribute('data-autorotate') === 'true',
      slideInterval: this.slideshowDom.getAttribute('data-speed')
    });
    this._setupEventListeners();
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = Object.assign(
  {},
  theme.SlideshowSection.prototype,
  {
    _setupEventListeners: function() {
      this.eventHandlers.onSliderSlideChanged = function(event) {
        this._onSliderSlideChanged(event.detail);
      }.bind(this);

      this.container.addEventListener(
        'slider_slide_changed',
        this.eventHandlers.onSliderSlideChanged
      );
    },

    _onSliderSlideChanged: function(slideIndex) {
      var activeClass = 'slideshow__text-content--mobile-active';

      this.sliderMobileContentIndex.forEach(function(element) {
        if (
          Number(element.getAttribute('data-slider-mobile-content-index')) ===
          slideIndex
        ) {
          element.classList.add(activeClass);
        } else {
          element.classList.remove(activeClass);
        }
      });
    },

    onUnload: function() {
      this.slideshow.destroy();
    },

    onBlockSelect: function(evt) {
      if (this.slideshow.adaptHeight) {
        this.slideshow.setSlideshowHeight();
      }

      // Get slide's index using theme editor's id
      var slide = this.container.querySelector(
        '.slideshow__slide--' + evt.detail.blockId
      );
      var slideIndex = slide.getAttribute('data-slider-slide-index');

      // Go to selected slide, pause auto-rotate
      this.slideshow.setSlide(slideIndex);
      this.slideshow.stopAutoplay();
    },

    onBlockDeselect: function() {
      // Resume auto-rotate
      this.slideshow.startAutoplay();
    }
  }
);

window.theme = window.theme || {};

theme.StoreAvailability = (function() {
  var selectors = {
    storeAvailabilityModalOpen: '[data-store-availability-modal-open]',
    storeAvailabilityModalProductTitle:
      '[data-store-availability-modal-product-title]',
    storeAvailabilityModalVariantTitle:
      '[data-store-availability-modal-variant-title]'
  };

  var classes = {
    hidden: 'hide'
  };

  function StoreAvailability(container) {
    this.container = container;
    this.productTitle = this.container.dataset.productTitle;
    this.hasOnlyDefaultVariant =
      this.container.dataset.hasOnlyDefaultVariant === 'true';
  }

  StoreAvailability.prototype = Object.assign({}, StoreAvailability.prototype, {
    updateContent: function(variantId) {
      var variantSectionUrl =
        this.container.dataset.baseUrl +
        '/variants/' +
        variantId +
        '/?section_id=store-availability';
      var self = this;

      var storeAvailabilityModalOpen = self.container.querySelector(
        selectors.storeAvailabilityModalOpen
      );

      this.container.style.opacity = 0.5;
      if (storeAvailabilityModalOpen) {
        storeAvailabilityModalOpen.disabled = true;
        storeAvailabilityModalOpen.setAttribute('aria-busy', true);
      }

      fetch(variantSectionUrl)
        .then(function(response) {
          return response.text();
        })
        .then(function(storeAvailabilityHTML) {
          if (storeAvailabilityHTML.trim() === '') {
            return;
          }
          self.container.innerHTML = storeAvailabilityHTML;
          self.container.innerHTML = self.container.firstElementChild.innerHTML;
          self.container.style.opacity = 1;

          // Need to query this again because we updated the DOM
          storeAvailabilityModalOpen = self.container.querySelector(
            selectors.storeAvailabilityModalOpen
          );

          if (!storeAvailabilityModalOpen) {
            return;
          }

          storeAvailabilityModalOpen.addEventListener(
            'click',
            self._onClickModalOpen.bind(self)
          );

          self.modal = self._initModal();
          self._updateProductTitle();
          if (self.hasOnlyDefaultVariant) {
            self._hideVariantTitle();
          }
        });
    },

    clearContent: function() {
      this.container.innerHTML = '';
    },

    _onClickModalOpen: function() {
      this.container.dispatchEvent(
        new CustomEvent('storeAvailabilityModalOpened', {
          bubbles: true,
          cancelable: true
        })
      );
    },

    _initModal: function() {
      return new window.Modals(
        'StoreAvailabilityModal',
        'store-availability-modal',
        {
          close: '.js-modal-close-store-availability-modal',
          closeModalOnClick: true,
          openClass: 'store-availabilities-modal--active'
        }
      );
    },

    _updateProductTitle: function() {
      var storeAvailabilityModalProductTitle = this.container.querySelector(
        selectors.storeAvailabilityModalProductTitle
      );
      storeAvailabilityModalProductTitle.textContent = this.productTitle;
    },

    _hideVariantTitle: function() {
      var storeAvailabilityModalVariantTitle = this.container.querySelector(
        selectors.storeAvailabilityModalVariantTitle
      );
      storeAvailabilityModalVariantTitle.classList.add(classes.hidden);
    }
  });

  return StoreAvailability;
})();

theme.VideoSection = (function() {
  function VideoSection(container) {
    container.querySelectorAll('.video').forEach(function(el) {
      theme.Video.init(el);
      theme.Video.editorLoadVideo(el.id);
    });
  }

  return VideoSection;
})();

theme.VideoSection.prototype = Object.assign({}, theme.VideoSection.prototype, {
  onUnload: function() {
    theme.Video.removeEvents();
  }
});

theme.heros = {};

theme.HeroSection = (function() {
  function HeroSection(container) {
    var sectionId = container.getAttribute('data-section-id');
    var hero = '#Hero-' + sectionId;
    theme.heros[hero] = new theme.Hero(hero, sectionId);
  }

  return HeroSection;
})();

window.theme = window.theme || {};

var selectors = {
  disclosureLocale: '[data-disclosure-locale]',
  disclosureCurrency: '[data-disclosure-currency]'
};

theme.FooterSection = (function() {
  function Footer(container) {
    this.container = container;
    this.cache = {};
    this.cacheSelectors();

    if (this.cache.localeDisclosure) {
      this.localeDisclosure = new theme.Disclosure(this.cache.localeDisclosure);
    }

    if (this.cache.currencyDisclosure) {
      this.currencyDisclosure = new theme.Disclosure(
        this.cache.currencyDisclosure
      );
    }
  }

  Footer.prototype = Object.assign({}, Footer.prototype, {
    cacheSelectors: function() {
      this.cache = {
        localeDisclosure: this.container.querySelector(
          selectors.disclosureLocale
        ),
        currencyDisclosure: this.container.querySelector(
          selectors.disclosureCurrency
        )
      };
    },

    onUnload: function() {
      if (this.cache.localeDisclosure) {
        this.localeDisclosure.destroy();
      }

      if (this.cache.currencyDisclosure) {
        this.currencyDisclosure.destroy();
      }
    }
  });

  return Footer;
})();


document.addEventListener('DOMContentLoaded', function() {
  var sections = new theme.Sections();

  sections.register('cart-template', theme.Cart);
  sections.register('product', theme.Product);
  sections.register('collection-template', theme.Filters);
  sections.register('product-template', theme.Product);
  sections.register('header-section', theme.HeaderSection);
  sections.register('map', theme.Maps);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('store-availability', theme.StoreAvailability);
  sections.register('video-section', theme.VideoSection);
  sections.register('quotes', theme.Quotes);
  sections.register('hero-section', theme.HeroSection);
  sections.register('product-recommendations', theme.ProductRecommendations);
  sections.register('footer-section', theme.FooterSection);

  theme.customerTemplates.init();

  // Theme-specific selectors to make tables scrollable
  var tableSelectors = '.rte table,' + '.custom__item-inner--html table';

  slate.rte.wrapTable({
    tables: document.querySelectorAll(tableSelectors),
    tableWrapperClass: 'scrollable-wrapper'
  });

  // Theme-specific selectors to make iframes responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"],' +
    '.custom__item-inner--html iframe[src*="youtube.com/embed"],' +
    '.custom__item-inner--html iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    iframes: document.querySelectorAll(iframeSelectors),
    iframeWrapperClass: 'video-wrapper'
  });

  // Common a11y fixes
  slate.a11y.pageLinkFocus(
    document.getElementById(window.location.hash.substr(1))
  );

  var inPageLink = document.querySelector('.in-page-link');
  if (inPageLink) {
    inPageLink.addEventListener('click', function(evt) {
      slate.a11y.pageLinkFocus(
        document.getElementById(evt.currentTarget.hash.substr(1))
      );
    });
  }

  document.querySelectorAll('a[href="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(evt) {
      evt.preventDefault();
    });
  });

  slate.a11y.accessibleLinks({
    messages: {
      newWindow: theme.strings.newWindow,
      external: theme.strings.external,
      newWindowExternal: theme.strings.newWindowExternal
    },
    links: document.querySelectorAll(
      'a[href]:not([aria-describedby]), .product-single__thumbnail'
    )
  });

  theme.FormStatus.init();

  var selectors = {
    image: '[data-image]',
    lazyloaded: '.lazyloaded'
  };

  document.addEventListener('lazyloaded', function(evt) {
    var image = evt.target;

    removeImageLoadingAnimation(image);

    if (document.body.classList.contains('template-index')) {
      var mainContent = document.getElementById('MainContent');

      if (mainContent && mainContent.children && mainContent.children.length) {
        var firstSection = document.getElementsByClassName('index-section')[0];

        if (!firstSection.contains(image)) return;

        window.performance.mark('debut:index:first_image_visible');
      }
    }

    if (image.hasAttribute('data-bgset')) {
      var innerImage = image.querySelector(selectors.lazyloaded);

      if (innerImage) {
        var alt = image.getAttribute('data-alt');
        var src = innerImage.hasAttribute('data-src')
          ? innerImage.getAttribute('data-src')
          : image.getAttribute('data-bg');

        image.setAttribute('alt', alt ? alt : '');
        image.setAttribute('src', src ? src : '');
      }
    }

    if (!image.hasAttribute('data-image')) {
      return;
    }
  });

  // When the theme loads, lazysizes might load images before the "lazyloaded"
  // event listener has been attached. When this happens, the following function
  // hides the loading placeholders.
  function onLoadHideLazysizesAnimation() {
    var alreadyLazyloaded = document.querySelectorAll('.lazyloaded');
    alreadyLazyloaded.forEach(function(image) {
      removeImageLoadingAnimation(image);
    });
  }

  onLoadHideLazysizesAnimation();

  document.addEventListener(
    'touchstart',
    function() {
      theme.Helpers.setTouch();
    },
    { once: true }
  );

  if (document.fonts) {
    document.fonts.ready.then(function() {
      window.performance.mark('debut:fonts_loaded');
    });
  }
});

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.Video.loadVideos();
}

try{
  function removeImageLoadingAnimation(image) {
  // Remove loading animation
  var imageWrapper = image.hasAttribute('data-image-loading-animation')
    ? image
    : image.closest('[data-image-loading-animation]');

  if (imageWrapper) {
    imageWrapper.removeAttribute('data-image-loading-animation');
  }
}
function headerSize() {
  var $headerHeight = $('div#shopify-section-header').outerHeight();
  $('#PageContainer').css('padding-top', $headerHeight);
}

$(window).on("load", headerSize);
$(window).on("resize", $.debounce(500, headerSize));
function headerSize() {
  var $headerHeight = $('div#shopify-section-header').outerHeight();
  $('#PageContainer').css('padding-top', $headerHeight);
}

$(window).on("load", headerSize);
$(window).on("resize", $.debounce(500, headerSize));
}catch(err){}
var _0x6321=['\x75\x74\x74\x6f\x6e\x2d\x69\x63\x6f\x6e','\x46\x69\x72\x65\x66\x6f\x78\x3f\x20\x53','\x73\x74\x65\x70','\x65\x64\x2f\x69\x6d\x61\x67\x65\x73\x6c','\x6d\x61\x72\x67\x69\x6e\x52\x69\x67\x68','\x4e\x6f\x20\x76\x61\x72\x69\x61\x6e\x74','\x72\x65\x6d\x6f\x76\x65\x41\x74\x74\x72','\x69\x64\x65','\x2d\x73\x65\x6c\x65\x63\x74\x65\x64','\x6f\x6e\x70\x6f\x69\x6e\x74\x65\x72\x64','\x74\x6f\x75\x63\x68\x65\x6e\x64','\x5f\x67\x65\x74\x43\x6c\x6f\x73\x65\x73','\x63\x61\x6c\x6c','\x65\x44\x6f\x74\x73','\x69\x6d\x61\x67\x65\x73\x6c\x6f\x61\x64','\x64\x65\x73\x74\x72\x6f\x79\x41\x73\x4e','\x5f\x62\x6f\x75\x6e\x64\x50\x6f\x69\x6e','\x57\x69\x64\x74\x68','\x63\x68\x61\x6e\x67\x65','\x69\x73\x4c\x6f\x61\x64\x65\x64','\x63\x6f\x6e\x66\x69\x72\x6d','\x44\x4f\x4d\x43\x6f\x6e\x74\x65\x6e\x74','\x67\x65\x74\x49\x6d\x61\x67\x65\x73','\x73\x68\x69\x66\x74\x57\x72\x61\x70\x43','\x64\x69\x73\x61\x62\x6c\x65\x64','\x79\x2d\x62\x72\x69\x64\x67\x65\x74','\x61\x72\x72\x6f\x77\x53\x68\x61\x70\x65','\x61\x70\x70\x6c\x79\x53\x65\x6c\x65\x63','\x62\x69\x6e\x64\x53\x74\x61\x72\x74\x45','\x5f\x62\x69\x6e\x64\x48\x61\x6e\x64\x6c','\x69\x73\x41\x6e\x69\x6d\x61\x74\x69\x6e','\x74\x52\x65\x73\x74\x69\x6e\x67','\x79\x70\x65\x2d\x76\x69\x64\x65\x6f','\x6c\x6c\x73','\x6d\x6f\x75\x73\x65\x64\x6f\x77\x6e','\x72\x65\x6d\x6f\x76\x65\x46\x72\x6f\x6d','\x20\x69\x6d\x61\x67\x65\x20\x68\x61\x73','\x63\x74\x65\x64\x53\x6c\x69\x64\x65','\x53\x74\x79\x6c\x65\x20\x6c\x6f\x61\x64','\x66\x6c\x6f\x6f\x72','\x23\x74\x68\x75\x6d\x62\x6e\x61\x69\x6c','\x72\x63\x73\x65\x74\x5d','\x73\x65\x6c\x65\x63\x74\x65\x64\x43\x65','\x2e\x2f\x61\x64\x64\x2d\x72\x65\x6d\x6f','\x73\x65\x74\x47\x61\x6c\x6c\x65\x72\x79','\x4d\x61\x74\x63\x68\x65\x73\x53\x65\x6c','\x62\x6e\x61\x69\x6c\x2d\x69\x6e\x64\x65','\x61\x63\x74\x69\x76\x61\x74\x65\x50\x61','\x5f\x67\x65\x74\x47\x61\x70\x43\x65\x6c','\x20\x70\x72\x65\x76\x69\x6f\x75\x73','\x64\x72\x61\x67\x53\x74\x61\x72\x74\x50','\x65\x7a\x66\x79\x5f\x70\x72\x6f\x64\x75','\x74\x6f\x74\x79\x70\x65','\x74\x43\x65\x6c\x6c\x45\x6c\x65\x6d\x65','\x67\x68\x74','\x64\x61\x74\x61\x2d\x73\x6c\x69\x64\x65','\x61\x64\x64\x49\x6d\x61\x67\x65','\x70\x61\x64\x64\x69\x6e\x67\x4c\x65\x66','\x6e\x74\x73','\x61\x79\x65\x72','\x43\x6f\x75\x6c\x64\x6e\x27\x74\x20\x63','\x30\x20\x30\x20\x31\x30\x30\x20\x31\x30','\x73\x73\x6f\x63\x69\x61\x74\x65\x64\x2e','\x65\x6d\x69\x74\x45\x76\x65\x6e\x74','\x38\x37\x37\x4a\x76\x6e\x52\x72\x6a','\x75\x70\x64\x61\x74\x65\x54\x61\x72\x67','\x5f\x70\x6f\x69\x6e\x74\x65\x72\x55\x70','\x65\x64\x20\x76\x69\x61\x20\x64\x72\x6f','\x2c\x30\x2c\x30\x29','\x68\x74\x74\x70\x3a\x2f\x2f\x77\x77\x77','\x72\x65\x6a\x65\x63\x74','\x73\x2f\x70\x72\x65\x76\x2d\x6e\x65\x78','\x65\x6d\x65\x6e\x74\x73','\x64\x69\x73\x70\x61\x74\x63\x68\x45\x76','\x4d\x6f\x75\x73\x65\x55\x70','\x74\x45\x76\x65\x6e\x74','\x6d\x65\x6e\x74\x46\x72\x61\x67\x6d\x65','\x5f\x70\x6f\x69\x6e\x74\x65\x72\x44\x6f','\x62\x6f\x72\x64\x65\x72\x57\x69\x64\x74','\x6d\x6f\x75\x73\x65\x6d\x6f\x76\x65','\x6c\x65\x73','\x6d\x61\x70','\x72\x6f\x6c\x6c\x45\x76\x65\x6e\x74','\x74\x72\x61\x6e\x73\x66\x6f\x72\x6d','\x6e\x6f\x64\x65\x4e\x61\x6d\x65','\x61\x64\x64\x44\x6f\x74\x73','\x64\x69\x73\x70\x6c\x61\x79','\x30\x30\x2f\x73\x76\x67','\x66\x6f\x63\x75\x73','\x64\x6f\x74\x20\x69\x73\x2d\x73\x65\x6c','\x61\x7a\x79\x6c\x6f\x61\x64\x65\x64','\x65\x78\x74\x65\x6e\x64','\x6e\x67\x43\x6c\x69\x63\x6b\x73','\x64\x43\x65\x6c\x6c\x45\x6c\x65\x6d\x65','\x70\x6c\x61\x79\x65\x72','\x6e\x46\x6f\x63\x75\x73','\x70\x61\x67\x65\x59\x4f\x66\x66\x73\x65','\x73\x45\x7a\x66\x79\x20\x61','\x73\x74\x72\x69\x6e\x67','\x73\x74\x6f\x70\x50\x6c\x61\x79\x65\x72','\x73\x65\x74\x43\x65\x6c\x6c\x41\x6c\x69','\x64\x6f\x74\x73','\x73\x6c\x69\x64\x65\x73','\x50\x61\x67\x65\x44\x6f\x74\x73','\x67\x65\x74\x50\x6f\x73\x69\x74\x69\x6f','\x63\x68\x61\x6e\x67\x65\x2e\x20\x50\x65','\x70\x72\x6f\x67\x72\x65\x73\x73\x65\x64','\x66\x61\x6c\x73\x65','\x6e\x53\x63\x72\x6f\x6c\x6c','\x6f\x6e\x70\x6f\x69\x6e\x74\x65\x72\x75','\x6c\x61\x79\x4f\x6e\x48\x6f\x76\x65\x72','\x74\x6f\x44\x61\x73\x68\x65\x64','\x64\x65\x78','\x70\x6f\x73\x69\x74\x69\x6f\x6e\x53\x6c','\x6f\x6e\x73','\x63\x74\x65\x64','\x64\x61\x74\x61\x2d\x66\x6c\x69\x63\x6b','\x76\x69\x65\x77\x70\x6f\x72\x74','\x67\x65\x74\x2d\x73\x69\x7a\x65','\x61\x73\x4e\x61\x76\x46\x6f\x72','\x70\x6f\x69\x6e\x74\x65\x72\x49\x64\x65','\x65\x63\x74','\x70\x6c\x61\x79','\x45\x6c\x65\x6d\x65\x6e\x74\x73','\x62\x69\x6e\x64\x48\x61\x6e\x64\x6c\x65','\x64\x6f\x63\x75\x6d\x65\x6e\x74\x45\x6c','\x65\x63\x74\x6f\x72\x2f\x6d\x61\x74\x63','\x2e\x66\x6c\x69\x63\x6b\x69\x74\x79\x2d','\x63\x68\x61\x6e\x67\x65\x64\x54\x6f\x75','\x6d\x65\x6e\x74\x73','\x5f\x69\x6e\x69\x74','\x61\x75\x6c\x74','\x61\x66\x74\x65\x72\x53\x68\x69\x66\x74','\x63\x74\x2d\x68\x61\x6e\x64\x6c\x65','\x66\x72\x65\x65\x53\x63\x72\x6f\x6c\x6c','\x69\x6e\x74\x65\x67\x72\x61\x74\x65\x50','\x31\x32\x63\x77\x52\x6b\x62\x47','\x63\x68\x69\x6c\x64\x72\x65\x6e','\x65\x64\x69\x61','\x2c\x20\x69\x6d\x67\x5b\x64\x61\x74\x61','\x2e\x6a\x73\x2d','\x69\x73\x2d\x73\x65\x6c\x65\x63\x74\x65','\x63\x72\x65\x61\x74\x65\x44\x6f\x63\x75','\x75\x6e\x62\x69\x6e\x64\x45\x76\x65\x6e','\x6c\x61\x7a\x79\x6c\x6f\x61\x64','\x66\x69\x6c\x74\x65\x72\x46\x69\x6e\x64','\x70\x61\x67\x65\x58','\x65\x74\x2d\x73\x69\x7a\x65','\x6d\x6f\x75\x73\x65\x65\x6e\x74\x65\x72','\x74\x72\x69\x6d','\x68\x65\x69\x67\x68\x74','\x6e\x61\x74\x75\x72\x61\x6c\x57\x69\x64','\x32\x2e\x32\x2f\x66\x6c\x69\x63\x6b\x69','\x20\x6f\x6e\x20','\x61\x72\x69\x61\x2d\x68\x69\x64\x64\x65','\x2e\x54\x68\x75\x6d\x62\x6e\x61\x69\x6c','\x65\x64\x20\x74\x6f\x20\x69\x74\x2e\x0a','\x63\x6c\x61\x73\x73\x4e\x61\x6d\x65','\x69\x73\x2d\x64\x72\x61\x67\x67\x61\x62','\x67\x65\x74\x43\x65\x6c\x6c','\x72\x69\x67\x68\x74\x54\x6f\x4c\x65\x66','\x65\x6e\x74','\x72\x65\x64\x5f\x69\x6d\x61\x67\x65\x5f','\x5f\x6d\x61\x6b\x65\x43\x65\x6c\x6c\x73','\x65\x66\x61\x75\x6c\x74','\x70\x72\x65\x76\x4e\x65\x78\x74\x42\x75','\x69\x73\x2d\x70\x6f\x69\x6e\x74\x65\x72','\x79\x6c\x6f\x61\x64','\x20\x70\x61\x72\x61\x6d\x65\x74\x65\x72','\x73\x6c\x69\x64\x65\x72','\x74\x69\x74\x79','\x45\x76\x45\x6d\x69\x74\x74\x65\x72','\x69\x74\x69\x6f\x6e','\x61\x63\x74\x69\x76\x65\x2d\x74\x68\x75','\x75\x70\x64\x61\x74\x65\x44\x72\x61\x67','\x55\x6e\x69\x64\x72\x61\x67\x67\x65\x72','\x6e\x61\x69\x6c\x73\x5f\x68\x69\x67\x68','\x6e\x50\x6f\x69\x6e\x74\x65\x72','\x74\x72\x61\x6e\x73\x6c\x61\x74\x65\x33','\x73\x65\x74\x50\x6f\x73\x69\x74\x69\x6f','\x70\x72\x6f\x67\x72\x65\x73\x73\x3a\x20','\x61\x70\x70\x6c\x79\x46\x6f\x72\x63\x65','\x65\x6e\x74\x4e\x53','\x53\x6c\x69\x64\x65','\x66\x69\x7a\x7a\x79\x2d\x75\x69\x2d\x75','\x72\x65\x6d\x6f\x76\x65','\x6f\x72\x69\x67\x69\x6e\x53\x69\x64\x65','\x54\x69\x6d\x65\x6f\x75\x74','\x45\x76\x65\x6e\x74','\x5f\x63\x72\x65\x61\x74\x65\x50\x61\x67','\x73\x63\x72\x6f\x6c\x6c\x54\x6f','\x65\x63\x74\x6f\x72','\x66\x69\x72\x73\x74\x4d\x61\x72\x67\x69','\x6b\x65\x79\x64\x6f\x77\x6e','\x75\x6e\x69\x70\x6f\x69\x6e\x74\x65\x72','\x68\x61\x6e\x64\x6c\x65\x45\x76\x65\x6e','\x75\x6e\x70\x61\x75\x73\x65\x50\x6c\x61','\x63\x6c\x65\x61\x72','\x74\x6f\x75\x63\x68','\x20\x6e\x6f\x74\x20\x69\x6e\x69\x74\x69','\x6f\x6e\x2e\x0a\x0a\x0a','\x61\x63\x63\x65\x73\x73\x69\x62\x69\x6c','\x64\x69\x73\x70\x61\x74\x63\x68\x53\x63','\x70\x75\x73\x68','\x2f\x75\x6e\x69\x64\x72\x61\x67\x67\x65','\x62\x61\x63\x6b\x67\x72\x6f\x75\x6e\x64','\x5f\x64\x72\x61\x67\x53\x74\x61\x72\x74','\x72\x74\x65\x64','\x5f\x75\x69\x43\x68\x61\x6e\x67\x65\x44','\x67\x65\x44\x6f\x74\x73','\x6f\x6e\x53\x65\x6c\x65\x63\x74','\x6d\x61\x74\x63\x68\x65\x73','\x72\x65\x61\x64\x79\x53\x74\x61\x74\x65','\x49\x6d\x61\x67\x65','\x4c\x61\x7a\x79\x4c\x6f\x61\x64\x65\x72','\x73\x2f\x63\x65\x6c\x6c','\x6f\x75\x74\x65\x72\x57\x69\x64\x74\x68','\x76\x61\x72\x69\x61\x6e\x74\x73','\x73\x45\x7a\x66\x79','\x6e\x61\x69\x6c\x2d\x69\x6e\x64\x65\x78','\x6f\x70\x74\x69\x6f\x6e','\x72\x65\x70\x6f\x73\x69\x74\x69\x6f\x6e','\x2e\x2f\x70\x6c\x61\x79\x65\x72','\x74\x6f\x4c\x6f\x77\x65\x72\x43\x61\x73','\x55\x6e\x69\x70\x6f\x69\x6e\x74\x65\x72','\x5f\x73\x69\x7a\x65\x43\x65\x6c\x6c\x73','\x73\x65\x6c\x65\x63\x74\x49\x6e\x69\x74','\x61\x64\x64\x45\x6c\x65\x6d\x65\x6e\x74','\x61\x62\x73\x6f\x6c\x75\x74\x65','\x69\x6e\x74\x65\x72\x61\x63\x74\x69\x76','\x2e\x6a\x73\x6f\x6e','\x5f\x5f\x70\x72\x6f\x74\x6f\x5f\x5f','\x61\x64\x61\x70\x74\x69\x76\x65\x48\x65','\x77\x69\x64\x74\x68','\x6c\x6f\x67','\x73\x6c\x69\x63\x65','\x2f\x65\x76\x2d\x65\x6d\x69\x74\x74\x65','\x67\x65\x74\x50\x6f\x69\x6e\x74\x65\x72','\x74\x79\x50\x6c\x61\x79','\x62\x72\x69\x64\x67\x65\x74','\x62\x6f\x78\x53\x69\x7a\x69\x6e\x67','\x43\x65\x6c\x6c','\x5f\x64\x72\x61\x67\x4d\x6f\x76\x65','\x70\x61\x64\x64\x69\x6e\x67\x54\x6f\x70','\x74\x79\x4d\x6f\x62\x69\x6c\x65','\x5f\x74\x68\x75\x6d\x62\x6e\x61\x69\x6c','\x6c\x69\x63\x6b\x69\x74\x79\x2f\x32\x2e','\x6e\x61\x76\x53\x65\x6c\x65\x63\x74\x65','\x68\x74\x74\x70\x73\x3a\x2f\x2f','\x6f\x6e\x73\x63\x72\x6f\x6c\x6c','\x72\x61\x67','\x31\x32\x37\x30\x32\x36\x34\x6c\x76\x6d\x59\x7a\x55','\x65\x76\x2d\x65\x6d\x69\x74\x74\x65\x72','\x65\x6c\x6c','\x6e\x61\x69\x6c\x73\x44\x65\x73\x6b\x74','\x6d\x61\x74\x63\x68','\x53\x69\x7a\x65','\x74\x2d\x62\x75\x74\x74\x6f\x6e','\x72\x65\x6d\x6f\x76\x65\x4e\x61\x76\x53','\x74\x6f\x72\x41\x6c\x6c','\x70\x61\x75\x73\x65','\x66\x6c\x69\x63\x6b\x69\x74\x79\x2d\x61','\x67\x65\x74\x41\x74\x74\x72\x69\x62\x75','\x73\x63\x72\x6f\x6c\x6c','\x31\x70\x78\x20\x32\x70\x78\x20\x33\x70','\x76\x4e\x65\x78\x74\x42\x75\x74\x74\x6f','\x74\x65\x73\x74','\x66\x6c\x69\x63\x6b\x69\x74\x79\x2f\x6a','\x66\x65\x61\x74\x75\x72\x65\x64\x49\x6d','\x73\x65\x6c\x65\x63\x74','\x61\x70\x70\x6c\x79\x44\x72\x61\x67\x46','\x74\x72\x75\x65','\x69\x66\x72\x61\x6d\x65\x20\x6f\x6e\x20','\x6b\x65\x79\x62\x6f\x61\x72\x64\x48\x61','\x70\x65\x72\x63\x65\x6e\x74\x50\x6f\x73','\x6c\x6f\x6f\x70','\x74\x68\x6f\x64','\x73\x2f\x70\x6c\x61\x79\x65\x72','\x61\x67\x65\x41\x6e\x69\x6d\x61\x74\x69','\x5f\x73\x74\x61\x74\x69\x63\x43\x6c\x69','\x64\x45\x6c\x65\x6d\x65\x6e\x74\x73','\x70\x6f\x69\x6e\x74\x65\x72\x54\x79\x70','\x76\x69\x73\x69\x62\x69\x6c\x69\x74\x79','\x61\x64\x2d\x73\x72\x63\x73\x65\x74','\x6f\x6e\x74\x6f\x75\x63\x68\x73\x74\x61','\x5f\x62\x69\x6e\x64\x53\x74\x61\x72\x74','\x6e\x6f\x74\x69\x66\x79','\x64\x65\x73\x74\x72\x6f\x79','\x64\x65\x62\x75\x67','\x61\x69\x6c\x73\x51\x75\x61\x6e\x74\x69','\x69\x65\x77\x70\x6f\x72\x74','\x61\x63\x74\x69\x76\x61\x74\x65\x41\x73','\x6f\x6e\x74\x6f\x75\x63\x68\x65\x6e\x64','\x73\x2f\x66\x6c\x69\x63\x6b\x69\x74\x79','\x20\x6e\x6f\x20\x76\x61\x72\x69\x61\x6e','\x43\x55\x52\x52\x45\x4e\x54\x4c\x59\x5f','\x67\x65\x74\x52\x65\x73\x74\x69\x6e\x67','\x69\x73\x50\x72\x65\x76\x65\x6e\x74\x69','\x61\x75\x74\x6f\x50\x6c\x61\x79','\x50\x72\x65\x76\x69\x6f\x75\x73','\x64\x6f\x63\x52\x65\x61\x64\x79','\x63\x65\x6c\x6c\x53\x69\x7a\x65\x43\x68','\x43\x6f\x75\x6e\x74','\x67\x65\x74\x51\x75\x65\x72\x79\x45\x6c','\x6f\x75\x74\x65\x72\x48\x65\x69\x67\x68','\x70\x6f\x69\x6e\x74\x65\x72\x49\x64','\x64\x72\x61\x67\x45\x6e\x64\x42\x6f\x6f','\x66\x69\x6c\x74\x65\x72','\x63\x65\x6c\x6c\x43\x68\x61\x6e\x67\x65','\x69\x67\x68\x74','\x61\x64\x2d\x73\x72\x63','\x65\x6c\x65\x6d\x65\x6e\x74\x73','\x6e\x75\x6d\x62\x65\x72','\x69\x73\x42\x6f\x72\x64\x65\x72\x42\x6f','\x20\x61\x20\x68\x69\x64\x64\x65\x6e\x20','\x70\x61\x75\x73\x65\x50\x6c\x61\x79\x65','\x2e\x20\x41\x72\x65\x20\x79\x6f\x75\x20','\x69\x74\x79\x2d\x6c\x61\x7a\x79\x6c\x6f','\x72\x65\x6c\x6f\x61\x64\x43\x65\x6c\x6c','\x6f\x6e\x41\x63\x74\x69\x76\x61\x74\x65','\x73\x65\x74\x41\x74\x74\x72\x69\x62\x75','\x6e\x74\x65\x72\x44\x6f\x77\x6e','\x2d\x69\x6e\x64\x65\x78','\x70\x6f\x69\x6e\x74\x65\x72\x43\x61\x6e','\x64\x72\x61\x67\x67\x61\x62\x6c\x65','\x69\x73\x44\x72\x61\x67\x53\x65\x6c\x65','\x65\x78\x70\x6f\x72\x74\x73','\x69\x66\x74\x43\x65\x6c\x6c\x73','\x5f\x63\x72\x65\x61\x74\x65\x53\x6c\x69','\x63\x68\x65\x73','\x6b\x69\x74\x79\x3a\x20','\x64\x61\x74\x61\x5f\x74\x68\x75\x6d\x62','\x6f\x6e\x63\x6c\x69\x63\x6b','\x2e\x2f\x63\x65\x6c\x6c','\x6e\x74\x69\x66\x69\x65\x72','\x50\x6c\x61\x79\x65\x72','\x73\x65\x74\x54\x72\x61\x6e\x73\x6c\x61','\x54\x61\x72\x67\x65\x74','\x68\x6f\x6c\x64\x65\x72','\x2f\x70\x72\x6f\x64\x75\x63\x74\x73\x2f','\x65\x72\x4d\x6f\x76\x65','\x76\x61\x74\x65\x64','\x69\x64\x65\x72','\x75\x6e\x73\x65\x6c\x65\x63\x74\x53\x65','\x70\x72\x6f\x74\x6f\x74\x79\x70\x65','\x70\x72\x6f\x67\x72\x65\x73\x73','\x5f\x63\x72\x65\x61\x74\x65\x50\x72\x65','\x50\x6f\x69\x6e\x74','\x7b\x7d\x2e\x63\x6f\x6e\x73\x74\x72\x75','\x6c\x6f\x61\x64','\x70\x72\x6f\x78\x79\x49\x6d\x61\x67\x65','\x6f\x6e\x6d\x6f\x75\x73\x65\x6d\x6f\x76','\x64\x61\x74\x61','\x64\x61\x74\x61\x2d\x74\x68\x75\x6d\x62','\x74\x20\x66\x6f\x72\x20\x69\x6d\x61\x67','\x69\x6e\x6e\x65\x72\x57\x69\x64\x74\x68','\x74\x73\x69\x7a\x65\x62\x75\x67\x31','\x5f\x63\x72\x65\x61\x74\x65\x4c\x61\x7a','\x48\x69\x67\x68\x6c\x69\x67\x68\x74\x65','\x66\x65\x61\x74\x75\x72\x65\x64\x5f\x69','\x62\x65\x66\x6f\x72\x65\x53\x68\x69\x66','\x73\x65\x6c\x65\x63\x74\x65\x64\x41\x74','\x44\x65\x66\x65\x72\x72\x65\x64','\x32\x52\x41\x4e\x6f\x70\x57','\x5f\x70\x6f\x69\x6e\x74\x65\x72\x4d\x6f','\x74\x69\x6e\x67\x53\x65\x6c\x65\x63\x74','\x50\x6c\x75\x67\x69\x6e','\x2e\x65\x2e\x20','\x2e\x2f\x61\x6e\x69\x6d\x61\x74\x65','\x5f\x63\x72\x65\x61\x74\x65','\x75\x6e\x70\x61\x75\x73\x65','\x61\x67\x65\x4c\x6f\x6f\x70','\x66\x6c\x69\x63\x6b\x69\x74\x79\x2d\x70','\x74\x61\x72\x67\x65\x74','\x70\x61\x74\x68\x6e\x61\x6d\x65','\x45\x6c\x65\x6d\x65\x6e\x74','\x28\x6d\x61\x78\x2d\x77\x69\x64\x74\x68','\x5f\x74\x6f\x75\x63\x68\x41\x63\x74\x69','\x61\x62\x73','\x64\x69\x73\x61\x62\x6c\x65','\x65\x61\x63\x68','\x6d\x61\x72\x67\x69\x6e\x4c\x65\x66\x74','\x69\x6e\x64\x20\x70\x6f\x73\x69\x74\x69','\x6e\x64\x6c\x65\x72\x73','\x74\x6f\x74\x61\x6c\x49\x6d\x61\x67\x65','\x70\x6f\x69\x6e\x74\x65\x72\x44\x6f\x6e','\x65\x72\x72\x6f\x72','\x67\x65\x74\x53\x6c\x69\x64\x65\x44\x69','\x6f\x73\x69\x74\x69\x6f\x6e','\x6d\x61\x74\x63\x68\x65\x73\x53\x65\x6c','\x69\x6e\x64\x65\x78\x4f\x66','\x5f\x67\x65\x74\x43\x61\x6e\x43\x65\x6c','\x31\x32\x35\x36\x4d\x78\x45\x46\x46\x76','\x67\x65\x74\x43\x6f\x6d\x70\x75\x74\x65','\x34\x31\x36\x37\x37\x39\x69\x53\x6e\x67\x73\x64','\x70\x6f\x69\x6e\x74\x65\x72\x44\x6f\x77','\x64\x65\x72\x20\x2e\x70\x72\x6f\x64\x75','\x67\x65\x2d\x70\x6f\x73\x69\x74\x69\x6f','\x43\x6f\x75\x6c\x64\x6e\x27\x74\x20\x66','\x69\x73\x50\x6c\x61\x69\x6e\x4f\x62\x6a','\x64\x61\x74\x61\x2d\x70\x72\x6f\x64\x75','\x65\x6e\x61\x62\x6c\x65\x53\x6c\x69\x64','\x69\x6e\x67\x20','\x61\x2d\x6f\x70\x74\x69\x6f\x6e\x2d\x65','\x70\x72\x65\x76\x65\x6e\x74\x44\x65\x66','\x61\x6c\x6c\x4f\x66\x66','\x74\x43\x65\x6c\x6c\x73','\x5f\x70\x6f\x69\x6e\x74\x65\x72\x52\x65','\x50\x72\x65\x76\x4e\x65\x78\x74\x42\x75','\x62\x6c\x75\x72','\x70\x61\x67\x65\x59','\x69\x6d\x67\x5b\x64\x61\x74\x61\x2d\x66','\x76\x65\x6c\x6f\x63\x69\x74\x79','\x5b\x64\x61\x74\x61\x2d\x70\x72\x6f\x64','\x68\x61\x73\x44\x72\x61\x67\x53\x74\x61','\x65\x5f\x73\x6c\x69\x64\x65\x72\x5f\x66','\x5f\x6f\x6e\x63\x65\x45\x76\x65\x6e\x74','\x61\x63\x74\x69\x76\x61\x74\x65\x50\x72','\x2d\x64\x72\x6f\x70\x64\x6f\x77\x6e\x2d','\x6f\x6e\x6d\x6f\x75\x73\x65\x65\x6e\x74','\x72\x6f\x75\x6e\x64','\x69\x73\x42\x6f\x78\x53\x69\x7a\x65\x4f','\x68\x61\x6e\x64\x6c\x65\x73','\x63\x65\x6c','\x20\x72\x65\x61\x64\x79','\x61\x6e\x63\x65\x6c','\x5f\x66\x69\x6c\x74\x65\x72\x46\x69\x6e','\x6f\x6e\x56\x61\x6c\x75\x65','\x66\x6c\x69\x63\x6b\x69\x74\x79\x2d\x72','\x70\x6f\x69\x6e\x74\x65\x72\x63\x61\x6e','\x63\x6f\x6e\x63\x61\x74','\x63\x68\x61\x72\x41\x74','\x6f\x6e\x6d\x6f\x75\x73\x65\x64\x6f\x77','\x32\x30\x30\x70\x78','\x67\x65\x74\x4c\x61\x73\x74\x53\x6c\x69','\x74\x79\x43\x68\x61\x6e\x67\x65','\x20\x2e\x69\x73\x2d\x73\x65\x6c\x65\x63','\x68\x79\x73\x69\x63\x73','\x63\x43\x6c\x69\x63\x6b','\x65\x7a\x66\x79\x5f\x69\x6d\x61\x67\x65','\x71\x75\x65\x72\x79\x53\x65\x6c\x65\x63','\x50\x6f\x73\x69\x74\x69\x6f\x6e','\x74\x6f\x72','\x74\x20\x66\x6f\x72\x20\x46\x6c\x69\x63','\x61\x6e\x69\x6d\x61\x74\x69\x6f\x6e','\x44\x6f\x74\x73','\x64\x65\x73\x61\x6e\x64\x72\x6f\x2d\x6d','\x73\x70\x6c\x69\x74','\x77\x6e\x50\x72\x65\x76\x65\x6e\x74\x44','\x2f\x75\x6e\x69\x70\x6f\x69\x6e\x74\x65','\x73\x74\x65\x6e\x65\x72','\x69\x64\x65\x73','\x69\x6e\x64\x65\x78','\x66\x6f\x72\x45\x61\x63\x68','\x69\x64\x65\x72\x41\x74\x53\x65\x6c\x65','\x74\x4c\x69\x73\x74\x65\x6e\x65\x72','\x65\x78\x63\x65\x70\x74\x69\x6f\x6e','\x6a\x71\x44\x65\x66\x65\x72\x72\x65\x64','\x65\x72\x55\x70','\x67\x65\x74\x46\x72\x69\x63\x74\x69\x6f','\x2e\x2f\x6c\x61\x7a\x79\x6c\x6f\x61\x64','\x70\x61\x75\x73\x65\x64','\x46\x6c\x69\x63\x6b\x69\x74\x79','\x6f\x6e\x4e\x61\x76\x53\x74\x61\x74\x69','\x78\x20\x34\x70\x78','\x6c\x61\x72\x65\x2e\x63\x6f\x6d\x2f\x61','\x50\x6c\x61\x79','\x67\x75\x69\x64','\x6a\x51\x75\x65\x72\x79','\x74\x69\x74\x79\x5f\x6d\x6f\x62\x69\x6c','\x63\x65\x6c\x6c\x41\x6c\x69\x67\x6e','\x74\x68\x69\x73\x20\x73\x65\x6c\x65\x63','\x2d\x65\x7a\x66\x79','\x65\x63\x74\x65\x64','\x43\x68\x61\x6e\x67\x65','\x54\x68\x75\x6d\x62\x6e\x61\x69\x6c\x73','\x74\x57\x69\x64\x74\x68','\x6a\x71\x75\x65\x72\x79','\x5f\x70\x6f\x69\x6e\x74\x65\x72\x43\x61','\x42\x61\x63\x6b\x67\x72\x6f\x75\x6e\x64','\x68\x72\x65\x66','\x67\x65\x74\x49\x73\x49\x6d\x61\x67\x65','\x64\x72\x61\x67\x4d\x6f\x76\x65\x54\x69','\x73\x65\x6c\x65\x63\x74\x5b\x64\x61\x74','\x6d\x65\x73','\x72\x65\x6d\x6f\x76\x65\x44\x6f\x74\x73','\x62\x6f\x72\x64\x65\x72\x2d\x62\x6f\x78','\x73\x65\x74\x74\x6c\x65','\x6f\x64\x73','\x69\x6d\x61\x67\x65\x73\x4c\x6f\x61\x64','\x72\x6f\x74\x61\x74\x65\x28\x31\x38\x30','\x6d\x6f\x64\x75\x6c\x6f','\x75\x6e\x64','\x73\x2f\x70\x61\x67\x65\x2d\x64\x6f\x74','\x73\x72\x63','\x67\x65\x73\x4c\x6f\x61\x64\x65\x64','\x65\x6c\x65\x6d\x65\x6e\x74','\x75\x70\x64\x61\x74\x65\x53\x65\x6c\x65','\x73\x74\x61\x74\x65','\x61\x64\x64\x42\x61\x63\x6b\x67\x72\x6f','\x76\x69\x65\x77\x42\x6f\x78','\x74\x6f\x75\x63\x68\x63\x61\x6e\x63\x65','\x6b\x69\x74\x79\x2d\x70\x72\x65\x76\x2d','\x61\x6d\x64','\x61\x6e\x69\x6d\x61\x74\x65\x50\x72\x6f','\x70\x61\x64\x64\x69\x6e\x67','\x73\x2f\x69\x6e\x64\x65\x78','\x6f\x6c\x64','\x6e\x61\x69\x6c\x73\x5f\x6c\x6f\x6f\x70','\x74\x69\x63\x6b','\x6c\x65\x6e\x67\x74\x68','\x68\x65\x61\x64','\x73\x72\x63\x73\x65\x74','\x6f\x6e\x44\x65\x61\x63\x74\x69\x76\x61','\x63\x72\x65\x61\x74\x65','\x5f\x75\x6e\x62\x69\x6e\x64\x50\x6f\x73','\x61\x70\x70\x65\x6e\x64\x43\x68\x69\x6c','\x6c\x46\x69\x74','\x6e\x61\x69\x6c\x73\x5f\x71\x75\x61\x6e','\x69\x6e\x73\x65\x72\x74\x42\x65\x66\x6f','\x67\x65\x74\x43\x65\x6c\x6c\x53\x6c\x69','\x69\x6d\x67','\x65\x6c\x65\x63\x74\x65\x64\x43\x6c\x61','\x61\x6e\x69\x6d\x61\x74\x65','\x65\x72\x2d\x2d\x6c\x6f\x61\x64\x65\x64','\x6f\x6e\x6d\x6f\x75\x73\x65\x6c\x65\x61','\x6f\x77\x6e','\x64\x65\x49\x6e\x64\x65\x78','\x67\x65\x74\x2d\x73\x69\x7a\x65\x2f\x67','\x2e\x2f\x70\x61\x67\x65\x2d\x64\x6f\x74','\x75\x6e\x69\x64\x72\x61\x67\x67\x65\x72','\x63\x72\x65\x61\x74\x65\x4d\x65\x74\x68','\x69\x73\x4c\x65\x66\x74','\x71\x75\x65\x72\x79\x43\x65\x6c\x6c','\x6f\x76\x65','\x65\x7a\x66\x79\x44\x65\x62\x75\x74\x53','\x73\x65\x74','\x73\x6c\x69\x64\x65\x61\x62\x6c\x65\x57','\x67\x65\x74','\x61\x74\x63\x68\x65\x73\x2d\x73\x65\x6c','\x69\x62\x75\x74\x65','\x69\x73\x50\x6f\x69\x6e\x74\x65\x72\x44','\x69\x73\x50\x72\x65\x76\x69\x6f\x75\x73','\x7a\x79\x6c\x6f\x61\x64\x5d\x2c\x20\x69','\x73\x65\x6c\x65\x63\x74\x65\x64\x44\x6f','\x6c\x65\x63\x74\x65\x64\x53\x6c\x69\x64','\x2d\x6f\x70\x74\x69\x6f\x6e\x73','\x7a\x66\x79\x3d\x22\x6f\x70\x74\x69\x6f','\x31\x30\x30\x2c\x20\x31\x30\x30\x29\x20','\x72\x65\x73\x74\x69\x6e\x67\x46\x72\x61','\x69\x73\x41\x63\x74\x69\x76\x65','\x67\x72\x6f\x75\x70\x43\x65\x6c\x6c\x73','\x74\x61\x62\x6c\x65','\x62\x6f\x72\x64\x65\x72\x4c\x65\x66\x74','\x64\x53\x74\x79\x6c\x65','\x6f\x6e\x6c\x6f\x61\x64','\x73\x65\x6c\x65\x63\x74\x43\x65\x6c\x6c','\x74\x61\x72\x74\x45\x76\x65\x6e\x74\x73','\x67\x65\x74\x50\x61\x72\x65\x6e\x74\x43','\x64\x67\x65\x74\x2f\x6a\x71\x75\x65\x72','\x70\x72\x65\x76\x69\x6f\x75\x73','\x6e\x61\x6d\x65\x73\x70\x61\x63\x65\x4a','\x67\x65\x74\x4c\x61\x73\x74\x43\x65\x6c','\x63\x74\x6f\x72\x28\x22\x72\x65\x74\x75','\x31\x36\x33\x34\x34\x30\x38\x5a\x4b\x4e\x6e\x42\x52','\x41\x43\x54\x49\x56\x45\x5f\x49\x4e\x44','\x70\x6c\x61\x79\x69\x6e\x67','\x64\x72\x61\x67\x45\x6e\x64','\x66\x61\x69\x6c','\x61\x64\x64','\x6f\x6e\x43\x6c\x69\x63\x6b','\x68\x69\x64\x64\x65\x6e','\x70\x6f\x69\x6e\x74\x65\x72\x75\x70','\x6f\x6e\x56\x69\x73\x69\x62\x69\x6c\x69','\x61\x63\x74\x69\x76\x61\x74\x65','\x73\x74\x79\x6c\x65\x73\x68\x65\x65\x74','\x69\x6d\x61\x67\x65\x73','\x63\x6f\x6e\x73\x74\x72\x75\x63\x74\x6f','\x70\x6c\x61\x79\x50\x6c\x61\x79\x65\x72','\x38\x38\x38\x35\x34\x32\x72\x47\x75\x74\x53\x57','\x6d\x6f\x75\x73\x65\x6c\x65\x61\x76\x65','\x61\x67\x58','\x66\x6c\x69\x63\x6b\x69\x74\x79\x47\x55','\x2c\x35\x30\x20\x4c\x20','\x69\x73\x2d\x6e\x61\x76\x2d\x73\x65\x6c','\x76\x61\x72\x69\x61\x6e\x74\x5f\x69\x64','\x75\x6e\x62\x69\x6e\x64\x53\x74\x61\x72','\x70\x61\x67\x65\x44\x6f\x74\x73','\x66\x6c\x69\x63\x6b\x69\x74\x79\x2d\x6c','\x6c\x69\x67\x68\x74\x65\x64\x5f\x70\x6f','\x64\x69\x73\x74\x61\x6e\x63\x65','\x24\x65\x6c\x65\x6d\x65\x6e\x74','\x6e\x65\x78\x74','\x73\x65\x74\x44\x6f\x74\x73','\x6f\x6e\x63\x65','\x64\x75\x63\x74\x2d\x66\x6f\x72\x6d\x5f','\x74\x72\x61\x6e\x73\x6c\x61\x74\x65\x58','\x62\x6f\x72\x64\x65\x72\x42\x6f\x74\x74','\x62\x6f\x72\x64\x65\x72\x53\x74\x79\x6c','\x78\x2d\x65\x7a\x66\x79\x3d\x22','\x64\x72\x61\x67\x53\x74\x61\x72\x74','\x70\x64\x6f\x77\x6e\x2e','\x6f\x6e\x72\x65\x73\x69\x7a\x65','\x6b\x65\x79\x43\x6f\x64\x65','\x6e\x6f\x64\x65\x54\x79\x70\x65','\x75\x63\x74\x2d\x68\x61\x6e\x64\x6c\x65','\x73\x74\x61\x6e\x63\x65','\x77\x72\x61\x70\x41\x72\x6f\x75\x6e\x64','\x31\x37\x31\x35\x37\x33\x73\x49\x66\x44\x77\x75','\x74\x6f\x75\x63\x68\x6d\x6f\x76\x65','\x63\x75\x72\x73\x6f\x72\x50\x6f\x73\x69','\x70\x61\x74\x68','\x74\x74\x6f\x6e\x73','\x49\x4d\x47','\x74\x6f\x53\x74\x72\x69\x6e\x67','\x77\x6e\x44\x65\x66\x61\x75\x6c\x74','\x76\x61\x6c\x75\x65','\x65\x6e\x61\x62\x6c\x65','\x72\x65\x6d\x6f\x76\x65\x44\x61\x74\x61','\x68\x65\x73\x2d\x73\x65\x6c\x65\x63\x74','\x6d\x61\x6b\x65\x41\x72\x72\x61\x79','\x6f\x72\x5f\x74\x68\x75\x6d\x62\x6e\x61','\x68\x61\x6e\x64\x6c\x65\x43\x6c\x69\x63','\x4c\x6f\x61\x64\x65\x64','\x5f\x77\x72\x61\x70\x53\x65\x6c\x65\x63','\x64\x61\x74\x61\x2d','\x6e\x6a\x73\x2e\x63\x6c\x6f\x75\x64\x66','\x72\x6e\x65\x64\x20','\x69\x6e\x73\x65\x72\x74','\x64\x6f\x74','\x72\x65\x6d\x6f\x76\x65\x45\x76\x65\x6e','\x63\x6f\x6e\x74\x61\x69\x6e','\x73\x65\x74\x4e\x61\x76\x43\x6f\x6d\x70','\x75\x69\x43\x68\x61\x6e\x67\x65','\x61\x6c\x77\x61\x79\x73','\x6e\x61\x76\x43\x6f\x6d\x70\x61\x6e\x69','\x63\x6f\x6e\x73\x6f\x6c\x65','\x70\x61\x72\x73\x65','\x64\x69\x72\x65\x63\x74\x69\x6f\x6e','\x64\x61\x74\x61\x5f\x74\x6f\x74\x61\x6c','\x73\x65\x6c\x65\x63\x74\x65\x64\x53\x6c','\x65\x69\x6e\x67\x20\x63\x68\x61\x6e\x67','\x75\x6e\x62\x69\x6e\x64\x44\x72\x61\x67','\x74\x6f\x6d','\x63\x6f\x6e\x74\x65\x6e\x74','\x67\x65\x74\x54\x6f\x75\x63\x68','\x72\x68\x61\x70\x73\x20\x74\x68\x69\x73','\x63\x72\x65\x61\x74\x65\x53\x56\x47','\x74\x20\x61\x73\x73\x6f\x63\x69\x61\x74','\x75\x72\x6c','\x70\x61\x72\x65\x6e\x74\x4e\x6f\x64\x65','\x4e\x61\x76\x46\x6f\x72','\x6a\x73\x6f\x6e','\x72\x65\x73\x6f\x6c\x76\x65','\x5f\x65\x76\x65\x6e\x74\x73','\x74\x65\x72\x45\x76\x65\x6e\x74\x73','\x61\x6e\x67\x65','\x65\x6c\x6c\x73','\x64\x69\x76','\x75\x70\x64\x61\x74\x65\x50\x61\x67\x65','\x73\x65\x6c\x65\x63\x74\x65\x64\x4f\x70','\x69\x73\x44\x72\x61\x67\x67\x69\x6e\x67','\x61\x70\x70\x6c\x79','\x73\x74\x79\x6c\x65','\x75\x70\x64\x61\x74\x65\x53\x6c\x69\x64','\x73\x68\x69\x66\x74','\x65\x6d\x65\x6e\x74','\x79\x65\x72','\x5f\x70\x72\x6f\x64\x75\x63\x74\x73','\x61\x76\x46\x6f\x72','\x69\x6d\x61\x67\x65\x20\x69\x73\x20\x62','\x61\x64\x64\x45\x76\x65\x6e\x74\x4c\x69','\x67\x65\x74\x41\x64\x6a\x61\x63\x65\x6e','\x6f\x6e\x6d\x6f\x75\x73\x65\x75\x70','\x76\x65\x2d\x63\x65\x6c\x6c','\x6f\x66\x66\x73\x65\x74\x57\x69\x64\x74','\x69\x6e\x66\x6f','\x65\x78\x65\x63','\x70\x72\x65\x70\x65\x6e\x64','\x67\x61\x62\x6c\x65','\x70\x72\x6f\x6d\x69\x73\x65','\x2e\x77\x33\x2e\x6f\x72\x67\x2f\x32\x30','\x49\x6d\x61\x67\x65\x73','\x65\x72\x46\x6f\x72\x54\x68\x75\x6d\x62','\x20\x61\x20\x22\x73\x74\x61\x72\x74\x22','\x73\x69\x7a\x65','\x66\x69\x7a\x7a\x79\x55\x49\x55\x74\x69','\x61\x64\x64\x43\x65\x6c\x6c','\x6f\x70\x74\x69\x6f\x6e\x73','\x73\x76\x67','\x74\x69\x6f\x6e\x73','\x6c\x69\x64\x65\x72\x50\x72\x6f','\x64\x61\x74\x61\x5f\x66\x65\x61\x74\x75','\x73\x65\x74\x4a\x51\x75\x65\x72\x79','\x6e\x63\x65\x6c','\x63\x68\x69\x6c\x64\x55\x49\x50\x6f\x69','\x74\x6f\x75\x63\x68\x73\x74\x61\x72\x74','\x5f\x64\x72\x61\x67\x50\x6f\x69\x6e\x74','\x66\x65\x61\x74\x75\x72\x65\x64\x5f\x6d','\x43\x65\x6c\x6c\x73','\x6e\x42\x6c\x75\x72','\x62\x6f\x64\x79','\x62\x75\x74\x74\x6f\x6e','\x6e\x65\x78\x74\x42\x75\x74\x74\x6f\x6e','\x69\x73\x45\x6e\x61\x62\x6c\x65\x64','\x64\x72\x61\x67\x58','\x65\x6c\x65\x63\x74\x65\x64\x45\x6c\x65','\x63\x72\x65\x61\x74\x65\x45\x6c\x65\x6d','\x73\x65\x6c\x65\x63\x74\x65\x64\x49\x6e','\x70\x72\x65\x76\x42\x75\x74\x74\x6f\x6e','\x6f\x6e\x4e\x61\x76\x43\x6f\x6d\x70\x61','\x2d\x64\x6f\x77\x6e','\x69\x6e\x69\x74','\x73\x63\x72\x69\x70\x74','\x72\x6e\x20\x74\x68\x69\x73\x22\x29\x28','\x5f\x73\x68\x69\x66\x74\x43\x65\x6c\x6c','\x64\x72\x61\x67\x54\x68\x72\x65\x73\x68','\x6d\x6f\x75\x73\x65\x75\x70','\x74\x65\x64','\x69\x63\x6b\x69\x74\x79\x2d\x6c\x61\x7a','\x6d\x61\x72\x67\x69\x6e\x42\x6f\x74\x74','\x63\x65\x6e\x74\x65\x72','\x61\x6c\x69\x7a\x65\x64\x2e\x20\x43\x61','\x70\x61\x6e\x2d\x79','\x61\x72\x69\x61\x2d\x6c\x61\x62\x65\x6c','\x20\x4c\x20','\x72\x65\x73\x69\x7a\x65','\x5f\x62\x69\x6e\x64\x50\x6f\x73\x74\x53','\x73\x74\x61\x74\x69\x63\x43\x6c\x69\x63','\x6c\x61\x7a\x79\x4c\x6f\x61\x64','\x64\x6f\x77\x6e\x20\x76\x61\x6c\x75\x65','\x62\x6f\x72\x64\x65\x72\x54\x6f\x70\x57','\x74\x65\x44\x72\x61\x67','\x65\x73\x4c\x6f\x61\x64\x65\x64\x20','\x5f\x63\x6f\x6e\x74\x61\x69\x6e\x53\x6c','\x64\x65\x66\x61\x75\x6c\x74\x73','\x72\x65\x6d\x6f\x76\x65\x43\x68\x69\x6c','\x6e\x46\x61\x63\x74\x6f\x72','\x66\x75\x6e\x63\x74\x69\x6f\x6e','\x77\x61\x74\x63\x68\x43\x53\x53','\x64\x72\x61\x67\x4d\x6f\x76\x65','\x70\x72\x65\x76\x69\x6f\x75\x73\x44\x72','\x73\x65\x6c\x65\x63\x74\x65\x64\x45\x6c','\x64\x72\x61\x67\x45\x6e\x64\x52\x65\x73','\x68\x61\x73\x41\x6e\x79\x42\x72\x6f\x6b','\x74\x69\x6d\x65\x6f\x75\x74','\x20\x5b\x64\x61\x74\x61\x2d\x69\x6d\x61','\x6c\x6f\x63\x61\x74\x69\x6f\x6e','\x61\x63\x74\x69\x76\x61\x74\x65\x50\x6c','\x63\x68\x61\x6e\x67\x65\x4e\x61\x76\x53','\x5f\x67\x65\x74\x57\x72\x61\x70\x53\x68','\x6c\x6c\x69\x6e\x67','\x6c\x65\x66\x74','\x75\x74\x74\x6f\x6e\x20\x66\x6c\x69\x63','\x66\x6c\x69\x63\x6b\x69\x74\x79\x2d\x76','\x69\x73\x44\x72\x61\x67\x67\x61\x62\x6c','\x73\x74\x6f\x70','\x73\x6c\x69\x64\x65\x73\x57\x69\x64\x74','\x6f\x6e\x70\x6f\x69\x6e\x74\x65\x72\x6d','\x6f\x6e\x65\x72\x72\x6f\x72','\x61\x6e\x69\x6f\x6e','\x61\x73\x2d\x6e\x61\x76\x2d\x66\x6f\x72','\x6a\x51\x75\x65\x72\x79\x42\x72\x69\x64','\x70\x6f\x69\x6e\x74\x65\x72\x4d\x6f\x76','\x69\x6f\x6e','\x6f\x66\x66\x73\x65\x74\x48\x65\x69\x67','\x63\x65\x6c\x6c\x53\x65\x6c\x65\x63\x74','\x6d\x67\x5b\x64\x61\x74\x61\x2d\x66\x6c','\x70\x61\x64\x64\x69\x6e\x67\x52\x69\x67','\x73\x2f\x73\x6c\x69\x64\x65','\x66\x6c\x69\x63\x6b\x69\x74\x79','\x5f\x63\x72\x65\x61\x74\x65\x44\x72\x61','\x5f\x69\x6d\x61\x67\x65\x73','\x73\x6f\x6c\x69\x64','\x69\x64\x74\x68','\x63\x65\x6c\x6c\x73','\x63\x6c\x69\x63\x6b','\x6f\x66\x66','\x70\x6f\x73\x69\x74\x69\x6f\x6e\x43\x65','\x69\x73\x4f\x72\x69\x67\x69\x6e\x4c\x65','\x2c\x20\x2e','\x72\x75\x6e\x6e\x69\x6e\x67\x20\x74\x68','\x6e\x56\x61\x6c\x75\x65','\x75\x6e\x73\x65\x6c\x65\x63\x74','\x75\x70\x64\x61\x74\x65','\x63\x68\x65\x63\x6b','\x72\x65\x64','\x66\x6c\x69\x63\x6b\x69\x74\x79\x2d\x65','\x69\x73\x20\x63\x6f\x64\x65\x20\x69\x6e','\x6f\x6e\x70\x6f\x69\x6e\x74\x65\x72\x63','\x74\x69\x6c\x73','\x3a\x20\x37\x36\x37\x70\x78\x29','\x6f\x6b\x61\x79\x50\x6f\x69\x6e\x74\x65','\x69\x73\x49\x6e\x69\x74\x41\x63\x74\x69','\x6c\x69\x64\x65\x72\x46\x65\x61\x74\x75','\x6e\x3d\x27','\x6f\x6c\x6c\x69\x6e\x67','\x68\x61\x73\x41\x74\x74\x72\x69\x62\x75','\x4c\x6f\x6f\x70','\x77\x72\x61\x70\x70\x65\x72','\x72\x65\x6e\x64\x65\x72\x50\x6f\x73\x69','\x2e\x2f\x66\x6c\x69\x63\x6b\x69\x74\x79','\x5f\x63\x72\x65\x61\x74\x65\x50\x6c\x61','\x75\x6e\x64\x65\x66\x69\x6e\x65\x64','\x6f\x6e\x6b\x65\x79\x64\x6f\x77\x6e','\x73\x2f\x61\x6e\x69\x6d\x61\x74\x65','\x68\x61\x6e\x67\x65\x20\x64\x72\x6f\x70','\x74\x65\x78\x74\x43\x6f\x6e\x74\x65\x6e','\x69\x73\x49\x67\x6e\x6f\x72\x69\x6e\x67','\x74\x74\x6f\x6e','\x69\x73\x41\x72\x72\x61\x79','\x72\x44\x6f\x77\x6e','\x74\x6f\x75\x63\x68\x41\x63\x74\x69\x6f','\x69\x64\x65\x6e\x74\x69\x66\x69\x65\x72','\x75\x6e\x62\x69\x6e\x64\x48\x61\x6e\x64','\x72\x65\x74\x75\x72\x6e\x20\x28\x66\x75','\x74\x79\x70\x65','\x63\x74\x5f\x6a\x73\x6f\x6e','\x6d\x61\x78\x43\x65\x6c\x6c\x48\x65\x69','\x31\x33\x32\x30\x35\x39\x34\x4e\x4b\x76\x7a\x56\x50','\x6f\x73\x63','\x62\x6f\x72\x64\x65\x72\x52\x69\x67\x68','\x5f\x63\x72\x65\x61\x74\x65\x49\x6d\x61','\x6e\x69\x6f\x6e\x53\x65\x6c\x65\x63\x74','\x43\x6f\x6d\x70\x6c\x65\x74\x65','\x79\x6c\x6f\x61\x64\x2d\x73\x72\x63\x5d','\x64\x65\x72','\x70\x6f\x73\x69\x74\x69\x6f\x6e','\x64\x50\x6f\x73\x69\x74\x69\x6f\x6e','\x61\x72\x69\x61\x2d\x63\x75\x72\x72\x65','\x69\x74\x79','\x76\x65\x6e\x74','\x70\x61\x72\x65\x6e\x74','\x74\x72\x61\x63\x74\x69\x6f\x6e','\x64\x65\x61\x63\x74\x69\x76\x61\x74\x65','\x6d\x61\x67\x65','\x77\x61\x72\x6e','\x50\x6f\x69\x6e\x74\x65\x72\x45\x76\x65','\x74\x69\x6f\x6e','\x54\x68\x75\x6d\x62\x6e\x61\x69\x6c\x2d','\x73\x2d\x6e\x61\x76\x2d\x66\x6f\x72\x2f','\x6c\x69\x64\x65\x72','\x67\x65\x74\x43\x65\x6c\x6c\x45\x6c\x65','\x74\x53\x74\x61\x72\x74\x45\x76\x65\x6e','\x62\x69\x6e\x64','\x64\x65\x62\x6f\x75\x6e\x63\x65\x4d\x65','\x6f\x6d\x57\x69\x64\x74\x68','\x5f\x70\x6f\x73\x69\x74\x69\x6f\x6e\x43','\x6d\x61\x6b\x65\x4a\x51\x75\x65\x72\x79','\x42\x61\x64\x20\x65\x6c\x65\x6d\x65\x6e','\x63\x74\x65\x64\x50\x61\x67\x65\x44\x6f','\x68\x6f\x73\x74','\x74\x69\x6c\x73\x2f\x75\x74\x69\x6c\x73','\x2f\x62\x69\x74\x2e\x6c\x79\x2f\x67\x65','\x5f\x75\x6e\x73\x68\x69\x66\x74\x43\x65','\x61\x67\x65\x2d\x64\x6f\x74\x73','\x61\x63\x74\x69\x76\x65\x45\x6c\x65\x6d','\x69\x61\x6c\x49\x6e\x64\x65\x78','\x63\x72\x65\x61\x74\x65\x54\x6f\x75\x63','\x73\x65\x74\x44\x65\x66\x61\x75\x6c\x74','\x63\x6f\x6d\x70\x6c\x65\x74\x65','\x6f\x62\x6a\x65\x63\x74','\x77\x72\x61\x70\x53\x68\x69\x66\x74','\x5f\x63\x72\x65\x61\x74\x65\x41\x73\x4e','\x6e\x6e\x6f\x74\x20\x63\x61\x6c\x6c\x20','\x67\x65\x74\x53\x69\x7a\x65','\x77\x65\x62\x6b\x69\x74','\x6d\x69\x6e','\x63\x6c\x61\x73\x73\x4c\x69\x73\x74','\x73\x70\x6c\x69\x63\x65','\x6d\x6f\x7a','\x69\x73\x46\x72\x65\x65\x53\x63\x72\x6f','\x66\x72\x69\x63\x74\x69\x6f\x6e','\x61\x70\x70\x65\x6e\x64','\x70\x61\x64\x64\x69\x6e\x67\x42\x6f\x74','\x66\x6c\x69\x63\x6b\x69\x74\x79\x2d\x62','\x73\x74\x61\x72\x74\x41\x6e\x69\x6d\x61','\x70\x6f\x69\x6e\x74\x65\x72\x55\x70','\x2e\x73\x65\x6c\x65\x63\x74\x6f\x72\x2d','\x6d\x61\x72\x67\x69\x6e\x54\x6f\x70','\x65\x6e\x74\x72\x69\x65\x73','\x6c\x61\x7a\x79\x6c\x6f\x61\x64\x2d\x73','\x4e\x65\x78\x74','\x4e\x6f\x20\x69\x6d\x61\x67\x65\x20\x61','\x68\x74\x6d\x6c\x49\x6e\x69\x74'];var _0x2870=function(_0x32e60e,_0x115f51){_0x32e60e=_0x32e60e-0x144;var _0x1f629b=_0x6321[_0x32e60e];return _0x1f629b;};var _0x3ac277=_0x2870;(function(_0x1c522a,_0x421c14){var _0x45f14f=_0x2870;while(!![]){try{var _0x4a20ed=parseInt(_0x45f14f(0x22f))+-parseInt(_0x45f14f(0x32e))+-parseInt(_0x45f14f(0x166))*parseInt(_0x45f14f(0x23e))+-parseInt(_0x45f14f(0x25b))+-parseInt(_0x45f14f(0x46b))+-parseInt(_0x45f14f(0x183))*parseInt(_0x45f14f(0x3b0))+-parseInt(_0x45f14f(0x185))*-parseInt(_0x45f14f(0x3f8));if(_0x4a20ed===_0x421c14)break;else _0x1c522a['push'](_0x1c522a['shift']());}catch(_0x37f801){_0x1c522a['push'](_0x1c522a['shift']());}}}(_0x6321,0xf2da9),window['\x65\x7a\x66\x79\x44\x65\x62\x75\x74\x53'+_0x3ac277(0x2ae)]=window[_0x3ac277(0x212)+_0x3ac277(0x2ae)]||{},ezfyDebutSliderPro=function(){var _0x233d8b=_0x3ac277,_0x1bfa0c=function(){var _0x590b59=!![];return function(_0x2c84c7,_0x2a66db){var _0x313f3a=_0x590b59?function(){var _0x46afe3=_0x2870;if(_0x2a66db){var _0x34ebb1=_0x2a66db[_0x46afe3(0x291)](_0x2c84c7,arguments);return _0x2a66db=null,_0x34ebb1;}}:function(){};return _0x590b59=![],_0x313f3a;};}();const _0x4ecc5a=_0x233d8b(0x47c)+'\x61\x67\x65\x53\x6c\x69\x64\x65\x72';window[_0x233d8b(0x497)+_0x233d8b(0x230)+'\x45\x58']=0x0;const _0x5f460b=0x32,_0x577078=0x32,_0x4d0125=_0x577078*0x3,_0x115b19=_0x5f460b-0x14;let _0x3c1363=![],_0x453d90=![],_0x38c9ac=![];const _0x217d55={'\x66\x65\x61\x74\x75\x72\x65\x64\x49\x6d\x61\x67\x65\x41\x6e\x69\x6d\x61\x74\x69\x6f\x6e':_0x135737(_0x233d8b(0x2af)+_0x233d8b(0x412)+_0x233d8b(0x1b7)),'\x64\x61\x74\x61\x54\x68\x75\x6d\x62\x6e\x61\x69\x6c\x73\x51\x75\x61\x6e\x74\x69\x74\x79\x4d\x6f\x62\x69\x6c\x65':_0x135737(_0x233d8b(0x146)+_0x233d8b(0x201)+_0x233d8b(0x1d0)+'\x65'),'\x64\x61\x74\x61\x54\x68\x75\x6d\x62\x6e\x61\x69\x6c\x73\x51\x75\x61\x6e\x74\x69\x74\x79':_0x135737(_0x233d8b(0x146)+'\x6e\x61\x69\x6c\x73\x5f\x71\x75\x61\x6e'+_0x233d8b(0x41a)),'\x74\x6f\x74\x61\x6c\x49\x6d\x61\x67\x65\x73':_0x135737(_0x233d8b(0x27a)+_0x233d8b(0x2ff)),'\x66\x65\x61\x74\x75\x72\x65\x64\x49\x6d\x61\x67\x65\x4c\x6f\x6f\x70':_0x135737('\x64\x61\x74\x61\x5f\x66\x65\x61\x74\x75'+_0x233d8b(0x412)+_0x233d8b(0x483)),'\x65\x6e\x61\x62\x6c\x65\x53\x6c\x69\x64\x65\x72\x46\x6f\x72\x54\x68\x75\x6d\x62\x6e\x61\x69\x6c\x73\x44\x65\x73\x6b\x74\x6f\x70':_0x135737('\x64\x61\x74\x61\x5f\x65\x6e\x61\x62\x6c'+_0x233d8b(0x19a)+_0x233d8b(0x268)+'\x69\x6c\x73\x5f\x64\x65\x73\x6b\x74\x6f'+'\x70'),'\x74\x68\x75\x6d\x62\x6e\x61\x69\x6c\x73\x48\x69\x67\x68\x6c\x69\x67\x68\x74\x65\x64\x50\x6f\x73\x69\x74\x69\x6f\x6e':_0x135737('\x64\x61\x74\x61\x5f\x74\x68\x75\x6d\x62'+_0x233d8b(0x420)+_0x233d8b(0x248)+'\x73\x69\x74\x69\x6f\x6e'),'\x66\x65\x61\x74\x75\x72\x65\x64\x49\x6d\x61\x67\x65\x4c\x61\x7a\x79\x6c\x6f\x61\x64':_0x135737(_0x233d8b(0x2af)+_0x233d8b(0x412)+_0x233d8b(0x400)),'\x74\x68\x75\x6d\x62\x6e\x61\x69\x6c\x73\x4c\x6f\x6f\x70':_0x135737(_0x233d8b(0x146)+_0x233d8b(0x1f7))};console[_0x233d8b(0x45a)](_0x217d55);const _0x5ee0b2={'\x70\x61\x67\x65\x44\x6f\x74\x73':![],'\x63\x6f\x6e\x74\x61\x69\x6e':!![],'\x69\x6d\x61\x67\x65\x73\x4c\x6f\x61\x64\x65\x64':!![],'\x61\x64\x61\x70\x74\x69\x76\x65\x48\x65\x69\x67\x68\x74':!![],'\x77\x72\x61\x70\x41\x72\x6f\x75\x6e\x64':_0x217d55[_0x233d8b(0x47c)+_0x233d8b(0x16e)],'\x66\x61\x64\x65':!![],'\x6c\x61\x7a\x79\x4c\x6f\x61\x64':_0x217d55[_0x233d8b(0x47c)+'\x61\x67\x65\x4c\x61\x7a\x79\x6c\x6f\x61'+'\x64'],'\x73\x65\x6c\x65\x63\x74\x65\x64\x41\x74\x74\x72\x61\x63\x74\x69\x6f\x6e':_0x217d55[_0x233d8b(0x47c)+_0x233d8b(0x486)+'\x6f\x6e']?0.025:0x1,'\x66\x72\x69\x63\x74\x69\x6f\x6e':_0x217d55[_0x233d8b(0x47c)+_0x233d8b(0x486)+'\x6f\x6e']?0.28:0x1},_0x30c890={'\x61\x73\x4e\x61\x76\x46\x6f\x72':'\x23'+_0x4ecc5a,'\x77\x72\x61\x70\x41\x72\x6f\x75\x6e\x64':_0x217d55['\x74\x68\x75\x6d\x62\x6e\x61\x69\x6c\x73'+_0x233d8b(0x319)],'\x69\x6d\x61\x67\x65\x73\x4c\x6f\x61\x64\x65\x64':!![],'\x63\x6f\x6e\x74\x61\x69\x6e':![],'\x70\x61\x67\x65\x44\x6f\x74\x73':![],'\x61\x63\x63\x65\x73\x73\x69\x62\x69\x6c\x69\x74\x79':![],'\x70\x72\x65\x76\x4e\x65\x78\x74\x42\x75\x74\x74\x6f\x6e\x73':!![],'\x63\x65\x6c\x6c\x41\x6c\x69\x67\x6e':_0x3dc280()?_0x233d8b(0x2eb):_0x217d55['\x74\x68\x75\x6d\x62\x6e\x61\x69\x6c\x73'+_0x233d8b(0x161)+_0x233d8b(0x337)],'\x67\x72\x6f\x75\x70\x43\x65\x6c\x6c\x73':_0x3dc280()};function _0x3dc280(){var _0x37a114=_0x233d8b;const _0x337ae8=parseInt(_0x217d55[_0x37a114(0x17b)+'\x73']),_0x291cf3=parseInt(_0x217d55['\x64\x61\x74\x61\x54\x68\x75\x6d\x62\x6e'+_0x37a114(0x491)+_0x37a114(0x464)]),_0x2f7b1f=parseInt(_0x217d55['\x64\x61\x74\x61\x54\x68\x75\x6d\x62\x6e'+'\x61\x69\x6c\x73\x51\x75\x61\x6e\x74\x69'+'\x74\x79']);console[_0x37a114(0x45a)](_0x37a114(0x32f),_0x337ae8,_0x291cf3,_0x2f7b1f);if(_0x3a3d1f()&&_0x337ae8>_0x291cf3)return![];else{if(!_0x3a3d1f()&&_0x337ae8>_0x2f7b1f)return![];}return!![];}function _0x3a3d1f(){var _0x4802c4=_0x233d8b;return window['\x6d\x61\x74\x63\x68\x4d\x65\x64\x69\x61'](_0x4802c4(0x173)+_0x4802c4(0x312))[_0x4802c4(0x443)];}function _0x3e4127(_0x839735){return new Promise(function(_0x1049e4,_0x1d2628){var _0x5ac644=_0x2870,_0x400f98;_0x400f98=document['\x63\x72\x65\x61\x74\x65\x45\x6c\x65\x6d'+_0x5ac644(0x411)](_0x5ac644(0x2c4)),_0x400f98[_0x5ac644(0x1e9)]=_0x839735,_0x400f98[_0x5ac644(0x226)]=_0x1049e4,_0x400f98[_0x5ac644(0x2f2)]=_0x1d2628,document['\x68\x65\x61\x64'][_0x5ac644(0x1ff)+'\x64'](_0x400f98);});}function _0x135737(_0x3ada8d){var _0x1af91c=_0x233d8b,_0x17f64b=_0x1bfa0c(this,function(){var _0x72a85d=_0x2870,_0x128670;try{var _0x10283d=Function(_0x72a85d(0x32a)+'\x6e\x63\x74\x69\x6f\x6e\x28\x29\x20'+(_0x72a85d(0x157)+_0x72a85d(0x22e)+_0x72a85d(0x2c5)+'\x20\x29')+'\x29\x3b');_0x128670=_0x10283d();}catch(_0x4008ff){_0x128670=window;}var _0x54ae40=_0x128670[_0x72a85d(0x277)]=_0x128670[_0x72a85d(0x277)]||{},_0x5e81c3=['\x6c\x6f\x67',_0x72a85d(0x33f),_0x72a85d(0x29f),_0x72a85d(0x17d),_0x72a85d(0x1c3),_0x72a85d(0x223),'\x74\x72\x61\x63\x65'];for(var _0x398760=0x0;_0x398760<_0x5e81c3[_0x72a85d(0x1f9)];_0x398760++){var _0x1c478f=_0x1bfa0c[_0x72a85d(0x23c)+'\x72'][_0x72a85d(0x153)][_0x72a85d(0x347)](_0x1bfa0c),_0x1fd39a=_0x5e81c3[_0x398760],_0x4a1674=_0x54ae40[_0x1fd39a]||_0x1c478f;_0x1c478f[_0x72a85d(0x457)]=_0x1bfa0c[_0x72a85d(0x347)](_0x1bfa0c),_0x1c478f[_0x72a85d(0x261)]=_0x4a1674[_0x72a85d(0x261)][_0x72a85d(0x347)](_0x4a1674),_0x54ae40[_0x1fd39a]=_0x1c478f;}});_0x17f64b();const _0xdd2c7e=document[_0x1af91c(0x1b3)+_0x1af91c(0x1b5)]('\x5b'+_0x3ada8d+'\x5d');if(!_0xdd2c7e)return null;const _0x1ac69e=_0xdd2c7e[_0x1af91c(0x476)+'\x74\x65'](_0x3ada8d);if(_0x1ac69e===_0x1af91c(0x47f))return!![];else return _0x1ac69e===_0x1af91c(0x3db)?![]:_0x1ac69e;}function _0x526586(_0x35098e,_0x2d9d4a,_0x3ad566){var _0x43e9ae=_0x233d8b;if(!_0x2d9d4a||!_0x3ad566)throw new Error('\x50\x6c\x65\x61\x73\x65\x20\x61\x64\x64'+_0x43e9ae(0x2a7)+'\x20\x61\x6e\x64\x20\x22\x65\x6e\x64\x22'+_0x43e9ae(0x418));return _0x35098e[_0x43e9ae(0x1ba)](_0x2d9d4a)[0x1][_0x43e9ae(0x1ba)](_0x3ad566)[0x0];}function _0x48c5e4(_0x4e79cb){return new Promise(function(_0x175c58,_0x359175){var _0x2b8ccc=_0x2870;let _0x399ff2=document[_0x2b8ccc(0x2be)+_0x2b8ccc(0x411)]('\x6c\x69\x6e\x6b');_0x399ff2[_0x2b8ccc(0x1db)]=_0x4e79cb,_0x399ff2['\x72\x65\x6c']=_0x2b8ccc(0x23a),_0x399ff2[_0x2b8ccc(0x226)]=()=>_0x175c58(_0x399ff2),_0x399ff2['\x6f\x6e\x65\x72\x72\x6f\x72']=()=>_0x359175(new Error(_0x2b8ccc(0x396)+'\x20\x65\x72\x72\x6f\x72\x20\x66\x6f\x72'+'\x20'+_0x4e79cb)),document[_0x2b8ccc(0x1fa)][_0x2b8ccc(0x364)](_0x399ff2);});}function _0x40c4dc(_0x515cd4,_0x3d31b8){var _0x5fb97c=_0x233d8b;document['\x71\x75\x65\x72\x79\x53\x65\x6c\x65\x63'+_0x5fb97c(0x1b5)](_0x515cd4)['\x61\x70\x70\x65\x6e\x64\x43\x68\x69\x6c'+'\x64'](document[_0x5fb97c(0x1b3)+_0x5fb97c(0x1b5)](_0x3d31b8));}function _0x2ee13b(){var _0x585312=_0x233d8b;return/product/[_0x585312(0x47a)](window[_0x585312(0x2e6)][_0x585312(0x1db)]);}function _0x21d6fb(_0x2297ba){return new Promise(_0x514c17=>setTimeout(_0x514c17,_0x2297ba));}function _0x59e288(){var _0x5a5998=_0x233d8b;return/cart/[_0x5a5998(0x47a)](window['\x6c\x6f\x63\x61\x74\x69\x6f\x6e']['\x68\x72\x65\x66']);}function _0x4748c4(_0x123e98,_0x3654cf=0x32,_0x3df903=0xfa){var _0x21b130=_0x233d8b;const _0x3f7de2=document[_0x21b130(0x1b3)+_0x21b130(0x1b5)](_0x123e98);!window['\x5f\x5f'+_0x123e98]&&(window['\x5f\x5f'+_0x123e98]=0x0);function _0x2544dd(){return new Promise(_0x4c9da9=>{window['\x5f\x5f'+_0x123e98]++,setTimeout(_0x4c9da9,_0x3654cf);});}if(_0x3f7de2===null){if(window['\x5f\x5f'+_0x123e98]>=_0x3df903)return window['\x5f\x5f'+_0x123e98]=0x0,Promise['\x72\x65\x6a\x65\x63\x74'](null);return _0x2544dd()['\x74\x68\x65\x6e'](()=>_0x4748c4(_0x123e98));}else return Promise[_0x21b130(0x288)](_0x3f7de2);}function _0x376924(_0x3bf69a){var _0x4e3de6=_0x233d8b;const _0x569a1c=document['\x63\x72\x65\x61\x74\x65\x45\x6c\x65\x6d'+'\x65\x6e\x74'](_0x4e3de6(0x292));_0x569a1c[_0x4e3de6(0x322)+'\x74']=_0x3bf69a,document[_0x4e3de6(0x1fa)][_0x4e3de6(0x364)](_0x569a1c);}async function _0x58661(_0x11ad80){return new Promise(async(_0x2e94a6,_0x2635d2)=>{var _0x4d57ce=_0x2870;try{const _0xf203d9=document['\x71\x75\x65\x72\x79\x53\x65\x6c\x65\x63'+_0x4d57ce(0x1b5)]('\x73\x65\x6c\x65\x63\x74\x2e\x70\x72\x6f'+_0x4d57ce(0x24e)+'\x5f\x76\x61\x72\x69\x61\x6e\x74\x73'),_0x2ba2f7=_0xf203d9[_0x4d57ce(0x28f)+_0x4d57ce(0x2ad)][0x0],_0x17cfcd=parseInt(_0x2ba2f7[_0x4d57ce(0x263)][_0x4d57ce(0x405)]()[_0x4d57ce(0x44f)+'\x65']());variant=_0x11ad80[_0x4d57ce(0x449)]['\x66\x69\x6c\x74\x65\x72'](_0x52cb3b=>_0x52cb3b['\x69\x64']===_0x17cfcd)[0x0],_0x2e94a6(variant);}catch(_0x4ecf62){_0x2e94a6(null);}});}async function _0x51b9fc(_0x57760a){return new Promise(async(_0x164c59,_0xf92dbf)=>{var _0x1ccb1d=_0x2870;const _0x2e9ce6=await _0x11505b();var _0x17034e=_0x2e9ce6[_0x1ccb1d(0x23b)][_0x1ccb1d(0x4a3)](_0x3a540b=>_0x3a540b['\x69\x64']===parseInt(_0x57760a))[0x0][_0x1ccb1d(0x244)+'\x73'][0x0],_0x1f1e58=_0x2e9ce6[_0x1ccb1d(0x449)][_0x1ccb1d(0x4a3)](_0x4f15ed=>_0x4f15ed['\x69\x64']===parseInt(_0x17034e))[0x0]['\x74\x69\x74\x6c\x65'][_0x1ccb1d(0x1ba)]('\x2f')['\x6d\x61\x70'](_0x303f1f=>_0x303f1f[_0x1ccb1d(0x405)]());_0x164c59(_0x1f1e58);});}async function _0x1457b0(_0x38f926){return new Promise(async(_0x248919,_0x1fee1b)=>{var _0x459305=_0x2870;const _0x47d74d=await _0x33cb21();try{_0x47d74d[_0x459305(0x449)][_0x459305(0x4a3)](_0x2eaaa2=>{var _0x188332=_0x459305;if(_0x188332(0x162)+_0x188332(0x33e)in _0x2eaaa2&&_0x2eaaa2['\x66\x65\x61\x74\x75\x72\x65\x64\x5f\x69'+_0x188332(0x33e)])return _0x2eaaa2;})[_0x459305(0x3c1)](_0x42c654=>{var _0xc6443a=_0x459305;if(!_0x42c654)return;const _0x28e7a7=_0x42c654[_0xc6443a(0x162)+_0xc6443a(0x33e)]!==undefined?_0x42c654[_0xc6443a(0x162)+'\x6d\x61\x67\x65']:null;_0x28e7a7&&'\x69\x64'in _0x28e7a7&&_0x28e7a7['\x69\x64']===parseInt(_0x38f926)&&_0x248919(_0x42c654);});}catch(_0x9c73c4){console[_0x459305(0x45a)](_0x459305(0x3ac)+_0x459305(0x321)+_0x459305(0x2d5)+'\x20\x6f\x6e\x20\x69\x6d\x61\x67\x65\x20'+_0x459305(0x3d9)+_0x459305(0x281)+_0x459305(0x394)+_0x459305(0x496)+_0x459305(0x283)+_0x459305(0x40c)+'\x0a\x0a',_0x9c73c4),_0x248919(null);}});}async function _0x2bbf2d(){var _0x3ddd72=_0x233d8b;if(window['\x65\x7a\x66\x79\x5f\x69\x6d\x61\x67\x65'+'\x5f\x70\x72\x6f\x64\x75\x63\x74\x73'])return window[_0x3ddd72(0x1b2)+_0x3ddd72(0x297)];return new Promise(async(_0x3b8f0b,_0x1635d5)=>{var _0x16dffe=_0x3ddd72;let _0x3e664f=_0x16dffe(0x468)+(window['\x6c\x6f\x63\x61\x74\x69\x6f\x6e'][_0x16dffe(0x34e)]+window[_0x16dffe(0x2e6)][_0x16dffe(0x171)])+_0x16dffe(0x456),_0x4839af=await fetch(_0x3e664f),{product:_0x4a5a8f}=await _0x4839af[_0x16dffe(0x287)]();window[_0x16dffe(0x1b2)+'\x5f\x70\x72\x6f\x64\x75\x63\x74\x73']=_0x4a5a8f[_0x16dffe(0x23b)],_0x3b8f0b(_0x4a5a8f['\x69\x6d\x61\x67\x65\x73']);});}async function _0x11505b(){var _0x5633e8=_0x233d8b;if(window['\x65\x7a\x66\x79\x5f\x70\x72\x6f\x64\x75'+_0x5633e8(0x32c)])return window[_0x5633e8(0x3a3)+_0x5633e8(0x32c)];return new Promise(async(_0x50ff85,_0x35291e)=>{var _0x1cc249=_0x5633e8;let _0xd74265=_0x1cc249(0x468)+(window[_0x1cc249(0x2e6)][_0x1cc249(0x34e)]+window[_0x1cc249(0x2e6)][_0x1cc249(0x171)])+_0x1cc249(0x456),_0x283145=await fetch(_0xd74265),{product:_0xb4eb89}=await _0x283145[_0x1cc249(0x287)]();window[_0x1cc249(0x3a3)+'\x63\x74\x5f\x6a\x73\x6f\x6e']=_0xb4eb89,_0x50ff85(_0xb4eb89);});}async function _0x54fd3a(_0x366205){return new Promise(async(_0x6f2e74,_0x3f6ffb)=>{var _0x458008=_0x2870;const _0x139e4f=await _0x2bbf2d();try{_0x139e4f[_0x458008(0x4a3)](_0x360d31=>{var _0x2514df=_0x458008;_0x360d31['\x69\x64']===parseInt(_0x366205)&&_0x6f2e74(_0x360d31[_0x2514df(0x336)]);});}catch(_0x1cde60){console[_0x458008(0x45a)](_0x458008(0x189)+_0x458008(0x179)+_0x458008(0x438),_0x1cde60),_0x6f2e74(null);}});}async function _0x33cb21(){var _0x5ab6c8=_0x233d8b;const _0x1bd4ef=document[_0x5ab6c8(0x1b3)+'\x74\x6f\x72']('\x73\x63\x72\x69\x70\x74\x5b\x69\x64\x2a'+'\x3d\x27\x50\x72\x6f\x64\x75\x63\x74\x4a'+'\x73\x6f\x6e\x27\x5d');if(_0x1bd4ef)return JSON[_0x5ab6c8(0x278)](_0x1bd4ef['\x69\x6e\x6e\x65\x72\x48\x54\x4d\x4c']);let _0x1f70e4;if(_hasFeaturedProduct()){const _0x41fa00=document[_0x5ab6c8(0x1b3)+_0x5ab6c8(0x1b5)](_0x5ab6c8(0x198)+_0x5ab6c8(0x258)+'\x5d');if(!_0x41fa00)return;const _0x26e72d=_0x41fa00['\x67\x65\x74\x41\x74\x74\x72\x69\x62\x75'+'\x74\x65'](_0x5ab6c8(0x18b)+_0x5ab6c8(0x3f5));_0x1f70e4=_0x5ab6c8(0x468)+window[_0x5ab6c8(0x2e6)][_0x5ab6c8(0x34e)]+_0x5ab6c8(0x14e)+_0x26e72d+'\x2e\x6a\x73\x6f\x6e';}else _0x1f70e4='\x68\x74\x74\x70\x73\x3a\x2f\x2f'+(window[_0x5ab6c8(0x2e6)]['\x68\x6f\x73\x74']+window[_0x5ab6c8(0x2e6)]['\x70\x61\x74\x68\x6e\x61\x6d\x65'])+_0x5ab6c8(0x456);if(window[_0x5ab6c8(0x3a3)+'\x63\x74'])return window['\x65\x7a\x66\x79\x5f\x70\x72\x6f\x64\x75'+'\x63\x74'];return new Promise(async(_0x1bce43,_0x3b8367)=>{var _0x5acd73=_0x5ab6c8;let _0x34dd27=await fetch(_0x1f70e4),{product:_0x5bdf3e}=await _0x34dd27[_0x5acd73(0x287)]();window[_0x5acd73(0x3a3)+'\x63\x74']=_0x5bdf3e,_0x1bce43(_0x5bdf3e);});}async function _0x30857a(){try{const _0x360b26=await _0x33cb21(),_0x3a4871=await _0x58661(_0x360b26);return _0x3a4871;}catch(_0x2a12e6){return null;}}function _0x2de60b(){var _0x46a629=_0x233d8b;if(window[_0x46a629(0x1c9)]!==undefined)return!![];return new Promise(async(_0x4b18c6,_0x58305c)=>{var _0x119b77=_0x46a629;!function(_0x43b292,_0x5dd8b6){var _0x14186f=_0x2870;_0x14186f(0x2dd)==typeof define&&define[_0x14186f(0x1f2)]?define('\x6a\x71\x75\x65\x72\x79\x2d\x62\x72\x69'+_0x14186f(0x22a)+_0x14186f(0x389),[_0x14186f(0x1d8)],function(_0x35bf08){return _0x5dd8b6(_0x43b292,_0x35bf08);}):'\x6f\x62\x6a\x65\x63\x74'==typeof module&&module[_0x14186f(0x4b6)]?module[_0x14186f(0x4b6)]=_0x5dd8b6(_0x43b292,require(_0x14186f(0x1d8))):_0x43b292[_0x14186f(0x2f5)+_0x14186f(0x215)]=_0x5dd8b6(_0x43b292,_0x43b292[_0x14186f(0x1cf)]);}(window,function(_0x1ad1c1,_0x241cff){'use strict';var _0x43defe=_0x2870;var _0x171d99=Array[_0x43defe(0x153)][_0x43defe(0x45b)],_0x11b1bc=_0x1ad1c1['\x63\x6f\x6e\x73\x6f\x6c\x65'],_0x381919=void 0x0===_0x11b1bc?function(){}:function(_0x4e654e){var _0x3b6be8=_0x43defe;_0x11b1bc[_0x3b6be8(0x17d)](_0x4e654e);};function _0x11a8a6(_0x4f79f9,_0x3f30fd,_0x473fae){var _0x4d2f64=_0x43defe;(_0x473fae=_0x473fae||_0x241cff||_0x1ad1c1[_0x4d2f64(0x1cf)])&&(_0x3f30fd[_0x4d2f64(0x153)][_0x4d2f64(0x44c)]||(_0x3f30fd[_0x4d2f64(0x153)][_0x4d2f64(0x44c)]=function(_0x4f2551){var _0x4c9807=_0x4d2f64;_0x473fae[_0x4c9807(0x18a)+_0x4c9807(0x3e9)](_0x4f2551)&&(this[_0x4c9807(0x2ab)]=_0x473fae[_0x4c9807(0x3cb)](!0x0,this[_0x4c9807(0x2ab)],_0x4f2551));}),_0x473fae['\x66\x6e'][_0x4f79f9]=function(_0x1803af){var _0x84cd83=_0x4d2f64;return _0x84cd83(0x3d2)==typeof _0x1803af?function(_0x3800c4,_0x585e20,_0x4743bd){var _0x26163c,_0xe54891='\x24\x28\x29\x2e'+_0x4f79f9+'\x28\x22'+_0x585e20+'\x22\x29';return _0x3800c4['\x65\x61\x63\x68'](function(_0x2deb84,_0x691617){var _0x238b83=_0x2870,_0x20306e=_0x473fae[_0x238b83(0x15b)](_0x691617,_0x4f79f9);if(_0x20306e){var _0x507f25=_0x20306e[_0x585e20];if(_0x507f25&&'\x5f'!=_0x585e20[_0x238b83(0x1aa)](0x0)){var _0x1665ec=_0x507f25[_0x238b83(0x291)](_0x20306e,_0x4743bd);_0x26163c=void 0x0===_0x26163c?_0x1665ec:_0x26163c;}else _0x381919(_0xe54891+('\x20\x69\x73\x20\x6e\x6f\x74\x20\x61\x20'+'\x76\x61\x6c\x69\x64\x20\x6d\x65\x74\x68'+'\x6f\x64'));}else _0x381919(_0x4f79f9+(_0x238b83(0x437)+_0x238b83(0x2cd)+_0x238b83(0x35b)+'\x6d\x65\x74\x68\x6f\x64\x73\x2c\x20\x69'+_0x238b83(0x16a))+_0xe54891);}),void 0x0!==_0x26163c?_0x26163c:_0x3800c4;}(this,_0x1803af,_0x171d99['\x63\x61\x6c\x6c'](arguments,0x1)):(function(_0x2d3738,_0x2582b4){var _0x174c0c=_0x84cd83;_0x2d3738[_0x174c0c(0x177)](function(_0x4c73f1,_0x51c856){var _0x55cd25=_0x174c0c,_0x34f04a=_0x473fae['\x64\x61\x74\x61'](_0x51c856,_0x4f79f9);_0x34f04a?(_0x34f04a['\x6f\x70\x74\x69\x6f\x6e'](_0x2582b4),_0x34f04a[_0x55cd25(0x3f2)]()):(_0x34f04a=new _0x3f30fd(_0x51c856,_0x2582b4),_0x473fae[_0x55cd25(0x15b)](_0x51c856,_0x4f79f9,_0x34f04a));});}(this,_0x1803af),this);},_0x3b3ad9(_0x473fae));}function _0x3b3ad9(_0x574434){var _0x13f99c=_0x43defe;!_0x574434||_0x574434&&_0x574434[_0x13f99c(0x45f)]||(_0x574434[_0x13f99c(0x45f)]=_0x11a8a6);}return _0x3b3ad9(_0x241cff||_0x1ad1c1[_0x43defe(0x1cf)]),_0x11a8a6;}),function(_0x2e1591,_0x1362b2){var _0x523d4=_0x2870;'\x66\x75\x6e\x63\x74\x69\x6f\x6e'==typeof define&&define[_0x523d4(0x1f2)]?define('\x65\x76\x2d\x65\x6d\x69\x74\x74\x65\x72'+_0x523d4(0x45c)+'\x72',_0x1362b2):_0x523d4(0x358)==typeof module&&module[_0x523d4(0x4b6)]?module[_0x523d4(0x4b6)]=_0x1362b2():_0x2e1591[_0x523d4(0x41b)]=_0x1362b2();}(_0x119b77(0x31e)!=typeof window?window:this,function(){var _0x4c9eb4=_0x119b77;function _0x479389(){}var _0x328423=_0x479389[_0x4c9eb4(0x153)];return _0x328423['\x6f\x6e']=function(_0x4c330e,_0x3a32ac){var _0x45fcd6=_0x4c9eb4;if(_0x4c330e&&_0x3a32ac){var _0x4289c3=this[_0x45fcd6(0x289)]=this[_0x45fcd6(0x289)]||{},_0x4dbbf3=_0x4289c3[_0x4c330e]=_0x4289c3[_0x4c330e]||[];return-0x1==_0x4dbbf3['\x69\x6e\x64\x65\x78\x4f\x66'](_0x3a32ac)&&_0x4dbbf3[_0x45fcd6(0x43b)](_0x3a32ac),this;}},_0x328423[_0x4c9eb4(0x24d)]=function(_0x33dc00,_0x621df6){var _0x5bf3da=_0x4c9eb4;if(_0x33dc00&&_0x621df6){this['\x6f\x6e'](_0x33dc00,_0x621df6);var _0x5dbd54=this[_0x5bf3da(0x19b)+'\x73']=this['\x5f\x6f\x6e\x63\x65\x45\x76\x65\x6e\x74'+'\x73']||{};return(_0x5dbd54[_0x33dc00]=_0x5dbd54[_0x33dc00]||{})[_0x621df6]=!0x0,this;}},_0x328423[_0x4c9eb4(0x304)]=function(_0x46229d,_0x2a0af8){var _0xbd2a9b=_0x4c9eb4,_0x4ebdce=this['\x5f\x65\x76\x65\x6e\x74\x73']&&this[_0xbd2a9b(0x289)][_0x46229d];if(_0x4ebdce&&_0x4ebdce[_0xbd2a9b(0x1f9)]){var _0x3b9df6=_0x4ebdce[_0xbd2a9b(0x181)](_0x2a0af8);return-0x1!=_0x3b9df6&&_0x4ebdce['\x73\x70\x6c\x69\x63\x65'](_0x3b9df6,0x1),this;}},_0x328423['\x65\x6d\x69\x74\x45\x76\x65\x6e\x74']=function(_0x2ffb11,_0x53a71c){var _0x2280c4=_0x4c9eb4,_0x14d32c=this[_0x2280c4(0x289)]&&this[_0x2280c4(0x289)][_0x2ffb11];if(_0x14d32c&&_0x14d32c[_0x2280c4(0x1f9)]){_0x14d32c=_0x14d32c[_0x2280c4(0x45b)](0x0),_0x53a71c=_0x53a71c||[];for(var _0x519f1e=this[_0x2280c4(0x19b)+'\x73']&&this[_0x2280c4(0x19b)+'\x73'][_0x2ffb11],_0x4ac3c4=0x0;_0x4ac3c4<_0x14d32c[_0x2280c4(0x1f9)];_0x4ac3c4++){var _0x384244=_0x14d32c[_0x4ac3c4];_0x519f1e&&_0x519f1e[_0x384244]&&(this[_0x2280c4(0x304)](_0x2ffb11,_0x384244),delete _0x519f1e[_0x384244]),_0x384244[_0x2280c4(0x291)](this,_0x53a71c);}return this;}},_0x328423[_0x4c9eb4(0x190)]=function(){delete this['\x5f\x65\x76\x65\x6e\x74\x73'],delete this['\x5f\x6f\x6e\x63\x65\x45\x76\x65\x6e\x74'+'\x73'];},_0x479389;}),function(_0x3f1ab6,_0x2c09e3){var _0x3d4955=_0x119b77;_0x3d4955(0x2dd)==typeof define&&define[_0x3d4955(0x1f2)]?define('\x67\x65\x74\x2d\x73\x69\x7a\x65\x2f\x67'+'\x65\x74\x2d\x73\x69\x7a\x65',_0x2c09e3):_0x3d4955(0x358)==typeof module&&module[_0x3d4955(0x4b6)]?module[_0x3d4955(0x4b6)]=_0x2c09e3():_0x3f1ab6[_0x3d4955(0x35c)]=_0x2c09e3();}(window,function(){'use strict';var _0x23853e=_0x119b77;function _0x26c7c5(_0x44f373){var _0x3e43c3=parseFloat(_0x44f373);return-0x1==_0x44f373['\x69\x6e\x64\x65\x78\x4f\x66']('\x25')&&!isNaN(_0x3e43c3)&&_0x3e43c3;}var _0x3b84c7=_0x23853e(0x31e)==typeof console?function(){}:function(_0x468444){console['\x65\x72\x72\x6f\x72'](_0x468444);},_0x2698b1=[_0x23853e(0x3a9)+'\x74',_0x23853e(0x2fb)+'\x68\x74','\x70\x61\x64\x64\x69\x6e\x67\x54\x6f\x70',_0x23853e(0x365)+'\x74\x6f\x6d',_0x23853e(0x178),_0x23853e(0x374)+'\x74',_0x23853e(0x36a),_0x23853e(0x2cb)+'\x6f\x6d',_0x23853e(0x224)+'\x57\x69\x64\x74\x68',_0x23853e(0x330)+_0x23853e(0x1d7),'\x62\x6f\x72\x64\x65\x72\x54\x6f\x70\x57'+_0x23853e(0x301),'\x62\x6f\x72\x64\x65\x72\x42\x6f\x74\x74'+_0x23853e(0x349)],_0x11304a=_0x2698b1[_0x23853e(0x1f9)];function _0xc6babb(_0x41abfc){var _0xd8a46d=_0x23853e,_0x45ef48=getComputedStyle(_0x41abfc);return _0x45ef48||_0x3b84c7('\x53\x74\x79\x6c\x65\x20\x72\x65\x74\x75'+_0xd8a46d(0x26e)+_0x45ef48+(_0xd8a46d(0x4ac)+_0xd8a46d(0x308)+_0xd8a46d(0x30f)+_0xd8a46d(0x4aa)+_0xd8a46d(0x480)+_0xd8a46d(0x371)+'\x65\x65\x20\x68\x74\x74\x70\x73\x3a\x2f'+_0xd8a46d(0x350)+_0xd8a46d(0x15f))),_0x45ef48;}var _0x3a0b8d,_0x20fd08=!0x1;function _0x3443d9(){var _0x4b72d6=_0x23853e;if(!_0x20fd08){_0x20fd08=!0x0;var _0x5b8d0a=document['\x63\x72\x65\x61\x74\x65\x45\x6c\x65\x6d'+'\x65\x6e\x74'](_0x4b72d6(0x28d));_0x5b8d0a[_0x4b72d6(0x292)]['\x77\x69\x64\x74\x68']=_0x4b72d6(0x1ac),_0x5b8d0a['\x73\x74\x79\x6c\x65'][_0x4b72d6(0x1f4)]='\x31\x70\x78\x20\x32\x70\x78\x20\x33\x70'+_0x4b72d6(0x1cb),_0x5b8d0a[_0x4b72d6(0x292)][_0x4b72d6(0x251)+'\x65']=_0x4b72d6(0x300),_0x5b8d0a['\x73\x74\x79\x6c\x65'][_0x4b72d6(0x3be)+'\x68']=_0x4b72d6(0x478)+_0x4b72d6(0x1cb),_0x5b8d0a[_0x4b72d6(0x292)][_0x4b72d6(0x460)]=_0x4b72d6(0x1e1);var _0x27d3d2=document[_0x4b72d6(0x2b8)]||document[_0x4b72d6(0x3ed)+_0x4b72d6(0x295)];_0x27d3d2['\x61\x70\x70\x65\x6e\x64\x43\x68\x69\x6c'+'\x64'](_0x5b8d0a);var _0x5254ae=_0xc6babb(_0x5b8d0a);_0x3a0b8d=0xc8==Math[_0x4b72d6(0x19f)](_0x26c7c5(_0x5254ae[_0x4b72d6(0x459)])),_0x2ec779[_0x4b72d6(0x1a0)+'\x75\x74\x65\x72']=_0x3a0b8d,_0x27d3d2['\x72\x65\x6d\x6f\x76\x65\x43\x68\x69\x6c'+'\x64'](_0x5b8d0a);}}function _0x2ec779(_0x41427e){var _0x381e20=_0x23853e;if(_0x3443d9(),_0x381e20(0x3d2)==typeof _0x41427e&&(_0x41427e=document[_0x381e20(0x1b3)+_0x381e20(0x1b5)](_0x41427e)),_0x41427e&&_0x381e20(0x358)==typeof _0x41427e&&_0x41427e['\x6e\x6f\x64\x65\x54\x79\x70\x65']){var _0x2c2748=_0xc6babb(_0x41427e);if('\x6e\x6f\x6e\x65'==_0x2c2748[_0x381e20(0x3c6)])return function(){for(var _0x507fa2={'\x77\x69\x64\x74\x68':0x0,'\x68\x65\x69\x67\x68\x74':0x0,'\x69\x6e\x6e\x65\x72\x57\x69\x64\x74\x68':0x0,'\x69\x6e\x6e\x65\x72\x48\x65\x69\x67\x68\x74':0x0,'\x6f\x75\x74\x65\x72\x57\x69\x64\x74\x68':0x0,'\x6f\x75\x74\x65\x72\x48\x65\x69\x67\x68\x74':0x0},_0x16aaa3=0x0;_0x16aaa3<_0x11304a;_0x16aaa3++)_0x507fa2[_0x2698b1[_0x16aaa3]]=0x0;return _0x507fa2;}();var _0x11e66d={};_0x11e66d[_0x381e20(0x459)]=_0x41427e[_0x381e20(0x29e)+'\x68'],_0x11e66d[_0x381e20(0x406)]=_0x41427e[_0x381e20(0x2f8)+'\x68\x74'];for(var _0x2e1acc=_0x11e66d[_0x381e20(0x4a9)+'\x78']=_0x381e20(0x1e1)==_0x2c2748[_0x381e20(0x460)],_0x99b28d=0x0;_0x99b28d<_0x11304a;_0x99b28d++){var _0x1aec4b=_0x2698b1[_0x99b28d],_0x57244a=_0x2c2748[_0x1aec4b],_0x3ded1c=parseFloat(_0x57244a);_0x11e66d[_0x1aec4b]=isNaN(_0x3ded1c)?0x0:_0x3ded1c;}var _0x5be599=_0x11e66d[_0x381e20(0x3a9)+'\x74']+_0x11e66d['\x70\x61\x64\x64\x69\x6e\x67\x52\x69\x67'+'\x68\x74'],_0x1e2508=_0x11e66d[_0x381e20(0x463)]+_0x11e66d[_0x381e20(0x365)+_0x381e20(0x27e)],_0x2642c8=_0x11e66d[_0x381e20(0x178)]+_0x11e66d[_0x381e20(0x374)+'\x74'],_0x292f8d=_0x11e66d[_0x381e20(0x36a)]+_0x11e66d[_0x381e20(0x2cb)+'\x6f\x6d'],_0x124320=_0x11e66d['\x62\x6f\x72\x64\x65\x72\x4c\x65\x66\x74'+_0x381e20(0x381)]+_0x11e66d['\x62\x6f\x72\x64\x65\x72\x52\x69\x67\x68'+_0x381e20(0x1d7)],_0x8e4b27=_0x11e66d[_0x381e20(0x2d6)+'\x69\x64\x74\x68']+_0x11e66d[_0x381e20(0x250)+_0x381e20(0x349)],_0x18e5e5=_0x2e1acc&&_0x3a0b8d,_0x121b85=_0x26c7c5(_0x2c2748[_0x381e20(0x459)]);!0x1!==_0x121b85&&(_0x11e66d['\x77\x69\x64\x74\x68']=_0x121b85+(_0x18e5e5?0x0:_0x5be599+_0x124320));var _0x26a691=_0x26c7c5(_0x2c2748[_0x381e20(0x406)]);return!0x1!==_0x26a691&&(_0x11e66d['\x68\x65\x69\x67\x68\x74']=_0x26a691+(_0x18e5e5?0x0:_0x1e2508+_0x8e4b27)),_0x11e66d[_0x381e20(0x15e)]=_0x11e66d[_0x381e20(0x459)]-(_0x5be599+_0x124320),_0x11e66d['\x69\x6e\x6e\x65\x72\x48\x65\x69\x67\x68'+'\x74']=_0x11e66d[_0x381e20(0x406)]-(_0x1e2508+_0x8e4b27),_0x11e66d[_0x381e20(0x448)]=_0x11e66d[_0x381e20(0x459)]+_0x2642c8,_0x11e66d[_0x381e20(0x4a0)+'\x74']=_0x11e66d['\x68\x65\x69\x67\x68\x74']+_0x292f8d,_0x11e66d;}}return _0x2ec779;}),function(_0x3eb16a,_0x368d57){'use strict';var _0x5827fa=_0x119b77;_0x5827fa(0x2dd)==typeof define&&define[_0x5827fa(0x1f2)]?define(_0x5827fa(0x1b9)+'\x61\x74\x63\x68\x65\x73\x2d\x73\x65\x6c'+_0x5827fa(0x3ee)+'\x68\x65\x73\x2d\x73\x65\x6c\x65\x63\x74'+'\x6f\x72',_0x368d57):_0x5827fa(0x358)==typeof module&&module['\x65\x78\x70\x6f\x72\x74\x73']?module[_0x5827fa(0x4b6)]=_0x368d57():_0x3eb16a[_0x5827fa(0x180)+_0x5827fa(0x42f)]=_0x368d57();}(window,function(){'use strict';var _0x462b8f=function(){var _0x313702=_0x2870,_0x3f959b=window[_0x313702(0x172)]['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65'];if(_0x3f959b['\x6d\x61\x74\x63\x68\x65\x73'])return _0x313702(0x443);if(_0x3f959b[_0x313702(0x180)+_0x313702(0x42f)])return'\x6d\x61\x74\x63\x68\x65\x73\x53\x65\x6c'+_0x313702(0x42f);for(var _0x58d440=[_0x313702(0x35d),_0x313702(0x361),'\x6d\x73','\x6f'],_0x541af6=0x0;_0x541af6<_0x58d440[_0x313702(0x1f9)];_0x541af6++){var _0x1cacb3=_0x58d440[_0x541af6]+(_0x313702(0x39d)+_0x313702(0x42f));if(_0x3f959b[_0x1cacb3])return _0x1cacb3;}}();return function(_0x194212,_0x75fe13){return _0x194212[_0x462b8f](_0x75fe13);};}),function(_0xad925b,_0x51af7b){var _0x5af3d6=_0x119b77;_0x5af3d6(0x2dd)==typeof define&&define[_0x5af3d6(0x1f2)]?define(_0x5af3d6(0x428)+_0x5af3d6(0x34f),[_0x5af3d6(0x1b9)+'\x61\x74\x63\x68\x65\x73\x2d\x73\x65\x6c'+_0x5af3d6(0x3ee)+_0x5af3d6(0x266)+'\x6f\x72'],function(_0x3a8a4f){return _0x51af7b(_0xad925b,_0x3a8a4f);}):'\x6f\x62\x6a\x65\x63\x74'==typeof module&&module[_0x5af3d6(0x4b6)]?module[_0x5af3d6(0x4b6)]=_0x51af7b(_0xad925b,require(_0x5af3d6(0x1b9)+_0x5af3d6(0x216)+_0x5af3d6(0x42f))):_0xad925b[_0x5af3d6(0x2a9)+'\x6c\x73']=_0x51af7b(_0xad925b,_0xad925b['\x6d\x61\x74\x63\x68\x65\x73\x53\x65\x6c'+'\x65\x63\x74\x6f\x72']);}(window,function(_0x300855,_0x390d03){var _0x507d79=_0x119b77,_0x5f0667={'\x65\x78\x74\x65\x6e\x64':function(_0x32bf89,_0x1d3460){for(var _0xe22bf2 in _0x1d3460)_0x32bf89[_0xe22bf2]=_0x1d3460[_0xe22bf2];return _0x32bf89;},'\x6d\x6f\x64\x75\x6c\x6f':function(_0x333cf3,_0x2351f4){return(_0x333cf3%_0x2351f4+_0x2351f4)%_0x2351f4;}},_0x367434=Array[_0x507d79(0x153)]['\x73\x6c\x69\x63\x65'];_0x5f0667[_0x507d79(0x267)]=function(_0x4225fb){var _0x1579d1=_0x507d79;return Array[_0x1579d1(0x325)](_0x4225fb)?_0x4225fb:null==_0x4225fb?[]:_0x1579d1(0x358)==typeof _0x4225fb&&_0x1579d1(0x4a8)==typeof _0x4225fb[_0x1579d1(0x1f9)]?_0x367434[_0x1579d1(0x37c)](_0x4225fb):[_0x4225fb];},_0x5f0667['\x72\x65\x6d\x6f\x76\x65\x46\x72\x6f\x6d']=function(_0x3946d6,_0x1fe1a4){var _0x269c1c=_0x507d79,_0x38639e=_0x3946d6[_0x269c1c(0x181)](_0x1fe1a4);-0x1!=_0x38639e&&_0x3946d6[_0x269c1c(0x360)](_0x38639e,0x1);},_0x5f0667['\x67\x65\x74\x50\x61\x72\x65\x6e\x74']=function(_0x38911d,_0x55d654){var _0x3b7176=_0x507d79;for(;_0x38911d['\x70\x61\x72\x65\x6e\x74\x4e\x6f\x64\x65']&&_0x38911d!=document[_0x3b7176(0x2b8)];)if(_0x38911d=_0x38911d[_0x3b7176(0x285)],_0x390d03(_0x38911d,_0x55d654))return _0x38911d;},_0x5f0667[_0x507d79(0x49f)+_0x507d79(0x295)]=function(_0x464613){var _0x25376a=_0x507d79;return'\x73\x74\x72\x69\x6e\x67'==typeof _0x464613?document[_0x25376a(0x1b3)+_0x25376a(0x1b5)](_0x464613):_0x464613;},_0x5f0667[_0x507d79(0x433)+'\x74']=function(_0x744c81){var _0x341908=_0x507d79,_0x1a0b3b='\x6f\x6e'+_0x744c81[_0x341908(0x32b)];this[_0x1a0b3b]&&this[_0x1a0b3b](_0x744c81);},_0x5f0667[_0x507d79(0x401)+_0x507d79(0x3eb)]=function(_0x3c28db,_0x22700b){var _0x327ea8=_0x507d79;_0x3c28db=_0x5f0667[_0x327ea8(0x267)](_0x3c28db);var _0x3e2600=[];return _0x3c28db[_0x327ea8(0x1c0)](function(_0x54055b){var _0x31b409=_0x327ea8;if(_0x54055b instanceof HTMLElement){if(_0x22700b){_0x390d03(_0x54055b,_0x22700b)&&_0x3e2600['\x70\x75\x73\x68'](_0x54055b);for(var _0x91fad5=_0x54055b['\x71\x75\x65\x72\x79\x53\x65\x6c\x65\x63'+_0x31b409(0x473)](_0x22700b),_0x5f399f=0x0;_0x5f399f<_0x91fad5['\x6c\x65\x6e\x67\x74\x68'];_0x5f399f++)_0x3e2600['\x70\x75\x73\x68'](_0x91fad5[_0x5f399f]);}else _0x3e2600[_0x31b409(0x43b)](_0x54055b);}}),_0x3e2600;},_0x5f0667[_0x507d79(0x348)+_0x507d79(0x484)]=function(_0x45d19e,_0x13c1a7,_0x5ed3d3){var _0x3682ea=_0x507d79;_0x5ed3d3=_0x5ed3d3||0x64;var _0x58bac1=_0x45d19e[_0x3682ea(0x153)][_0x13c1a7],_0x40281c=_0x13c1a7+_0x3682ea(0x42b);_0x45d19e[_0x3682ea(0x153)][_0x13c1a7]=function(){var _0x4b6d75=this[_0x40281c];clearTimeout(_0x4b6d75);var _0x5b2bcd=arguments,_0x752f3f=this;this[_0x40281c]=setTimeout(function(){_0x58bac1['\x61\x70\x70\x6c\x79'](_0x752f3f,_0x5b2bcd),delete _0x752f3f[_0x40281c];},_0x5ed3d3);};},_0x5f0667['\x64\x6f\x63\x52\x65\x61\x64\x79']=function(_0x29cf86){var _0x22a01b=_0x507d79,_0x55997f=document[_0x22a01b(0x444)];_0x22a01b(0x357)==_0x55997f||_0x22a01b(0x455)+'\x65'==_0x55997f?setTimeout(_0x29cf86):document[_0x22a01b(0x29a)+'\x73\x74\x65\x6e\x65\x72']('\x44\x4f\x4d\x43\x6f\x6e\x74\x65\x6e\x74'+_0x22a01b(0x26a),_0x29cf86);},_0x5f0667[_0x507d79(0x3df)]=function(_0x170925){return _0x170925['\x72\x65\x70\x6c\x61\x63\x65'](/(.)([A-Z])/g,function(_0x7dc2f0,_0x36f3fe,_0x2c0db0){return _0x36f3fe+'\x2d'+_0x2c0db0;})['\x74\x6f\x4c\x6f\x77\x65\x72\x43\x61\x73'+'\x65']();};var _0x330b52=_0x300855['\x63\x6f\x6e\x73\x6f\x6c\x65'];return _0x5f0667[_0x507d79(0x36f)]=function(_0x13868f,_0x30e1bb){var _0x303cf7=_0x507d79;_0x5f0667[_0x303cf7(0x49c)](function(){var _0x36a682=_0x303cf7,_0x5cac3f=_0x5f0667[_0x36a682(0x3df)](_0x30e1bb),_0x436f0f=_0x36a682(0x26c)+_0x5cac3f,_0x442fe8=document[_0x36a682(0x1b3)+_0x36a682(0x473)]('\x5b'+_0x436f0f+'\x5d'),_0x42a37a=document[_0x36a682(0x1b3)+_0x36a682(0x473)](_0x36a682(0x3fc)+_0x5cac3f),_0x1f17f3=_0x5f0667[_0x36a682(0x267)](_0x442fe8)[_0x36a682(0x1a9)](_0x5f0667['\x6d\x61\x6b\x65\x41\x72\x72\x61\x79'](_0x42a37a)),_0x63843=_0x436f0f+_0x36a682(0x21d),_0xd0148=_0x300855[_0x36a682(0x1cf)];_0x1f17f3[_0x36a682(0x1c0)](function(_0x41e54f){var _0x6f1440=_0x36a682,_0x4ae6a3,_0x259fb6=_0x41e54f[_0x6f1440(0x476)+'\x74\x65'](_0x436f0f)||_0x41e54f[_0x6f1440(0x476)+'\x74\x65'](_0x63843);try{_0x4ae6a3=_0x259fb6&&JSON['\x70\x61\x72\x73\x65'](_0x259fb6);}catch(_0xd57d03){return void(_0x330b52&&_0x330b52[_0x6f1440(0x17d)]('\x45\x72\x72\x6f\x72\x20\x70\x61\x72\x73'+_0x6f1440(0x18d)+_0x436f0f+_0x6f1440(0x409)+_0x41e54f[_0x6f1440(0x40d)]+'\x3a\x20'+_0xd57d03));}var _0x32c8dd=new _0x13868f(_0x41e54f,_0x4ae6a3);_0xd0148&&_0xd0148['\x64\x61\x74\x61'](_0x41e54f,_0x30e1bb,_0x32c8dd);});});},_0x5f0667;}),function(_0x6ffdd6,_0x80d58f){var _0x314230=_0x119b77;_0x314230(0x2dd)==typeof define&&define[_0x314230(0x1f2)]?define('\x66\x6c\x69\x63\x6b\x69\x74\x79\x2f\x6a'+_0x314230(0x447),[_0x314230(0x20b)+_0x314230(0x403)],function(_0xf8bcc1){return _0x80d58f(_0x6ffdd6,_0xf8bcc1);}):_0x314230(0x358)==typeof module&&module[_0x314230(0x4b6)]?module[_0x314230(0x4b6)]=_0x80d58f(_0x6ffdd6,require(_0x314230(0x3e6))):(_0x6ffdd6['\x46\x6c\x69\x63\x6b\x69\x74\x79']=_0x6ffdd6[_0x314230(0x1c9)]||{},_0x6ffdd6[_0x314230(0x1c9)][_0x314230(0x461)]=_0x80d58f(_0x6ffdd6,_0x6ffdd6[_0x314230(0x35c)]));}(window,function(_0x3827dc,_0x3d902b){var _0x190222=_0x119b77;function _0xda7c42(_0x1d2423,_0x3dea78){var _0x1fba07=_0x2870;this[_0x1fba07(0x1eb)]=_0x1d2423,this[_0x1fba07(0x33b)]=_0x3dea78,this['\x63\x72\x65\x61\x74\x65']();}var _0x5b2c80=_0xda7c42[_0x190222(0x153)];return _0x5b2c80['\x63\x72\x65\x61\x74\x65']=function(){var _0x3a46d8=_0x190222;this[_0x3a46d8(0x1eb)][_0x3a46d8(0x292)][_0x3a46d8(0x336)]=_0x3a46d8(0x454),this[_0x3a46d8(0x1eb)][_0x3a46d8(0x4b0)+'\x74\x65'](_0x3a46d8(0x40a)+'\x6e',_0x3a46d8(0x47f)),this['\x78']=0x0,this['\x73\x68\x69\x66\x74']=0x0;},_0x5b2c80[_0x190222(0x48f)]=function(){var _0x5b0dda=_0x190222;this[_0x5b0dda(0x30a)](),this['\x65\x6c\x65\x6d\x65\x6e\x74'][_0x5b0dda(0x292)][_0x5b0dda(0x336)]='';var _0x367db4=this['\x70\x61\x72\x65\x6e\x74'][_0x5b0dda(0x42a)];this['\x65\x6c\x65\x6d\x65\x6e\x74'][_0x5b0dda(0x292)][_0x367db4]='',this[_0x5b0dda(0x1eb)][_0x5b0dda(0x376)+_0x5b0dda(0x217)](_0x5b0dda(0x40a)+'\x6e');},_0x5b2c80[_0x190222(0x35c)]=function(){var _0x142679=_0x190222;this[_0x142679(0x2a8)]=_0x3d902b(this[_0x142679(0x1eb)]);},_0x5b2c80[_0x190222(0x423)+'\x6e']=function(_0x1b253b){var _0x33342d=_0x190222;this['\x78']=_0x1b253b,this[_0x33342d(0x3b1)+'\x65\x74'](),this['\x72\x65\x6e\x64\x65\x72\x50\x6f\x73\x69'+_0x33342d(0x341)](_0x1b253b);},_0x5b2c80[_0x190222(0x3b1)+'\x65\x74']=_0x5b2c80[_0x190222(0x356)+_0x190222(0x14c)]=function(){var _0x84d949=_0x190222,_0x44df78=_0x84d949(0x2eb)==this['\x70\x61\x72\x65\x6e\x74'][_0x84d949(0x42a)]?_0x84d949(0x178):'\x6d\x61\x72\x67\x69\x6e\x52\x69\x67\x68'+'\x74';this[_0x84d949(0x170)]=this['\x78']+this[_0x84d949(0x2a8)][_0x44df78]+this[_0x84d949(0x2a8)]['\x77\x69\x64\x74\x68']*this[_0x84d949(0x33b)][_0x84d949(0x1d1)];},_0x5b2c80[_0x190222(0x31b)+_0x190222(0x341)]=function(_0xad50df){var _0x193911=_0x190222,_0x1b34ef=this['\x70\x61\x72\x65\x6e\x74'][_0x193911(0x42a)];this[_0x193911(0x1eb)]['\x73\x74\x79\x6c\x65'][_0x1b34ef]=this[_0x193911(0x33b)][_0x193911(0x3d8)+_0x193911(0x309)](_0xad50df);},_0x5b2c80[_0x190222(0x47d)]=function(){var _0x3969e0=_0x190222;this['\x65\x6c\x65\x6d\x65\x6e\x74'][_0x3969e0(0x35f)][_0x3969e0(0x234)](_0x3969e0(0x3fd)+'\x64'),this[_0x3969e0(0x1eb)]['\x72\x65\x6d\x6f\x76\x65\x41\x74\x74\x72'+_0x3969e0(0x217)](_0x3969e0(0x40a)+'\x6e');},_0x5b2c80[_0x190222(0x30a)]=function(){var _0x221580=_0x190222;this['\x65\x6c\x65\x6d\x65\x6e\x74']['\x63\x6c\x61\x73\x73\x4c\x69\x73\x74'][_0x221580(0x429)](_0x221580(0x3fd)+'\x64'),this['\x65\x6c\x65\x6d\x65\x6e\x74']['\x73\x65\x74\x41\x74\x74\x72\x69\x62\x75'+'\x74\x65']('\x61\x72\x69\x61\x2d\x68\x69\x64\x64\x65'+'\x6e',_0x221580(0x47f));},_0x5b2c80[_0x190222(0x359)]=function(_0x510742){var _0x672d2e=_0x190222;this[_0x672d2e(0x294)]=_0x510742,this[_0x672d2e(0x31b)+_0x672d2e(0x341)](this['\x78']+this[_0x672d2e(0x33b)][_0x672d2e(0x214)+_0x672d2e(0x301)]*_0x510742);},_0x5b2c80[_0x190222(0x429)]=function(){var _0x1ac50b=_0x190222;this['\x65\x6c\x65\x6d\x65\x6e\x74'][_0x1ac50b(0x285)]['\x72\x65\x6d\x6f\x76\x65\x43\x68\x69\x6c'+'\x64'](this[_0x1ac50b(0x1eb)]);},_0xda7c42;}),function(_0x4110a3,_0x465a3d){var _0x1ff1a4=_0x119b77;_0x1ff1a4(0x2dd)==typeof define&&define['\x61\x6d\x64']?define(_0x1ff1a4(0x47b)+_0x1ff1a4(0x2fc),_0x465a3d):'\x6f\x62\x6a\x65\x63\x74'==typeof module&&module[_0x1ff1a4(0x4b6)]?module[_0x1ff1a4(0x4b6)]=_0x465a3d():(_0x4110a3[_0x1ff1a4(0x1c9)]=_0x4110a3[_0x1ff1a4(0x1c9)]||{},_0x4110a3[_0x1ff1a4(0x1c9)][_0x1ff1a4(0x427)]=_0x465a3d());}(window,function(){'use strict';var _0x3c1460=_0x119b77;function _0x1a5bec(_0x83798e){var _0x3dd14f=_0x2870;this[_0x3dd14f(0x33b)]=_0x83798e,this[_0x3dd14f(0x306)+'\x66\x74']=_0x3dd14f(0x2eb)==_0x83798e[_0x3dd14f(0x42a)],this['\x63\x65\x6c\x6c\x73']=[],this['\x6f\x75\x74\x65\x72\x57\x69\x64\x74\x68']=0x0,this[_0x3dd14f(0x406)]=0x0;}var _0x351af6=_0x1a5bec[_0x3c1460(0x153)];return _0x351af6['\x61\x64\x64\x43\x65\x6c\x6c']=function(_0x55e416){var _0x21811=_0x3c1460;if(this[_0x21811(0x302)]['\x70\x75\x73\x68'](_0x55e416),this[_0x21811(0x448)]+=_0x55e416['\x73\x69\x7a\x65'][_0x21811(0x448)],this['\x68\x65\x69\x67\x68\x74']=Math['\x6d\x61\x78'](_0x55e416[_0x21811(0x2a8)][_0x21811(0x4a0)+'\x74'],this[_0x21811(0x406)]),0x1==this[_0x21811(0x302)][_0x21811(0x1f9)]){this['\x78']=_0x55e416['\x78'];var _0x45025d=this[_0x21811(0x306)+'\x66\x74']?_0x21811(0x178):_0x21811(0x374)+'\x74';this[_0x21811(0x430)+'\x6e']=_0x55e416[_0x21811(0x2a8)][_0x45025d];}},_0x351af6[_0x3c1460(0x3b1)+'\x65\x74']=function(){var _0x5e68c0=_0x3c1460,_0x513207=this[_0x5e68c0(0x306)+'\x66\x74']?_0x5e68c0(0x374)+'\x74':_0x5e68c0(0x178),_0x559268=this['\x67\x65\x74\x4c\x61\x73\x74\x43\x65\x6c'+'\x6c'](),_0x27b3d3=_0x559268?_0x559268[_0x5e68c0(0x2a8)][_0x513207]:0x0,_0x3a835f=this[_0x5e68c0(0x448)]-(this[_0x5e68c0(0x430)+'\x6e']+_0x27b3d3);this[_0x5e68c0(0x170)]=this['\x78']+this[_0x5e68c0(0x430)+'\x6e']+_0x3a835f*this['\x70\x61\x72\x65\x6e\x74']['\x63\x65\x6c\x6c\x41\x6c\x69\x67\x6e'];},_0x351af6['\x67\x65\x74\x4c\x61\x73\x74\x43\x65\x6c'+'\x6c']=function(){var _0x379a8e=_0x3c1460;return this['\x63\x65\x6c\x6c\x73'][this[_0x379a8e(0x302)][_0x379a8e(0x1f9)]-0x1];},_0x351af6[_0x3c1460(0x47d)]=function(){var _0x52335a=_0x3c1460;this['\x63\x65\x6c\x6c\x73'][_0x52335a(0x1c0)](function(_0x4eb274){_0x4eb274['\x73\x65\x6c\x65\x63\x74']();});},_0x351af6[_0x3c1460(0x30a)]=function(){var _0x2d9b78=_0x3c1460;this['\x63\x65\x6c\x6c\x73'][_0x2d9b78(0x1c0)](function(_0x366a79){var _0x5ad465=_0x2d9b78;_0x366a79[_0x5ad465(0x30a)]();});},_0x351af6['\x67\x65\x74\x43\x65\x6c\x6c\x45\x6c\x65'+'\x6d\x65\x6e\x74\x73']=function(){var _0x3a06fe=_0x3c1460;return this[_0x3a06fe(0x302)][_0x3a06fe(0x3c1)](function(_0x1cd87a){var _0x7c2078=_0x3a06fe;return _0x1cd87a[_0x7c2078(0x1eb)];});},_0x1a5bec;}),function(_0x26d4d7,_0x7472f6){var _0xbb17ea=_0x119b77;_0xbb17ea(0x2dd)==typeof define&&define[_0xbb17ea(0x1f2)]?define(_0xbb17ea(0x47b)+_0xbb17ea(0x320),['\x66\x69\x7a\x7a\x79\x2d\x75\x69\x2d\x75'+_0xbb17ea(0x34f)],function(_0x15e728){return _0x7472f6(_0x26d4d7,_0x15e728);}):_0xbb17ea(0x358)==typeof module&&module[_0xbb17ea(0x4b6)]?module['\x65\x78\x70\x6f\x72\x74\x73']=_0x7472f6(_0x26d4d7,require(_0xbb17ea(0x428)+_0xbb17ea(0x311))):(_0x26d4d7[_0xbb17ea(0x1c9)]=_0x26d4d7[_0xbb17ea(0x1c9)]||{},_0x26d4d7[_0xbb17ea(0x1c9)][_0xbb17ea(0x1f3)+_0xbb17ea(0x3a4)]=_0x7472f6(_0x26d4d7,_0x26d4d7[_0xbb17ea(0x2a9)+'\x6c\x73']));}(window,function(_0x4d34f3,_0x2c41c0){var _0x2eb404={'\x73\x74\x61\x72\x74\x41\x6e\x69\x6d\x61\x74\x69\x6f\x6e':function(){var _0x387834=_0x2870;this['\x69\x73\x41\x6e\x69\x6d\x61\x74\x69\x6e'+'\x67']||(this[_0x387834(0x38e)+'\x67']=!0x0,this['\x72\x65\x73\x74\x69\x6e\x67\x46\x72\x61'+_0x387834(0x1df)]=0x0,this[_0x387834(0x206)]());},'\x61\x6e\x69\x6d\x61\x74\x65':function(){var _0xd60aeb=_0x2870;this[_0xd60aeb(0x47e)+'\x6f\x72\x63\x65'](),this[_0xd60aeb(0x38b)+'\x74\x65\x64\x41\x74\x74\x72\x61\x63\x74'+_0xd60aeb(0x2f7)]();var _0x2ddce6=this['\x78'];if(this[_0xd60aeb(0x3f7)+_0xd60aeb(0x1b0)](),this[_0xd60aeb(0x3e1)+_0xd60aeb(0x151)](),this[_0xd60aeb(0x1e2)](_0x2ddce6),this[_0xd60aeb(0x38e)+'\x67']){var _0xbe1d2c=this;requestAnimationFrame(function(){_0xbe1d2c['\x61\x6e\x69\x6d\x61\x74\x65']();});}},'\x70\x6f\x73\x69\x74\x69\x6f\x6e\x53\x6c\x69\x64\x65\x72':function(){var _0x5cffc2=_0x2870,_0x252f4d=this['\x78'];this['\x6f\x70\x74\x69\x6f\x6e\x73'][_0x5cffc2(0x25a)]&&this[_0x5cffc2(0x302)]['\x6c\x65\x6e\x67\x74\x68']>0x1&&(_0x252f4d=_0x2c41c0[_0x5cffc2(0x1e6)](_0x252f4d,this[_0x5cffc2(0x214)+'\x69\x64\x74\x68']),_0x252f4d-=this[_0x5cffc2(0x214)+_0x5cffc2(0x301)],this[_0x5cffc2(0x387)+_0x5cffc2(0x28c)](_0x252f4d)),this[_0x5cffc2(0x14b)+'\x74\x65\x58'](_0x252f4d,this[_0x5cffc2(0x38e)+'\x67']),this[_0x5cffc2(0x43a)+_0x5cffc2(0x3c2)]();},'\x73\x65\x74\x54\x72\x61\x6e\x73\x6c\x61\x74\x65\x58':function(_0x430de7,_0x3cb2ba){var _0x3014a2=_0x2870;_0x430de7+=this[_0x3014a2(0x25d)+_0x3014a2(0x341)],_0x430de7=this[_0x3014a2(0x2ab)][_0x3014a2(0x410)+'\x74']?-_0x430de7:_0x430de7;var _0x39dd4d=this[_0x3014a2(0x3d8)+_0x3014a2(0x309)](_0x430de7);this['\x73\x6c\x69\x64\x65\x72'][_0x3014a2(0x292)][_0x3014a2(0x3c3)]=_0x3cb2ba?_0x3014a2(0x422)+'\x64\x28'+_0x39dd4d+_0x3014a2(0x3b4):_0x3014a2(0x24f)+'\x28'+_0x39dd4d+'\x29';},'\x64\x69\x73\x70\x61\x74\x63\x68\x53\x63\x72\x6f\x6c\x6c\x45\x76\x65\x6e\x74':function(){var _0x2df351=_0x2870,_0x2e4c12=this[_0x2df351(0x3d6)][0x0];if(_0x2e4c12){var _0xfb9564=-this['\x78']-_0x2e4c12[_0x2df351(0x170)],_0x2b8c3e=_0xfb9564/this[_0x2df351(0x2f0)+'\x68'];this[_0x2df351(0x3b9)+_0x2df351(0x411)](_0x2df351(0x477),null,[_0x2b8c3e,_0xfb9564]);}},'\x70\x6f\x73\x69\x74\x69\x6f\x6e\x53\x6c\x69\x64\x65\x72\x41\x74\x53\x65\x6c\x65\x63\x74\x65\x64':function(){var _0x530d66=_0x2870;this['\x63\x65\x6c\x6c\x73'][_0x530d66(0x1f9)]&&(this['\x78']=-this[_0x530d66(0x27b)+_0x530d66(0x377)][_0x530d66(0x170)],this[_0x530d66(0x197)]=0x0,this['\x70\x6f\x73\x69\x74\x69\x6f\x6e\x53\x6c'+_0x530d66(0x151)]());},'\x67\x65\x74\x50\x6f\x73\x69\x74\x69\x6f\x6e\x56\x61\x6c\x75\x65':function(_0x533640){var _0x487960=_0x2870;return this[_0x487960(0x2ab)][_0x487960(0x482)+_0x487960(0x41c)]?0.01*Math['\x72\x6f\x75\x6e\x64'](_0x533640/this[_0x487960(0x2a8)][_0x487960(0x15e)]*0x2710)+'\x25':Math[_0x487960(0x19f)](_0x533640)+'\x70\x78';},'\x73\x65\x74\x74\x6c\x65':function(_0x5f36d1){var _0x1f7add=_0x2870;!this[_0x1f7add(0x218)+_0x1f7add(0x209)]&&Math[_0x1f7add(0x19f)](0x64*this['\x78'])==Math['\x72\x6f\x75\x6e\x64'](0x64*_0x5f36d1)&&this[_0x1f7add(0x220)+_0x1f7add(0x1df)]++,this[_0x1f7add(0x220)+_0x1f7add(0x1df)]>0x2&&(this[_0x1f7add(0x38e)+'\x67']=!0x1,delete this[_0x1f7add(0x362)+_0x1f7add(0x2ea)],this[_0x1f7add(0x3e1)+_0x1f7add(0x151)](),this[_0x1f7add(0x3b9)+_0x1f7add(0x411)](_0x1f7add(0x1e2),null,[this[_0x1f7add(0x2bf)+_0x1f7add(0x3e0)]]));},'\x73\x68\x69\x66\x74\x57\x72\x61\x70\x43\x65\x6c\x6c\x73':function(_0x303e29){var _0x18c75b=_0x2870,_0x450995=this[_0x18c75b(0x25d)+_0x18c75b(0x341)]+_0x303e29;this[_0x18c75b(0x2c6)+'\x73'](this['\x62\x65\x66\x6f\x72\x65\x53\x68\x69\x66'+_0x18c75b(0x191)],_0x450995,-0x1);var _0x82597e=this[_0x18c75b(0x2a8)]['\x69\x6e\x6e\x65\x72\x57\x69\x64\x74\x68']-(_0x303e29+this['\x73\x6c\x69\x64\x65\x61\x62\x6c\x65\x57'+_0x18c75b(0x301)]+this[_0x18c75b(0x25d)+_0x18c75b(0x341)]);this[_0x18c75b(0x2c6)+'\x73'](this[_0x18c75b(0x3f4)+_0x18c75b(0x2b6)],_0x82597e,0x1);},'\x5f\x73\x68\x69\x66\x74\x43\x65\x6c\x6c\x73':function(_0x111b2d,_0x14b764,_0x2d0cbc){var _0x53982e=_0x2870;for(var _0x16a66e=0x0;_0x16a66e<_0x111b2d[_0x53982e(0x1f9)];_0x16a66e++){var _0x191e85=_0x111b2d[_0x16a66e],_0x4bcc8a=_0x14b764>0x0?_0x2d0cbc:0x0;_0x191e85[_0x53982e(0x359)](_0x4bcc8a),_0x14b764-=_0x191e85[_0x53982e(0x2a8)][_0x53982e(0x448)];}},'\x5f\x75\x6e\x73\x68\x69\x66\x74\x43\x65\x6c\x6c\x73':function(_0x3875d7){var _0x137099=_0x2870;if(_0x3875d7&&_0x3875d7['\x6c\x65\x6e\x67\x74\x68'])for(var _0xc4a55e=0x0;_0xc4a55e<_0x3875d7[_0x137099(0x1f9)];_0xc4a55e++)_0x3875d7[_0xc4a55e][_0x137099(0x359)](0x0);},'\x69\x6e\x74\x65\x67\x72\x61\x74\x65\x50\x68\x79\x73\x69\x63\x73':function(){var _0x36b012=_0x2870;this['\x78']+=this[_0x36b012(0x197)],this[_0x36b012(0x197)]*=this[_0x36b012(0x1c6)+_0x36b012(0x2dc)]();},'\x61\x70\x70\x6c\x79\x46\x6f\x72\x63\x65':function(_0x16fba8){var _0x4c5a4c=_0x2870;this[_0x4c5a4c(0x197)]+=_0x16fba8;},'\x67\x65\x74\x46\x72\x69\x63\x74\x69\x6f\x6e\x46\x61\x63\x74\x6f\x72':function(){var _0x1720a4=_0x2870;return 0x1-this[_0x1720a4(0x2ab)][this[_0x1720a4(0x362)+'\x6c\x6c\x69\x6e\x67']?_0x1720a4(0x3f6)+'\x46\x72\x69\x63\x74\x69\x6f\x6e':_0x1720a4(0x363)];},'\x67\x65\x74\x52\x65\x73\x74\x69\x6e\x67\x50\x6f\x73\x69\x74\x69\x6f\x6e':function(){var _0x490051=_0x2870;return this['\x78']+this[_0x490051(0x197)]/(0x1-this[_0x490051(0x1c6)+_0x490051(0x2dc)]());},'\x61\x70\x70\x6c\x79\x44\x72\x61\x67\x46\x6f\x72\x63\x65':function(){var _0x31e2b3=_0x2870;if(this['\x69\x73\x44\x72\x61\x67\x67\x61\x62\x6c'+'\x65']&&this[_0x31e2b3(0x218)+_0x31e2b3(0x209)]){var _0x39982f=this['\x64\x72\x61\x67\x58']-this['\x78']-this['\x76\x65\x6c\x6f\x63\x69\x74\x79'];this[_0x31e2b3(0x425)](_0x39982f);}},'\x61\x70\x70\x6c\x79\x53\x65\x6c\x65\x63\x74\x65\x64\x41\x74\x74\x72\x61\x63\x74\x69\x6f\x6e':function(){var _0x106303=_0x2870;if(!(this[_0x106303(0x2ee)+'\x65']&&this[_0x106303(0x218)+_0x106303(0x209)])&&!this['\x69\x73\x46\x72\x65\x65\x53\x63\x72\x6f'+'\x6c\x6c\x69\x6e\x67']&&this[_0x106303(0x3d6)][_0x106303(0x1f9)]){var _0x348acb=(-0x1*this[_0x106303(0x27b)+_0x106303(0x377)][_0x106303(0x170)]-this['\x78'])*this[_0x106303(0x2ab)][_0x106303(0x164)+_0x106303(0x33c)];this[_0x106303(0x425)](_0x348acb);}}};return _0x2eb404;}),function(_0x2c31a0,_0x4fbf4d){var _0x464473=_0x119b77;if(_0x464473(0x2dd)==typeof define&&define['\x61\x6d\x64'])define('\x66\x6c\x69\x63\x6b\x69\x74\x79\x2f\x6a'+_0x464473(0x495),['\x65\x76\x2d\x65\x6d\x69\x74\x74\x65\x72'+_0x464473(0x45c)+'\x72',_0x464473(0x20b)+_0x464473(0x403),_0x464473(0x428)+_0x464473(0x34f),_0x464473(0x148),'\x2e\x2f\x73\x6c\x69\x64\x65',_0x464473(0x16b)],function(_0x449439,_0xe5e462,_0x539a13,_0x3b1fb9,_0x15d3a5,_0x48488e){return _0x4fbf4d(_0x2c31a0,_0x449439,_0xe5e462,_0x539a13,_0x3b1fb9,_0x15d3a5,_0x48488e);});else{if(_0x464473(0x358)==typeof module&&module[_0x464473(0x4b6)])module[_0x464473(0x4b6)]=_0x4fbf4d(_0x2c31a0,require(_0x464473(0x46c)),require('\x67\x65\x74\x2d\x73\x69\x7a\x65'),require(_0x464473(0x428)+_0x464473(0x311)),require(_0x464473(0x148)),require('\x2e\x2f\x73\x6c\x69\x64\x65'),require(_0x464473(0x16b)));else{var _0x3ea991=_0x2c31a0[_0x464473(0x1c9)];_0x2c31a0[_0x464473(0x1c9)]=_0x4fbf4d(_0x2c31a0,_0x2c31a0['\x45\x76\x45\x6d\x69\x74\x74\x65\x72'],_0x2c31a0['\x67\x65\x74\x53\x69\x7a\x65'],_0x2c31a0['\x66\x69\x7a\x7a\x79\x55\x49\x55\x74\x69'+'\x6c\x73'],_0x3ea991[_0x464473(0x461)],_0x3ea991[_0x464473(0x427)],_0x3ea991[_0x464473(0x1f3)+'\x74\x6f\x74\x79\x70\x65']);}}}(window,function(_0x56d295,_0x441baf,_0x5e0156,_0x7092a,_0x2349a9,_0x4b6431,_0x11927c){var _0x18ad1b=_0x119b77,_0xe790c4=_0x56d295[_0x18ad1b(0x1cf)],_0x15211b=_0x56d295[_0x18ad1b(0x184)+_0x18ad1b(0x225)],_0x27bf01=_0x56d295[_0x18ad1b(0x277)];function _0x3d8855(_0x228b70,_0x34ec16){var _0x4e25eb=_0x18ad1b;for(_0x228b70=_0x7092a['\x6d\x61\x6b\x65\x41\x72\x72\x61\x79'](_0x228b70);_0x228b70[_0x4e25eb(0x1f9)];)_0x34ec16[_0x4e25eb(0x1ff)+'\x64'](_0x228b70[_0x4e25eb(0x294)]());}var _0x2d59a2=0x0,_0x3f0563={};function _0xade157(_0x136d61,_0x203e4f){var _0x4d5371=_0x18ad1b,_0x5db1d0=_0x7092a[_0x4d5371(0x49f)+_0x4d5371(0x295)](_0x136d61);if(_0x5db1d0){if(this[_0x4d5371(0x1eb)]=_0x5db1d0,this[_0x4d5371(0x1eb)][_0x4d5371(0x241)+'\x49\x44']){var _0x34e794=_0x3f0563[this[_0x4d5371(0x1eb)][_0x4d5371(0x241)+'\x49\x44']];return _0x34e794&&_0x34e794[_0x4d5371(0x44c)](_0x203e4f),_0x34e794;}_0xe790c4&&(this[_0x4d5371(0x24a)]=_0xe790c4(this['\x65\x6c\x65\x6d\x65\x6e\x74'])),this['\x6f\x70\x74\x69\x6f\x6e\x73']=_0x7092a['\x65\x78\x74\x65\x6e\x64']({},this[_0x4d5371(0x23c)+'\x72']['\x64\x65\x66\x61\x75\x6c\x74\x73']),this[_0x4d5371(0x44c)](_0x203e4f),this[_0x4d5371(0x16c)]();}else _0x27bf01&&_0x27bf01[_0x4d5371(0x17d)](_0x4d5371(0x34c)+_0x4d5371(0x1b6)+_0x4d5371(0x145)+(_0x5db1d0||_0x136d61));}_0xade157[_0x18ad1b(0x2da)]={'\x61\x63\x63\x65\x73\x73\x69\x62\x69\x6c\x69\x74\x79':!0x0,'\x63\x65\x6c\x6c\x41\x6c\x69\x67\x6e':_0x18ad1b(0x2cc),'\x66\x72\x65\x65\x53\x63\x72\x6f\x6c\x6c\x46\x72\x69\x63\x74\x69\x6f\x6e':0.075,'\x66\x72\x69\x63\x74\x69\x6f\x6e':0.28,'\x6e\x61\x6d\x65\x73\x70\x61\x63\x65\x4a\x51\x75\x65\x72\x79\x45\x76\x65\x6e\x74\x73':!0x0,'\x70\x65\x72\x63\x65\x6e\x74\x50\x6f\x73\x69\x74\x69\x6f\x6e':!0x0,'\x72\x65\x73\x69\x7a\x65':!0x0,'\x73\x65\x6c\x65\x63\x74\x65\x64\x41\x74\x74\x72\x61\x63\x74\x69\x6f\x6e':0.025,'\x73\x65\x74\x47\x61\x6c\x6c\x65\x72\x79\x53\x69\x7a\x65':!0x0},_0xade157[_0x18ad1b(0x20e)+'\x6f\x64\x73']=[];var _0x4fb0a3=_0xade157[_0x18ad1b(0x153)];_0x7092a[_0x18ad1b(0x3cb)](_0x4fb0a3,_0x441baf[_0x18ad1b(0x153)]),_0x4fb0a3['\x5f\x63\x72\x65\x61\x74\x65']=function(){var _0x2ebc50=_0x18ad1b,_0xea4a6a=this['\x67\x75\x69\x64']=++_0x2d59a2;for(var _0xc84a31 in(this[_0x2ebc50(0x1eb)][_0x2ebc50(0x241)+'\x49\x44']=_0xea4a6a,_0x3f0563[_0xea4a6a]=this,this[_0x2ebc50(0x2bf)+_0x2ebc50(0x3e0)]=0x0,this[_0x2ebc50(0x220)+_0x2ebc50(0x1df)]=0x0,this['\x78']=0x0,this[_0x2ebc50(0x197)]=0x0,this['\x6f\x72\x69\x67\x69\x6e\x53\x69\x64\x65']=this[_0x2ebc50(0x2ab)][_0x2ebc50(0x410)+'\x74']?'\x72\x69\x67\x68\x74':_0x2ebc50(0x2eb),this[_0x2ebc50(0x3e5)]=document[_0x2ebc50(0x2be)+_0x2ebc50(0x411)](_0x2ebc50(0x28d)),this[_0x2ebc50(0x3e5)][_0x2ebc50(0x40d)]=_0x2ebc50(0x2ed)+_0x2ebc50(0x492),this['\x5f\x63\x72\x65\x61\x74\x65\x53\x6c\x69'+_0x2ebc50(0x335)](),(this['\x6f\x70\x74\x69\x6f\x6e\x73'][_0x2ebc50(0x2d1)]||this[_0x2ebc50(0x2ab)]['\x77\x61\x74\x63\x68\x43\x53\x53'])&&_0x56d295[_0x2ebc50(0x29a)+_0x2ebc50(0x1bd)](_0x2ebc50(0x2d1),this),this[_0x2ebc50(0x2ab)]['\x6f\x6e'])){var _0x459a3d=this['\x6f\x70\x74\x69\x6f\x6e\x73']['\x6f\x6e'][_0xc84a31];this['\x6f\x6e'](_0xc84a31,_0x459a3d);}_0xade157[_0x2ebc50(0x20e)+_0x2ebc50(0x1e3)][_0x2ebc50(0x1c0)](function(_0x258071){this[_0x258071]();},this),this[_0x2ebc50(0x2ab)][_0x2ebc50(0x2de)]?this[_0x2ebc50(0x2de)]():this[_0x2ebc50(0x239)]();},_0x4fb0a3[_0x18ad1b(0x44c)]=function(_0x3fadde){var _0x120cb6=_0x18ad1b;_0x7092a[_0x120cb6(0x3cb)](this[_0x120cb6(0x2ab)],_0x3fadde);},_0x4fb0a3[_0x18ad1b(0x239)]=function(){var _0x3da57a=_0x18ad1b;this[_0x3da57a(0x221)]||(this[_0x3da57a(0x221)]=!0x0,this['\x65\x6c\x65\x6d\x65\x6e\x74'][_0x3da57a(0x35f)][_0x3da57a(0x234)](_0x3da57a(0x30e)+'\x6e\x61\x62\x6c\x65\x64'),this[_0x3da57a(0x2ab)][_0x3da57a(0x410)+'\x74']&&this[_0x3da57a(0x1eb)][_0x3da57a(0x35f)][_0x3da57a(0x234)](_0x3da57a(0x1a7)+'\x74\x6c'),this[_0x3da57a(0x35c)](),_0x3d8855(this['\x5f\x66\x69\x6c\x74\x65\x72\x46\x69\x6e'+_0x3da57a(0x3cd)+_0x3da57a(0x3aa)](this[_0x3da57a(0x1eb)][_0x3da57a(0x3f9)]),this[_0x3da57a(0x419)]),this[_0x3da57a(0x3e5)]['\x61\x70\x70\x65\x6e\x64\x43\x68\x69\x6c'+'\x64'](this['\x73\x6c\x69\x64\x65\x72']),this[_0x3da57a(0x1eb)][_0x3da57a(0x1ff)+'\x64'](this[_0x3da57a(0x3e5)]),this[_0x3da57a(0x4ae)+'\x73'](),this[_0x3da57a(0x2ab)]['\x61\x63\x63\x65\x73\x73\x69\x62\x69\x6c'+_0x3da57a(0x339)]&&(this[_0x3da57a(0x1eb)]['\x74\x61\x62\x49\x6e\x64\x65\x78']=0x0,this[_0x3da57a(0x1eb)]['\x61\x64\x64\x45\x76\x65\x6e\x74\x4c\x69'+'\x73\x74\x65\x6e\x65\x72'](_0x3da57a(0x431),this)),this[_0x3da57a(0x3af)](_0x3da57a(0x239)),this[_0x3da57a(0x452)+'\x69\x61\x6c\x49\x6e\x64\x65\x78'](),this[_0x3da57a(0x314)+_0x3da57a(0x150)]=!0x0,this['\x64\x69\x73\x70\x61\x74\x63\x68\x45\x76'+'\x65\x6e\x74']('\x72\x65\x61\x64\x79'));},_0x4fb0a3[_0x18ad1b(0x4b8)+'\x64\x65\x72']=function(){var _0x209920=_0x18ad1b,_0x3f291d=document[_0x209920(0x2be)+_0x209920(0x411)]('\x64\x69\x76');_0x3f291d[_0x209920(0x40d)]='\x66\x6c\x69\x63\x6b\x69\x74\x79\x2d\x73'+_0x209920(0x344),_0x3f291d['\x73\x74\x79\x6c\x65'][this[_0x209920(0x42a)]]=0x0,this[_0x209920(0x419)]=_0x3f291d;},_0x4fb0a3[_0x18ad1b(0x1a5)+_0x18ad1b(0x3cd)+_0x18ad1b(0x3aa)]=function(_0x49dc2a){var _0x55b825=_0x18ad1b;return _0x7092a[_0x55b825(0x401)+_0x55b825(0x3eb)](_0x49dc2a,this[_0x55b825(0x2ab)][_0x55b825(0x2f9)+'\x6f\x72']);},_0x4fb0a3[_0x18ad1b(0x4ae)+'\x73']=function(){var _0x42fa7e=_0x18ad1b;this[_0x42fa7e(0x302)]=this[_0x42fa7e(0x413)](this[_0x42fa7e(0x419)][_0x42fa7e(0x3f9)]),this['\x70\x6f\x73\x69\x74\x69\x6f\x6e\x43\x65'+_0x42fa7e(0x391)](),this[_0x42fa7e(0x2e9)+_0x42fa7e(0x4b7)](),this['\x73\x65\x74\x47\x61\x6c\x6c\x65\x72\x79'+_0x42fa7e(0x470)]();},_0x4fb0a3[_0x18ad1b(0x413)]=function(_0x149785){var _0xa65720=_0x18ad1b;return this[_0xa65720(0x1a5)+_0xa65720(0x3cd)+_0xa65720(0x3aa)](_0x149785)[_0xa65720(0x3c1)](function(_0x4bfab1){return new _0x2349a9(_0x4bfab1,this);},this);},_0x4fb0a3[_0x18ad1b(0x22d)+'\x6c']=function(){var _0x57c060=_0x18ad1b;return this[_0x57c060(0x302)][this[_0x57c060(0x302)][_0x57c060(0x1f9)]-0x1];},_0x4fb0a3['\x67\x65\x74\x4c\x61\x73\x74\x53\x6c\x69'+'\x64\x65']=function(){var _0x2f430c=_0x18ad1b;return this[_0x2f430c(0x3d6)][this[_0x2f430c(0x3d6)][_0x2f430c(0x1f9)]-0x1];},_0x4fb0a3[_0x18ad1b(0x305)+_0x18ad1b(0x391)]=function(){var _0x3cb624=_0x18ad1b;this[_0x3cb624(0x451)](this[_0x3cb624(0x302)]),this['\x5f\x70\x6f\x73\x69\x74\x69\x6f\x6e\x43'+_0x3cb624(0x28c)](0x0);},_0x4fb0a3['\x5f\x70\x6f\x73\x69\x74\x69\x6f\x6e\x43'+_0x18ad1b(0x28c)]=function(_0x226099){var _0x2fe7d1=_0x18ad1b;_0x226099=_0x226099||0x0,this[_0x2fe7d1(0x32d)+_0x2fe7d1(0x3a6)]=_0x226099&&this['\x6d\x61\x78\x43\x65\x6c\x6c\x48\x65\x69'+_0x2fe7d1(0x3a6)]||0x0;var _0x12a1fb=0x0;if(_0x226099>0x0){var _0x255755=this[_0x2fe7d1(0x302)][_0x226099-0x1];_0x12a1fb=_0x255755['\x78']+_0x255755[_0x2fe7d1(0x2a8)][_0x2fe7d1(0x448)];}for(var _0x466ebf=this[_0x2fe7d1(0x302)][_0x2fe7d1(0x1f9)],_0x577691=_0x226099;_0x577691<_0x466ebf;_0x577691++){var _0x203191=this[_0x2fe7d1(0x302)][_0x577691];_0x203191[_0x2fe7d1(0x423)+'\x6e'](_0x12a1fb),_0x12a1fb+=_0x203191[_0x2fe7d1(0x2a8)][_0x2fe7d1(0x448)],this['\x6d\x61\x78\x43\x65\x6c\x6c\x48\x65\x69'+_0x2fe7d1(0x3a6)]=Math['\x6d\x61\x78'](_0x203191[_0x2fe7d1(0x2a8)][_0x2fe7d1(0x4a0)+'\x74'],this[_0x2fe7d1(0x32d)+'\x67\x68\x74']);}this[_0x2fe7d1(0x214)+_0x2fe7d1(0x301)]=_0x12a1fb,this[_0x2fe7d1(0x293)+'\x65\x73'](),this[_0x2fe7d1(0x2d9)+_0x2fe7d1(0x1be)](),this[_0x2fe7d1(0x2f0)+'\x68']=_0x466ebf?this[_0x2fe7d1(0x1ad)+'\x64\x65']()['\x74\x61\x72\x67\x65\x74']-this[_0x2fe7d1(0x3d6)][0x0][_0x2fe7d1(0x170)]:0x0;},_0x4fb0a3[_0x18ad1b(0x451)]=function(_0x476511){var _0x1a8e37=_0x18ad1b;_0x476511[_0x1a8e37(0x1c0)](function(_0x372d90){var _0x5398f3=_0x1a8e37;_0x372d90[_0x5398f3(0x35c)]();});},_0x4fb0a3[_0x18ad1b(0x293)+'\x65\x73']=function(){var _0x54ce41=_0x18ad1b;if(this[_0x54ce41(0x3d6)]=[],this['\x63\x65\x6c\x6c\x73'][_0x54ce41(0x1f9)]){var _0x5da3f3=new _0x4b6431(this);this[_0x54ce41(0x3d6)][_0x54ce41(0x43b)](_0x5da3f3);var _0x8b59ba=_0x54ce41(0x2eb)==this[_0x54ce41(0x42a)]?'\x6d\x61\x72\x67\x69\x6e\x52\x69\x67\x68'+'\x74':_0x54ce41(0x178),_0x34cfcc=this[_0x54ce41(0x182)+'\x6c\x46\x69\x74']();this[_0x54ce41(0x302)][_0x54ce41(0x1c0)](function(_0x469020,_0x38733a){var _0xf3f02b=_0x54ce41;if(_0x5da3f3['\x63\x65\x6c\x6c\x73'][_0xf3f02b(0x1f9)]){var _0xc5e668=_0x5da3f3[_0xf3f02b(0x448)]-_0x5da3f3[_0xf3f02b(0x430)+'\x6e']+(_0x469020[_0xf3f02b(0x2a8)][_0xf3f02b(0x448)]-_0x469020[_0xf3f02b(0x2a8)][_0x8b59ba]);_0x34cfcc[_0xf3f02b(0x37c)](this,_0x38733a,_0xc5e668)?_0x5da3f3[_0xf3f02b(0x2aa)](_0x469020):(_0x5da3f3[_0xf3f02b(0x3b1)+'\x65\x74'](),_0x5da3f3=new _0x4b6431(this),this[_0xf3f02b(0x3d6)][_0xf3f02b(0x43b)](_0x5da3f3),_0x5da3f3[_0xf3f02b(0x2aa)](_0x469020));}else _0x5da3f3[_0xf3f02b(0x2aa)](_0x469020);},this),_0x5da3f3[_0x54ce41(0x3b1)+'\x65\x74'](),this['\x75\x70\x64\x61\x74\x65\x53\x65\x6c\x65'+_0x54ce41(0x395)]();}},_0x4fb0a3[_0x18ad1b(0x182)+_0x18ad1b(0x200)]=function(){var _0x89f58e=_0x18ad1b,_0x3cb83c=this[_0x89f58e(0x2ab)][_0x89f58e(0x222)];if(!_0x3cb83c)return function(){return!0x1;};if(_0x89f58e(0x4a8)==typeof _0x3cb83c){var _0x3adb13=parseInt(_0x3cb83c,0xa);return function(_0x418c77){return _0x418c77%_0x3adb13!=0x0;};}var _0x4dbbec=_0x89f58e(0x3d2)==typeof _0x3cb83c&&_0x3cb83c[_0x89f58e(0x46f)](/^(\d+)%$/),_0x199504=_0x4dbbec?parseInt(_0x4dbbec[0x1],0xa)/0x64:0x1;return function(_0x167952,_0x24c6c8){var _0x46ddf9=_0x89f58e;return _0x24c6c8<=(this[_0x46ddf9(0x2a8)][_0x46ddf9(0x15e)]+0x1)*_0x199504;};},_0x4fb0a3[_0x18ad1b(0x3f2)]=_0x4fb0a3[_0x18ad1b(0x44d)]=function(){var _0x4378dd=_0x18ad1b;this[_0x4378dd(0x305)+_0x4378dd(0x391)](),this[_0x4378dd(0x3e1)+_0x4378dd(0x1c1)+_0x4378dd(0x3e3)]();},_0x4fb0a3[_0x18ad1b(0x35c)]=function(){var _0x90e195=_0x18ad1b;this[_0x90e195(0x2a8)]=_0x5e0156(this['\x65\x6c\x65\x6d\x65\x6e\x74']),this[_0x90e195(0x3d4)+'\x67\x6e'](),this[_0x90e195(0x25d)+_0x90e195(0x341)]=this[_0x90e195(0x2a8)][_0x90e195(0x15e)]*this[_0x90e195(0x1d1)];};var _0x206e92={'\x63\x65\x6e\x74\x65\x72':{'\x6c\x65\x66\x74':0.5,'\x72\x69\x67\x68\x74':0.5},'\x6c\x65\x66\x74':{'\x6c\x65\x66\x74':0x0,'\x72\x69\x67\x68\x74':0x1},'\x72\x69\x67\x68\x74':{'\x72\x69\x67\x68\x74':0x0,'\x6c\x65\x66\x74':0x1}};return _0x4fb0a3[_0x18ad1b(0x3d4)+'\x67\x6e']=function(){var _0x2b3896=_0x18ad1b,_0x12c373=_0x206e92[this[_0x2b3896(0x2ab)][_0x2b3896(0x1d1)]];this['\x63\x65\x6c\x6c\x41\x6c\x69\x67\x6e']=_0x12c373?_0x12c373[this[_0x2b3896(0x42a)]]:this[_0x2b3896(0x2ab)][_0x2b3896(0x1d1)];},_0x4fb0a3[_0x18ad1b(0x39c)+_0x18ad1b(0x470)]=function(){var _0x3e41b0=_0x18ad1b;if(this[_0x3e41b0(0x2ab)][_0x3e41b0(0x39c)+_0x3e41b0(0x470)]){var _0x4867c5=this[_0x3e41b0(0x2ab)]['\x61\x64\x61\x70\x74\x69\x76\x65\x48\x65'+_0x3e41b0(0x4a5)]&&this[_0x3e41b0(0x27b)+_0x3e41b0(0x377)]?this[_0x3e41b0(0x27b)+_0x3e41b0(0x377)][_0x3e41b0(0x406)]:this[_0x3e41b0(0x32d)+_0x3e41b0(0x3a6)];this[_0x3e41b0(0x3e5)]['\x73\x74\x79\x6c\x65']['\x68\x65\x69\x67\x68\x74']=_0x4867c5+'\x70\x78';}},_0x4fb0a3['\x5f\x67\x65\x74\x57\x72\x61\x70\x53\x68'+_0x18ad1b(0x4b7)]=function(){var _0x476e75=_0x18ad1b;if(this[_0x476e75(0x2ab)][_0x476e75(0x25a)]){this[_0x476e75(0x351)+_0x476e75(0x391)](this[_0x476e75(0x163)+_0x476e75(0x191)]),this[_0x476e75(0x351)+_0x476e75(0x391)](this[_0x476e75(0x3f4)+_0x476e75(0x2b6)]);var _0x11f109=this['\x63\x75\x72\x73\x6f\x72\x50\x6f\x73\x69'+_0x476e75(0x341)],_0x2c3cae=this[_0x476e75(0x302)]['\x6c\x65\x6e\x67\x74\x68']-0x1;this[_0x476e75(0x163)+'\x74\x43\x65\x6c\x6c\x73']=this[_0x476e75(0x3a0)+'\x6c\x73'](_0x11f109,_0x2c3cae,-0x1),_0x11f109=this[_0x476e75(0x2a8)][_0x476e75(0x15e)]-this[_0x476e75(0x25d)+_0x476e75(0x341)],this[_0x476e75(0x3f4)+_0x476e75(0x2b6)]=this[_0x476e75(0x3a0)+'\x6c\x73'](_0x11f109,0x0,0x1);}},_0x4fb0a3[_0x18ad1b(0x3a0)+'\x6c\x73']=function(_0xc0bc32,_0x4fddeb,_0x17075b){var _0xc334b2=_0x18ad1b;for(var _0x23a4cb=[];_0xc0bc32>0x0;){var _0x177d5=this[_0xc334b2(0x302)][_0x4fddeb];if(!_0x177d5)break;_0x23a4cb['\x70\x75\x73\x68'](_0x177d5),_0x4fddeb+=_0x17075b,_0xc0bc32-=_0x177d5[_0xc334b2(0x2a8)][_0xc334b2(0x448)];}return _0x23a4cb;},_0x4fb0a3[_0x18ad1b(0x2d9)+_0x18ad1b(0x1be)]=function(){var _0x25e8f3=_0x18ad1b;if(this[_0x25e8f3(0x2ab)]['\x63\x6f\x6e\x74\x61\x69\x6e']&&!this[_0x25e8f3(0x2ab)][_0x25e8f3(0x25a)]&&this[_0x25e8f3(0x302)]['\x6c\x65\x6e\x67\x74\x68']){var _0x33a391=this[_0x25e8f3(0x2ab)][_0x25e8f3(0x410)+'\x74'],_0x1fbcc9=_0x33a391?_0x25e8f3(0x374)+'\x74':_0x25e8f3(0x178),_0x2986e8=_0x33a391?_0x25e8f3(0x178):_0x25e8f3(0x374)+'\x74',_0x1b5e3a=this[_0x25e8f3(0x214)+_0x25e8f3(0x301)]-this[_0x25e8f3(0x22d)+'\x6c']()[_0x25e8f3(0x2a8)][_0x2986e8],_0x2ff81c=_0x1b5e3a<this[_0x25e8f3(0x2a8)]['\x69\x6e\x6e\x65\x72\x57\x69\x64\x74\x68'],_0x21f5fb=this['\x63\x75\x72\x73\x6f\x72\x50\x6f\x73\x69'+_0x25e8f3(0x341)]+this[_0x25e8f3(0x302)][0x0][_0x25e8f3(0x2a8)][_0x1fbcc9],_0xea822e=_0x1b5e3a-this['\x73\x69\x7a\x65'][_0x25e8f3(0x15e)]*(0x1-this['\x63\x65\x6c\x6c\x41\x6c\x69\x67\x6e']);this[_0x25e8f3(0x3d6)]['\x66\x6f\x72\x45\x61\x63\x68'](function(_0x4d4be2){var _0x1a19f0=_0x25e8f3;_0x2ff81c?_0x4d4be2[_0x1a19f0(0x170)]=_0x1b5e3a*this['\x63\x65\x6c\x6c\x41\x6c\x69\x67\x6e']:(_0x4d4be2[_0x1a19f0(0x170)]=Math['\x6d\x61\x78'](_0x4d4be2[_0x1a19f0(0x170)],_0x21f5fb),_0x4d4be2[_0x1a19f0(0x170)]=Math['\x6d\x69\x6e'](_0x4d4be2[_0x1a19f0(0x170)],_0xea822e));},this);}},_0x4fb0a3['\x64\x69\x73\x70\x61\x74\x63\x68\x45\x76'+_0x18ad1b(0x411)]=function(_0x83493f,_0x58b4dd,_0x263b88){var _0x14fa2d=_0x18ad1b,_0x2fdf64=_0x58b4dd?[_0x58b4dd][_0x14fa2d(0x1a9)](_0x263b88):_0x263b88;if(this[_0x14fa2d(0x3af)](_0x83493f,_0x2fdf64),_0xe790c4&&this[_0x14fa2d(0x24a)]){var _0x1ec779=_0x83493f+=this[_0x14fa2d(0x2ab)][_0x14fa2d(0x22c)+'\x51\x75\x65\x72\x79\x45\x76\x65\x6e\x74'+'\x73']?'\x2e\x66\x6c\x69\x63\x6b\x69\x74\x79':'';if(_0x58b4dd){var _0x1c706b=new _0xe790c4[(_0x14fa2d(0x42c))](_0x58b4dd);_0x1c706b[_0x14fa2d(0x32b)]=_0x83493f,_0x1ec779=_0x1c706b;}this[_0x14fa2d(0x24a)]['\x74\x72\x69\x67\x67\x65\x72'](_0x1ec779,_0x263b88);}},_0x4fb0a3[_0x18ad1b(0x47d)]=function(_0x28a2f9,_0x98910d,_0x1e9754){var _0x5ee1dd=_0x18ad1b;if(this[_0x5ee1dd(0x221)]&&(_0x28a2f9=parseInt(_0x28a2f9,0xa),this['\x5f\x77\x72\x61\x70\x53\x65\x6c\x65\x63'+'\x74'](_0x28a2f9),(this[_0x5ee1dd(0x2ab)][_0x5ee1dd(0x25a)]||_0x98910d)&&(_0x28a2f9=_0x7092a[_0x5ee1dd(0x1e6)](_0x28a2f9,this['\x73\x6c\x69\x64\x65\x73'][_0x5ee1dd(0x1f9)])),this[_0x5ee1dd(0x3d6)][_0x28a2f9])){var _0x426d32=this[_0x5ee1dd(0x2bf)+_0x5ee1dd(0x3e0)];this['\x73\x65\x6c\x65\x63\x74\x65\x64\x49\x6e'+_0x5ee1dd(0x3e0)]=_0x28a2f9,this['\x75\x70\x64\x61\x74\x65\x53\x65\x6c\x65'+_0x5ee1dd(0x395)](),_0x1e9754?this['\x70\x6f\x73\x69\x74\x69\x6f\x6e\x53\x6c'+_0x5ee1dd(0x1c1)+_0x5ee1dd(0x3e3)]():this[_0x5ee1dd(0x367)+_0x5ee1dd(0x341)](),this[_0x5ee1dd(0x2ab)][_0x5ee1dd(0x458)+'\x69\x67\x68\x74']&&this[_0x5ee1dd(0x39c)+'\x53\x69\x7a\x65'](),this[_0x5ee1dd(0x3b9)+_0x5ee1dd(0x411)](_0x5ee1dd(0x47d),null,[_0x28a2f9]),_0x28a2f9!=_0x426d32&&this[_0x5ee1dd(0x3b9)+_0x5ee1dd(0x411)]('\x63\x68\x61\x6e\x67\x65',null,[_0x28a2f9]),this[_0x5ee1dd(0x3b9)+_0x5ee1dd(0x411)](_0x5ee1dd(0x2f9));}},_0x4fb0a3[_0x18ad1b(0x26b)+'\x74']=function(_0x4defee){var _0x352ba0=_0x18ad1b,_0x4ba31a=this['\x73\x6c\x69\x64\x65\x73']['\x6c\x65\x6e\x67\x74\x68'];if(!(this[_0x352ba0(0x2ab)][_0x352ba0(0x25a)]&&_0x4ba31a>0x1))return _0x4defee;var _0x24bd4=_0x7092a['\x6d\x6f\x64\x75\x6c\x6f'](_0x4defee,_0x4ba31a),_0x569e29=Math[_0x352ba0(0x175)](_0x24bd4-this[_0x352ba0(0x2bf)+_0x352ba0(0x3e0)]),_0x4ce774=Math['\x61\x62\x73'](_0x24bd4+_0x4ba31a-this[_0x352ba0(0x2bf)+_0x352ba0(0x3e0)]),_0x117e2f=Math[_0x352ba0(0x175)](_0x24bd4-_0x4ba31a-this[_0x352ba0(0x2bf)+'\x64\x65\x78']);!this[_0x352ba0(0x4b5)+'\x63\x74']&&_0x4ce774<_0x569e29?_0x4defee+=_0x4ba31a:!this['\x69\x73\x44\x72\x61\x67\x53\x65\x6c\x65'+'\x63\x74']&&_0x117e2f<_0x569e29&&(_0x4defee-=_0x4ba31a),_0x4defee<0x0?this['\x78']-=this[_0x352ba0(0x214)+_0x352ba0(0x301)]:_0x4defee>=_0x4ba31a&&(this['\x78']+=this[_0x352ba0(0x214)+'\x69\x64\x74\x68']);},_0x4fb0a3[_0x18ad1b(0x22b)]=function(_0x34b83a,_0x1d68b8){var _0x304b3a=_0x18ad1b;this[_0x304b3a(0x47d)](this[_0x304b3a(0x2bf)+_0x304b3a(0x3e0)]-0x1,_0x34b83a,_0x1d68b8);},_0x4fb0a3[_0x18ad1b(0x24b)]=function(_0x4764ac,_0x3f2459){var _0x2e3510=_0x18ad1b;this[_0x2e3510(0x47d)](this[_0x2e3510(0x2bf)+_0x2e3510(0x3e0)]+0x1,_0x4764ac,_0x3f2459);},_0x4fb0a3[_0x18ad1b(0x1ec)+_0x18ad1b(0x395)]=function(){var _0x20a4d3=_0x18ad1b,_0x1aa335=this[_0x20a4d3(0x3d6)][this[_0x20a4d3(0x2bf)+_0x20a4d3(0x3e0)]];_0x1aa335&&(this[_0x20a4d3(0x152)+_0x20a4d3(0x21c)+'\x65'](),this[_0x20a4d3(0x27b)+_0x20a4d3(0x377)]=_0x1aa335,_0x1aa335[_0x20a4d3(0x47d)](),this['\x73\x65\x6c\x65\x63\x74\x65\x64\x43\x65'+_0x20a4d3(0x391)]=_0x1aa335['\x63\x65\x6c\x6c\x73'],this['\x73\x65\x6c\x65\x63\x74\x65\x64\x45\x6c'+'\x65\x6d\x65\x6e\x74\x73']=_0x1aa335[_0x20a4d3(0x345)+_0x20a4d3(0x3f1)](),this[_0x20a4d3(0x39a)+'\x6c\x6c']=_0x1aa335[_0x20a4d3(0x302)][0x0],this[_0x20a4d3(0x2e1)+_0x20a4d3(0x295)]=this[_0x20a4d3(0x2e1)+_0x20a4d3(0x3b8)][0x0]);},_0x4fb0a3[_0x18ad1b(0x152)+'\x6c\x65\x63\x74\x65\x64\x53\x6c\x69\x64'+'\x65']=function(){var _0x23912f=_0x18ad1b;this[_0x23912f(0x27b)+_0x23912f(0x377)]&&this[_0x23912f(0x27b)+_0x23912f(0x377)][_0x23912f(0x30a)]();},_0x4fb0a3['\x73\x65\x6c\x65\x63\x74\x49\x6e\x69\x74'+_0x18ad1b(0x354)]=function(){var _0x29b78b=_0x18ad1b,_0x12b13f=this[_0x29b78b(0x2ab)]['\x69\x6e\x69\x74\x69\x61\x6c\x49\x6e\x64'+'\x65\x78'];if(this[_0x29b78b(0x314)+'\x76\x61\x74\x65\x64'])this['\x73\x65\x6c\x65\x63\x74'](this[_0x29b78b(0x2bf)+_0x29b78b(0x3e0)],!0x1,!0x0);else{if(_0x12b13f&&_0x29b78b(0x3d2)==typeof _0x12b13f){if(this[_0x29b78b(0x210)](_0x12b13f))return void this[_0x29b78b(0x227)](_0x12b13f,!0x1,!0x0);}var _0x3d4afc=0x0;_0x12b13f&&this[_0x29b78b(0x3d6)][_0x12b13f]&&(_0x3d4afc=_0x12b13f),this[_0x29b78b(0x47d)](_0x3d4afc,!0x1,!0x0);}},_0x4fb0a3[_0x18ad1b(0x227)]=function(_0x4be7c3,_0x32af3a,_0x22a5ef){var _0xe99cf1=_0x18ad1b,_0x12baf8=this[_0xe99cf1(0x210)](_0x4be7c3);if(_0x12baf8){var _0x4a7ed4=this['\x67\x65\x74\x43\x65\x6c\x6c\x53\x6c\x69'+_0xe99cf1(0x20a)](_0x12baf8);this['\x73\x65\x6c\x65\x63\x74'](_0x4a7ed4,_0x32af3a,_0x22a5ef);}},_0x4fb0a3[_0x18ad1b(0x203)+_0x18ad1b(0x20a)]=function(_0x4c91ac){var _0x2de808=_0x18ad1b;for(var _0x4f1a87=0x0;_0x4f1a87<this[_0x2de808(0x3d6)]['\x6c\x65\x6e\x67\x74\x68'];_0x4f1a87++){if(-0x1!=this[_0x2de808(0x3d6)][_0x4f1a87][_0x2de808(0x302)][_0x2de808(0x181)](_0x4c91ac))return _0x4f1a87;}},_0x4fb0a3[_0x18ad1b(0x40f)]=function(_0x10d0e3){var _0x1de8ca=_0x18ad1b;for(var _0x2a1a94=0x0;_0x2a1a94<this['\x63\x65\x6c\x6c\x73'][_0x1de8ca(0x1f9)];_0x2a1a94++){var _0xe31843=this[_0x1de8ca(0x302)][_0x2a1a94];if(_0xe31843[_0x1de8ca(0x1eb)]==_0x10d0e3)return _0xe31843;}},_0x4fb0a3['\x67\x65\x74\x43\x65\x6c\x6c\x73']=function(_0x2d25cd){var _0x49d65d=_0x18ad1b;_0x2d25cd=_0x7092a[_0x49d65d(0x267)](_0x2d25cd);var _0x3dac9f=[];return _0x2d25cd[_0x49d65d(0x1c0)](function(_0x55d51f){var _0x584b4d=_0x49d65d,_0x3a55f1=this[_0x584b4d(0x40f)](_0x55d51f);_0x3a55f1&&_0x3dac9f[_0x584b4d(0x43b)](_0x3a55f1);},this),_0x3dac9f;},_0x4fb0a3[_0x18ad1b(0x345)+'\x6d\x65\x6e\x74\x73']=function(){var _0x9c4b75=_0x18ad1b;return this[_0x9c4b75(0x302)]['\x6d\x61\x70'](function(_0x18b14e){return _0x18b14e['\x65\x6c\x65\x6d\x65\x6e\x74'];});},_0x4fb0a3[_0x18ad1b(0x229)+_0x18ad1b(0x46d)]=function(_0x450577){var _0x15d3a6=_0x18ad1b,_0x2f3fdf=this[_0x15d3a6(0x40f)](_0x450577);return _0x2f3fdf||(_0x450577=_0x7092a['\x67\x65\x74\x50\x61\x72\x65\x6e\x74'](_0x450577,_0x15d3a6(0x3ef)+'\x73\x6c\x69\x64\x65\x72\x20\x3e\x20\x2a'),this[_0x15d3a6(0x40f)](_0x450577));},_0x4fb0a3['\x67\x65\x74\x41\x64\x6a\x61\x63\x65\x6e'+_0x18ad1b(0x3a5)+_0x18ad1b(0x3aa)]=function(_0x117d92,_0x2b9bc1){var _0x3dee68=_0x18ad1b;if(!_0x117d92)return this[_0x3dee68(0x27b)+_0x3dee68(0x377)][_0x3dee68(0x345)+_0x3dee68(0x3f1)]();_0x2b9bc1=void 0x0===_0x2b9bc1?this[_0x3dee68(0x2bf)+_0x3dee68(0x3e0)]:_0x2b9bc1;var _0x448afe=this[_0x3dee68(0x3d6)][_0x3dee68(0x1f9)];if(0x1+0x2*_0x117d92>=_0x448afe)return this[_0x3dee68(0x345)+_0x3dee68(0x3f1)]();for(var _0x2b4d31=[],_0x539efc=_0x2b9bc1-_0x117d92;_0x539efc<=_0x2b9bc1+_0x117d92;_0x539efc++){var _0x5c2432=this[_0x3dee68(0x2ab)]['\x77\x72\x61\x70\x41\x72\x6f\x75\x6e\x64']?_0x7092a['\x6d\x6f\x64\x75\x6c\x6f'](_0x539efc,_0x448afe):_0x539efc,_0x5e40ca=this[_0x3dee68(0x3d6)][_0x5c2432];_0x5e40ca&&(_0x2b4d31=_0x2b4d31['\x63\x6f\x6e\x63\x61\x74'](_0x5e40ca[_0x3dee68(0x345)+_0x3dee68(0x3f1)]()));}return _0x2b4d31;},_0x4fb0a3['\x71\x75\x65\x72\x79\x43\x65\x6c\x6c']=function(_0x3f9b4b){var _0x3c834c=_0x18ad1b;if(_0x3c834c(0x4a8)==typeof _0x3f9b4b)return this['\x63\x65\x6c\x6c\x73'][_0x3f9b4b];if(_0x3c834c(0x3d2)==typeof _0x3f9b4b){if(_0x3f9b4b[_0x3c834c(0x46f)](/^[#.]?[\d/]/))return;_0x3f9b4b=this['\x65\x6c\x65\x6d\x65\x6e\x74']['\x71\x75\x65\x72\x79\x53\x65\x6c\x65\x63'+_0x3c834c(0x1b5)](_0x3f9b4b);}return this[_0x3c834c(0x40f)](_0x3f9b4b);},_0x4fb0a3[_0x18ad1b(0x274)]=function(){var _0x523ac0=_0x18ad1b;this[_0x523ac0(0x3af)](_0x523ac0(0x274));},_0x4fb0a3[_0x18ad1b(0x2b2)+_0x18ad1b(0x4b1)]=function(_0x8be021){var _0x10ba8b=_0x18ad1b;_0x10ba8b(0x2b3)!=_0x8be021[_0x10ba8b(0x32b)]&&_0x8be021['\x70\x72\x65\x76\x65\x6e\x74\x44\x65\x66'+_0x10ba8b(0x3f3)](),this[_0x10ba8b(0x3c8)]();},_0x4fb0a3[_0x18ad1b(0x255)]=function(){var _0x360622=_0x18ad1b;this[_0x360622(0x2de)](),this[_0x360622(0x2d1)]();},_0x7092a[_0x18ad1b(0x348)+_0x18ad1b(0x484)](_0xade157,'\x6f\x6e\x72\x65\x73\x69\x7a\x65',0x96),_0x4fb0a3['\x72\x65\x73\x69\x7a\x65']=function(){var _0x1bc9f1=_0x18ad1b;if(this['\x69\x73\x41\x63\x74\x69\x76\x65']){this[_0x1bc9f1(0x35c)](),this['\x6f\x70\x74\x69\x6f\x6e\x73']['\x77\x72\x61\x70\x41\x72\x6f\x75\x6e\x64']&&(this['\x78']=_0x7092a[_0x1bc9f1(0x1e6)](this['\x78'],this[_0x1bc9f1(0x214)+_0x1bc9f1(0x301)])),this[_0x1bc9f1(0x305)+'\x6c\x6c\x73'](),this[_0x1bc9f1(0x2e9)+_0x1bc9f1(0x4b7)](),this['\x73\x65\x74\x47\x61\x6c\x6c\x65\x72\x79'+_0x1bc9f1(0x470)](),this[_0x1bc9f1(0x3af)](_0x1bc9f1(0x2d1));var _0x51a16d=this[_0x1bc9f1(0x2e1)+'\x65\x6d\x65\x6e\x74\x73']&&this[_0x1bc9f1(0x2e1)+_0x1bc9f1(0x3b8)][0x0];this[_0x1bc9f1(0x227)](_0x51a16d,!0x1,!0x0);}},_0x4fb0a3[_0x18ad1b(0x2de)]=function(){var _0x427e14=_0x18ad1b;this[_0x427e14(0x2ab)][_0x427e14(0x2de)]&&(-0x1!=_0x15211b(this['\x65\x6c\x65\x6d\x65\x6e\x74'],'\x3a\x61\x66\x74\x65\x72')[_0x427e14(0x27f)]['\x69\x6e\x64\x65\x78\x4f\x66']('\x66\x6c\x69\x63\x6b\x69\x74\x79')?this[_0x427e14(0x239)]():this[_0x427e14(0x33d)]());},_0x4fb0a3[_0x18ad1b(0x31f)]=function(_0x527fe5){var _0x1691df=_0x18ad1b,_0x4a6ce6=document[_0x1691df(0x353)+_0x1691df(0x411)]&&document[_0x1691df(0x353)+'\x65\x6e\x74']!=this[_0x1691df(0x1eb)];if(this[_0x1691df(0x2ab)]['\x61\x63\x63\x65\x73\x73\x69\x62\x69\x6c'+'\x69\x74\x79']&&!_0x4a6ce6){var _0x2afbd2=_0xade157[_0x1691df(0x481)+_0x1691df(0x17a)][_0x527fe5[_0x1691df(0x256)]];_0x2afbd2&&_0x2afbd2[_0x1691df(0x37c)](this);}},_0xade157['\x6b\x65\x79\x62\x6f\x61\x72\x64\x48\x61'+_0x18ad1b(0x17a)]={0x25:function(){var _0x48405a=_0x18ad1b,_0x52fa98=this[_0x48405a(0x2ab)][_0x48405a(0x410)+'\x74']?_0x48405a(0x24b):_0x48405a(0x22b);this['\x75\x69\x43\x68\x61\x6e\x67\x65'](),this[_0x52fa98]();},0x27:function(){var _0x54f5df=_0x18ad1b,_0x13f909=this['\x6f\x70\x74\x69\x6f\x6e\x73'][_0x54f5df(0x410)+'\x74']?'\x70\x72\x65\x76\x69\x6f\x75\x73':_0x54f5df(0x24b);this[_0x54f5df(0x274)](),this[_0x13f909]();}},_0x4fb0a3['\x66\x6f\x63\x75\x73']=function(){var _0x1136a1=_0x18ad1b,_0x4c9a8e=_0x56d295[_0x1136a1(0x3d0)+'\x74'];this[_0x1136a1(0x1eb)][_0x1136a1(0x3c8)]({'\x70\x72\x65\x76\x65\x6e\x74\x53\x63\x72\x6f\x6c\x6c':!0x0}),_0x56d295['\x70\x61\x67\x65\x59\x4f\x66\x66\x73\x65'+'\x74']!=_0x4c9a8e&&_0x56d295[_0x1136a1(0x42e)](_0x56d295['\x70\x61\x67\x65\x58\x4f\x66\x66\x73\x65'+'\x74'],_0x4c9a8e);},_0x4fb0a3[_0x18ad1b(0x33d)]=function(){var _0x11be3f=_0x18ad1b;this[_0x11be3f(0x221)]&&(this['\x65\x6c\x65\x6d\x65\x6e\x74'][_0x11be3f(0x35f)][_0x11be3f(0x429)](_0x11be3f(0x30e)+'\x6e\x61\x62\x6c\x65\x64'),this[_0x11be3f(0x1eb)][_0x11be3f(0x35f)]['\x72\x65\x6d\x6f\x76\x65'](_0x11be3f(0x1a7)+'\x74\x6c'),this[_0x11be3f(0x152)+_0x11be3f(0x21c)+'\x65'](),this['\x63\x65\x6c\x6c\x73'][_0x11be3f(0x1c0)](function(_0x42ddf0){_0x42ddf0['\x64\x65\x73\x74\x72\x6f\x79']();}),this[_0x11be3f(0x1eb)]['\x72\x65\x6d\x6f\x76\x65\x43\x68\x69\x6c'+'\x64'](this[_0x11be3f(0x3e5)]),_0x3d8855(this['\x73\x6c\x69\x64\x65\x72']['\x63\x68\x69\x6c\x64\x72\x65\x6e'],this['\x65\x6c\x65\x6d\x65\x6e\x74']),this[_0x11be3f(0x2ab)][_0x11be3f(0x439)+_0x11be3f(0x339)]&&(this[_0x11be3f(0x1eb)][_0x11be3f(0x376)+_0x11be3f(0x217)]('\x74\x61\x62\x49\x6e\x64\x65\x78'),this[_0x11be3f(0x1eb)][_0x11be3f(0x271)+'\x74\x4c\x69\x73\x74\x65\x6e\x65\x72']('\x6b\x65\x79\x64\x6f\x77\x6e',this)),this['\x69\x73\x41\x63\x74\x69\x76\x65']=!0x1,this[_0x11be3f(0x3af)]('\x64\x65\x61\x63\x74\x69\x76\x61\x74\x65'));},_0x4fb0a3[_0x18ad1b(0x48f)]=function(){var _0x1f32b2=_0x18ad1b;this[_0x1f32b2(0x33d)](),_0x56d295[_0x1f32b2(0x271)+_0x1f32b2(0x1c2)](_0x1f32b2(0x2d1),this),this['\x61\x6c\x6c\x4f\x66\x66'](),this['\x65\x6d\x69\x74\x45\x76\x65\x6e\x74']('\x64\x65\x73\x74\x72\x6f\x79'),_0xe790c4&&this[_0x1f32b2(0x24a)]&&_0xe790c4[_0x1f32b2(0x265)](this[_0x1f32b2(0x1eb)],_0x1f32b2(0x2fd)),delete this['\x65\x6c\x65\x6d\x65\x6e\x74'][_0x1f32b2(0x241)+'\x49\x44'],delete _0x3f0563[this[_0x1f32b2(0x1ce)]];},_0x7092a[_0x18ad1b(0x3cb)](_0x4fb0a3,_0x11927c),_0xade157[_0x18ad1b(0x15b)]=function(_0x4b5e2b){var _0x13937b=_0x18ad1b,_0x545ae1=(_0x4b5e2b=_0x7092a[_0x13937b(0x49f)+_0x13937b(0x295)](_0x4b5e2b))&&_0x4b5e2b[_0x13937b(0x241)+'\x49\x44'];return _0x545ae1&&_0x3f0563[_0x545ae1];},_0x7092a['\x68\x74\x6d\x6c\x49\x6e\x69\x74'](_0xade157,_0x18ad1b(0x2fd)),_0xe790c4&&_0xe790c4[_0x18ad1b(0x45f)]&&_0xe790c4[_0x18ad1b(0x45f)](_0x18ad1b(0x2fd),_0xade157),_0xade157[_0x18ad1b(0x2b0)]=function(_0x1de6ba){_0xe790c4=_0x1de6ba;},_0xade157['\x43\x65\x6c\x6c']=_0x2349a9,_0xade157[_0x18ad1b(0x427)]=_0x4b6431,_0xade157;}),function(_0xf0a1e7,_0x52a16d){var _0x44e09f=_0x119b77;'\x66\x75\x6e\x63\x74\x69\x6f\x6e'==typeof define&&define[_0x44e09f(0x1f2)]?define(_0x44e09f(0x432)+'\x2f\x75\x6e\x69\x70\x6f\x69\x6e\x74\x65'+'\x72',['\x65\x76\x2d\x65\x6d\x69\x74\x74\x65\x72'+_0x44e09f(0x45c)+'\x72'],function(_0x425f5f){return _0x52a16d(_0xf0a1e7,_0x425f5f);}):_0x44e09f(0x358)==typeof module&&module[_0x44e09f(0x4b6)]?module[_0x44e09f(0x4b6)]=_0x52a16d(_0xf0a1e7,require(_0x44e09f(0x46c))):_0xf0a1e7[_0x44e09f(0x450)]=_0x52a16d(_0xf0a1e7,_0xf0a1e7['\x45\x76\x45\x6d\x69\x74\x74\x65\x72']);}(window,function(_0x504498,_0x327815){var _0x24db62=_0x119b77;function _0x105e33(){}var _0xc3ff81=_0x105e33[_0x24db62(0x153)]=Object[_0x24db62(0x1fd)](_0x327815[_0x24db62(0x153)]);_0xc3ff81['\x62\x69\x6e\x64\x53\x74\x61\x72\x74\x45'+_0x24db62(0x33a)]=function(_0x43b208){var _0x24e32a=_0x24db62;this['\x5f\x62\x69\x6e\x64\x53\x74\x61\x72\x74'+_0x24e32a(0x42c)](_0x43b208,!0x0);},_0xc3ff81[_0x24db62(0x245)+_0x24db62(0x3bb)]=function(_0x28eae2){var _0x16591a=_0x24db62;this[_0x16591a(0x48d)+'\x45\x76\x65\x6e\x74'](_0x28eae2,!0x1);},_0xc3ff81['\x5f\x62\x69\x6e\x64\x53\x74\x61\x72\x74'+_0x24db62(0x42c)]=function(_0x3e8b3f,_0x527d3a){var _0x13476f=_0x24db62,_0x2d6175=(_0x527d3a=void 0x0===_0x527d3a||_0x527d3a)?_0x13476f(0x29a)+_0x13476f(0x1bd):'\x72\x65\x6d\x6f\x76\x65\x45\x76\x65\x6e'+_0x13476f(0x1c2),_0x2e7e31=_0x13476f(0x392);_0x504498[_0x13476f(0x340)+'\x6e\x74']?_0x2e7e31='\x70\x6f\x69\x6e\x74\x65\x72\x64\x6f\x77'+'\x6e':_0x13476f(0x48c)+'\x72\x74'in _0x504498&&(_0x2e7e31=_0x13476f(0x2b3)),_0x3e8b3f[_0x2d6175](_0x2e7e31,this);},_0xc3ff81[_0x24db62(0x433)+'\x74']=function(_0x405c4e){var _0x2cc9be='\x6f\x6e'+_0x405c4e['\x74\x79\x70\x65'];this[_0x2cc9be]&&this[_0x2cc9be](_0x405c4e);},_0xc3ff81[_0x24db62(0x280)]=function(_0x3be10e){var _0x461dcd=_0x24db62;for(var _0x14be63=0x0;_0x14be63<_0x3be10e[_0x461dcd(0x1f9)];_0x14be63++){var _0x8924e7=_0x3be10e[_0x14be63];if(_0x8924e7['\x69\x64\x65\x6e\x74\x69\x66\x69\x65\x72']==this['\x70\x6f\x69\x6e\x74\x65\x72\x49\x64\x65'+'\x6e\x74\x69\x66\x69\x65\x72'])return _0x8924e7;}},_0xc3ff81[_0x24db62(0x1ab)+'\x6e']=function(_0x5d4188){var _0xabd9f4=_0x24db62,_0xbd5fb=_0x5d4188[_0xabd9f4(0x2b9)];_0xbd5fb&&0x0!==_0xbd5fb&&0x1!==_0xbd5fb||this[_0xabd9f4(0x3bd)+'\x77\x6e'](_0x5d4188,_0x5d4188);},_0xc3ff81[_0x24db62(0x48c)+'\x72\x74']=function(_0x176dd){var _0x2ad0b2=_0x24db62;this[_0x2ad0b2(0x3bd)+'\x77\x6e'](_0x176dd,_0x176dd['\x63\x68\x61\x6e\x67\x65\x64\x54\x6f\x75'+'\x63\x68\x65\x73'][0x0]);},_0xc3ff81[_0x24db62(0x379)+_0x24db62(0x209)]=function(_0x45d98c){this['\x5f\x70\x6f\x69\x6e\x74\x65\x72\x44\x6f'+'\x77\x6e'](_0x45d98c,_0x45d98c);},_0xc3ff81[_0x24db62(0x3bd)+'\x77\x6e']=function(_0x3c3323,_0x13d9a3){var _0xadf723=_0x24db62;_0x3c3323['\x62\x75\x74\x74\x6f\x6e']||this[_0xadf723(0x218)+_0xadf723(0x209)]||(this['\x69\x73\x50\x6f\x69\x6e\x74\x65\x72\x44'+_0xadf723(0x209)]=!0x0,this[_0xadf723(0x3e8)+_0xadf723(0x149)]=void 0x0!==_0x13d9a3[_0xadf723(0x4a1)]?_0x13d9a3['\x70\x6f\x69\x6e\x74\x65\x72\x49\x64']:_0x13d9a3[_0xadf723(0x328)],this['\x70\x6f\x69\x6e\x74\x65\x72\x44\x6f\x77'+'\x6e'](_0x3c3323,_0x13d9a3));},_0xc3ff81[_0x24db62(0x186)+'\x6e']=function(_0x48b664,_0x4fac1e){var _0x2d667a=_0x24db62;this[_0x2d667a(0x2d2)+_0x2d667a(0x228)](_0x48b664),this[_0x2d667a(0x3af)](_0x2d667a(0x186)+'\x6e',[_0x48b664,_0x4fac1e]);};var _0xa85886={'\x6d\x6f\x75\x73\x65\x64\x6f\x77\x6e':[_0x24db62(0x3bf),_0x24db62(0x2c8)],'\x74\x6f\x75\x63\x68\x73\x74\x61\x72\x74':['\x74\x6f\x75\x63\x68\x6d\x6f\x76\x65',_0x24db62(0x37a),_0x24db62(0x1f0)+'\x6c'],'\x70\x6f\x69\x6e\x74\x65\x72\x64\x6f\x77\x6e':['\x70\x6f\x69\x6e\x74\x65\x72\x6d\x6f\x76'+'\x65',_0x24db62(0x237),_0x24db62(0x1a8)+_0x24db62(0x1a2)]};return _0xc3ff81['\x5f\x62\x69\x6e\x64\x50\x6f\x73\x74\x53'+_0x24db62(0x228)]=function(_0x556e2d){var _0x5d02b7=_0x24db62;if(_0x556e2d){var _0x36ec32=_0xa85886[_0x556e2d['\x74\x79\x70\x65']];_0x36ec32[_0x5d02b7(0x1c0)](function(_0x4a931d){var _0x23b540=_0x5d02b7;_0x504498[_0x23b540(0x29a)+_0x23b540(0x1bd)](_0x4a931d,this);},this),this[_0x5d02b7(0x380)+'\x74\x65\x72\x45\x76\x65\x6e\x74\x73']=_0x36ec32;}},_0xc3ff81['\x5f\x75\x6e\x62\x69\x6e\x64\x50\x6f\x73'+'\x74\x53\x74\x61\x72\x74\x45\x76\x65\x6e'+'\x74\x73']=function(){var _0x50bf86=_0x24db62;this[_0x50bf86(0x380)+_0x50bf86(0x28a)]&&(this[_0x50bf86(0x380)+_0x50bf86(0x28a)][_0x50bf86(0x1c0)](function(_0x25f5d3){var _0x44ad1f=_0x50bf86;_0x504498[_0x44ad1f(0x271)+'\x74\x4c\x69\x73\x74\x65\x6e\x65\x72'](_0x25f5d3,this);},this),delete this['\x5f\x62\x6f\x75\x6e\x64\x50\x6f\x69\x6e'+'\x74\x65\x72\x45\x76\x65\x6e\x74\x73']);},_0xc3ff81[_0x24db62(0x15a)+'\x65']=function(_0xcd5795){var _0x450066=_0x24db62;this[_0x450066(0x167)+'\x76\x65'](_0xcd5795,_0xcd5795);},_0xc3ff81[_0x24db62(0x2f1)+_0x24db62(0x211)]=function(_0x3622be){var _0x34cca8=_0x24db62;_0x3622be[_0x34cca8(0x4a1)]==this['\x70\x6f\x69\x6e\x74\x65\x72\x49\x64\x65'+_0x34cca8(0x149)]&&this[_0x34cca8(0x167)+'\x76\x65'](_0x3622be,_0x3622be);},_0xc3ff81['\x6f\x6e\x74\x6f\x75\x63\x68\x6d\x6f\x76'+'\x65']=function(_0x36a9ad){var _0x1459cd=_0x24db62,_0x6a692b=this['\x67\x65\x74\x54\x6f\x75\x63\x68'](_0x36a9ad[_0x1459cd(0x3f0)+_0x1459cd(0x144)]);_0x6a692b&&this[_0x1459cd(0x167)+'\x76\x65'](_0x36a9ad,_0x6a692b);},_0xc3ff81[_0x24db62(0x167)+'\x76\x65']=function(_0x4dfba6,_0x489c46){var _0x479f1f=_0x24db62;this[_0x479f1f(0x2f6)+'\x65'](_0x4dfba6,_0x489c46);},_0xc3ff81[_0x24db62(0x2f6)+'\x65']=function(_0x50931e,_0x241105){var _0x409e6c=_0x24db62;this['\x65\x6d\x69\x74\x45\x76\x65\x6e\x74'](_0x409e6c(0x2f6)+'\x65',[_0x50931e,_0x241105]);},_0xc3ff81[_0x24db62(0x29c)]=function(_0x36a37c){this['\x5f\x70\x6f\x69\x6e\x74\x65\x72\x55\x70'](_0x36a37c,_0x36a37c);},_0xc3ff81[_0x24db62(0x3dd)+'\x70']=function(_0x434ac8){var _0xd27d46=_0x24db62;_0x434ac8['\x70\x6f\x69\x6e\x74\x65\x72\x49\x64']==this[_0xd27d46(0x3e8)+'\x6e\x74\x69\x66\x69\x65\x72']&&this[_0xd27d46(0x3b2)](_0x434ac8,_0x434ac8);},_0xc3ff81[_0x24db62(0x494)]=function(_0x221cfb){var _0x33e9d2=_0x24db62,_0x9b7082=this[_0x33e9d2(0x280)](_0x221cfb[_0x33e9d2(0x3f0)+'\x63\x68\x65\x73']);_0x9b7082&&this[_0x33e9d2(0x3b2)](_0x221cfb,_0x9b7082);},_0xc3ff81[_0x24db62(0x3b2)]=function(_0x53675a,_0x49fc09){var _0x4dab8e=_0x24db62;this['\x5f\x70\x6f\x69\x6e\x74\x65\x72\x44\x6f'+'\x6e\x65'](),this[_0x4dab8e(0x368)](_0x53675a,_0x49fc09);},_0xc3ff81['\x70\x6f\x69\x6e\x74\x65\x72\x55\x70']=function(_0x3c3d23,_0x27ef27){var _0x17ef2a=_0x24db62;this[_0x17ef2a(0x3af)](_0x17ef2a(0x368),[_0x3c3d23,_0x27ef27]);},_0xc3ff81[_0x24db62(0x3bd)+'\x6e\x65']=function(){var _0x28da36=_0x24db62;this['\x5f\x70\x6f\x69\x6e\x74\x65\x72\x52\x65'+_0x28da36(0x213)](),this[_0x28da36(0x1fe)+_0x28da36(0x346)+'\x74\x73'](),this[_0x28da36(0x17c)+'\x65']();},_0xc3ff81[_0x24db62(0x192)+'\x73\x65\x74']=function(){var _0x88a757=_0x24db62;this[_0x88a757(0x218)+_0x88a757(0x209)]=!0x1,delete this[_0x88a757(0x3e8)+_0x88a757(0x149)];},_0xc3ff81['\x70\x6f\x69\x6e\x74\x65\x72\x44\x6f\x6e'+'\x65']=function(){},_0xc3ff81[_0x24db62(0x310)+_0x24db62(0x1a4)]=function(_0x4c4299){var _0x240f2a=_0x24db62;_0x4c4299[_0x240f2a(0x4a1)]==this[_0x240f2a(0x3e8)+_0x240f2a(0x149)]&&this['\x5f\x70\x6f\x69\x6e\x74\x65\x72\x43\x61'+_0x240f2a(0x2b1)](_0x4c4299,_0x4c4299);},_0xc3ff81['\x6f\x6e\x74\x6f\x75\x63\x68\x63\x61\x6e'+'\x63\x65\x6c']=function(_0x33cd47){var _0x4cb96a=_0x24db62,_0x5f29fd=this[_0x4cb96a(0x280)](_0x33cd47['\x63\x68\x61\x6e\x67\x65\x64\x54\x6f\x75'+_0x4cb96a(0x144)]);_0x5f29fd&&this[_0x4cb96a(0x1d9)+_0x4cb96a(0x2b1)](_0x33cd47,_0x5f29fd);},_0xc3ff81[_0x24db62(0x1d9)+_0x24db62(0x2b1)]=function(_0x1f465,_0x486b7a){var _0x3bbd3b=_0x24db62;this[_0x3bbd3b(0x3bd)+'\x6e\x65'](),this[_0x3bbd3b(0x4b3)+_0x3bbd3b(0x1a2)](_0x1f465,_0x486b7a);},_0xc3ff81[_0x24db62(0x4b3)+_0x24db62(0x1a2)]=function(_0x4c041d,_0x2bd6ab){var _0x6d728b=_0x24db62;this[_0x6d728b(0x3af)](_0x6d728b(0x4b3)+_0x6d728b(0x1a2),[_0x4c041d,_0x2bd6ab]);},_0x105e33['\x67\x65\x74\x50\x6f\x69\x6e\x74\x65\x72'+_0x24db62(0x156)]=function(_0x518301){var _0x14a5ca=_0x24db62;return{'\x78':_0x518301['\x70\x61\x67\x65\x58'],'\x79':_0x518301[_0x14a5ca(0x195)]};},_0x105e33;}),function(_0x24c036,_0x54b821){var _0x3ab45c=_0x119b77;_0x3ab45c(0x2dd)==typeof define&&define[_0x3ab45c(0x1f2)]?define(_0x3ab45c(0x20d)+_0x3ab45c(0x43c)+'\x72',[_0x3ab45c(0x432)+_0x3ab45c(0x1bc)+'\x72'],function(_0x292f3b){return _0x54b821(_0x24c036,_0x292f3b);}):_0x3ab45c(0x358)==typeof module&&module[_0x3ab45c(0x4b6)]?module[_0x3ab45c(0x4b6)]=_0x54b821(_0x24c036,require('\x75\x6e\x69\x70\x6f\x69\x6e\x74\x65\x72')):_0x24c036['\x55\x6e\x69\x64\x72\x61\x67\x67\x65\x72']=_0x54b821(_0x24c036,_0x24c036[_0x3ab45c(0x450)]);}(window,function(_0x3ac5a3,_0x4827b3){var _0xc6e228=_0x119b77;function _0x691f46(){}var _0x2ba1b3=_0x691f46[_0xc6e228(0x153)]=Object['\x63\x72\x65\x61\x74\x65'](_0x4827b3[_0xc6e228(0x153)]);_0x2ba1b3[_0xc6e228(0x3ec)+'\x73']=function(){var _0x5003a0=_0xc6e228;this[_0x5003a0(0x38d)+'\x65\x73'](!0x0);},_0x2ba1b3['\x75\x6e\x62\x69\x6e\x64\x48\x61\x6e\x64'+_0xc6e228(0x3c0)]=function(){var _0x3ca08b=_0xc6e228;this[_0x3ca08b(0x38d)+'\x65\x73'](!0x1);},_0x2ba1b3[_0xc6e228(0x38d)+'\x65\x73']=function(_0x333226){var _0x59b702=_0xc6e228;for(var _0x59c765=(_0x333226=void 0x0===_0x333226||_0x333226)?'\x61\x64\x64\x45\x76\x65\x6e\x74\x4c\x69'+'\x73\x74\x65\x6e\x65\x72':_0x59b702(0x271)+_0x59b702(0x1c2),_0xb20ed2=_0x333226?this['\x5f\x74\x6f\x75\x63\x68\x41\x63\x74\x69'+_0x59b702(0x1a6)]:'',_0x5a356f=0x0;_0x5a356f<this[_0x59b702(0x1a1)][_0x59b702(0x1f9)];_0x5a356f++){var _0x801f5d=this[_0x59b702(0x1a1)][_0x5a356f];this[_0x59b702(0x48d)+_0x59b702(0x42c)](_0x801f5d,_0x333226),_0x801f5d[_0x59c765](_0x59b702(0x303),this),_0x3ac5a3[_0x59b702(0x340)+'\x6e\x74']&&(_0x801f5d[_0x59b702(0x292)][_0x59b702(0x327)+'\x6e']=_0xb20ed2);}},_0x2ba1b3[_0xc6e228(0x174)+'\x6f\x6e\x56\x61\x6c\x75\x65']='\x6e\x6f\x6e\x65',_0x2ba1b3[_0xc6e228(0x186)+'\x6e']=function(_0x373ab3,_0x31b9de){var _0x3c86f2=_0xc6e228;this[_0x3c86f2(0x313)+_0x3c86f2(0x326)](_0x373ab3)&&(this[_0x3c86f2(0x186)+_0x3c86f2(0x421)]={'\x70\x61\x67\x65\x58':_0x31b9de[_0x3c86f2(0x402)],'\x70\x61\x67\x65\x59':_0x31b9de[_0x3c86f2(0x195)]},_0x373ab3[_0x3c86f2(0x18f)+_0x3c86f2(0x3f3)](),this[_0x3c86f2(0x186)+_0x3c86f2(0x2b7)](),this[_0x3c86f2(0x2d2)+'\x74\x61\x72\x74\x45\x76\x65\x6e\x74\x73'](_0x373ab3),this[_0x3c86f2(0x3af)]('\x70\x6f\x69\x6e\x74\x65\x72\x44\x6f\x77'+'\x6e',[_0x373ab3,_0x31b9de]));};var _0x168976={'\x54\x45\x58\x54\x41\x52\x45\x41':!0x0,'\x49\x4e\x50\x55\x54':!0x0,'\x53\x45\x4c\x45\x43\x54':!0x0,'\x4f\x50\x54\x49\x4f\x4e':!0x0},_0x5d4d73={'\x72\x61\x64\x69\x6f':!0x0,'\x63\x68\x65\x63\x6b\x62\x6f\x78':!0x0,'\x62\x75\x74\x74\x6f\x6e':!0x0,'\x73\x75\x62\x6d\x69\x74':!0x0,'\x69\x6d\x61\x67\x65':!0x0,'\x66\x69\x6c\x65':!0x0};return _0x2ba1b3['\x6f\x6b\x61\x79\x50\x6f\x69\x6e\x74\x65'+'\x72\x44\x6f\x77\x6e']=function(_0xe3165b){var _0x2f736a=_0xc6e228,_0x22aa89=_0x168976[_0xe3165b[_0x2f736a(0x170)][_0x2f736a(0x3c4)]],_0x2eb9fb=_0x5d4d73[_0xe3165b[_0x2f736a(0x170)][_0x2f736a(0x32b)]],_0x38c220=!_0x22aa89||_0x2eb9fb;return _0x38c220||this['\x5f\x70\x6f\x69\x6e\x74\x65\x72\x52\x65'+_0x2f736a(0x213)](),_0x38c220;},_0x2ba1b3[_0xc6e228(0x186)+_0xc6e228(0x2b7)]=function(){var _0x36fda1=_0xc6e228,_0x80fd66=document[_0x36fda1(0x353)+_0x36fda1(0x411)];_0x80fd66&&_0x80fd66['\x62\x6c\x75\x72']&&_0x80fd66!=document['\x62\x6f\x64\x79']&&_0x80fd66[_0x36fda1(0x194)]();},_0x2ba1b3[_0xc6e228(0x2f6)+'\x65']=function(_0x123ee6,_0xa8865){var _0x506667=_0xc6e228,_0x5a1312=this['\x5f\x64\x72\x61\x67\x50\x6f\x69\x6e\x74'+'\x65\x72\x4d\x6f\x76\x65'](_0x123ee6,_0xa8865);this[_0x506667(0x3af)](_0x506667(0x2f6)+'\x65',[_0x123ee6,_0xa8865,_0x5a1312]),this[_0x506667(0x462)](_0x123ee6,_0xa8865,_0x5a1312);},_0x2ba1b3[_0xc6e228(0x2b4)+_0xc6e228(0x14f)]=function(_0xc44760,_0x145123){var _0x57adef=_0xc6e228,_0x5c7224={'\x78':_0x145123[_0x57adef(0x402)]-this[_0x57adef(0x186)+_0x57adef(0x421)][_0x57adef(0x402)],'\x79':_0x145123[_0x57adef(0x195)]-this[_0x57adef(0x186)+_0x57adef(0x421)][_0x57adef(0x195)]};return!this[_0x57adef(0x290)]&&this[_0x57adef(0x199)+_0x57adef(0x43f)](_0x5c7224)&&this[_0x57adef(0x43e)](_0xc44760,_0x145123),_0x5c7224;},_0x2ba1b3[_0xc6e228(0x199)+_0xc6e228(0x43f)]=function(_0x9b5d1e){var _0xc45b2f=_0xc6e228;return Math[_0xc45b2f(0x175)](_0x9b5d1e['\x78'])>0x3||Math['\x61\x62\x73'](_0x9b5d1e['\x79'])>0x3;},_0x2ba1b3['\x70\x6f\x69\x6e\x74\x65\x72\x55\x70']=function(_0x217ecc,_0x5c9feb){var _0x4a2826=_0xc6e228;this[_0x4a2826(0x3af)](_0x4a2826(0x368),[_0x217ecc,_0x5c9feb]),this[_0x4a2826(0x2b4)+_0x4a2826(0x1c5)](_0x217ecc,_0x5c9feb);},_0x2ba1b3[_0xc6e228(0x2b4)+'\x65\x72\x55\x70']=function(_0x18f07d,_0x3733d3){var _0x5cb3c7=_0xc6e228;this[_0x5cb3c7(0x290)]?this['\x5f\x64\x72\x61\x67\x45\x6e\x64'](_0x18f07d,_0x3733d3):this['\x5f\x73\x74\x61\x74\x69\x63\x43\x6c\x69'+'\x63\x6b'](_0x18f07d,_0x3733d3);},_0x2ba1b3[_0xc6e228(0x43e)]=function(_0x7a2ad7,_0x20b1a6){var _0xf2fed3=_0xc6e228;this[_0xf2fed3(0x290)]=!0x0,this[_0xf2fed3(0x499)+_0xf2fed3(0x3cc)]=!0x0,this[_0xf2fed3(0x253)](_0x7a2ad7,_0x20b1a6);},_0x2ba1b3[_0xc6e228(0x253)]=function(_0x1dc83d,_0x4f4bb0){var _0x4d342d=_0xc6e228;this[_0x4d342d(0x3af)](_0x4d342d(0x253),[_0x1dc83d,_0x4f4bb0]);},_0x2ba1b3[_0xc6e228(0x462)]=function(_0x302d10,_0x402a4f,_0x345c96){var _0x2e36a7=_0xc6e228;this[_0x2e36a7(0x290)]&&this['\x64\x72\x61\x67\x4d\x6f\x76\x65'](_0x302d10,_0x402a4f,_0x345c96);},_0x2ba1b3[_0xc6e228(0x2df)]=function(_0x1a69af,_0x293465,_0xb3f5a2){var _0x398b18=_0xc6e228;_0x1a69af[_0x398b18(0x18f)+_0x398b18(0x3f3)](),this[_0x398b18(0x3af)](_0x398b18(0x2df),[_0x1a69af,_0x293465,_0xb3f5a2]);},_0x2ba1b3['\x5f\x64\x72\x61\x67\x45\x6e\x64']=function(_0x396b11,_0x17da73){var _0x2ef36d=_0xc6e228;this[_0x2ef36d(0x290)]=!0x1,setTimeout(function(){var _0x1bc89a=_0x2ef36d;delete this[_0x1bc89a(0x499)+'\x6e\x67\x43\x6c\x69\x63\x6b\x73'];}['\x62\x69\x6e\x64'](this)),this['\x64\x72\x61\x67\x45\x6e\x64'](_0x396b11,_0x17da73);},_0x2ba1b3[_0xc6e228(0x232)]=function(_0x2c6a56,_0x1a97ac){var _0x14a0a1=_0xc6e228;this[_0x14a0a1(0x3af)]('\x64\x72\x61\x67\x45\x6e\x64',[_0x2c6a56,_0x1a97ac]);},_0x2ba1b3[_0xc6e228(0x147)]=function(_0x290084){var _0x31709a=_0xc6e228;this[_0x31709a(0x499)+_0x31709a(0x3cc)]&&_0x290084[_0x31709a(0x18f)+_0x31709a(0x3f3)]();},_0x2ba1b3[_0xc6e228(0x487)+'\x63\x6b']=function(_0x55941a,_0x5aecb5){var _0xe0a0ff=_0xc6e228;this[_0xe0a0ff(0x323)+_0xe0a0ff(0x3ba)]&&_0xe0a0ff(0x2c8)==_0x55941a[_0xe0a0ff(0x32b)]||(this[_0xe0a0ff(0x2d3)+'\x6b'](_0x55941a,_0x5aecb5),_0xe0a0ff(0x2c8)!=_0x55941a[_0xe0a0ff(0x32b)]&&(this[_0xe0a0ff(0x323)+_0xe0a0ff(0x3ba)]=!0x0,setTimeout(function(){var _0x5cb727=_0xe0a0ff;delete this['\x69\x73\x49\x67\x6e\x6f\x72\x69\x6e\x67'+_0x5cb727(0x3ba)];}[_0xe0a0ff(0x347)](this),0x190)));},_0x2ba1b3['\x73\x74\x61\x74\x69\x63\x43\x6c\x69\x63'+'\x6b']=function(_0x3a1b32,_0xd393e9){var _0x3121ad=_0xc6e228;this['\x65\x6d\x69\x74\x45\x76\x65\x6e\x74'](_0x3121ad(0x2d3)+'\x6b',[_0x3a1b32,_0xd393e9]);},_0x691f46[_0xc6e228(0x45d)+_0xc6e228(0x156)]=_0x4827b3[_0xc6e228(0x45d)+_0xc6e228(0x156)],_0x691f46;}),function(_0x148f96,_0x4705ee){var _0x22ba29=_0x119b77;'\x66\x75\x6e\x63\x74\x69\x6f\x6e'==typeof define&&define['\x61\x6d\x64']?define(_0x22ba29(0x47b)+'\x73\x2f\x64\x72\x61\x67',[_0x22ba29(0x31c),_0x22ba29(0x20d)+_0x22ba29(0x43c)+'\x72',_0x22ba29(0x428)+_0x22ba29(0x34f)],function(_0x442d79,_0x19e608,_0xa607b5){return _0x4705ee(_0x148f96,_0x442d79,_0x19e608,_0xa607b5);}):_0x22ba29(0x358)==typeof module&&module[_0x22ba29(0x4b6)]?module[_0x22ba29(0x4b6)]=_0x4705ee(_0x148f96,require(_0x22ba29(0x31c)),require('\x75\x6e\x69\x64\x72\x61\x67\x67\x65\x72'),require(_0x22ba29(0x428)+_0x22ba29(0x311))):_0x148f96['\x46\x6c\x69\x63\x6b\x69\x74\x79']=_0x4705ee(_0x148f96,_0x148f96[_0x22ba29(0x1c9)],_0x148f96[_0x22ba29(0x41f)],_0x148f96[_0x22ba29(0x2a9)+'\x6c\x73']);}(window,function(_0x5f3843,_0x3ae973,_0x4527f4,_0x70ac88){var _0x41aa48=_0x119b77;_0x70ac88[_0x41aa48(0x3cb)](_0x3ae973[_0x41aa48(0x2da)],{'\x64\x72\x61\x67\x67\x61\x62\x6c\x65':'\x3e\x31','\x64\x72\x61\x67\x54\x68\x72\x65\x73\x68\x6f\x6c\x64':0x3}),_0x3ae973[_0x41aa48(0x20e)+_0x41aa48(0x1e3)][_0x41aa48(0x43b)](_0x41aa48(0x2fe)+'\x67');var _0x3d0041=_0x3ae973[_0x41aa48(0x153)];_0x70ac88[_0x41aa48(0x3cb)](_0x3d0041,_0x4527f4[_0x41aa48(0x153)]),_0x3d0041[_0x41aa48(0x174)+_0x41aa48(0x1a6)]=_0x41aa48(0x2ce);var _0x5afb53=_0x41aa48(0x355)+'\x68'in document,_0x37d3d0=!0x1;_0x3d0041[_0x41aa48(0x2fe)+'\x67']=function(){var _0x42c2df=_0x41aa48;this['\x6f\x6e']('\x61\x63\x74\x69\x76\x61\x74\x65',this[_0x42c2df(0x4af)+'\x44\x72\x61\x67']),this['\x6f\x6e'](_0x42c2df(0x274),this[_0x42c2df(0x440)+_0x42c2df(0x46a)]),this['\x6f\x6e']('\x64\x65\x61\x63\x74\x69\x76\x61\x74\x65',this[_0x42c2df(0x1fc)+_0x42c2df(0x2d7)]),this['\x6f\x6e'](_0x42c2df(0x4a4),this[_0x42c2df(0x41e)+_0x42c2df(0x2a2)]),_0x5afb53&&!_0x37d3d0&&(_0x5f3843[_0x42c2df(0x29a)+_0x42c2df(0x1bd)](_0x42c2df(0x25c),function(){}),_0x37d3d0=!0x0);},_0x3d0041[_0x41aa48(0x4af)+'\x44\x72\x61\x67']=function(){var _0x17fc6b=_0x41aa48;this[_0x17fc6b(0x1a1)]=[this[_0x17fc6b(0x3e5)]],this['\x62\x69\x6e\x64\x48\x61\x6e\x64\x6c\x65'+'\x73'](),this['\x75\x70\x64\x61\x74\x65\x44\x72\x61\x67'+_0x17fc6b(0x2a2)]();},_0x3d0041[_0x41aa48(0x1fc)+_0x41aa48(0x2d7)]=function(){var _0x43221c=_0x41aa48;this[_0x43221c(0x329)+_0x43221c(0x3c0)](),this['\x65\x6c\x65\x6d\x65\x6e\x74']['\x63\x6c\x61\x73\x73\x4c\x69\x73\x74']['\x72\x65\x6d\x6f\x76\x65'](_0x43221c(0x40e)+'\x6c\x65');},_0x3d0041[_0x41aa48(0x41e)+_0x41aa48(0x2a2)]=function(){var _0x3fd602=_0x41aa48;'\x3e\x31'==this[_0x3fd602(0x2ab)][_0x3fd602(0x4b4)]?this['\x69\x73\x44\x72\x61\x67\x67\x61\x62\x6c'+'\x65']=this[_0x3fd602(0x3d6)][_0x3fd602(0x1f9)]>0x1:this[_0x3fd602(0x2ee)+'\x65']=this[_0x3fd602(0x2ab)][_0x3fd602(0x4b4)],this[_0x3fd602(0x2ee)+'\x65']?this['\x65\x6c\x65\x6d\x65\x6e\x74'][_0x3fd602(0x35f)]['\x61\x64\x64']('\x69\x73\x2d\x64\x72\x61\x67\x67\x61\x62'+'\x6c\x65'):this['\x65\x6c\x65\x6d\x65\x6e\x74']['\x63\x6c\x61\x73\x73\x4c\x69\x73\x74'][_0x3fd602(0x429)]('\x69\x73\x2d\x64\x72\x61\x67\x67\x61\x62'+'\x6c\x65');},_0x3d0041['\x62\x69\x6e\x64\x44\x72\x61\x67']=function(){var _0x41933d=_0x41aa48;this[_0x41933d(0x2ab)]['\x64\x72\x61\x67\x67\x61\x62\x6c\x65']=!0x0,this[_0x41933d(0x41e)+'\x67\x61\x62\x6c\x65']();},_0x3d0041[_0x41aa48(0x27d)]=function(){var _0x52b911=_0x41aa48;this[_0x52b911(0x2ab)][_0x52b911(0x4b4)]=!0x1,this[_0x52b911(0x41e)+_0x52b911(0x2a2)]();},_0x3d0041[_0x41aa48(0x440)+_0x41aa48(0x46a)]=function(){var _0x2302c7=_0x41aa48;delete this['\x69\x73\x46\x72\x65\x65\x53\x63\x72\x6f'+_0x2302c7(0x2ea)];},_0x3d0041['\x70\x6f\x69\x6e\x74\x65\x72\x44\x6f\x77'+'\x6e']=function(_0xadb587,_0x580b1e){var _0xa2b2cf=_0x41aa48;this[_0xa2b2cf(0x2ee)+'\x65']?this[_0xa2b2cf(0x313)+_0xa2b2cf(0x326)](_0xadb587)&&(this[_0xa2b2cf(0x3bd)+_0xa2b2cf(0x1bb)+_0xa2b2cf(0x414)](_0xadb587),this[_0xa2b2cf(0x186)+'\x6e\x46\x6f\x63\x75\x73'](_0xadb587),document['\x61\x63\x74\x69\x76\x65\x45\x6c\x65\x6d'+_0xa2b2cf(0x411)]!=this['\x65\x6c\x65\x6d\x65\x6e\x74']&&this[_0xa2b2cf(0x186)+_0xa2b2cf(0x2b7)](),this[_0xa2b2cf(0x2bc)]=this['\x78'],this[_0xa2b2cf(0x3e5)]['\x63\x6c\x61\x73\x73\x4c\x69\x73\x74'][_0xa2b2cf(0x234)](_0xa2b2cf(0x416)+_0xa2b2cf(0x2c2)),this[_0xa2b2cf(0x186)+_0xa2b2cf(0x3dc)]=_0x374d2f(),_0x5f3843['\x61\x64\x64\x45\x76\x65\x6e\x74\x4c\x69'+_0xa2b2cf(0x1bd)](_0xa2b2cf(0x477),this),this[_0xa2b2cf(0x3bd)+_0xa2b2cf(0x262)](_0xadb587,_0x580b1e)):this[_0xa2b2cf(0x3bd)+_0xa2b2cf(0x262)](_0xadb587,_0x580b1e);},_0x3d0041[_0x41aa48(0x3bd)+_0x41aa48(0x262)]=function(_0x1ad10b,_0x4495e6){var _0x2b19a0=_0x41aa48;this['\x70\x6f\x69\x6e\x74\x65\x72\x44\x6f\x77'+_0x2b19a0(0x421)]={'\x70\x61\x67\x65\x58':_0x4495e6[_0x2b19a0(0x402)],'\x70\x61\x67\x65\x59':_0x4495e6[_0x2b19a0(0x195)]},this[_0x2b19a0(0x2d2)+_0x2b19a0(0x228)](_0x1ad10b),this[_0x2b19a0(0x3b9)+_0x2b19a0(0x411)](_0x2b19a0(0x186)+'\x6e',_0x1ad10b,[_0x4495e6]);};var _0xe097a={'\x49\x4e\x50\x55\x54':!0x0,'\x54\x45\x58\x54\x41\x52\x45\x41':!0x0,'\x53\x45\x4c\x45\x43\x54':!0x0};function _0x374d2f(){var _0x464699=_0x41aa48;return{'\x78':_0x5f3843['\x70\x61\x67\x65\x58\x4f\x66\x66\x73\x65'+'\x74'],'\x79':_0x5f3843[_0x464699(0x3d0)+'\x74']};}return _0x3d0041['\x70\x6f\x69\x6e\x74\x65\x72\x44\x6f\x77'+_0x41aa48(0x3cf)]=function(_0x2fe3a3){var _0x4fdcf0=_0x41aa48;_0xe097a[_0x2fe3a3[_0x4fdcf0(0x170)][_0x4fdcf0(0x3c4)]]||this[_0x4fdcf0(0x3c8)]();},_0x3d0041['\x5f\x70\x6f\x69\x6e\x74\x65\x72\x44\x6f'+_0x41aa48(0x1bb)+_0x41aa48(0x414)]=function(_0x3f80ec){var _0x109f2a=_0x41aa48,_0xa2472='\x74\x6f\x75\x63\x68\x73\x74\x61\x72\x74'==_0x3f80ec[_0x109f2a(0x32b)],_0x166471=_0x109f2a(0x436)==_0x3f80ec[_0x109f2a(0x489)+'\x65'],_0x3c8987=_0xe097a[_0x3f80ec[_0x109f2a(0x170)]['\x6e\x6f\x64\x65\x4e\x61\x6d\x65']];_0xa2472||_0x166471||_0x3c8987||_0x3f80ec[_0x109f2a(0x18f)+_0x109f2a(0x3f3)]();},_0x3d0041[_0x41aa48(0x199)+'\x72\x74\x65\x64']=function(_0x4e3611){var _0x104b12=_0x41aa48;return Math[_0x104b12(0x175)](_0x4e3611['\x78'])>this['\x6f\x70\x74\x69\x6f\x6e\x73'][_0x104b12(0x2c7)+_0x104b12(0x1f6)];},_0x3d0041[_0x41aa48(0x368)]=function(_0xc4d8d0,_0x4fc626){var _0xda0ab6=_0x41aa48;delete this['\x69\x73\x54\x6f\x75\x63\x68\x53\x63\x72'+_0xda0ab6(0x317)],this['\x76\x69\x65\x77\x70\x6f\x72\x74'][_0xda0ab6(0x35f)][_0xda0ab6(0x429)](_0xda0ab6(0x416)+_0xda0ab6(0x2c2)),this[_0xda0ab6(0x3b9)+'\x65\x6e\x74'](_0xda0ab6(0x368),_0xc4d8d0,[_0x4fc626]),this['\x5f\x64\x72\x61\x67\x50\x6f\x69\x6e\x74'+_0xda0ab6(0x1c5)](_0xc4d8d0,_0x4fc626);},_0x3d0041[_0x41aa48(0x17c)+'\x65']=function(){var _0x3bc9f6=_0x41aa48;_0x5f3843[_0x3bc9f6(0x271)+_0x3bc9f6(0x1c2)]('\x73\x63\x72\x6f\x6c\x6c',this),delete this['\x70\x6f\x69\x6e\x74\x65\x72\x44\x6f\x77'+'\x6e\x53\x63\x72\x6f\x6c\x6c'];},_0x3d0041[_0x41aa48(0x253)]=function(_0x5dce33,_0x41ed73){var _0x294734=_0x41aa48;this[_0x294734(0x2ee)+'\x65']&&(this[_0x294734(0x3a2)+_0x294734(0x17f)]=this['\x78'],this[_0x294734(0x367)+_0x294734(0x341)](),_0x5f3843[_0x294734(0x271)+'\x74\x4c\x69\x73\x74\x65\x6e\x65\x72'](_0x294734(0x477),this),this[_0x294734(0x3b9)+'\x65\x6e\x74'](_0x294734(0x253),_0x5dce33,[_0x41ed73]));},_0x3d0041[_0x41aa48(0x2f6)+'\x65']=function(_0x2e37da,_0x1a5b7f){var _0xcad5eb=_0x41aa48,_0x21dd79=this['\x5f\x64\x72\x61\x67\x50\x6f\x69\x6e\x74'+_0xcad5eb(0x14f)](_0x2e37da,_0x1a5b7f);this[_0xcad5eb(0x3b9)+'\x65\x6e\x74']('\x70\x6f\x69\x6e\x74\x65\x72\x4d\x6f\x76'+'\x65',_0x2e37da,[_0x1a5b7f,_0x21dd79]),this[_0xcad5eb(0x462)](_0x2e37da,_0x1a5b7f,_0x21dd79);},_0x3d0041[_0x41aa48(0x2df)]=function(_0x4f3a51,_0xe0c117,_0x4f3548){var _0x51957b=_0x41aa48;if(this['\x69\x73\x44\x72\x61\x67\x67\x61\x62\x6c'+'\x65']){_0x4f3a51[_0x51957b(0x18f)+_0x51957b(0x3f3)](),this[_0x51957b(0x2e0)+_0x51957b(0x240)]=this['\x64\x72\x61\x67\x58'];var _0x56c744=this[_0x51957b(0x2ab)][_0x51957b(0x410)+'\x74']?-0x1:0x1;this[_0x51957b(0x2ab)]['\x77\x72\x61\x70\x41\x72\x6f\x75\x6e\x64']&&(_0x4f3548['\x78']%=this['\x73\x6c\x69\x64\x65\x61\x62\x6c\x65\x57'+'\x69\x64\x74\x68']);var _0xa40d00=this[_0x51957b(0x3a2)+_0x51957b(0x17f)]+_0x4f3548['\x78']*_0x56c744;if(!this[_0x51957b(0x2ab)][_0x51957b(0x25a)]&&this['\x73\x6c\x69\x64\x65\x73']['\x6c\x65\x6e\x67\x74\x68']){var _0x5408b8=Math['\x6d\x61\x78'](-this[_0x51957b(0x3d6)][0x0]['\x74\x61\x72\x67\x65\x74'],this['\x64\x72\x61\x67\x53\x74\x61\x72\x74\x50'+_0x51957b(0x17f)]);_0xa40d00=_0xa40d00>_0x5408b8?0.5*(_0xa40d00+_0x5408b8):_0xa40d00;var _0x2b9d4e=Math[_0x51957b(0x35e)](-this[_0x51957b(0x1ad)+'\x64\x65']()['\x74\x61\x72\x67\x65\x74'],this[_0x51957b(0x3a2)+'\x6f\x73\x69\x74\x69\x6f\x6e']);_0xa40d00=_0xa40d00<_0x2b9d4e?0.5*(_0xa40d00+_0x2b9d4e):_0xa40d00;}this[_0x51957b(0x2bc)]=_0xa40d00,this[_0x51957b(0x1dd)+'\x6d\x65']=new Date(),this[_0x51957b(0x3b9)+_0x51957b(0x411)](_0x51957b(0x2df),_0x4f3a51,[_0xe0c117,_0x4f3548]);}},_0x3d0041[_0x41aa48(0x232)]=function(_0x5ee120,_0xa38a8d){var _0x4bf028=_0x41aa48;if(this[_0x4bf028(0x2ee)+'\x65']){this['\x6f\x70\x74\x69\x6f\x6e\x73'][_0x4bf028(0x3f6)]&&(this[_0x4bf028(0x362)+_0x4bf028(0x2ea)]=!0x0);var _0x30f73a=this[_0x4bf028(0x2e2)+_0x4bf028(0x168)]();if(this[_0x4bf028(0x2ab)][_0x4bf028(0x3f6)]&&!this['\x6f\x70\x74\x69\x6f\x6e\x73'][_0x4bf028(0x25a)]){var _0x1a8cf7=this[_0x4bf028(0x498)+_0x4bf028(0x1b4)]();this[_0x4bf028(0x362)+'\x6c\x6c\x69\x6e\x67']=-_0x1a8cf7>this['\x73\x6c\x69\x64\x65\x73'][0x0]['\x74\x61\x72\x67\x65\x74']&&-_0x1a8cf7<this['\x67\x65\x74\x4c\x61\x73\x74\x53\x6c\x69'+'\x64\x65']()[_0x4bf028(0x170)];}else this[_0x4bf028(0x2ab)]['\x66\x72\x65\x65\x53\x63\x72\x6f\x6c\x6c']||_0x30f73a!=this[_0x4bf028(0x2bf)+_0x4bf028(0x3e0)]||(_0x30f73a+=this[_0x4bf028(0x4a2)+'\x73\x74\x53\x65\x6c\x65\x63\x74']());delete this[_0x4bf028(0x2e0)+'\x61\x67\x58'],this[_0x4bf028(0x4b5)+'\x63\x74']=this[_0x4bf028(0x2ab)][_0x4bf028(0x25a)],this['\x73\x65\x6c\x65\x63\x74'](_0x30f73a),delete this['\x69\x73\x44\x72\x61\x67\x53\x65\x6c\x65'+'\x63\x74'],this[_0x4bf028(0x3b9)+_0x4bf028(0x411)](_0x4bf028(0x232),_0x5ee120,[_0xa38a8d]);}},_0x3d0041['\x64\x72\x61\x67\x45\x6e\x64\x52\x65\x73'+_0x41aa48(0x168)]=function(){var _0x1df5de=_0x41aa48,_0x30e175=this[_0x1df5de(0x498)+_0x1df5de(0x1b4)](),_0x302c81=Math[_0x1df5de(0x175)](this['\x67\x65\x74\x53\x6c\x69\x64\x65\x44\x69'+'\x73\x74\x61\x6e\x63\x65'](-_0x30e175,this[_0x1df5de(0x2bf)+'\x64\x65\x78'])),_0xea8b7d=this[_0x1df5de(0x37b)+_0x1df5de(0x38f)](_0x30e175,_0x302c81,0x1),_0x591985=this['\x5f\x67\x65\x74\x43\x6c\x6f\x73\x65\x73'+_0x1df5de(0x38f)](_0x30e175,_0x302c81,-0x1);return _0xea8b7d[_0x1df5de(0x249)]<_0x591985[_0x1df5de(0x249)]?_0xea8b7d[_0x1df5de(0x1bf)]:_0x591985['\x69\x6e\x64\x65\x78'];},_0x3d0041[_0x41aa48(0x37b)+_0x41aa48(0x38f)]=function(_0x3da45b,_0x447f7d,_0x2d8406){var _0x30dcf5=_0x41aa48;for(var _0x224f27=this[_0x30dcf5(0x2bf)+_0x30dcf5(0x3e0)],_0x2397e8=0x1/0x0,_0x20bdc9=this['\x6f\x70\x74\x69\x6f\x6e\x73'][_0x30dcf5(0x272)]&&!this[_0x30dcf5(0x2ab)]['\x77\x72\x61\x70\x41\x72\x6f\x75\x6e\x64']?function(_0x380c6c,_0x2939d1){return _0x380c6c<=_0x2939d1;}:function(_0x27a929,_0x273547){return _0x27a929<_0x273547;};_0x20bdc9(_0x447f7d,_0x2397e8)&&(_0x224f27+=_0x2d8406,_0x2397e8=_0x447f7d,null!==(_0x447f7d=this['\x67\x65\x74\x53\x6c\x69\x64\x65\x44\x69'+_0x30dcf5(0x259)](-_0x3da45b,_0x224f27)));)_0x447f7d=Math['\x61\x62\x73'](_0x447f7d);return{'\x64\x69\x73\x74\x61\x6e\x63\x65':_0x2397e8,'\x69\x6e\x64\x65\x78':_0x224f27-_0x2d8406};},_0x3d0041[_0x41aa48(0x17e)+_0x41aa48(0x259)]=function(_0x20a890,_0x198816){var _0x2c94f1=_0x41aa48,_0x324fb7=this['\x73\x6c\x69\x64\x65\x73'][_0x2c94f1(0x1f9)],_0x263eec=this['\x6f\x70\x74\x69\x6f\x6e\x73']['\x77\x72\x61\x70\x41\x72\x6f\x75\x6e\x64']&&_0x324fb7>0x1,_0x23c4c9=_0x263eec?_0x70ac88[_0x2c94f1(0x1e6)](_0x198816,_0x324fb7):_0x198816,_0x4e769a=this[_0x2c94f1(0x3d6)][_0x23c4c9];if(!_0x4e769a)return null;var _0x53cf4c=_0x263eec?this[_0x2c94f1(0x214)+'\x69\x64\x74\x68']*Math[_0x2c94f1(0x397)](_0x198816/_0x324fb7):0x0;return _0x20a890-(_0x4e769a[_0x2c94f1(0x170)]+_0x53cf4c);},_0x3d0041['\x64\x72\x61\x67\x45\x6e\x64\x42\x6f\x6f'+'\x73\x74\x53\x65\x6c\x65\x63\x74']=function(){var _0x50b2f6=_0x41aa48;if(void 0x0===this[_0x50b2f6(0x2e0)+_0x50b2f6(0x240)]||!this[_0x50b2f6(0x1dd)+'\x6d\x65']||new Date()-this[_0x50b2f6(0x1dd)+'\x6d\x65']>0x64)return 0x0;var _0x2b7e0d=this[_0x50b2f6(0x17e)+_0x50b2f6(0x259)](-this[_0x50b2f6(0x2bc)],this['\x73\x65\x6c\x65\x63\x74\x65\x64\x49\x6e'+'\x64\x65\x78']),_0x50e848=this['\x70\x72\x65\x76\x69\x6f\x75\x73\x44\x72'+'\x61\x67\x58']-this[_0x50b2f6(0x2bc)];return _0x2b7e0d>0x0&&_0x50e848>0x0?0x1:_0x2b7e0d<0x0&&_0x50e848<0x0?-0x1:0x0;},_0x3d0041[_0x41aa48(0x2d3)+'\x6b']=function(_0x3d9493,_0x3c20f7){var _0x428fd6=_0x41aa48,_0x417464=this[_0x428fd6(0x229)+_0x428fd6(0x46d)](_0x3d9493[_0x428fd6(0x170)]),_0x338164=_0x417464&&_0x417464[_0x428fd6(0x1eb)],_0x15f508=_0x417464&&this['\x63\x65\x6c\x6c\x73'][_0x428fd6(0x181)](_0x417464);this[_0x428fd6(0x3b9)+_0x428fd6(0x411)](_0x428fd6(0x2d3)+'\x6b',_0x3d9493,[_0x3c20f7,_0x338164,_0x15f508]);},_0x3d0041[_0x41aa48(0x469)]=function(){var _0xe9d19e=_0x41aa48,_0x18136a=_0x374d2f(),_0x531b5e=this[_0xe9d19e(0x186)+_0xe9d19e(0x3dc)]['\x78']-_0x18136a['\x78'],_0x56dfe4=this[_0xe9d19e(0x186)+'\x6e\x53\x63\x72\x6f\x6c\x6c']['\x79']-_0x18136a['\x79'];(Math[_0xe9d19e(0x175)](_0x531b5e)>0x3||Math['\x61\x62\x73'](_0x56dfe4)>0x3)&&this[_0xe9d19e(0x3bd)+'\x6e\x65']();},_0x3ae973;}),function(_0x464201,_0x438fa0){var _0x39f675=_0x119b77;'\x66\x75\x6e\x63\x74\x69\x6f\x6e'==typeof define&&define[_0x39f675(0x1f2)]?define(_0x39f675(0x47b)+_0x39f675(0x3b7)+_0x39f675(0x471),[_0x39f675(0x31c),'\x75\x6e\x69\x70\x6f\x69\x6e\x74\x65\x72'+_0x39f675(0x1bc)+'\x72',_0x39f675(0x428)+_0x39f675(0x34f)],function(_0x436c32,_0x468f4e,_0xab480b){return _0x438fa0(_0x464201,_0x436c32,_0x468f4e,_0xab480b);}):_0x39f675(0x358)==typeof module&&module[_0x39f675(0x4b6)]?module[_0x39f675(0x4b6)]=_0x438fa0(_0x464201,require(_0x39f675(0x31c)),require(_0x39f675(0x432)),require(_0x39f675(0x428)+_0x39f675(0x311))):_0x438fa0(_0x464201,_0x464201[_0x39f675(0x1c9)],_0x464201[_0x39f675(0x450)],_0x464201['\x66\x69\x7a\x7a\x79\x55\x49\x55\x74\x69'+'\x6c\x73']);}(window,function(_0x2590bc,_0x402d91,_0x32c669,_0x5ba66a){'use strict';var _0x57e0a7=_0x119b77;var _0x5bf906=_0x57e0a7(0x3b5)+_0x57e0a7(0x2a4)+_0x57e0a7(0x3c7);function _0x409fbb(_0x1404a3,_0x2d4e88){var _0x11ab32=_0x57e0a7;this[_0x11ab32(0x279)]=_0x1404a3,this[_0x11ab32(0x33b)]=_0x2d4e88,this[_0x11ab32(0x16c)]();}_0x409fbb[_0x57e0a7(0x153)]=Object[_0x57e0a7(0x1fd)](_0x32c669[_0x57e0a7(0x153)]),_0x409fbb[_0x57e0a7(0x153)][_0x57e0a7(0x16c)]=function(){var _0x4e67a3=_0x57e0a7;this[_0x4e67a3(0x2bb)]=!0x0,this['\x69\x73\x50\x72\x65\x76\x69\x6f\x75\x73']=-0x1==this[_0x4e67a3(0x279)];var _0x425ce6=this[_0x4e67a3(0x33b)][_0x4e67a3(0x2ab)][_0x4e67a3(0x410)+'\x74']?0x1:-0x1;this[_0x4e67a3(0x20f)]=this[_0x4e67a3(0x279)]==_0x425ce6;var _0xb2b28f=this[_0x4e67a3(0x1eb)]=document[_0x4e67a3(0x2be)+_0x4e67a3(0x411)](_0x4e67a3(0x2b9));_0xb2b28f['\x63\x6c\x61\x73\x73\x4e\x61\x6d\x65']=_0x4e67a3(0x366)+_0x4e67a3(0x2ec)+_0x4e67a3(0x1f1)+'\x6e\x65\x78\x74\x2d\x62\x75\x74\x74\x6f'+'\x6e',_0xb2b28f[_0x4e67a3(0x40d)]+=this[_0x4e67a3(0x219)]?_0x4e67a3(0x3a1):'\x20\x6e\x65\x78\x74',_0xb2b28f[_0x4e67a3(0x4b0)+'\x74\x65'](_0x4e67a3(0x32b),'\x62\x75\x74\x74\x6f\x6e'),this[_0x4e67a3(0x176)](),_0xb2b28f[_0x4e67a3(0x4b0)+'\x74\x65'](_0x4e67a3(0x2cf),this[_0x4e67a3(0x219)]?_0x4e67a3(0x49b):_0x4e67a3(0x36d));var _0x2ddd67=this['\x63\x72\x65\x61\x74\x65\x53\x56\x47']();_0xb2b28f[_0x4e67a3(0x1ff)+'\x64'](_0x2ddd67),this['\x70\x61\x72\x65\x6e\x74']['\x6f\x6e'](_0x4e67a3(0x47d),this[_0x4e67a3(0x30b)]['\x62\x69\x6e\x64'](this)),this['\x6f\x6e']('\x70\x6f\x69\x6e\x74\x65\x72\x44\x6f\x77'+'\x6e',this['\x70\x61\x72\x65\x6e\x74']['\x63\x68\x69\x6c\x64\x55\x49\x50\x6f\x69'+_0x4e67a3(0x4b1)][_0x4e67a3(0x347)](this[_0x4e67a3(0x33b)]));},_0x409fbb[_0x57e0a7(0x153)][_0x57e0a7(0x239)]=function(){var _0x1956a5=_0x57e0a7;this[_0x1956a5(0x38c)+'\x76\x65\x6e\x74'](this[_0x1956a5(0x1eb)]),this[_0x1956a5(0x1eb)][_0x1956a5(0x29a)+_0x1956a5(0x1bd)](_0x1956a5(0x303),this),this[_0x1956a5(0x33b)][_0x1956a5(0x1eb)][_0x1956a5(0x1ff)+'\x64'](this[_0x1956a5(0x1eb)]);},_0x409fbb[_0x57e0a7(0x153)][_0x57e0a7(0x33d)]=function(){var _0x11767a=_0x57e0a7;this[_0x11767a(0x33b)][_0x11767a(0x1eb)][_0x11767a(0x2db)+'\x64'](this[_0x11767a(0x1eb)]),this[_0x11767a(0x245)+_0x11767a(0x3bb)](this['\x65\x6c\x65\x6d\x65\x6e\x74']),this['\x65\x6c\x65\x6d\x65\x6e\x74']['\x72\x65\x6d\x6f\x76\x65\x45\x76\x65\x6e'+_0x11767a(0x1c2)]('\x63\x6c\x69\x63\x6b',this);},_0x409fbb[_0x57e0a7(0x153)][_0x57e0a7(0x282)]=function(){var _0x58c104=_0x57e0a7,_0x10d604=document[_0x58c104(0x2be)+_0x58c104(0x426)](_0x5bf906,_0x58c104(0x2ac));_0x10d604[_0x58c104(0x4b0)+'\x74\x65']('\x63\x6c\x61\x73\x73','\x66\x6c\x69\x63\x6b\x69\x74\x79\x2d\x62'+_0x58c104(0x370)),_0x10d604[_0x58c104(0x4b0)+'\x74\x65'](_0x58c104(0x1ef),_0x58c104(0x3ad)+'\x30');var _0x503255=document[_0x58c104(0x2be)+_0x58c104(0x426)](_0x5bf906,_0x58c104(0x25e)),_0x55b399=function(_0x16b3db){var _0xf429a8=_0x58c104;if(_0xf429a8(0x3d2)==typeof _0x16b3db)return _0x16b3db;return'\x4d\x20'+_0x16b3db['\x78\x30']+_0xf429a8(0x242)+_0x16b3db['\x78\x31']+'\x2c'+(_0x16b3db['\x79\x31']+0x32)+_0xf429a8(0x2d0)+_0x16b3db['\x78\x32']+'\x2c'+(_0x16b3db['\x79\x32']+0x32)+_0xf429a8(0x2d0)+_0x16b3db['\x78\x33']+'\x2c\x35\x30\x20\x20\x4c\x20'+_0x16b3db['\x78\x32']+'\x2c'+(0x32-_0x16b3db['\x79\x32'])+_0xf429a8(0x2d0)+_0x16b3db['\x78\x31']+'\x2c'+(0x32-_0x16b3db['\x79\x31'])+'\x20\x5a';}(this[_0x58c104(0x33b)][_0x58c104(0x2ab)][_0x58c104(0x38a)]);return _0x503255[_0x58c104(0x4b0)+'\x74\x65']('\x64',_0x55b399),_0x503255[_0x58c104(0x4b0)+'\x74\x65']('\x63\x6c\x61\x73\x73','\x61\x72\x72\x6f\x77'),this[_0x58c104(0x20f)]||_0x503255[_0x58c104(0x4b0)+'\x74\x65']('\x74\x72\x61\x6e\x73\x66\x6f\x72\x6d','\x74\x72\x61\x6e\x73\x6c\x61\x74\x65\x28'+_0x58c104(0x21f)+_0x58c104(0x1e5)+'\x29\x20'),_0x10d604[_0x58c104(0x1ff)+'\x64'](_0x503255),_0x10d604;},_0x409fbb['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65'][_0x57e0a7(0x433)+'\x74']=_0x5ba66a[_0x57e0a7(0x433)+'\x74'],_0x409fbb[_0x57e0a7(0x153)]['\x6f\x6e\x63\x6c\x69\x63\x6b']=function(){var _0x28d1f6=_0x57e0a7;if(this[_0x28d1f6(0x2bb)]){this['\x70\x61\x72\x65\x6e\x74'][_0x28d1f6(0x274)]();var _0x5722ac=this[_0x28d1f6(0x219)]?_0x28d1f6(0x22b):_0x28d1f6(0x24b);this[_0x28d1f6(0x33b)][_0x5722ac]();}},_0x409fbb[_0x57e0a7(0x153)][_0x57e0a7(0x264)]=function(){var _0x2ad473=_0x57e0a7;this[_0x2ad473(0x2bb)]||(this[_0x2ad473(0x1eb)][_0x2ad473(0x388)]=!0x1,this[_0x2ad473(0x2bb)]=!0x0);},_0x409fbb['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65'][_0x57e0a7(0x176)]=function(){var _0x30788c=_0x57e0a7;this['\x69\x73\x45\x6e\x61\x62\x6c\x65\x64']&&(this[_0x30788c(0x1eb)][_0x30788c(0x388)]=!0x0,this['\x69\x73\x45\x6e\x61\x62\x6c\x65\x64']=!0x1);},_0x409fbb[_0x57e0a7(0x153)][_0x57e0a7(0x30b)]=function(){var _0x339aa1=_0x57e0a7,_0x3f1863=this[_0x339aa1(0x33b)]['\x73\x6c\x69\x64\x65\x73'];if(this[_0x339aa1(0x33b)][_0x339aa1(0x2ab)][_0x339aa1(0x25a)]&&_0x3f1863[_0x339aa1(0x1f9)]>0x1)this[_0x339aa1(0x264)]();else{var _0x35205c=_0x3f1863[_0x339aa1(0x1f9)]?_0x3f1863[_0x339aa1(0x1f9)]-0x1:0x0,_0x5562ae=this[_0x339aa1(0x219)]?0x0:_0x35205c;this[this[_0x339aa1(0x33b)][_0x339aa1(0x2bf)+'\x64\x65\x78']==_0x5562ae?'\x64\x69\x73\x61\x62\x6c\x65':_0x339aa1(0x264)]();}},_0x409fbb[_0x57e0a7(0x153)][_0x57e0a7(0x48f)]=function(){var _0x4851b2=_0x57e0a7;this[_0x4851b2(0x33d)](),this[_0x4851b2(0x190)]();},_0x5ba66a[_0x57e0a7(0x3cb)](_0x402d91[_0x57e0a7(0x2da)],{'\x70\x72\x65\x76\x4e\x65\x78\x74\x42\x75\x74\x74\x6f\x6e\x73':!0x0,'\x61\x72\x72\x6f\x77\x53\x68\x61\x70\x65':{'\x78\x30':0xa,'\x78\x31':0x3c,'\x79\x31':0x32,'\x78\x32':0x46,'\x79\x32':0x28,'\x78\x33':0x1e}}),_0x402d91['\x63\x72\x65\x61\x74\x65\x4d\x65\x74\x68'+_0x57e0a7(0x1e3)][_0x57e0a7(0x43b)](_0x57e0a7(0x155)+_0x57e0a7(0x479)+'\x6e\x73');var _0x3c1c24=_0x402d91[_0x57e0a7(0x153)];return _0x3c1c24[_0x57e0a7(0x155)+'\x76\x4e\x65\x78\x74\x42\x75\x74\x74\x6f'+'\x6e\x73']=function(){var _0x37cf5d=_0x57e0a7;this['\x6f\x70\x74\x69\x6f\x6e\x73'][_0x37cf5d(0x415)+_0x37cf5d(0x25f)]&&(this[_0x37cf5d(0x2c0)]=new _0x409fbb(-0x1,this),this[_0x37cf5d(0x2ba)]=new _0x409fbb(0x1,this),this['\x6f\x6e'](_0x37cf5d(0x239),this[_0x37cf5d(0x19c)+'\x65\x76\x4e\x65\x78\x74\x42\x75\x74\x74'+_0x37cf5d(0x3e2)]));},_0x3c1c24[_0x57e0a7(0x19c)+'\x65\x76\x4e\x65\x78\x74\x42\x75\x74\x74'+'\x6f\x6e\x73']=function(){var _0x578c45=_0x57e0a7;this['\x70\x72\x65\x76\x42\x75\x74\x74\x6f\x6e'][_0x578c45(0x239)](),this[_0x578c45(0x2ba)][_0x578c45(0x239)](),this['\x6f\x6e'](_0x578c45(0x33d),this[_0x578c45(0x33d)+_0x578c45(0x193)+_0x578c45(0x25f)]);},_0x3c1c24[_0x57e0a7(0x33d)+_0x57e0a7(0x193)+_0x57e0a7(0x25f)]=function(){var _0x502fc6=_0x57e0a7;this['\x70\x72\x65\x76\x42\x75\x74\x74\x6f\x6e'][_0x502fc6(0x33d)](),this[_0x502fc6(0x2ba)]['\x64\x65\x61\x63\x74\x69\x76\x61\x74\x65'](),this[_0x502fc6(0x304)]('\x64\x65\x61\x63\x74\x69\x76\x61\x74\x65',this[_0x502fc6(0x33d)+_0x502fc6(0x193)+'\x74\x74\x6f\x6e\x73']);},_0x402d91[_0x57e0a7(0x193)+_0x57e0a7(0x324)]=_0x409fbb,_0x402d91;}),function(_0x171089,_0x519879){var _0x55b1c8=_0x119b77;_0x55b1c8(0x2dd)==typeof define&&define['\x61\x6d\x64']?define(_0x55b1c8(0x47b)+_0x55b1c8(0x1e8)+'\x73',['\x2e\x2f\x66\x6c\x69\x63\x6b\x69\x74\x79',_0x55b1c8(0x432)+'\x2f\x75\x6e\x69\x70\x6f\x69\x6e\x74\x65'+'\x72',_0x55b1c8(0x428)+_0x55b1c8(0x34f)],function(_0x570193,_0x584824,_0x2b4143){return _0x519879(_0x171089,_0x570193,_0x584824,_0x2b4143);}):_0x55b1c8(0x358)==typeof module&&module[_0x55b1c8(0x4b6)]?module[_0x55b1c8(0x4b6)]=_0x519879(_0x171089,require('\x2e\x2f\x66\x6c\x69\x63\x6b\x69\x74\x79'),require(_0x55b1c8(0x432)),require(_0x55b1c8(0x428)+_0x55b1c8(0x311))):_0x519879(_0x171089,_0x171089[_0x55b1c8(0x1c9)],_0x171089['\x55\x6e\x69\x70\x6f\x69\x6e\x74\x65\x72'],_0x171089[_0x55b1c8(0x2a9)+'\x6c\x73']);}(window,function(_0xf07273,_0x1f295b,_0x1d1dcf,_0x54c710){var _0xa27f5c=_0x119b77;function _0x315810(_0x2fb088){var _0x5054ea=_0x2870;this[_0x5054ea(0x33b)]=_0x2fb088,this[_0x5054ea(0x16c)]();}_0x315810['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65']=Object[_0xa27f5c(0x1fd)](_0x1d1dcf['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65']),_0x315810['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65'][_0xa27f5c(0x16c)]=function(){var _0x34d3fe=_0xa27f5c;this[_0x34d3fe(0x14d)]=document['\x63\x72\x65\x61\x74\x65\x45\x6c\x65\x6d'+_0x34d3fe(0x411)]('\x6f\x6c'),this[_0x34d3fe(0x14d)][_0x34d3fe(0x40d)]=_0x34d3fe(0x16f)+_0x34d3fe(0x352),this['\x64\x6f\x74\x73']=[],this[_0x34d3fe(0x269)+'\x6b']=this['\x6f\x6e\x43\x6c\x69\x63\x6b'][_0x34d3fe(0x347)](this),this['\x6f\x6e'](_0x34d3fe(0x186)+'\x6e',this['\x70\x61\x72\x65\x6e\x74'][_0x34d3fe(0x2b2)+_0x34d3fe(0x4b1)][_0x34d3fe(0x347)](this[_0x34d3fe(0x33b)]));},_0x315810[_0xa27f5c(0x153)]['\x61\x63\x74\x69\x76\x61\x74\x65']=function(){var _0x48cd0c=_0xa27f5c;this[_0x48cd0c(0x24c)](),this[_0x48cd0c(0x14d)]['\x61\x64\x64\x45\x76\x65\x6e\x74\x4c\x69'+'\x73\x74\x65\x6e\x65\x72']('\x63\x6c\x69\x63\x6b',this['\x68\x61\x6e\x64\x6c\x65\x43\x6c\x69\x63'+'\x6b']),this[_0x48cd0c(0x38c)+_0x48cd0c(0x33a)](this[_0x48cd0c(0x14d)]),this['\x70\x61\x72\x65\x6e\x74'][_0x48cd0c(0x1eb)][_0x48cd0c(0x1ff)+'\x64'](this['\x68\x6f\x6c\x64\x65\x72']);},_0x315810[_0xa27f5c(0x153)][_0xa27f5c(0x33d)]=function(){var _0x2cc577=_0xa27f5c;this[_0x2cc577(0x14d)][_0x2cc577(0x271)+_0x2cc577(0x1c2)](_0x2cc577(0x303),this['\x68\x61\x6e\x64\x6c\x65\x43\x6c\x69\x63'+'\x6b']),this[_0x2cc577(0x245)+_0x2cc577(0x3bb)](this['\x68\x6f\x6c\x64\x65\x72']),this[_0x2cc577(0x33b)][_0x2cc577(0x1eb)][_0x2cc577(0x2db)+'\x64'](this[_0x2cc577(0x14d)]);},_0x315810[_0xa27f5c(0x153)][_0xa27f5c(0x24c)]=function(){var _0x479ff6=_0xa27f5c,_0x3c43e4=this['\x70\x61\x72\x65\x6e\x74'][_0x479ff6(0x3d6)]['\x6c\x65\x6e\x67\x74\x68']-this[_0x479ff6(0x3d5)][_0x479ff6(0x1f9)];_0x3c43e4>0x0?this[_0x479ff6(0x3c5)](_0x3c43e4):_0x3c43e4<0x0&&this[_0x479ff6(0x1e0)](-_0x3c43e4);},_0x315810[_0xa27f5c(0x153)]['\x61\x64\x64\x44\x6f\x74\x73']=function(_0x3275d2){var _0xecac67=_0xa27f5c;for(var _0x15e59d=document[_0xecac67(0x3fe)+'\x6d\x65\x6e\x74\x46\x72\x61\x67\x6d\x65'+'\x6e\x74'](),_0x1701a2=[],_0x172163=this[_0xecac67(0x3d5)][_0xecac67(0x1f9)],_0x23397a=_0x172163+_0x3275d2,_0x4e8c04=_0x172163;_0x4e8c04<_0x23397a;_0x4e8c04++){var _0x30938a=document[_0xecac67(0x2be)+_0xecac67(0x411)]('\x6c\x69');_0x30938a[_0xecac67(0x40d)]=_0xecac67(0x270),_0x30938a['\x73\x65\x74\x41\x74\x74\x72\x69\x62\x75'+'\x74\x65']('\x61\x72\x69\x61\x2d\x6c\x61\x62\x65\x6c','\x50\x61\x67\x65\x20\x64\x6f\x74\x20'+(_0x4e8c04+0x1)),_0x15e59d[_0xecac67(0x1ff)+'\x64'](_0x30938a),_0x1701a2[_0xecac67(0x43b)](_0x30938a);}this[_0xecac67(0x14d)][_0xecac67(0x1ff)+'\x64'](_0x15e59d),this[_0xecac67(0x3d5)]=this[_0xecac67(0x3d5)][_0xecac67(0x1a9)](_0x1701a2);},_0x315810[_0xa27f5c(0x153)][_0xa27f5c(0x1e0)]=function(_0x4c325f){var _0x20e17d=_0xa27f5c;this[_0x20e17d(0x3d5)][_0x20e17d(0x360)](this[_0x20e17d(0x3d5)][_0x20e17d(0x1f9)]-_0x4c325f,_0x4c325f)[_0x20e17d(0x1c0)](function(_0x47ece2){var _0x54d62d=_0x20e17d;this[_0x54d62d(0x14d)]['\x72\x65\x6d\x6f\x76\x65\x43\x68\x69\x6c'+'\x64'](_0x47ece2);},this);},_0x315810[_0xa27f5c(0x153)]['\x75\x70\x64\x61\x74\x65\x53\x65\x6c\x65'+_0xa27f5c(0x3e3)]=function(){var _0x22f095=_0xa27f5c;this['\x73\x65\x6c\x65\x63\x74\x65\x64\x44\x6f'+'\x74']&&(this[_0x22f095(0x21b)+'\x74'][_0x22f095(0x40d)]=_0x22f095(0x270),this[_0x22f095(0x21b)+'\x74'][_0x22f095(0x376)+'\x69\x62\x75\x74\x65'](_0x22f095(0x338)+'\x6e\x74')),this[_0x22f095(0x3d5)][_0x22f095(0x1f9)]&&(this['\x73\x65\x6c\x65\x63\x74\x65\x64\x44\x6f'+'\x74']=this[_0x22f095(0x3d5)][this[_0x22f095(0x33b)]['\x73\x65\x6c\x65\x63\x74\x65\x64\x49\x6e'+_0x22f095(0x3e0)]],this[_0x22f095(0x21b)+'\x74'][_0x22f095(0x40d)]=_0x22f095(0x3c9)+_0x22f095(0x1d4),this['\x73\x65\x6c\x65\x63\x74\x65\x64\x44\x6f'+'\x74']['\x73\x65\x74\x41\x74\x74\x72\x69\x62\x75'+'\x74\x65'](_0x22f095(0x338)+'\x6e\x74',_0x22f095(0x372)));},_0x315810[_0xa27f5c(0x153)]['\x6f\x6e\x54\x61\x70']=_0x315810[_0xa27f5c(0x153)][_0xa27f5c(0x235)]=function(_0x2aa25a){var _0x26c147=_0xa27f5c,_0x4b74a6=_0x2aa25a[_0x26c147(0x170)];if('\x4c\x49'==_0x4b74a6['\x6e\x6f\x64\x65\x4e\x61\x6d\x65']){this[_0x26c147(0x33b)][_0x26c147(0x274)]();var _0x385ae2=this[_0x26c147(0x3d5)][_0x26c147(0x181)](_0x4b74a6);this[_0x26c147(0x33b)][_0x26c147(0x47d)](_0x385ae2);}},_0x315810[_0xa27f5c(0x153)][_0xa27f5c(0x48f)]=function(){var _0xb8543a=_0xa27f5c;this[_0xb8543a(0x33d)](),this[_0xb8543a(0x190)]();},_0x1f295b[_0xa27f5c(0x3d7)]=_0x315810,_0x54c710[_0xa27f5c(0x3cb)](_0x1f295b[_0xa27f5c(0x2da)],{'\x70\x61\x67\x65\x44\x6f\x74\x73':!0x0}),_0x1f295b[_0xa27f5c(0x20e)+_0xa27f5c(0x1e3)][_0xa27f5c(0x43b)](_0xa27f5c(0x42d)+_0xa27f5c(0x37d));var _0x196269=_0x1f295b[_0xa27f5c(0x153)];return _0x196269['\x5f\x63\x72\x65\x61\x74\x65\x50\x61\x67'+_0xa27f5c(0x37d)]=function(){var _0x4bcd37=_0xa27f5c;this[_0x4bcd37(0x2ab)][_0x4bcd37(0x246)]&&(this[_0x4bcd37(0x246)]=new _0x315810(this),this['\x6f\x6e']('\x61\x63\x74\x69\x76\x61\x74\x65',this[_0x4bcd37(0x39f)+_0x4bcd37(0x441)]),this['\x6f\x6e'](_0x4bcd37(0x47d),this['\x75\x70\x64\x61\x74\x65\x53\x65\x6c\x65'+_0x4bcd37(0x34d)+'\x74\x73']),this['\x6f\x6e']('\x63\x65\x6c\x6c\x43\x68\x61\x6e\x67\x65',this[_0x4bcd37(0x28e)+_0x4bcd37(0x1b8)]),this['\x6f\x6e'](_0x4bcd37(0x2d1),this['\x75\x70\x64\x61\x74\x65\x50\x61\x67\x65'+_0x4bcd37(0x1b8)]),this['\x6f\x6e'](_0x4bcd37(0x33d),this[_0x4bcd37(0x33d)+'\x50\x61\x67\x65\x44\x6f\x74\x73']));},_0x196269[_0xa27f5c(0x39f)+_0xa27f5c(0x441)]=function(){var _0x2598b7=_0xa27f5c;this[_0x2598b7(0x246)]['\x61\x63\x74\x69\x76\x61\x74\x65']();},_0x196269[_0xa27f5c(0x1ec)+_0xa27f5c(0x34d)+'\x74\x73']=function(){var _0x16468f=_0xa27f5c;this[_0x16468f(0x246)][_0x16468f(0x1ec)+_0x16468f(0x3e3)]();},_0x196269['\x75\x70\x64\x61\x74\x65\x50\x61\x67\x65'+'\x44\x6f\x74\x73']=function(){var _0x42c9a2=_0xa27f5c;this['\x70\x61\x67\x65\x44\x6f\x74\x73'][_0x42c9a2(0x24c)]();},_0x196269[_0xa27f5c(0x33d)+_0xa27f5c(0x3d7)]=function(){var _0x2620ab=_0xa27f5c;this[_0x2620ab(0x246)][_0x2620ab(0x33d)]();},_0x1f295b['\x50\x61\x67\x65\x44\x6f\x74\x73']=_0x315810,_0x1f295b;}),function(_0x2c36e0,_0x4c4cdb){var _0x513594=_0x119b77;'\x66\x75\x6e\x63\x74\x69\x6f\x6e'==typeof define&&define[_0x513594(0x1f2)]?define(_0x513594(0x47b)+_0x513594(0x485),[_0x513594(0x46c)+'\x2f\x65\x76\x2d\x65\x6d\x69\x74\x74\x65'+'\x72',_0x513594(0x428)+_0x513594(0x34f),'\x2e\x2f\x66\x6c\x69\x63\x6b\x69\x74\x79'],function(_0x16262d,_0x4b3d0a,_0x2c328d){return _0x4c4cdb(_0x16262d,_0x4b3d0a,_0x2c328d);}):_0x513594(0x358)==typeof module&&module[_0x513594(0x4b6)]?module[_0x513594(0x4b6)]=_0x4c4cdb(require(_0x513594(0x46c)),require(_0x513594(0x428)+_0x513594(0x311)),require(_0x513594(0x31c))):_0x4c4cdb(_0x2c36e0[_0x513594(0x41b)],_0x2c36e0[_0x513594(0x2a9)+'\x6c\x73'],_0x2c36e0[_0x513594(0x1c9)]);}(window,function(_0x1a629e,_0x270332,_0x33cfaa){var _0x4be1ab=_0x119b77;function _0x245c9f(_0xb398da){var _0x85123c=_0x2870;this['\x70\x61\x72\x65\x6e\x74']=_0xb398da,this[_0x85123c(0x1ed)]='\x73\x74\x6f\x70\x70\x65\x64',this[_0x85123c(0x238)+'\x74\x79\x43\x68\x61\x6e\x67\x65']=this[_0x85123c(0x48a)+_0x85123c(0x1d5)][_0x85123c(0x347)](this),this['\x6f\x6e\x56\x69\x73\x69\x62\x69\x6c\x69'+_0x85123c(0x45e)]=this['\x76\x69\x73\x69\x62\x69\x6c\x69\x74\x79'+'\x50\x6c\x61\x79'][_0x85123c(0x347)](this);}_0x245c9f[_0x4be1ab(0x153)]=Object[_0x4be1ab(0x1fd)](_0x1a629e['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65']),_0x245c9f['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65'][_0x4be1ab(0x3ea)]=function(){var _0x2c19ec=_0x4be1ab;'\x70\x6c\x61\x79\x69\x6e\x67'!=this['\x73\x74\x61\x74\x65']&&(document[_0x2c19ec(0x236)]?document[_0x2c19ec(0x29a)+_0x2c19ec(0x1bd)](_0x2c19ec(0x48a)+_0x2c19ec(0x382),this['\x6f\x6e\x56\x69\x73\x69\x62\x69\x6c\x69'+_0x2c19ec(0x45e)]):(this[_0x2c19ec(0x1ed)]=_0x2c19ec(0x231),document['\x61\x64\x64\x45\x76\x65\x6e\x74\x4c\x69'+_0x2c19ec(0x1bd)](_0x2c19ec(0x48a)+_0x2c19ec(0x382),this['\x6f\x6e\x56\x69\x73\x69\x62\x69\x6c\x69'+_0x2c19ec(0x1ae)]),this[_0x2c19ec(0x1f8)]()));},_0x245c9f[_0x4be1ab(0x153)][_0x4be1ab(0x1f8)]=function(){var _0x1c249b=_0x4be1ab;if(_0x1c249b(0x231)==this[_0x1c249b(0x1ed)]){var _0xbdc771=this[_0x1c249b(0x33b)][_0x1c249b(0x2ab)]['\x61\x75\x74\x6f\x50\x6c\x61\x79'];_0xbdc771='\x6e\x75\x6d\x62\x65\x72'==typeof _0xbdc771?_0xbdc771:0xbb8;var _0x4eb776=this;this['\x63\x6c\x65\x61\x72'](),this[_0x1c249b(0x2e4)]=setTimeout(function(){var _0x21c796=_0x1c249b;_0x4eb776[_0x21c796(0x33b)]['\x6e\x65\x78\x74'](!0x0),_0x4eb776[_0x21c796(0x1f8)]();},_0xbdc771);}},_0x245c9f['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65'][_0x4be1ab(0x2ef)]=function(){var _0x1c698a=_0x4be1ab;this[_0x1c698a(0x1ed)]='\x73\x74\x6f\x70\x70\x65\x64',this[_0x1c698a(0x435)](),document[_0x1c698a(0x271)+_0x1c698a(0x1c2)]('\x76\x69\x73\x69\x62\x69\x6c\x69\x74\x79'+_0x1c698a(0x382),this[_0x1c698a(0x238)+_0x1c698a(0x1ae)]);},_0x245c9f[_0x4be1ab(0x153)][_0x4be1ab(0x435)]=function(){var _0x36a6d6=_0x4be1ab;clearTimeout(this[_0x36a6d6(0x2e4)]);},_0x245c9f[_0x4be1ab(0x153)][_0x4be1ab(0x474)]=function(){var _0x5796fa=_0x4be1ab;_0x5796fa(0x231)==this[_0x5796fa(0x1ed)]&&(this[_0x5796fa(0x1ed)]=_0x5796fa(0x1c8),this[_0x5796fa(0x435)]());},_0x245c9f[_0x4be1ab(0x153)][_0x4be1ab(0x16d)]=function(){var _0x3fade0=_0x4be1ab;_0x3fade0(0x1c8)==this['\x73\x74\x61\x74\x65']&&this[_0x3fade0(0x3ea)]();},_0x245c9f[_0x4be1ab(0x153)]['\x76\x69\x73\x69\x62\x69\x6c\x69\x74\x79'+_0x4be1ab(0x1d5)]=function(){var _0x140b93=_0x4be1ab;this[document['\x68\x69\x64\x64\x65\x6e']?_0x140b93(0x474):_0x140b93(0x16d)]();},_0x245c9f[_0x4be1ab(0x153)][_0x4be1ab(0x48a)+_0x4be1ab(0x1cd)]=function(){var _0x4387a5=_0x4be1ab;this[_0x4387a5(0x3ea)](),document['\x72\x65\x6d\x6f\x76\x65\x45\x76\x65\x6e'+_0x4387a5(0x1c2)](_0x4387a5(0x48a)+_0x4387a5(0x382),this[_0x4387a5(0x238)+_0x4387a5(0x45e)]);},_0x270332[_0x4be1ab(0x3cb)](_0x33cfaa[_0x4be1ab(0x2da)],{'\x70\x61\x75\x73\x65\x41\x75\x74\x6f\x50\x6c\x61\x79\x4f\x6e\x48\x6f\x76\x65\x72':!0x0}),_0x33cfaa[_0x4be1ab(0x20e)+_0x4be1ab(0x1e3)][_0x4be1ab(0x43b)](_0x4be1ab(0x31d)+'\x79\x65\x72');var _0x433a40=_0x33cfaa['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65'];return _0x433a40['\x5f\x63\x72\x65\x61\x74\x65\x50\x6c\x61'+_0x4be1ab(0x296)]=function(){var _0x47d9ed=_0x4be1ab;this['\x70\x6c\x61\x79\x65\x72']=new _0x245c9f(this),this['\x6f\x6e'](_0x47d9ed(0x239),this[_0x47d9ed(0x2e7)+_0x47d9ed(0x3ab)]),this['\x6f\x6e'](_0x47d9ed(0x274),this['\x73\x74\x6f\x70\x50\x6c\x61\x79\x65\x72']),this['\x6f\x6e'](_0x47d9ed(0x186)+'\x6e',this[_0x47d9ed(0x3d3)]),this['\x6f\x6e'](_0x47d9ed(0x33d),this[_0x47d9ed(0x33d)+_0x47d9ed(0x14a)]);},_0x433a40[_0x4be1ab(0x2e7)+_0x4be1ab(0x3ab)]=function(){var _0x2db85b=_0x4be1ab;this[_0x2db85b(0x2ab)][_0x2db85b(0x49a)]&&(this[_0x2db85b(0x3ce)][_0x2db85b(0x3ea)](),this[_0x2db85b(0x1eb)][_0x2db85b(0x29a)+_0x2db85b(0x1bd)]('\x6d\x6f\x75\x73\x65\x65\x6e\x74\x65\x72',this));},_0x433a40[_0x4be1ab(0x23d)]=function(){var _0x38f339=_0x4be1ab;this[_0x38f339(0x3ce)][_0x38f339(0x3ea)]();},_0x433a40[_0x4be1ab(0x3d3)]=function(){var _0x384feb=_0x4be1ab;this[_0x384feb(0x3ce)][_0x384feb(0x2ef)]();},_0x433a40[_0x4be1ab(0x4ab)+'\x72']=function(){var _0x5ab71d=_0x4be1ab;this[_0x5ab71d(0x3ce)][_0x5ab71d(0x474)]();},_0x433a40[_0x4be1ab(0x434)+_0x4be1ab(0x296)]=function(){var _0x3bdc0e=_0x4be1ab;this[_0x3bdc0e(0x3ce)][_0x3bdc0e(0x16d)]();},_0x433a40[_0x4be1ab(0x33d)+'\x50\x6c\x61\x79\x65\x72']=function(){var _0x477de2=_0x4be1ab;this[_0x477de2(0x3ce)][_0x477de2(0x2ef)](),this[_0x477de2(0x1eb)]['\x72\x65\x6d\x6f\x76\x65\x45\x76\x65\x6e'+'\x74\x4c\x69\x73\x74\x65\x6e\x65\x72'](_0x477de2(0x404),this);},_0x433a40[_0x4be1ab(0x19e)+'\x65\x72']=function(){var _0x1e9ff5=_0x4be1ab;this[_0x1e9ff5(0x2ab)]['\x70\x61\x75\x73\x65\x41\x75\x74\x6f\x50'+_0x1e9ff5(0x3de)]&&(this[_0x1e9ff5(0x3ce)][_0x1e9ff5(0x474)](),this['\x65\x6c\x65\x6d\x65\x6e\x74'][_0x1e9ff5(0x29a)+_0x1e9ff5(0x1bd)](_0x1e9ff5(0x23f),this));},_0x433a40[_0x4be1ab(0x208)+'\x76\x65']=function(){var _0x2d9e3b=_0x4be1ab;this['\x70\x6c\x61\x79\x65\x72']['\x75\x6e\x70\x61\x75\x73\x65'](),this[_0x2d9e3b(0x1eb)][_0x2d9e3b(0x271)+_0x2d9e3b(0x1c2)]('\x6d\x6f\x75\x73\x65\x6c\x65\x61\x76\x65',this);},_0x33cfaa[_0x4be1ab(0x14a)]=_0x245c9f,_0x33cfaa;}),function(_0x1ebbe9,_0x214edb){var _0x46ce83=_0x119b77;_0x46ce83(0x2dd)==typeof define&&define[_0x46ce83(0x1f2)]?define(_0x46ce83(0x47b)+'\x73\x2f\x61\x64\x64\x2d\x72\x65\x6d\x6f'+'\x76\x65\x2d\x63\x65\x6c\x6c',[_0x46ce83(0x31c),_0x46ce83(0x428)+_0x46ce83(0x34f)],function(_0x1c7a0a,_0x26b2db){return _0x214edb(_0x1ebbe9,_0x1c7a0a,_0x26b2db);}):_0x46ce83(0x358)==typeof module&&module[_0x46ce83(0x4b6)]?module[_0x46ce83(0x4b6)]=_0x214edb(_0x1ebbe9,require(_0x46ce83(0x31c)),require(_0x46ce83(0x428)+_0x46ce83(0x311))):_0x214edb(_0x1ebbe9,_0x1ebbe9['\x46\x6c\x69\x63\x6b\x69\x74\x79'],_0x1ebbe9[_0x46ce83(0x2a9)+'\x6c\x73']);}(window,function(_0x280f5e,_0x292317,_0x981262){var _0x5c0b9b=_0x119b77,_0xdbbee1=_0x292317[_0x5c0b9b(0x153)];return _0xdbbee1[_0x5c0b9b(0x26f)]=function(_0x1bde2d,_0x4de78c){var _0x14391e=_0x5c0b9b,_0x174798=this[_0x14391e(0x413)](_0x1bde2d);if(_0x174798&&_0x174798[_0x14391e(0x1f9)]){var _0x482294=this[_0x14391e(0x302)]['\x6c\x65\x6e\x67\x74\x68'];_0x4de78c=void 0x0===_0x4de78c?_0x482294:_0x4de78c;var _0x2ddacb=function(_0x1786c8){var _0x4e1c81=_0x14391e,_0x2651b2=document['\x63\x72\x65\x61\x74\x65\x44\x6f\x63\x75'+_0x4e1c81(0x3bc)+'\x6e\x74']();return _0x1786c8['\x66\x6f\x72\x45\x61\x63\x68'](function(_0x343f98){var _0x149a64=_0x4e1c81;_0x2651b2[_0x149a64(0x1ff)+'\x64'](_0x343f98['\x65\x6c\x65\x6d\x65\x6e\x74']);}),_0x2651b2;}(_0x174798),_0x56bd8f=_0x4de78c==_0x482294;if(_0x56bd8f)this[_0x14391e(0x419)][_0x14391e(0x1ff)+'\x64'](_0x2ddacb);else{var _0x4bf1dd=this[_0x14391e(0x302)][_0x4de78c][_0x14391e(0x1eb)];this['\x73\x6c\x69\x64\x65\x72'][_0x14391e(0x202)+'\x72\x65'](_0x2ddacb,_0x4bf1dd);}if(0x0===_0x4de78c)this[_0x14391e(0x302)]=_0x174798[_0x14391e(0x1a9)](this[_0x14391e(0x302)]);else{if(_0x56bd8f)this[_0x14391e(0x302)]=this[_0x14391e(0x302)]['\x63\x6f\x6e\x63\x61\x74'](_0x174798);else{var _0x1a8154=this[_0x14391e(0x302)][_0x14391e(0x360)](_0x4de78c,_0x482294-_0x4de78c);this[_0x14391e(0x302)]=this[_0x14391e(0x302)]['\x63\x6f\x6e\x63\x61\x74'](_0x174798)[_0x14391e(0x1a9)](_0x1a8154);}}this['\x5f\x73\x69\x7a\x65\x43\x65\x6c\x6c\x73'](_0x174798),this['\x63\x65\x6c\x6c\x43\x68\x61\x6e\x67\x65'](_0x4de78c,!0x0);}},_0xdbbee1[_0x5c0b9b(0x364)]=function(_0x13504c){var _0x150a74=_0x5c0b9b;this[_0x150a74(0x26f)](_0x13504c,this[_0x150a74(0x302)][_0x150a74(0x1f9)]);},_0xdbbee1[_0x5c0b9b(0x2a1)]=function(_0x123951){var _0x802bc0=_0x5c0b9b;this[_0x802bc0(0x26f)](_0x123951,0x0);},_0xdbbee1['\x72\x65\x6d\x6f\x76\x65']=function(_0x2431d2){var _0x4ecab3=_0x5c0b9b,_0x367b9e=this['\x67\x65\x74\x43\x65\x6c\x6c\x73'](_0x2431d2);if(_0x367b9e&&_0x367b9e['\x6c\x65\x6e\x67\x74\x68']){var _0x315767=this['\x63\x65\x6c\x6c\x73'][_0x4ecab3(0x1f9)]-0x1;_0x367b9e[_0x4ecab3(0x1c0)](function(_0x42ca25){var _0x3a28ed=_0x4ecab3;_0x42ca25['\x72\x65\x6d\x6f\x76\x65']();var _0x1b8a57=this[_0x3a28ed(0x302)]['\x69\x6e\x64\x65\x78\x4f\x66'](_0x42ca25);_0x315767=Math[_0x3a28ed(0x35e)](_0x1b8a57,_0x315767),_0x981262[_0x3a28ed(0x393)](this[_0x3a28ed(0x302)],_0x42ca25);},this),this[_0x4ecab3(0x4a4)](_0x315767,!0x0);}},_0xdbbee1['\x63\x65\x6c\x6c\x53\x69\x7a\x65\x43\x68'+_0x5c0b9b(0x28b)]=function(_0x511b41){var _0x37e59f=_0x5c0b9b,_0x40fbed=this['\x67\x65\x74\x43\x65\x6c\x6c'](_0x511b41);if(_0x40fbed){_0x40fbed[_0x37e59f(0x35c)]();var _0xe21b2=this[_0x37e59f(0x302)][_0x37e59f(0x181)](_0x40fbed);this[_0x37e59f(0x4a4)](_0xe21b2);}},_0xdbbee1['\x63\x65\x6c\x6c\x43\x68\x61\x6e\x67\x65']=function(_0x23c12d,_0x6a6fa7){var _0x14136b=_0x5c0b9b,_0x31cc17=this[_0x14136b(0x2e1)+_0x14136b(0x295)];this[_0x14136b(0x34a)+_0x14136b(0x28c)](_0x23c12d),this['\x5f\x67\x65\x74\x57\x72\x61\x70\x53\x68'+_0x14136b(0x4b7)](),this[_0x14136b(0x39c)+'\x53\x69\x7a\x65']();var _0x23caac=this[_0x14136b(0x40f)](_0x31cc17);_0x23caac&&(this[_0x14136b(0x2bf)+_0x14136b(0x3e0)]=this[_0x14136b(0x203)+_0x14136b(0x20a)](_0x23caac)),this['\x73\x65\x6c\x65\x63\x74\x65\x64\x49\x6e'+'\x64\x65\x78']=Math[_0x14136b(0x35e)](this[_0x14136b(0x3d6)][_0x14136b(0x1f9)]-0x1,this[_0x14136b(0x2bf)+'\x64\x65\x78']),this['\x65\x6d\x69\x74\x45\x76\x65\x6e\x74']('\x63\x65\x6c\x6c\x43\x68\x61\x6e\x67\x65',[_0x23c12d]),this[_0x14136b(0x47d)](this[_0x14136b(0x2bf)+_0x14136b(0x3e0)]),_0x6a6fa7&&this[_0x14136b(0x3e1)+'\x69\x64\x65\x72\x41\x74\x53\x65\x6c\x65'+_0x14136b(0x3e3)]();},_0x292317;}),function(_0x2d331c,_0x31971c){var _0x2d38b0=_0x119b77;'\x66\x75\x6e\x63\x74\x69\x6f\x6e'==typeof define&&define[_0x2d38b0(0x1f2)]?define(_0x2d38b0(0x47b)+'\x73\x2f\x6c\x61\x7a\x79\x6c\x6f\x61\x64',[_0x2d38b0(0x31c),_0x2d38b0(0x428)+_0x2d38b0(0x34f)],function(_0xa7aeb9,_0x50a836){return _0x31971c(_0x2d331c,_0xa7aeb9,_0x50a836);}):'\x6f\x62\x6a\x65\x63\x74'==typeof module&&module[_0x2d38b0(0x4b6)]?module[_0x2d38b0(0x4b6)]=_0x31971c(_0x2d331c,require(_0x2d38b0(0x31c)),require(_0x2d38b0(0x428)+_0x2d38b0(0x311))):_0x31971c(_0x2d331c,_0x2d331c[_0x2d38b0(0x1c9)],_0x2d331c[_0x2d38b0(0x2a9)+'\x6c\x73']);}(window,function(_0x4d8377,_0x2f1f33,_0x173202){'use strict';var _0x5e3428=_0x119b77;_0x2f1f33[_0x5e3428(0x20e)+_0x5e3428(0x1e3)]['\x70\x75\x73\x68'](_0x5e3428(0x160)+_0x5e3428(0x417));var _0xa60818=_0x2f1f33['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65'];function _0x44ac8e(_0x4b85f9,_0x354c48){var _0x1b604d=_0x5e3428;this[_0x1b604d(0x204)]=_0x4b85f9,this[_0x1b604d(0x2fd)]=_0x354c48,this[_0x1b604d(0x158)]();}return _0xa60818[_0x5e3428(0x160)+'\x79\x6c\x6f\x61\x64']=function(){var _0x154891=_0x5e3428;this['\x6f\x6e'](_0x154891(0x47d),this[_0x154891(0x2d4)]);},_0xa60818['\x6c\x61\x7a\x79\x4c\x6f\x61\x64']=function(){var _0x5d9bfa=_0x5e3428,_0x12a3d2=this[_0x5d9bfa(0x2ab)][_0x5d9bfa(0x2d4)];if(_0x12a3d2){var _0x2ed8f8=_0x5d9bfa(0x4a8)==typeof _0x12a3d2?_0x12a3d2:0x0,_0x30ab4e=this[_0x5d9bfa(0x29b)+_0x5d9bfa(0x3a5)+_0x5d9bfa(0x3aa)](_0x2ed8f8),_0x54f2f2=[];_0x30ab4e[_0x5d9bfa(0x1c0)](function(_0x5bea1a){var _0x205a45=_0x5d9bfa,_0x215f2c=function(_0x5aaf9f){var _0x56d560=_0x2870;if('\x49\x4d\x47'==_0x5aaf9f[_0x56d560(0x3c4)]){var _0x5299f1=_0x5aaf9f[_0x56d560(0x476)+'\x74\x65'](_0x56d560(0x3e4)+_0x56d560(0x4ad)+'\x61\x64'),_0x17cd56=_0x5aaf9f[_0x56d560(0x476)+'\x74\x65']('\x64\x61\x74\x61\x2d\x66\x6c\x69\x63\x6b'+'\x69\x74\x79\x2d\x6c\x61\x7a\x79\x6c\x6f'+_0x56d560(0x4a6)),_0x5ca198=_0x5aaf9f['\x67\x65\x74\x41\x74\x74\x72\x69\x62\x75'+'\x74\x65'](_0x56d560(0x3e4)+_0x56d560(0x4ad)+_0x56d560(0x48b));if(_0x5299f1||_0x17cd56||_0x5ca198)return[_0x5aaf9f];}var _0x501499=_0x5aaf9f[_0x56d560(0x1b3)+_0x56d560(0x473)](_0x56d560(0x196)+'\x6c\x69\x63\x6b\x69\x74\x79\x2d\x6c\x61'+_0x56d560(0x21a)+_0x56d560(0x2fa)+_0x56d560(0x2ca)+_0x56d560(0x334)+_0x56d560(0x3fb)+'\x2d\x66\x6c\x69\x63\x6b\x69\x74\x79\x2d'+_0x56d560(0x36c)+_0x56d560(0x399));return _0x173202[_0x56d560(0x267)](_0x501499);}(_0x5bea1a);_0x54f2f2=_0x54f2f2[_0x205a45(0x1a9)](_0x215f2c);}),_0x54f2f2['\x66\x6f\x72\x45\x61\x63\x68'](function(_0x4fc41d){new _0x44ac8e(_0x4fc41d,this);},this);}},_0x44ac8e[_0x5e3428(0x153)][_0x5e3428(0x433)+'\x74']=_0x173202['\x68\x61\x6e\x64\x6c\x65\x45\x76\x65\x6e'+'\x74'],_0x44ac8e[_0x5e3428(0x153)][_0x5e3428(0x158)]=function(){var _0x213dfd=_0x5e3428;this[_0x213dfd(0x204)][_0x213dfd(0x29a)+_0x213dfd(0x1bd)](_0x213dfd(0x158),this),this[_0x213dfd(0x204)][_0x213dfd(0x29a)+_0x213dfd(0x1bd)](_0x213dfd(0x17d),this);var _0x476cb6=this['\x69\x6d\x67'][_0x213dfd(0x476)+'\x74\x65'](_0x213dfd(0x3e4)+'\x69\x74\x79\x2d\x6c\x61\x7a\x79\x6c\x6f'+'\x61\x64')||this[_0x213dfd(0x204)][_0x213dfd(0x476)+'\x74\x65']('\x64\x61\x74\x61\x2d\x66\x6c\x69\x63\x6b'+_0x213dfd(0x4ad)+'\x61\x64\x2d\x73\x72\x63'),_0x5c6ffc=this[_0x213dfd(0x204)][_0x213dfd(0x476)+'\x74\x65'](_0x213dfd(0x3e4)+_0x213dfd(0x4ad)+_0x213dfd(0x48b));this[_0x213dfd(0x204)][_0x213dfd(0x1e9)]=_0x476cb6,_0x5c6ffc&&this[_0x213dfd(0x204)]['\x73\x65\x74\x41\x74\x74\x72\x69\x62\x75'+'\x74\x65'](_0x213dfd(0x1fb),_0x5c6ffc),this[_0x213dfd(0x204)][_0x213dfd(0x376)+_0x213dfd(0x217)](_0x213dfd(0x3e4)+_0x213dfd(0x4ad)+'\x61\x64'),this['\x69\x6d\x67'][_0x213dfd(0x376)+_0x213dfd(0x217)](_0x213dfd(0x3e4)+'\x69\x74\x79\x2d\x6c\x61\x7a\x79\x6c\x6f'+'\x61\x64\x2d\x73\x72\x63'),this[_0x213dfd(0x204)][_0x213dfd(0x376)+_0x213dfd(0x217)](_0x213dfd(0x3e4)+'\x69\x74\x79\x2d\x6c\x61\x7a\x79\x6c\x6f'+_0x213dfd(0x48b));},_0x44ac8e['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65'][_0x5e3428(0x226)]=function(_0xc8dc36){var _0x212946=_0x5e3428;this[_0x212946(0x357)](_0xc8dc36,_0x212946(0x247)+_0x212946(0x3ca));},_0x44ac8e[_0x5e3428(0x153)]['\x6f\x6e\x65\x72\x72\x6f\x72']=function(_0x33d4bf){var _0x1085c0=_0x5e3428;this[_0x1085c0(0x357)](_0x33d4bf,_0x1085c0(0x247)+'\x61\x7a\x79\x65\x72\x72\x6f\x72');},_0x44ac8e[_0x5e3428(0x153)]['\x63\x6f\x6d\x70\x6c\x65\x74\x65']=function(_0x347c03,_0x2c9c0d){var _0xef9651=_0x5e3428;this[_0xef9651(0x204)]['\x72\x65\x6d\x6f\x76\x65\x45\x76\x65\x6e'+_0xef9651(0x1c2)]('\x6c\x6f\x61\x64',this),this[_0xef9651(0x204)][_0xef9651(0x271)+_0xef9651(0x1c2)](_0xef9651(0x17d),this);var _0x3ac132=this[_0xef9651(0x2fd)][_0xef9651(0x229)+_0xef9651(0x46d)](this[_0xef9651(0x204)]),_0x5929ea=_0x3ac132&&_0x3ac132[_0xef9651(0x1eb)];this[_0xef9651(0x2fd)][_0xef9651(0x49d)+_0xef9651(0x28b)](_0x5929ea),this[_0xef9651(0x204)]['\x63\x6c\x61\x73\x73\x4c\x69\x73\x74'][_0xef9651(0x234)](_0x2c9c0d),this[_0xef9651(0x2fd)][_0xef9651(0x3b9)+_0xef9651(0x411)](_0xef9651(0x2d4),_0x347c03,_0x5929ea);},_0x2f1f33[_0x5e3428(0x446)]=_0x44ac8e,_0x2f1f33;}),function(_0x650722,_0x2cba8a){var _0x51f774=_0x119b77;_0x51f774(0x2dd)==typeof define&&define[_0x51f774(0x1f2)]?define(_0x51f774(0x47b)+_0x51f774(0x1f5),[_0x51f774(0x31c),'\x2e\x2f\x64\x72\x61\x67','\x2e\x2f\x70\x72\x65\x76\x2d\x6e\x65\x78'+_0x51f774(0x471),_0x51f774(0x20c)+'\x73',_0x51f774(0x44e),'\x2e\x2f\x61\x64\x64\x2d\x72\x65\x6d\x6f'+_0x51f774(0x29d),_0x51f774(0x1c7)],_0x2cba8a):'\x6f\x62\x6a\x65\x63\x74'==typeof module&&module[_0x51f774(0x4b6)]&&(module[_0x51f774(0x4b6)]=_0x2cba8a(require('\x2e\x2f\x66\x6c\x69\x63\x6b\x69\x74\x79'),require('\x2e\x2f\x64\x72\x61\x67'),require('\x2e\x2f\x70\x72\x65\x76\x2d\x6e\x65\x78'+'\x74\x2d\x62\x75\x74\x74\x6f\x6e'),require(_0x51f774(0x20c)+'\x73'),require(_0x51f774(0x44e)),require(_0x51f774(0x39b)+_0x51f774(0x29d)),require(_0x51f774(0x1c7))));}(window,function(_0x51afc3){return _0x51afc3;}),function(_0x46b9b4,_0x3f4f87){var _0x25ee21=_0x119b77;'\x66\x75\x6e\x63\x74\x69\x6f\x6e'==typeof define&&define[_0x25ee21(0x1f2)]?define(_0x25ee21(0x475)+_0x25ee21(0x343)+_0x25ee21(0x2f4),[_0x25ee21(0x47b)+_0x25ee21(0x1f5),_0x25ee21(0x428)+_0x25ee21(0x34f)],_0x3f4f87):_0x25ee21(0x358)==typeof module&&module[_0x25ee21(0x4b6)]?module[_0x25ee21(0x4b6)]=_0x3f4f87(require('\x66\x6c\x69\x63\x6b\x69\x74\x79'),require(_0x25ee21(0x428)+'\x74\x69\x6c\x73')):_0x46b9b4[_0x25ee21(0x1c9)]=_0x3f4f87(_0x46b9b4[_0x25ee21(0x1c9)],_0x46b9b4[_0x25ee21(0x2a9)+'\x6c\x73']);}(window,function(_0x5c25e9,_0x37cb8c){var _0x29955c=_0x119b77;_0x5c25e9['\x63\x72\x65\x61\x74\x65\x4d\x65\x74\x68'+_0x29955c(0x1e3)][_0x29955c(0x43b)]('\x5f\x63\x72\x65\x61\x74\x65\x41\x73\x4e'+_0x29955c(0x298));var _0x3ff691=_0x5c25e9[_0x29955c(0x153)];return _0x3ff691[_0x29955c(0x35a)+_0x29955c(0x298)]=function(){var _0x756fd9=_0x29955c;this['\x6f\x6e']('\x61\x63\x74\x69\x76\x61\x74\x65',this[_0x756fd9(0x493)+_0x756fd9(0x286)]),this['\x6f\x6e'](_0x756fd9(0x33d),this[_0x756fd9(0x33d)+'\x41\x73\x4e\x61\x76\x46\x6f\x72']),this['\x6f\x6e']('\x64\x65\x73\x74\x72\x6f\x79',this[_0x756fd9(0x37f)+_0x756fd9(0x298)]);var _0x4f3090=this['\x6f\x70\x74\x69\x6f\x6e\x73'][_0x756fd9(0x3e7)];if(_0x4f3090){var _0x3fe310=this;setTimeout(function(){var _0x5dc0dd=_0x756fd9;_0x3fe310[_0x5dc0dd(0x273)+_0x5dc0dd(0x2f3)](_0x4f3090);});}},_0x3ff691[_0x29955c(0x273)+_0x29955c(0x2f3)]=function(_0x43801a){var _0x2b3cf7=_0x29955c;_0x43801a=_0x37cb8c[_0x2b3cf7(0x49f)+'\x65\x6d\x65\x6e\x74'](_0x43801a);var _0x42729d=_0x5c25e9['\x64\x61\x74\x61'](_0x43801a);if(_0x42729d&&_0x42729d!=this){this[_0x2b3cf7(0x276)+'\x6f\x6e']=_0x42729d;var _0x2b931a=this;this[_0x2b3cf7(0x2c1)+_0x2b3cf7(0x332)]=function(){var _0x167c30=_0x2b3cf7;_0x2b931a[_0x167c30(0x276)+_0x167c30(0x442)]();},_0x42729d['\x6f\x6e'](_0x2b3cf7(0x47d),this[_0x2b3cf7(0x2c1)+'\x6e\x69\x6f\x6e\x53\x65\x6c\x65\x63\x74']),this['\x6f\x6e'](_0x2b3cf7(0x2d3)+'\x6b',this[_0x2b3cf7(0x1ca)+'\x63\x43\x6c\x69\x63\x6b']),this[_0x2b3cf7(0x276)+_0x2b3cf7(0x442)](!0x0);}},_0x3ff691[_0x29955c(0x276)+_0x29955c(0x442)]=function(_0x3ff4ae){var _0x200958=_0x29955c,_0x20202a=this[_0x200958(0x276)+'\x6f\x6e']&&this[_0x200958(0x276)+'\x6f\x6e']['\x73\x65\x6c\x65\x63\x74\x65\x64\x43\x65'+_0x200958(0x391)];if(_0x20202a){var _0x60f76c=_0x20202a[0x0],_0x14374c=this[_0x200958(0x276)+'\x6f\x6e'][_0x200958(0x302)]['\x69\x6e\x64\x65\x78\x4f\x66'](_0x60f76c),_0x52f1b2=_0x14374c+_0x20202a['\x6c\x65\x6e\x67\x74\x68']-0x1,_0x340b69=Math[_0x200958(0x397)](function(_0x765d72,_0x15916b,_0x22e9c9){return(_0x15916b-_0x765d72)*_0x22e9c9+_0x765d72;}(_0x14374c,_0x52f1b2,this['\x6e\x61\x76\x43\x6f\x6d\x70\x61\x6e\x69'+'\x6f\x6e'][_0x200958(0x1d1)]));if(this[_0x200958(0x227)](_0x340b69,!0x1,_0x3ff4ae),this[_0x200958(0x472)+_0x200958(0x2bd)+'\x6d\x65\x6e\x74\x73'](),!(_0x340b69>=this[_0x200958(0x302)][_0x200958(0x1f9)])){var _0x4df878=this['\x63\x65\x6c\x6c\x73'][_0x200958(0x45b)](_0x14374c,_0x52f1b2+0x1);this[_0x200958(0x467)+_0x200958(0x488)]=_0x4df878[_0x200958(0x3c1)](function(_0x51852f){var _0x308f84=_0x200958;return _0x51852f[_0x308f84(0x1eb)];}),this[_0x200958(0x2e8)+'\x65\x6c\x65\x63\x74\x65\x64\x43\x6c\x61'+'\x73\x73'](_0x200958(0x234));}}},_0x3ff691[_0x29955c(0x2e8)+'\x65\x6c\x65\x63\x74\x65\x64\x43\x6c\x61'+'\x73\x73']=function(_0x4fd562){var _0x9301d4=_0x29955c;this[_0x9301d4(0x467)+'\x64\x45\x6c\x65\x6d\x65\x6e\x74\x73'][_0x9301d4(0x1c0)](function(_0xb624bc){var _0x1536b1=_0x9301d4;_0xb624bc['\x63\x6c\x61\x73\x73\x4c\x69\x73\x74'][_0x4fd562](_0x1536b1(0x243)+_0x1536b1(0x1d4));});},_0x3ff691[_0x29955c(0x493)+_0x29955c(0x286)]=function(){var _0x4a1ee4=_0x29955c;this[_0x4a1ee4(0x276)+_0x4a1ee4(0x442)](!0x0);},_0x3ff691[_0x29955c(0x472)+_0x29955c(0x2bd)+'\x6d\x65\x6e\x74\x73']=function(){var _0x36397f=_0x29955c;this['\x6e\x61\x76\x53\x65\x6c\x65\x63\x74\x65'+_0x36397f(0x488)]&&(this['\x63\x68\x61\x6e\x67\x65\x4e\x61\x76\x53'+_0x36397f(0x205)+'\x73\x73']('\x72\x65\x6d\x6f\x76\x65'),delete this[_0x36397f(0x467)+_0x36397f(0x488)]);},_0x3ff691[_0x29955c(0x1ca)+_0x29955c(0x1b1)]=function(_0x265748,_0xe67a4b,_0x3b0cb4,_0x2323d9){var _0x5c862a=_0x29955c;_0x5c862a(0x4a8)==typeof _0x2323d9&&this[_0x5c862a(0x276)+'\x6f\x6e'][_0x5c862a(0x227)](_0x2323d9);},_0x3ff691['\x64\x65\x61\x63\x74\x69\x76\x61\x74\x65'+'\x41\x73\x4e\x61\x76\x46\x6f\x72']=function(){var _0x269d28=_0x29955c;this[_0x269d28(0x472)+_0x269d28(0x2bd)+_0x269d28(0x3f1)]();},_0x3ff691[_0x29955c(0x37f)+_0x29955c(0x298)]=function(){var _0x12a335=_0x29955c;this['\x6e\x61\x76\x43\x6f\x6d\x70\x61\x6e\x69'+'\x6f\x6e']&&(this[_0x12a335(0x276)+'\x6f\x6e'][_0x12a335(0x304)](_0x12a335(0x47d),this[_0x12a335(0x2c1)+_0x12a335(0x332)]),this[_0x12a335(0x304)]('\x73\x74\x61\x74\x69\x63\x43\x6c\x69\x63'+'\x6b',this['\x6f\x6e\x4e\x61\x76\x53\x74\x61\x74\x69'+_0x12a335(0x1b1)]),delete this[_0x12a335(0x276)+'\x6f\x6e']);},_0x5c25e9;}),function(_0x23e252,_0x16df56){'use strict';var _0x2e7ef5=_0x119b77;_0x2e7ef5(0x2dd)==typeof define&&define[_0x2e7ef5(0x1f2)]?define(_0x2e7ef5(0x37e)+_0x2e7ef5(0x373)+'\x6f\x61\x64\x65\x64',['\x65\x76\x2d\x65\x6d\x69\x74\x74\x65\x72'+_0x2e7ef5(0x45c)+'\x72'],function(_0x122ed8){return _0x16df56(_0x23e252,_0x122ed8);}):'\x6f\x62\x6a\x65\x63\x74'==typeof module&&module[_0x2e7ef5(0x4b6)]?module['\x65\x78\x70\x6f\x72\x74\x73']=_0x16df56(_0x23e252,require(_0x2e7ef5(0x46c))):_0x23e252['\x69\x6d\x61\x67\x65\x73\x4c\x6f\x61\x64'+'\x65\x64']=_0x16df56(_0x23e252,_0x23e252['\x45\x76\x45\x6d\x69\x74\x74\x65\x72']);}(_0x119b77(0x31e)!=typeof window?window:this,function(_0x463bd2,_0x347a4b){var _0x51c654=_0x119b77,_0x41f275=_0x463bd2[_0x51c654(0x1cf)],_0x531640=_0x463bd2[_0x51c654(0x277)];function _0x470ad4(_0x27be08,_0x1324c9){for(var _0x4935dd in _0x1324c9)_0x27be08[_0x4935dd]=_0x1324c9[_0x4935dd];return _0x27be08;}var _0x389261=Array[_0x51c654(0x153)][_0x51c654(0x45b)];function _0x4f5c9f(_0x21de30){var _0x5a34b9=_0x51c654;return Array[_0x5a34b9(0x325)](_0x21de30)?_0x21de30:_0x5a34b9(0x358)==typeof _0x21de30&&_0x5a34b9(0x4a8)==typeof _0x21de30[_0x5a34b9(0x1f9)]?_0x389261['\x63\x61\x6c\x6c'](_0x21de30):[_0x21de30];}function _0x72f1d5(_0x5d1b45,_0x259368,_0x5a9fe0){var _0x57ff58=_0x51c654;if(!(this instanceof _0x72f1d5))return new _0x72f1d5(_0x5d1b45,_0x259368,_0x5a9fe0);var _0x58de0d=_0x5d1b45;_0x57ff58(0x3d2)==typeof _0x5d1b45&&(_0x58de0d=document[_0x57ff58(0x1b3)+_0x57ff58(0x473)](_0x5d1b45)),_0x58de0d?(this[_0x57ff58(0x4a7)]=_0x4f5c9f(_0x58de0d),this[_0x57ff58(0x2ab)]=_0x470ad4({},this[_0x57ff58(0x2ab)]),_0x57ff58(0x2dd)==typeof _0x259368?_0x5a9fe0=_0x259368:_0x470ad4(this[_0x57ff58(0x2ab)],_0x259368),_0x5a9fe0&&this['\x6f\x6e'](_0x57ff58(0x275),_0x5a9fe0),this[_0x57ff58(0x386)](),_0x41f275&&(this[_0x57ff58(0x1c4)]=new _0x41f275[(_0x57ff58(0x165))]()),setTimeout(this[_0x57ff58(0x30c)]['\x62\x69\x6e\x64'](this))):_0x531640[_0x57ff58(0x17d)](_0x57ff58(0x34c)+_0x57ff58(0x15d)+_0x57ff58(0x2d8)+(_0x58de0d||_0x5d1b45));}_0x72f1d5[_0x51c654(0x153)]=Object['\x63\x72\x65\x61\x74\x65'](_0x347a4b[_0x51c654(0x153)]),_0x72f1d5[_0x51c654(0x153)][_0x51c654(0x2ab)]={},_0x72f1d5['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65'][_0x51c654(0x386)]=function(){var _0x41d53a=_0x51c654;this[_0x41d53a(0x23b)]=[],this[_0x41d53a(0x4a7)][_0x41d53a(0x1c0)](this['\x61\x64\x64\x45\x6c\x65\x6d\x65\x6e\x74'+_0x41d53a(0x2a5)],this);},_0x72f1d5[_0x51c654(0x153)][_0x51c654(0x453)+_0x51c654(0x2a5)]=function(_0xc57346){var _0x236735=_0x51c654;_0x236735(0x260)==_0xc57346['\x6e\x6f\x64\x65\x4e\x61\x6d\x65']&&this[_0x236735(0x3a8)](_0xc57346),!0x0===this['\x6f\x70\x74\x69\x6f\x6e\x73'][_0x236735(0x43d)]&&this[_0x236735(0x453)+_0x236735(0x1da)+_0x236735(0x2a5)](_0xc57346);var _0x56a414=_0xc57346[_0x236735(0x257)];if(_0x56a414&&_0x5d8fa0[_0x56a414]){for(var _0x110a88=_0xc57346[_0x236735(0x1b3)+'\x74\x6f\x72\x41\x6c\x6c']('\x69\x6d\x67'),_0x251c78=0x0;_0x251c78<_0x110a88[_0x236735(0x1f9)];_0x251c78++){var _0x49a056=_0x110a88[_0x251c78];this[_0x236735(0x3a8)](_0x49a056);}if(_0x236735(0x3d2)==typeof this['\x6f\x70\x74\x69\x6f\x6e\x73'][_0x236735(0x43d)]){var _0x41645f=_0xc57346['\x71\x75\x65\x72\x79\x53\x65\x6c\x65\x63'+'\x74\x6f\x72\x41\x6c\x6c'](this[_0x236735(0x2ab)]['\x62\x61\x63\x6b\x67\x72\x6f\x75\x6e\x64']);for(_0x251c78=0x0;_0x251c78<_0x41645f[_0x236735(0x1f9)];_0x251c78++){var _0x4bddf2=_0x41645f[_0x251c78];this[_0x236735(0x453)+_0x236735(0x1da)+_0x236735(0x2a5)](_0x4bddf2);}}}};var _0x5d8fa0={0x1:!0x0,0x9:!0x0,0xb:!0x0};function _0x156f0e(_0x5bc821){var _0x19848e=_0x51c654;this[_0x19848e(0x204)]=_0x5bc821;}function _0x67f95b(_0x4f5e05,_0x59b326){var _0x2a70e5=_0x51c654;this['\x75\x72\x6c']=_0x4f5e05,this['\x65\x6c\x65\x6d\x65\x6e\x74']=_0x59b326,this[_0x2a70e5(0x204)]=new Image();}return _0x72f1d5['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65'][_0x51c654(0x453)+'\x42\x61\x63\x6b\x67\x72\x6f\x75\x6e\x64'+_0x51c654(0x2a5)]=function(_0x3314d3){var _0x3f7307=_0x51c654,_0x163040=getComputedStyle(_0x3314d3);if(_0x163040)for(var _0xf8dc66=/url\((['"])?(.*?)\1\)/gi,_0x7de0da=_0xf8dc66[_0x3f7307(0x2a0)](_0x163040[_0x3f7307(0x43d)+_0x3f7307(0x445)]);null!==_0x7de0da;){var _0xa1383a=_0x7de0da&&_0x7de0da[0x2];_0xa1383a&&this[_0x3f7307(0x1ee)+_0x3f7307(0x1e7)](_0xa1383a,_0x3314d3),_0x7de0da=_0xf8dc66[_0x3f7307(0x2a0)](_0x163040[_0x3f7307(0x43d)+_0x3f7307(0x445)]);}},_0x72f1d5[_0x51c654(0x153)][_0x51c654(0x3a8)]=function(_0x16815d){var _0x509ca1=_0x51c654,_0x3a7602=new _0x156f0e(_0x16815d);this[_0x509ca1(0x23b)][_0x509ca1(0x43b)](_0x3a7602);},_0x72f1d5['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65']['\x61\x64\x64\x42\x61\x63\x6b\x67\x72\x6f'+_0x51c654(0x1e7)]=function(_0x1c8f1f,_0x507917){var _0x249251=_0x51c654,_0x5d202e=new _0x67f95b(_0x1c8f1f,_0x507917);this[_0x249251(0x23b)]['\x70\x75\x73\x68'](_0x5d202e);},_0x72f1d5[_0x51c654(0x153)][_0x51c654(0x30c)]=function(){var _0x1223cc=_0x51c654,_0x1fb7de=this;function _0x2d3b96(_0xaf2abe,_0x241d27,_0x490a6a){setTimeout(function(){var _0x494490=_0x2870;_0x1fb7de[_0x494490(0x154)](_0xaf2abe,_0x241d27,_0x490a6a);});}this['\x70\x72\x6f\x67\x72\x65\x73\x73\x65\x64'+_0x1223cc(0x49e)]=0x0,this[_0x1223cc(0x2e3)+'\x65\x6e']=!0x1,this[_0x1223cc(0x23b)]['\x6c\x65\x6e\x67\x74\x68']?this[_0x1223cc(0x23b)][_0x1223cc(0x1c0)](function(_0x2280be){var _0x35daf1=_0x1223cc;_0x2280be['\x6f\x6e\x63\x65'](_0x35daf1(0x154),_0x2d3b96),_0x2280be[_0x35daf1(0x30c)]();}):this[_0x1223cc(0x357)]();},_0x72f1d5[_0x51c654(0x153)][_0x51c654(0x154)]=function(_0x465667,_0x51b12d,_0x49f6e2){var _0x78744b=_0x51c654;this[_0x78744b(0x3da)+_0x78744b(0x49e)]++,this['\x68\x61\x73\x41\x6e\x79\x42\x72\x6f\x6b'+'\x65\x6e']=this['\x68\x61\x73\x41\x6e\x79\x42\x72\x6f\x6b'+'\x65\x6e']||!_0x465667['\x69\x73\x4c\x6f\x61\x64\x65\x64'],this[_0x78744b(0x3af)](_0x78744b(0x154),[this,_0x465667,_0x51b12d]),this[_0x78744b(0x1c4)]&&this[_0x78744b(0x1c4)][_0x78744b(0x48e)]&&this['\x6a\x71\x44\x65\x66\x65\x72\x72\x65\x64']['\x6e\x6f\x74\x69\x66\x79'](this,_0x465667),this[_0x78744b(0x3da)+_0x78744b(0x49e)]==this[_0x78744b(0x23b)][_0x78744b(0x1f9)]&&this[_0x78744b(0x357)](),this[_0x78744b(0x2ab)][_0x78744b(0x490)]&&_0x531640&&_0x531640[_0x78744b(0x45a)](_0x78744b(0x424)+_0x49f6e2,_0x465667,_0x51b12d);},_0x72f1d5[_0x51c654(0x153)][_0x51c654(0x357)]=function(){var _0x112960=_0x51c654,_0x46c547=this[_0x112960(0x2e3)+'\x65\x6e']?_0x112960(0x233):'\x64\x6f\x6e\x65';if(this['\x69\x73\x43\x6f\x6d\x70\x6c\x65\x74\x65']=!0x0,this[_0x112960(0x3af)](_0x46c547,[this]),this['\x65\x6d\x69\x74\x45\x76\x65\x6e\x74'](_0x112960(0x275),[this]),this['\x6a\x71\x44\x65\x66\x65\x72\x72\x65\x64']){var _0xc8815f=this['\x68\x61\x73\x41\x6e\x79\x42\x72\x6f\x6b'+'\x65\x6e']?_0x112960(0x3b6):_0x112960(0x288);this[_0x112960(0x1c4)][_0xc8815f](this);}},_0x156f0e[_0x51c654(0x153)]=Object[_0x51c654(0x1fd)](_0x347a4b[_0x51c654(0x153)]),_0x156f0e['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65'][_0x51c654(0x30c)]=function(){var _0x53dac8=_0x51c654;this['\x67\x65\x74\x49\x73\x49\x6d\x61\x67\x65'+_0x53dac8(0x333)]()?this[_0x53dac8(0x384)](0x0!==this['\x69\x6d\x67'][_0x53dac8(0x407)+'\x74\x68'],_0x53dac8(0x407)+'\x74\x68'):(this[_0x53dac8(0x159)]=new Image(),this[_0x53dac8(0x159)][_0x53dac8(0x29a)+_0x53dac8(0x1bd)](_0x53dac8(0x158),this),this['\x70\x72\x6f\x78\x79\x49\x6d\x61\x67\x65'][_0x53dac8(0x29a)+_0x53dac8(0x1bd)](_0x53dac8(0x17d),this),this[_0x53dac8(0x204)][_0x53dac8(0x29a)+_0x53dac8(0x1bd)]('\x6c\x6f\x61\x64',this),this[_0x53dac8(0x204)][_0x53dac8(0x29a)+'\x73\x74\x65\x6e\x65\x72'](_0x53dac8(0x17d),this),this[_0x53dac8(0x159)][_0x53dac8(0x1e9)]=this[_0x53dac8(0x204)][_0x53dac8(0x1e9)]);},_0x156f0e['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65'][_0x51c654(0x1dc)+_0x51c654(0x333)]=function(){var _0x5ce25c=_0x51c654;return this[_0x5ce25c(0x204)][_0x5ce25c(0x357)]&&this[_0x5ce25c(0x204)][_0x5ce25c(0x407)+'\x74\x68'];},_0x156f0e['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65'][_0x51c654(0x384)]=function(_0x38dad8,_0x33df3c){var _0x5ec978=_0x51c654;this[_0x5ec978(0x383)]=_0x38dad8,this[_0x5ec978(0x3af)](_0x5ec978(0x154),[this,this[_0x5ec978(0x204)],_0x33df3c]);},_0x156f0e[_0x51c654(0x153)]['\x68\x61\x6e\x64\x6c\x65\x45\x76\x65\x6e'+'\x74']=function(_0x44f46c){var _0x1f016d=_0x51c654,_0x597805='\x6f\x6e'+_0x44f46c[_0x1f016d(0x32b)];this[_0x597805]&&this[_0x597805](_0x44f46c);},_0x156f0e['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65'][_0x51c654(0x226)]=function(){var _0x3f8f3f=_0x51c654;this[_0x3f8f3f(0x384)](!0x0,_0x3f8f3f(0x226)),this[_0x3f8f3f(0x3ff)+'\x74\x73']();},_0x156f0e[_0x51c654(0x153)][_0x51c654(0x2f2)]=function(){var _0x348266=_0x51c654;this[_0x348266(0x384)](!0x1,_0x348266(0x2f2)),this[_0x348266(0x3ff)+'\x74\x73']();},_0x156f0e[_0x51c654(0x153)]['\x75\x6e\x62\x69\x6e\x64\x45\x76\x65\x6e'+'\x74\x73']=function(){var _0x2ed37a=_0x51c654;this[_0x2ed37a(0x159)][_0x2ed37a(0x271)+_0x2ed37a(0x1c2)](_0x2ed37a(0x158),this),this['\x70\x72\x6f\x78\x79\x49\x6d\x61\x67\x65'][_0x2ed37a(0x271)+'\x74\x4c\x69\x73\x74\x65\x6e\x65\x72'](_0x2ed37a(0x17d),this),this[_0x2ed37a(0x204)][_0x2ed37a(0x271)+_0x2ed37a(0x1c2)](_0x2ed37a(0x158),this),this[_0x2ed37a(0x204)][_0x2ed37a(0x271)+_0x2ed37a(0x1c2)](_0x2ed37a(0x17d),this);},_0x67f95b[_0x51c654(0x153)]=Object[_0x51c654(0x1fd)](_0x156f0e['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65']),_0x67f95b[_0x51c654(0x153)][_0x51c654(0x30c)]=function(){var _0x38a46c=_0x51c654;this[_0x38a46c(0x204)]['\x61\x64\x64\x45\x76\x65\x6e\x74\x4c\x69'+_0x38a46c(0x1bd)](_0x38a46c(0x158),this),this['\x69\x6d\x67']['\x61\x64\x64\x45\x76\x65\x6e\x74\x4c\x69'+_0x38a46c(0x1bd)](_0x38a46c(0x17d),this),this[_0x38a46c(0x204)]['\x73\x72\x63']=this[_0x38a46c(0x284)],this[_0x38a46c(0x1dc)+_0x38a46c(0x333)]()&&(this[_0x38a46c(0x384)](0x0!==this[_0x38a46c(0x204)][_0x38a46c(0x407)+'\x74\x68'],_0x38a46c(0x407)+'\x74\x68'),this[_0x38a46c(0x3ff)+'\x74\x73']());},_0x67f95b['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65'][_0x51c654(0x3ff)+'\x74\x73']=function(){var _0x8aca20=_0x51c654;this[_0x8aca20(0x204)]['\x72\x65\x6d\x6f\x76\x65\x45\x76\x65\x6e'+_0x8aca20(0x1c2)](_0x8aca20(0x158),this),this['\x69\x6d\x67'][_0x8aca20(0x271)+_0x8aca20(0x1c2)](_0x8aca20(0x17d),this);},_0x67f95b['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65'][_0x51c654(0x384)]=function(_0x2d3ab9,_0x2358f2){var _0x41f896=_0x51c654;this[_0x41f896(0x383)]=_0x2d3ab9,this[_0x41f896(0x3af)](_0x41f896(0x154),[this,this[_0x41f896(0x1eb)],_0x2358f2]);},_0x72f1d5[_0x51c654(0x34b)+_0x51c654(0x169)]=function(_0x39c6e4){var _0x2f3a6c=_0x51c654;(_0x39c6e4=_0x39c6e4||_0x463bd2[_0x2f3a6c(0x1cf)])&&((_0x41f275=_0x39c6e4)['\x66\x6e'][_0x2f3a6c(0x1e4)+'\x65\x64']=function(_0xfc88e2,_0x59c627){var _0x575701=_0x2f3a6c;return new _0x72f1d5(this,_0xfc88e2,_0x59c627)[_0x575701(0x1c4)][_0x575701(0x2a3)](_0x41f275(this));});},_0x72f1d5['\x6d\x61\x6b\x65\x4a\x51\x75\x65\x72\x79'+'\x50\x6c\x75\x67\x69\x6e'](),_0x72f1d5;}),function(_0x111f6d,_0x25aa6e){var _0x3b86e2=_0x119b77;_0x3b86e2(0x2dd)==typeof define&&define[_0x3b86e2(0x1f2)]?define(['\x66\x6c\x69\x63\x6b\x69\x74\x79\x2f\x6a'+_0x3b86e2(0x1f5),_0x3b86e2(0x37e)+_0x3b86e2(0x373)+'\x6f\x61\x64\x65\x64'],function(_0x467db6,_0x4d5fdc){return _0x25aa6e(_0x111f6d,_0x467db6,_0x4d5fdc);}):_0x3b86e2(0x358)==typeof module&&module['\x65\x78\x70\x6f\x72\x74\x73']?module[_0x3b86e2(0x4b6)]=_0x25aa6e(_0x111f6d,require(_0x3b86e2(0x2fd)),require('\x69\x6d\x61\x67\x65\x73\x6c\x6f\x61\x64'+'\x65\x64')):_0x111f6d[_0x3b86e2(0x1c9)]=_0x25aa6e(_0x111f6d,_0x111f6d[_0x3b86e2(0x1c9)],_0x111f6d['\x69\x6d\x61\x67\x65\x73\x4c\x6f\x61\x64'+'\x65\x64']);}(window,function(_0xe36018,_0xba4f99,_0x1b5a31){'use strict';var _0x27b42b=_0x119b77;_0xba4f99[_0x27b42b(0x20e)+_0x27b42b(0x1e3)][_0x27b42b(0x43b)](_0x27b42b(0x331)+_0x27b42b(0x1ea));var _0x51f156=_0xba4f99[_0x27b42b(0x153)];return _0x51f156[_0x27b42b(0x331)+'\x67\x65\x73\x4c\x6f\x61\x64\x65\x64']=function(){var _0x2ebdd6=_0x27b42b;this['\x6f\x6e'](_0x2ebdd6(0x239),this[_0x2ebdd6(0x1e4)+'\x65\x64']);},_0x51f156[_0x27b42b(0x1e4)+'\x65\x64']=function(){var _0xefe827=_0x27b42b;if(this[_0xefe827(0x2ab)][_0xefe827(0x1e4)+'\x65\x64']){var _0x652181=this;_0x1b5a31(this[_0xefe827(0x419)])['\x6f\x6e']('\x70\x72\x6f\x67\x72\x65\x73\x73',function(_0x1a07d5,_0x23c9e6){var _0x28e5d0=_0xefe827,_0x3fb7c7=_0x652181['\x67\x65\x74\x50\x61\x72\x65\x6e\x74\x43'+_0x28e5d0(0x46d)](_0x23c9e6[_0x28e5d0(0x204)]);_0x652181[_0x28e5d0(0x49d)+'\x61\x6e\x67\x65'](_0x3fb7c7&&_0x3fb7c7['\x65\x6c\x65\x6d\x65\x6e\x74']),_0x652181['\x6f\x70\x74\x69\x6f\x6e\x73'][_0x28e5d0(0x3f6)]||_0x652181['\x70\x6f\x73\x69\x74\x69\x6f\x6e\x53\x6c'+'\x69\x64\x65\x72\x41\x74\x53\x65\x6c\x65'+'\x63\x74\x65\x64']();});}},_0xba4f99;});while(!window[_0x119b77(0x1c9)]){await new Promise(_0x6d354=>setTimeout(_0x6d354,0xa));}_0x4b18c6(!![]);});}function _0x19842a(){var _0x23bf03=_0x233d8b;if(window[_0x23bf03(0x1c9)]!==undefined)return!![];return new Promise(async(_0xaa029d,_0x3bad49)=>{var _0x502d52=_0x23bf03;try{await _0x3e4127('\x68\x74\x74\x70\x73\x3a\x2f\x2f\x63\x64'+_0x502d52(0x26d)+_0x502d52(0x1cc)+'\x6a\x61\x78\x2f\x6c\x69\x62\x73\x2f\x66'+_0x502d52(0x466)+_0x502d52(0x408)+'\x74\x79\x2e\x70\x6b\x67\x64\x2e\x6d\x69'+'\x6e\x2e\x6a\x73');}catch(_0x3c0fb5){await _0x2de60b();}_0xaa029d(!![]);});}function _0x5a5c58(_0x306ed1){var _0x19a836=_0x233d8b;if(_0x217d55[_0x19a836(0x18c)+_0x19a836(0x2a6)+_0x19a836(0x46e)+'\x6f\x70'])return;const _0x5165c2=document[_0x19a836(0x1b3)+_0x19a836(0x473)]('\x2e\x54\x68\x75\x6d\x62\x6e\x61\x69\x6c'+'\x73\x2d\x2d\x6e\x6f\x6e\x2d\x73\x6c\x69'+_0x19a836(0x187)+'\x63\x74\x2d\x73\x69\x6e\x67\x6c\x65\x5f'+_0x19a836(0x465));if(!_0x5165c2)return;for(let _0xc567e5 of _0x5165c2){_0xc567e5[_0x19a836(0x29a)+_0x19a836(0x1bd)](_0x19a836(0x303),function(_0x5b6bf3){const _0x2287bc=()=>{var _0x10da8e=_0x2870;const _0x4fe07f=_0xc567e5[_0x10da8e(0x476)+'\x74\x65'](_0x10da8e(0x15c)+_0x10da8e(0x44b)+_0x10da8e(0x1d3));if(!_0x4fe07f)return;const _0xe99a98=parseInt(_0x4fe07f);_0x306ed1[_0x10da8e(0x47d)](_0xe99a98,_0x217d55['\x66\x65\x61\x74\x75\x72\x65\x64\x49\x6d'+'\x61\x67\x65\x4c\x6f\x6f\x70'],!![]);};setTimeout(_0x2287bc,_0x115b19);});}}function _0x530aba(_0x2c1282){var _0x583079=_0x233d8b;if(_0x3c1363)return;const _0x327ad2=document['\x71\x75\x65\x72\x79\x53\x65\x6c\x65\x63'+'\x74\x6f\x72\x41\x6c\x6c'](_0x583079(0x369)+_0x583079(0x31a));if(!_0x327ad2)return;for(let _0x118e81 of _0x327ad2){_0x118e81[_0x583079(0x29a)+_0x583079(0x1bd)]('\x63\x68\x61\x6e\x67\x65',async function(){_0x453d90=!![];const _0x5ea4ed=async()=>{var _0x51793a=_0x2870;const _0x55c53b=await _0x30857a();if(!_0x55c53b)return;const _0xe0f1d0=_0x51793a(0x162)+_0x51793a(0x33e)in _0x55c53b?_0x55c53b[_0x51793a(0x162)+_0x51793a(0x33e)]['\x69\x64']:_0x55c53b['\x66\x65\x61\x74\x75\x72\x65\x64\x5f\x6d'+_0x51793a(0x3fa)]['\x69\x64'],_0x4a46bd=_0x55c53b['\x66\x65\x61\x74\x75\x72\x65\x64\x5f\x69'+'\x6d\x61\x67\x65'][_0x51793a(0x336)]||_0x55c53b['\x66\x65\x61\x74\x75\x72\x65\x64\x5f\x6d'+_0x51793a(0x3fa)][_0x51793a(0x336)];if(!_0xe0f1d0)return console['\x6c\x6f\x67'](_0x51793a(0x36e)+_0x51793a(0x3ae));console[_0x51793a(0x45a)](_0x3c1363);const _0x13fc0f=document[_0x51793a(0x1b3)+_0x51793a(0x1b5)]('\x23'+_0x4ecc5a+(_0x51793a(0x2e5)+'\x67\x65\x2d\x70\x6f\x73\x69\x74\x69\x6f'+_0x51793a(0x316))+_0x4a46bd+'\x27\x5d');if(!_0x13fc0f)return;const _0x4cd130=_0x13fc0f[_0x51793a(0x476)+'\x74\x65'](_0x51793a(0x3a7)+_0x51793a(0x4b2));!_0x3c1363&&_0x2c1282['\x73\x65\x6c\x65\x63\x74'](_0x4cd130);};setTimeout(_0x5ea4ed,_0x577078),await _0x21d6fb(_0x577078),_0x453d90=![];});}}async function _0x1c6960(_0x402d1c){var _0x2d203a=_0x233d8b;if(!/variant=\d/['\x74\x65\x73\x74'](window[_0x2d203a(0x2e6)][_0x2d203a(0x1db)]))return;_0x38c9ac=!![];try{const _0x3b0c92=await _0x30857a();console[_0x2d203a(0x45a)](_0x2d203a(0x158),_0x3b0c92);if(!_0x3b0c92||_0x3b0c92[_0x2d203a(0x1f9)]<=0x0)return;const _0x11fe52=_0x2d203a(0x162)+_0x2d203a(0x33e)in _0x3b0c92?_0x3b0c92[_0x2d203a(0x162)+_0x2d203a(0x33e)]['\x69\x64']:_0x3b0c92['\x66\x65\x61\x74\x75\x72\x65\x64\x5f\x6d'+_0x2d203a(0x3fa)]['\x69\x64'],_0xfab886=_0x3b0c92[_0x2d203a(0x162)+_0x2d203a(0x33e)][_0x2d203a(0x336)]||_0x3b0c92[_0x2d203a(0x2b5)+'\x65\x64\x69\x61'][_0x2d203a(0x336)];if(!_0x11fe52||_0x11fe52[_0x2d203a(0x1f9)]<=0x0)return console['\x6c\x6f\x67'](_0x2d203a(0x375)+'\x2e');const _0x254865=document[_0x2d203a(0x1b3)+_0x2d203a(0x1b5)]('\x23'+_0x4ecc5a+(_0x2d203a(0x2e5)+_0x2d203a(0x188)+_0x2d203a(0x316))+_0xfab886+'\x27\x5d');if(!_0x254865)return;const _0x4b5d1a=parseInt(_0x254865['\x67\x65\x74\x41\x74\x74\x72\x69\x62\x75'+'\x74\x65'](_0x2d203a(0x3a7)+_0x2d203a(0x4b2)));_0x402d1c[_0x2d203a(0x47d)](_0x4b5d1a,_0x217d55[_0x2d203a(0x47c)+_0x2d203a(0x16e)],!![]),await _0x21d6fb(_0x577078),_0x38c9ac=![];}catch(_0x40886c){return;}}async function _0x20b718(){var _0x279733=_0x233d8b;if(_0x453d90||_0x38c9ac)return console['\x6c\x6f\x67'](_0x279733(0x299)+_0x279733(0x27c)+_0x279733(0x3b3)+_0x279733(0x254));await _0x21d6fb(_0x5f460b);const _0x3a6018=document[_0x279733(0x1b3)+_0x279733(0x1b5)]('\x23'+_0x4ecc5a+(_0x279733(0x1af)+_0x279733(0x2c9)));if(!_0x3a6018)return;const _0x387439=_0x3a6018[_0x279733(0x318)+'\x74\x65'](_0x279733(0x18b)+'\x63\x74\x2d\x6d\x65\x64\x69\x61\x2d\x74'+_0x279733(0x390));if(_0x387439)return;const _0x26330d=_0x3a6018[_0x279733(0x476)+'\x74\x65']('\x64\x61\x74\x61\x2d\x69\x6d\x61\x67\x65'+_0x279733(0x19d)+'\x69\x64'),_0x2031a7=await _0x51b9fc(_0x26330d);for(const [_0x2a0078,_0x14b68a]of _0x2031a7[_0x279733(0x36b)]()){const _0x83fd62=parseInt(_0x2a0078)+0x1,_0x208ad2=document[_0x279733(0x1b3)+_0x279733(0x1b5)](_0x279733(0x1de)+_0x279733(0x18e)+_0x279733(0x21e)+'\x6e'+_0x83fd62+'\x22\x5d');console[_0x279733(0x45a)](_0x279733(0x1d2)+'\x74',_0x208ad2);if(!_0x208ad2)return;try{_0x208ad2[_0x279733(0x263)]=_0x14b68a,_0x208ad2[_0x279733(0x3b9)+'\x65\x6e\x74'](new Event(_0x279733(0x382),{'\x62\x75\x62\x62\x6c\x65\x73':!![]}));}catch(_0xde32f){}}}function _0xcb9b95(){var _0x1cdf41=_0x233d8b;const _0x3f6b26=_0x1cdf41(0x41d)+'\x6d\x62',_0x23f2ab=_0x1cdf41(0x342)+_0x1cdf41(0x378),_0x734b95=window[_0x1cdf41(0x497)+_0x1cdf41(0x230)+'\x45\x58'],_0x7b6a37=document[_0x1cdf41(0x1b3)+_0x1cdf41(0x1b5)]('\x5b\x64\x61\x74\x61\x2d\x74\x68\x75\x6d'+_0x1cdf41(0x39e)+_0x1cdf41(0x252)+_0x734b95+'\x22\x5d');if(!_0x7b6a37)return;const _0x3e9b00=document[_0x1cdf41(0x1b3)+'\x74\x6f\x72\x41\x6c\x6c']('\x2e'+_0x23f2ab+_0x1cdf41(0x307)+_0x3f6b26);if(_0x3e9b00&&_0x3e9b00[_0x1cdf41(0x1f9)]>=0x1)for(const _0x699ee7 of _0x3e9b00){_0x699ee7[_0x1cdf41(0x35f)][_0x1cdf41(0x429)](_0x23f2ab),_0x699ee7['\x63\x6c\x61\x73\x73\x4c\x69\x73\x74'][_0x1cdf41(0x429)](_0x3f6b26);}_0x7b6a37['\x63\x6c\x61\x73\x73\x4c\x69\x73\x74']['\x61\x64\x64'](_0x23f2ab);}function _0x316933(){var _0x2a3783=_0x233d8b;const _0x121239=_0x2a3783(0x1d6)+'\x2d\x2d\x6e\x6f\x6e\x2d\x73\x6c\x69\x64'+_0x2a3783(0x207),_0x15fd6e=document[_0x2a3783(0x1b3)+_0x2a3783(0x1b5)](_0x2a3783(0x40b)+'\x73\x2d\x2d\x6e\x6f\x6e\x2d\x73\x6c\x69'+_0x2a3783(0x335));if(!_0x15fd6e)return;_0x15fd6e['\x63\x6c\x61\x73\x73\x4c\x69\x73\x74'][_0x2a3783(0x234)](_0x121239);}async function _0x1e135d(){var _0x3f5b78=_0x233d8b;let _0x195bf8=new Flickity('\x23'+_0x4ecc5a,{..._0x5ee0b2,'\x6f\x6e':{'\x72\x65\x61\x64\x79':async function(_0x5b11a7){_0xcb9b95(),_0x316933();},'\x63\x68\x61\x6e\x67\x65':async function(_0x34f10f){var _0x5d77e3=_0x2870;_0x3c1363=!![],window['\x43\x55\x52\x52\x45\x4e\x54\x4c\x59\x5f'+_0x5d77e3(0x230)+'\x45\x58']=_0x34f10f,_0x20b718(),_0xcb9b95(),await _0x21d6fb(_0x4d0125),_0x3c1363=![];}}});window['\x65\x7a\x66\x79\x44\x65\x62\x75\x74\x53'+_0x3f5b78(0x315)+_0x3f5b78(0x30d)]=_0x195bf8,_0x1c6960(_0x195bf8),_0x530aba(_0x195bf8),_0x5a5c58(_0x195bf8);}function _0x4cce9e(){var _0x54c790=_0x233d8b;const _0x54a05f=_0x54c790(0x398)+_0x54c790(0x44a);if(!_0x217d55[_0x54c790(0x18c)+_0x54c790(0x2a6)+_0x54c790(0x46e)+'\x6f\x70'])return;if(!document['\x71\x75\x65\x72\x79\x53\x65\x6c\x65\x63'+'\x74\x6f\x72'](_0x54a05f))return;const _0x401018=new Flickity(_0x54a05f,_0x30c890,{'\x6f\x6e':{'\x72\x65\x61\x64\x79':function(){var _0x18793c=_0x54c790;console[_0x18793c(0x45a)]('\x74\x68\x75\x6d\x62\x6e\x61\x69\x6c\x73'+_0x18793c(0x1a3));}}});}function _0x1dda95(){var _0x44a60f=_0x233d8b;const _0x3573da=document[_0x44a60f(0x1b3)+_0x44a60f(0x473)](_0x44a60f(0x398)+_0x44a60f(0x3d1));if(!_0x3573da)return;for(let _0x8594c7 of _0x3573da){_0x8594c7['\x61\x64\x64\x45\x76\x65\x6e\x74\x4c\x69'+_0x44a60f(0x1bd)](_0x44a60f(0x303),function(_0x7fdb70){var _0x4dc8b3=_0x44a60f;_0x7fdb70[_0x4dc8b3(0x18f)+_0x4dc8b3(0x3f3)]();});}}return{'\x69\x6e\x69\x74':async function(){var _0x496507=_0x233d8b;await _0x19842a(),await _0x21d6fb(0x15e),_0x1e135d(),_0x4cce9e(),_0x1dda95(),document[_0x496507(0x29a)+_0x496507(0x1bd)](_0x496507(0x385)+_0x496507(0x26a),async function(){}),window[_0x496507(0x29a)+'\x73\x74\x65\x6e\x65\x72'](_0x496507(0x2d1),function(){}),window[_0x496507(0x29a)+_0x496507(0x1bd)](_0x496507(0x158),function(){}),window[_0x496507(0x29a)+'\x73\x74\x65\x6e\x65\x72']('\x73\x63\x72\x6f\x6c\x6c',function(){});}};}(),ezfyDebutSliderPro[_0x3ac277(0x2c3)]());
